import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import Select from 'react-select';
import { Line,Doughnut, Bar, Pie, Scatter } from 'react-chartjs-2';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ProgressBar } from "react-bootstrap";
import GaugeChart from 'react-gauge-chart';
import { useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import 'react-datepicker/dist/react-datepicker.css';
import Picker from 'emoji-picker-react'; 
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Compressor from 'compressorjs';
import "chart.js/auto";
import Calendar from "react-calendar";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from 'uuid'; 
import polyline from '@mapbox/polyline';
import moment from 'moment';
import QRCode from 'react-qr-code';
import autoTable from 'jspdf-autotable';
import { Rnd } from 'react-rnd';

import { useNotification } from '../../shared/NotificationContext';
import styles from '../../styles/UltimatePage.module.css';
import Loader from '../../shared/Loader'; // Importă componenta Loader
import Notifications from '../../shared/NotificationsSettings';
import ChartMenu from '../../shared/ChartMenu';
import TwoFactorNotification from '../../shared/TwoFactorNotification';
import LoadsNotifications from '../../shared/LoadsNotifications';
import DriversNotifications from '../../shared/DriverNotifications';
import DeleteNotifications from '../../shared/DeleteNotifications';
import { PDFDownloadLink, PDFViewer, Document, Page, Text, View } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';
import PdfViewerWithSelect from "./PdfViewerWithSelect";
import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  ArcElement
} from 'chart.js';
import {
  BarChart,
  XAxis,
  YAxis,
  LineChart,
  
  CartesianGrid,
  PieChart,
  
  Cell
} from "recharts";

import { GoogleMap, LoadScript, Marker, Polyline, Circle } from '@react-google-maps/api';
import { Chart, registerables } from "chart.js";
import { getTimeWindowDP, resolveDriverName } from "../../../utils/dashboard";


// Înregistrăm ArcElement împreună cu celelalte elemente
ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
  Title
);

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
const socket = io('https://api-backend.full-trucking-service.com', {
  transports: ['websocket', 'polling'],
  secure: true, // Asigură conexiuni securizate în mediul de producție
  reconnect: true, // Activează reconectarea automată în cazul întreruperii
  timeout: 20000, // Timpul maxim de conectare înainte de timeout (în milisecunde)
  reconnectionAttempts: 5, // Numărul de încercări de reconectare înainte de a renunța
  reconnectionDelay: 1000, // Întârziere între reconectări (în milisecunde)
  rejectUnauthorized: false, // Permite conexiuni securizate fără a respinge cererile nesemnate
});



const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';

const BusinessPage = () => {
  
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [activeSection, setActiveSection] = useState('dashboard'); // Default la dashboard
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());
  const inactivityTimeoutRef = useRef(null);
  const refreshOnNextInteractionRef = useRef(false);
  const [selectedLoadId, setSelectedLoadId] = useState(null);
  
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [trailers, setTrailers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [shippers, setShippers] = useState([]);
  const [consignees, setConsignees] = useState([]);
  const [loads, setLoads] = useState([]);
  const [driverPays, setDriverPays] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [loadNumber, setLoadNumber] = useState('');
  const [dispatcher, setDispatcher] = useState('');
  const [brokerName, setBrokerName] = useState('');
  const [brokerAddress, setBrokerAddress] = useState('');
  const [rate, setRate] = useState('');
  const [equipment, setEquipment] = useState('');
  const [driver, setDriver] = useState('');
  const [truck, setTruck] = useState('');
  const [trailer, setTrailer] = useState('');
  const [status, setStatus] = useState('');
  const [shipperName, setShipperName] = useState('');
  const [shipperAddress, setShipperAddress] = useState('');
  const [consigneeName, setConsigneeName] = useState('');
  const [consigneeAddress, setConsigneeAddress] = useState('');
  const [miles, setMiles] = useState('');
  const [dh, setDH] = useState('');
  const [notes, setNotes] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [messages, setMessages] = useState([]);
  const [startDate, setStartDate] = useState('');  // Definim startDate
  const [endDate, setEndDate] = useState('');  
  const [loading, setLoading] = useState(false);
  const [dispatchers, setDispatchers] = useState([]); // Definește `dispatchers`
  const [currentUserId, setCurrentUserId] = useState(null); // Definește `currentUserId`
  const [currentUserRole, setCurrentUserRole] = useState(null); // Definește `currentUserRole`
  const [hasTwoFactorAuth, setHasTwoFactorAuth] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const location = useLocation(); // Inițializează useLocation
  const userRole = location.state?.role || 'client'; // Setează 'client' ca rol implicit
  const [isLoading, setIsLoading] = useState(true); // Stare pentru controlul procesului de încărcare
  const [isInitialized, setIsInitialized] = useState(false); // Controlăm complet procesul de inițializare
  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  const { notify } = useNotification();
  const [fuelReports, setFuelReports] = useState([]);
const [iftaReports, setIftaReports] = useState([]);
const [userSettings, setUserSettings] = useState({});

  const [kpiData, setKpiData] = useState({
  utilizationRate: 0,
  revenuePerTruck: 0,
  revenuePerDriver: 0,
  profitMargin: 0,
  operatingRatio: 0,
  iftaCompliance: 0,
  driverTurnover: 0,
  payPerMile: 0,
  maintCostPerMile: 0,
  fuelEfficiency: 0,
  nextServiceDue: 0,
  topClients: [],
  repeatLoads: 0,
  loadsPerDispatcher: 0,
  revenuePerDispatcher: 0,
});
useEffect(() => {
  fetchTheme();
}, []);

const [theme, setTheme] = useState("dark");

useEffect(() => {
  fetchTheme();
}, []);

const fetchTheme = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const apiUrl = "https://api-backend.full-trucking-service.com/api";

    const res = await axios.get(`${apiUrl}/settings`, config);

    if (res.data.theme) {
      setTheme(res.data.theme);
    }
  } catch (err) {
    console.log("Error fetching theme:", err);
  }
};


  const [isInteractionAllowed, setIsInteractionAllowed] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(() => {
    const saved = localStorage.getItem("unreadMessages");
    try {
      const parsed = JSON.parse(saved);
      return typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  });
  
  const audioRef = useRef(null);
  
  const getToken = () => {
    return sessionStorage.getItem('token') || localStorage.getItem('token');
  };
  
  const socketRef = useRef(null);
  const clientId = localStorage.getItem('clientId');
  const [newMessageNotification, setNewMessageNotification] = useState(null);

// 🔥 Funcție pentru afișarea notificării vizuale
const showNewMessageNotification = (data) => {
  setNewMessageNotification(`${data.sender}: ${data.message}`);

  setTimeout(() => {
    setNewMessageNotification(null);
  }, 5000); // 🔥 Se ascunde după 5 secunde
};


  const handleNavigateToSection = (section, loadId = null) => {
    setActiveSection(section);
    setSelectedLoadId(loadId); // Setăm `loadId` pentru secțiunea `LoadManager`
  };

  const savedPermissions = JSON.parse(localStorage.getItem('permissions')) || [];

const accessibleModules =
  savedPermissions && savedPermissions.length > 0
    ? savedPermissions // ✅ Folosește permisiunile reale din DB
    : userRole === "client"
    ? [
        "dashboard",
        "driver-dashboard",
        "truck-dashboard",

        "accounting-manager",
        "driver-pay",
        "driverpay-manager",
        "fleet-report",
        "payroll-employee",
        "payroll-manager",
        "invoice",
        "receivedInvoices",
        "balanceSheet",
        "ifta",
        "fuel-report",
        "truckandtrailer",

        "drivers",
        "trucks",
        "trailers",
        "shippers",
        "consignee",
        "brokers",
        "employees",

        "load-manager",
        "load-finder",
        "trucking",
        
        "settings",
        "add-new-load",
      ]
    : [];

  
    const queryParams = new URLSearchParams(window.location.search);
    const activeTab = queryParams.get('tab') || 'default'; // Default poate fi un alt tab implicit.
  

    useEffect(() => {
      if (activeTab === 'add-new-load') {
        setActiveSection('add-new-load');
      }
    }, [activeTab]);
  
    useEffect(() => {
      if (activeSection === 'settings' && !isTwoFactorEnabled) {
        const element = document.querySelector('.twoFactorWarningsettings');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, [activeSection, isTwoFactorEnabled]);
    

    useEffect(() => {
      const resetInactivityTimer = () => {
        setLastInteractionTime(Date.now());
  
        if (refreshOnNextInteractionRef.current) {
          refreshOnNextInteractionRef.current = false;
          window.location.reload();
        }
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
  
        inactivityTimeoutRef.current = setTimeout(() => {
          refreshOnNextInteractionRef.current = true;
        }, 10 * 60 * 1000); // 10 minute
      };
  
      document.addEventListener("mousemove", resetInactivityTimer);
      document.addEventListener("keydown", resetInactivityTimer);
      document.addEventListener("scroll", resetInactivityTimer);
      document.addEventListener("click", resetInactivityTimer);
  
      return () => {
        document.removeEventListener("mousemove", resetInactivityTimer);
        document.removeEventListener("keydown", resetInactivityTimer);
        document.removeEventListener("scroll", resetInactivityTimer);
        document.removeEventListener("click", resetInactivityTimer);
  
        if (inactivityTimeoutRef.current) {
          clearTimeout(inactivityTimeoutRef.current);
        }
      };
    }, []);
    // === KPI CALCULATOR ===
const calculateKPIData = (drivers, trucks, loads, driverPays, iftaReports, brokers) => {
  if (!loads || loads.length === 0) {
    setKpiData({
      utilizationRate: 0,
      revenuePerTruck: 0,
      revenuePerDriver: 0,
      profitMargin: 0,
      operatingRatio: 0,
      iftaCompliance: 0,
      driverTurnover: 0,
      payPerMile: 0,
      maintCostPerMile: 0,
      fuelEfficiency: 0,
      nextServiceDue: 0,
      topClients: [],
      repeatLoads: 0,
      loadsPerDispatcher: 0,
      revenuePerDispatcher: 0,
    });
    return;
  }

  // aici bagi calculele (fix cum ți le-am rescris mai sus)
};


  const fetchData = async () => {
  try {
    const token = localStorage.getItem('token');
    const tokenExpiration = localStorage.getItem('tokenExpiration');

    if (!token || !tokenExpiration || new Date() >= new Date(tokenExpiration)) {
      notify('Session expired. Please log in again.', 'error');
      navigate('/login');
      return;
    }

    // verifică dacă există cache în localStorage
    const cached = localStorage.getItem("dashboardData");
// în fetchData, după ce citești din localStorage:
if (cached) {
  const parsed = JSON.parse(cached);
  setUserSettings(parsed.userSettings || {});
  setDrivers(parsed.drivers || []);
  setTrucks(parsed.trucks || []);
  setTrailers(parsed.trailers || []);
  setBrokers(parsed.brokers || []);
  setShippers(parsed.shippers || []);
  setConsignees(parsed.consignees || []);
  setLoads(parsed.loads || []);
  setDriverPays(parsed.driverPays || []);
  calculateDashboardData(
    parsed.drivers,
    parsed.trucks,
    parsed.loads,
    parsed.iftaReports
  );
  // ⚠️ NU mai face return aici
}

// indiferent dacă există cache sau nu, refă requestul real:
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};

const [
  userSettingsRes,
  driversRes,
  trucksRes,
  trailersRes,
  brokersRes,
  shippersRes,
  consigneesRes,
  loadsRes,
  driverPaysRes,
  iftaReportsRes,
  fuelReportsRes
] = await Promise.all([
  axios.get(`${apiUrl}/settings`, config),
  axios.get(`${apiUrl}/drivers`, config),
  axios.get(`${apiUrl}/trucks`, config),
  axios.get(`${apiUrl}/trailers`, config),
  axios.get(`${apiUrl}/brokers`, config),
  axios.get(`${apiUrl}/shippers`, config),
  axios.get(`${apiUrl}/consignees`, config),
  axios.get(`${apiUrl}/loads`, config),
  axios.get(`${apiUrl}/driverpays`, config),
  axios.get(`${apiUrl}/ifta`, config),
  axios.get(`${apiUrl}/fuel-reports`, config),
]);

setUserSettings(userSettingsRes.data);
setDrivers(driversRes.data);
setTrucks(trucksRes.data);
setTrailers(trailersRes.data);
setBrokers(brokersRes.data);
setShippers(shippersRes.data);
setConsignees(consigneesRes.data);
setLoads(loadsRes.data);
setDriverPays(driverPaysRes.data);
setIftaReports(iftaReportsRes.data);
setFuelReports(fuelReportsRes.data);

calculateDashboardData(
  driversRes.data,
  trucksRes.data,
  loadsRes.data,
  iftaReportsRes.data
);

calculateKPIData(
  driversRes.data,
  trucksRes.data,
  loadsRes.data,
  driverPaysRes.data,
  iftaReportsRes.data,
  brokersRes.data,
  fuelReportsRes.data
);

// actualizează cache-ul cu date proaspete
localStorage.setItem("dashboardData", JSON.stringify({
  userSettings: userSettingsRes.data,
  drivers: driversRes.data,
  trucks: trucksRes.data,
  trailers: trailersRes.data,
  brokers: brokersRes.data,
  shippers: shippersRes.data,
  consignees: consigneesRes.data,
  loads: loadsRes.data,
  driverPays: driverPaysRes.data,
  iftaReports: iftaReportsRes.data,
  fuelReports: fuelReportsRes.data,
}));

  } catch (error) {
    notify('Failed to fetch data. Please try again later.', 'error');
  }
};
useEffect(() => {
  const fetchLoads = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      };

      const res = await axios.get(`${apiUrl}/loads`, config);
      setLoads(res.data); // ✅ încărcăm toate loadurile din DB
    } catch (err) {
      console.error("Error fetching loads:", err);
      notify("Could not fetch loads", "error");
    }
  };

  fetchLoads();
}, []); // rulează doar la mount
    useEffect(() => {
      const fetchTwoFactorAuthStatus = async () => {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
        if (!token) {
         
          setHasTwoFactorAuth(false); // Presupunem că 2FA nu este activat
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
          return;
        }
    
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };
    
        try {
          const response = await axios.get(`${apiUrl}/settings`, config);
          const settings = response.data;
    
          if (settings && typeof settings.twoFactorAuthEnabled === 'boolean') {
            setHasTwoFactorAuth(settings.twoFactorAuthEnabled);
          } else {
          
            setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
          }
        } catch (error) {
    
          setHasTwoFactorAuth(false); // Implicit presupunem că 2FA nu este activat
        } finally {
          setIsInitialized(true); // Marcam inițializarea ca fiind completă
        }
      };
    
      fetchTwoFactorAuthStatus();
    }, [apiUrl]);
    
    useEffect(() => {
      const enableAudio = () => setIsInteractionAllowed(true);
      document.addEventListener("click", enableAudio);
      return () => document.removeEventListener("click", enableAudio);
    }, []);
    
    useEffect(() => {
      const values = unreadMessages ? Object.values(unreadMessages) : [];
      if (values.some((count) => count > 0) && isInteractionAllowed) {
        audioRef.current.play().catch((err) => console.error("🔇 Audio playback error:", err));
      }
    }, [unreadMessages]);
    
  const handleSendMessage = (message) => {
    if (message.trim() !== '') {
      setMessages((prevMessages) => [
        ...prevMessages,
        { from: 'me', message },
      ]);
    }
  };


  useEffect(() => {
    localStorage.setItem("unreadMessages", JSON.stringify(unreadMessages));
  }, [unreadMessages]);


  useEffect(() => {
    // Exemplu de apel API pentru a obține dispatchers și datele utilizatorului
    const fetchData = async () => {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token'); // Obține token-ul de autentificare
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`, // Include token-ul cu prefixul Bearer
          'Content-Type': 'application/json',
        },
        withCredentials: true, // Permite trimiterea cookie-urilor pentru autentificare
      };
    
      try {
        // Apel pentru a obține lista de dispatchers
        const dispatchersData = await axios.get('https://api-backend.full-trucking-service.com/api/dispatchers', config);
        setDispatchers(dispatchersData.data);
    
        // Apel pentru a obține datele utilizatorului curent
        const userData = await axios.get('https://api-backend.full-trucking-service.com/api/current-user', config);
        setCurrentUserId(userData.data.id);
        setCurrentUserRole(userData.data.role);
      } catch (error) {

      }
    };
    fetchData();
  }, []);
  const calculateDashboardData = (drivers = [], trucks = [], loads = [], iftaReports = []) => {
    const totalDrivers = Array.isArray(drivers) ? drivers.length : 0;
    const totalLoads = Array.isArray(loads) ? loads.length : 0;
    const totalMiles = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.miles || 0), 0)
      : 0;
    const totalDH = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.dh || 0), 0)
      : 0;
    const totalRevenue = Array.isArray(loads)
      ? loads.reduce((sum, load) => sum + parseFloat(load.rate || 0), 0)
      : 0;
  
    const totalIFTAFuelTax = Array.isArray(iftaReports)
      ? iftaReports.reduce((sum, report) => sum + parseFloat(report.totalFuelTax || 0), 0)
      : 0;
    const totalIFTAFuelCost = Array.isArray(iftaReports)
      ? iftaReports.reduce((sum, report) => sum + parseFloat(report.totalFuelCost || 0), 0)
      : 0;
  
    const upcomingLicenseExpirations = Array.isArray(drivers)
      ? drivers.filter(driver =>
          new Date(driver.licenseExpiryDate) < new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        ).length
      : 0;
  
    setDashboardData({
      totalDrivers,
      totalLoads,
      totalMiles,
      totalDH,
      totalRevenue,
      totalIFTAFuelTax,
      totalIFTAFuelCost,
      upcomingLicenseExpirations,
      loads, // Include loads data for later use
      drivers, // Include drivers data for later use
      iftaReports, // Include IFTA data for later use
    });
  };
  
  
  function handleImageUpload(event) {
    const file = event.target.files[0];
  
    if (!file) return;
  
    new Compressor(file, {
      quality: 0.6, // Nivel de compresie (0-1), 0.6 înseamnă 60% din calitatea originală
      maxWidth: 1000, // Lățimea maximă a imaginii (în funcție de nevoie)
      success(result) {
        // Trimite imaginea comprimata la server
        const formData = new FormData();
        formData.append('image', result);
  
        fetch('/api/logo', {
          method: 'PUT',
          body: formData,
        })
        .then(response => response.json())
        .then(data => {
      
        })
        .catch(error => {
       
        });
      },
      error(err) {
   
      },
    });
  }
  
  useEffect(() => {
    fetchData();
  }, []);
  const handleUpdateDriver = async (updatedDriver) => {
    try {
      const response = await axios.put(`${apiUrl}/drivers/${updatedDriver._id}`, updatedDriver, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
  
      if (!response || response.status !== 200) {
        throw new Error('Failed to update driver');
      }
  
      const updatedData = response.data;
      setDrivers((prevDrivers) =>
        prevDrivers.map((driver) => (driver._id === updatedDriver._id ? updatedData : driver))
      );
notify('Driver information has been updated successfully!' , 'succes');
    } catch (error) {

      notify('Failed to update driver' , 'error');
    }
  };
  
  const openSection = (section) => {
    setTimeout(() => {
      setActiveSection(section);
    }, 1000);
  };
  
  
   
  const closeSection = () => setActiveSection(null);
const handleLogout = async () => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com/api';

    // Trimite cererea de logout către backend (opțional)
    await axios.post(`${apiUrl}/logout`, {}, { withCredentials: true });

    // 🔥 Șterge TOT din localStorage și sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // Navighează utilizatorul înapoi la login
    navigate('/login');
  } catch (error) {
    notify('An error occurred while logging out. Please try again.', 'error');
  }
};


  const updateUserSettings = async (settings) => {
    setLoading(true); // Pornește animația
    
    const token = sessionStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };
  
    try {
      const response = await axios.put(`${apiUrl}/settings`, settings, config);
      setUserSettings(response.data.client);

     notify('Settings updated successfully!', 'success');
    } catch (error) {

      if (error.response && error.response.status === 401) {
notify('Unauthorized access. Please log in again.' , 'error');
        navigate('/login');
      }
    } finally {
      setLoading(false); // Oprește animația după finalizarea cererii
    }
  };
  
 

  const handleAddLoad = async (load) => {
    try {
        if (!load.loadNumber || !load.brokerName || !load.brokerAddress || !load.rate || !load.miles || !load.dh) {
           notify('Please fill in all required fields.' , 'error');
            return;
        }

        // Elimina virgula și convertește rate într-un număr
        const cleanedRate = parseFloat(load.rate.replace(/,/g, ''));
        
        const loadData = {
            ...load,
            rate: cleanedRate,  // Asigură-te că `rate` este un număr
            miles: parseFloat(load.miles), // Adaugă miles și convertește în număr
            dh: parseFloat(load.dh), // Adaugă dh și convertește în număr
        };

        const config = { headers: { 'Content-Type': 'application/json' }, withCredentials: true };
        const response = await axios.post(`${apiUrl}/loads`, loadData, config);

        setLoads([...loads, response.data]);
    } catch (error) {

    }
};

  
  
  
const handleAddDriverPay = async (driverPayData) => {
  try {
    const response = await axios.post('https://api-backend.full-trucking-service.com/api/driverpays', driverPayData, {
      withCredentials: true, // Dacă folosești autentificare
    });
 
  } catch (error) {

  }
};




return (
<div className={`${styles.ultimatePage} ${
  theme === 'light' ? styles.ultimatePageLight : ''
}`}>




    
    <header className={styles.headerultimatePage}>
      <div className={styles.logoultimatePage} onClick={() => navigate('')}>
        <span className={styles.logoPart1ultimatePage}>Full</span>{' '}
        <span className={styles.logoPart2ultimatePage}>Trucking</span>{' '}
        <span className={styles.logoPart1ultimatePage}>Service</span>
      </div>

 {/* 🔥 Icon hamburger */}
  <div className={styles.hamburgerUltimate} onClick={() => setIsMenuOpen(!isMenuOpen)}>
    ☰
  </div>

      
      <nav className={`${styles.navultimatePage} ${isMenuOpen ? styles.activeUltimate : ''}`}>
        <ul className={styles.mainMenuultimatePage}>
          {accessibleModules.includes('dashboard') && <li onClick={() => openSection('dashboard')}>Dashboard</li>}
          {accessibleModules.includes('accounting-manager') && (
            <li>
              Finance
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('accounting-manager')}>Accounting Manager</li>
                <li onClick={() => openSection('driver-pay')}>Driver Pay</li>
                <li onClick={() => openSection('driverpay-manager')}>Driver Pay Manager</li>
               <li onClick={() => openSection('fleet-report')}>Fleet Report</li>
                <li onClick={() => openSection('payroll-employee')}>Payroll</li> {/* ✅ Asta e cheia pentru PayrollEmployee */}
                <li onClick={() => openSection('payroll-manager')}>Payroll Manager</li>
                <li onClick={() => openSection('invoice')}>Invoice</li>
                <li onClick={() => openSection('receivedInvoices')}>Received Invoices</li>
                <li onClick={() => openSection('balanceSheet')}>Balance Sheet</li>
                <li onClick={() => openSection('ifta')}>IFTA Manual</li>
                <li onClick={() => openSection('fuel-report')}>Fuel Report</li>
                <li onClick={() => openSection('truckandtrailer')}>Additions and Deductions</li>
               
              </ul>
            </li>
          )}
          {accessibleModules.includes('drivers') && (
            <li>
              Operations
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('drivers')}>Drivers</li>
                <li onClick={() => openSection('trucks')}>Fleet</li>
                <li onClick={() => openSection('trailers')}>Trailers</li>
                <li onClick={() => openSection('shippers')}>Shippers</li>
                <li onClick={() => openSection('consignee')}>Consignees</li>
                <li onClick={() => openSection('brokers')}>Brokers</li>
                <li onClick={() => openSection('employees')}>Employees</li>
         
         
              </ul>
            </li>
          )}
          {accessibleModules.includes('load-manager') && (
            <li>
              Logistics
              <ul className={styles.subMenuultimatePage}>
                <li onClick={() => openSection('load-manager')}>Load Scheduler</li>
                <li onClick={() => openSection('load-finder')}>Load Tracker</li>
              </ul>
            </li>
          )}
 

          {accessibleModules.includes('settings') && <li onClick={() => openSection('settings')}>Settings</li>}
          {accessibleModules.includes('add-new-load') && (
            <li>
              <button className={styles.buttonultimatePage} onClick={() => openSection('add-new-load')}>
                Load Entry
              </button>
            </li>
          )}
          <li>
            <button className={styles.buttonultimatePage} onClick={handleLogout}>Logout</button>
          </li>
        </ul>
      </nav>
    </header>


{isInitialized && !hasTwoFactorAuth && (
  <TwoFactorNotification 
    hasTwoFactorAuth={hasTwoFactorAuth}
    onNavigateToSection={handleNavigateToSection}
  />)}

{isInitialized && (
  <LoadsNotifications
    initialDelay={10000} // Prima notificare la 10 secunde
    intervalDelay={2 * 60 * 1000} // Notificare la fiecare 2 minute
    hideAfter={5000}  
    resetDelay={24 * 60 * 60 * 1000} // Fără notificări repetate timp de 24h
    onNavigateToSection={(section, loadId) => {
      navigate(`/${section}/${loadId}`);
    }}
  />
)}

<DriversNotifications
  initialDelay={15000} // Prima notificare după 15 secunde
  intervalDelay={2 * 60 * 1000} // Notificare la fiecare 2 minute
  resetDelay={24 * 60 * 60 * 1000} // O notificare per șofer la fiecare 24 de ore
/>


    <main>
    {activeSection === 'dashboard' && (
    <Dashboard
      dashboardData={dashboardData}
      drivers={drivers}
      trucks={trucks}
      loads={loads}
      onNavigate={setActiveSection}
      shippers={shippers}
      brokers={brokers}
      consignees={consignees}
    />
  )}
 {activeSection === 'load-dashboard' && (
  <LoadsDashboard
    drivers={drivers}
    loads={loads}
    onNavigate={setActiveSection}
    shippers={shippers}
    consignees={consignees}
    trucks={trucks}
  />
)}
{activeSection === 'driver-dashboard' && (
  <DriverDashboard 
    drivers={drivers}
    loads={loads}
    trucks={trucks}
    onNavigate={setActiveSection}
  />
)}
{activeSection === 'truck-dashboard' && (  // ✅ Adăugat TruckDashboard
        <TruckDashboard 
            trucks={trucks}
            setTrucks={setTrucks}
            onNavigate={setActiveSection}
        />
    )}

      {activeSection === 'drivers' && <Drivers drivers={drivers} setDrivers={setDrivers} trucks={trucks} />}
      {activeSection === 'trucks' && <Trucks trucks={trucks} setTrucks={setTrucks} drivers={drivers} trailers={trailers} />}
      {activeSection === 'trailers' && <Trailers trailers={trailers} setTrailers={setTrailers} />}
      {activeSection === 'brokers' && <Brokers brokers={brokers} setBrokers={setBrokers} />}
      {activeSection === 'employees' && <Employees employees={employees} setEmployees={setEmployees} />}
      {activeSection === 'shippers' && <Shippers shippers={shippers} setShippers={setShippers} />}
      {activeSection === 'consignee' && <Consignees consignees={consignees} setConsignees={setConsignees} />}
      {activeSection === 'load-manager' && (
        <LoadManager
          loads={loads}
          setLoads={setLoads}
          selectedLoadId={selectedLoadId} // Transmitem loadId-ul selectat
        />
      )}
      {activeSection === 'invoice' && <Invoice
       loads={loads}
      setLoads={setLoads}
      settings={userSettings}
      drivers={drivers}
      trucks={trucks}
      brokers={brokers}
      shippers={shippers}
      consignees={consignees}
         />}
         {activeSection === 'receivedInvoices' && <ReceivedInvoices />}
      {activeSection === 'load-finder' && <LoadFinder loads={loads} />}
      {activeSection === 'accounting-manager' && <AccountingManager loads={loads} drivers={drivers} />}
      {activeSection === 'driver-pay' && <DriverPay drivers={drivers} trucks={trucks} loads={loads} onAddDriverPay={handleAddDriverPay} />}
      {activeSection === 'driverpay-manager' && <DriverPayManager drivers={drivers} trucks={trucks}  />}
      {activeSection === 'fleet-report' && <FleetReport drivers={drivers} trucks={trucks} loads={loads} />}
      {activeSection === 'payroll-employee' && <PayrollEmployee employees={employees} />}
      {activeSection === 'payroll-manager' && <PayrollManager employees={employees} />}
      {activeSection === 'fuel-report' && <FuelReport drivers={drivers} trucks={trucks} />}
     {activeSection === 'settings' && <Settings settings={userSettings} updateUserSettings={updateUserSettings} drivers={drivers} />}
      {activeSection === 'add-new-load' && <AddLoad
  onClose={closeSection}
  onAddLoad={handleAddLoad}
  drivers={drivers}
  trucks={trucks}
  trailers={trailers}
  brokers={brokers}
  shippers={shippers}
  consignees={consignees}

  dispatchers={dispatchers} // Asigură-te că `dispatchers` este definit în componenta principală
  currentUserId={currentUserId} // Obține `currentUserId` și `currentUserRole` din starea sau props
  currentUserRole={currentUserRole}
/>
}      {activeSection === 'ifta' && <IFTA />}
     
{activeSection === 'balanceSheet' && (
  <BalanceSheet/>
)}
{activeSection === 'truckandtrailer' && (
  <TruckAndTrailers />
)}
    </main>
  </div>
);
};

const DriverDashboard = ({ onNavigate }) => {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverDetails, setDriverDetails] = useState(null);
  const [loading, setLoading] = useState(false);
 const [isSidebarOpen, setIsSidebarOpen] = useState(false);
 const [userSettings, setUserSettings] = useState({});
   const [updatedSettings, setUpdatedSettings] = useState({});
const [theme, setTheme] = useState('dark');

 // pentru Add Widget modal
const [showAddModal, setShowAddModal] = useState(false);
const [charts, setCharts] = useState([]);
  const [timeRange, setTimeRange] = useState("month");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const [showMore, setShowMore] = useState(false);
const [showLoadsModal, setShowLoadsModal] = useState(false);
const [driverLoadsList, setDriverLoadsList] = useState([]);
const [totalDriverPay, setTotalDriverPay] = useState(0);
const [driverLoads, setDriverLoads] = useState({ completed: 0, open: 0 });
  const [rateEvolution, setRateEvolution] = useState({ labels: [], values: [] });
  const [fuelUsage, setFuelUsage] = useState(0);
  const [loads, setLoads] = useState([]);
const [avgLoadDistanceData, setAvgLoadDistanceData] = useState([]);
const [loadsPerWeekData, setLoadsPerWeekData] = useState([]);
const [revenueVsFuelData, setRevenueVsFuelData] = useState([]);
const [deadheadData, setDeadheadData] = useState([]);
const [topBrokersData, setTopBrokersData] = useState([]);
const [onTimeDeliveryData, setOnTimeDeliveryData] = useState([]);
const [earningsShareData, setEarningsShareData] = useState([]);
const [driverLoadsData, setDriverLoadsData] = useState([]);

// dacă ai nevoie de clientId (ex: pentru requests la backend)
const [clientId, setClientId] = useState(null);
const [revenueVsFuelTimeline, setRevenueVsFuelTimeline] = useState({
  labels: [],
  revenue: [],
  fuel: []
});

// dacă folosești KPI-uri
const [kpiData, setKpiData] = useState([]);

// charts (toate metricele într-un singur array)




const allChartOptions = [
  { key: "avgLoadDistance", label: "Average Load Distance" },
  { key: "loadsPerWeek", label: "Loads per Week" },
  { key: "revenueVsFuel", label: "Revenue vs Fuel Cost" },
  { key: "deadhead", label: "Deadhead %" },
  { key: "topBrokers", label: "Top Brokers" },
  { key: "onTimeDelivery", label: "On-Time Delivery %" },
  { key: "earningsShare", label: "Driver Earnings Share" }
];


const [centsPerMile, setCentsPerMile] = useState({ labels: [], values: [] });
const [earningsPerMile, setEarningsPerMile] = useState([]);
const [avgLoadDistance, setAvgLoadDistance] = useState([]);
  const [totalPay, setTotalPay] = useState(0);
  const [activeSection, setActiveSection] = useState('driver-dashboard');
 const [driverPays, setDriverPays] = useState({}); 

const [chartTypes, setChartTypes] = useState({
  loadStatus: "Pie",
  rateEvolution: "Line",
  fuelUsage: "Doughnut",
  totalPay: "Bar",
  driverPay: "Bar",           // pentru fiecare driver
  centsPerMile: "Bar",        // 👈 default CPM
  earningsPerMile: "Bar",     // 👈 default Earnings per Mile
  avgLoadDistance: "Bar",     // 👈 Average Load Distance
  loadsPerWeek: "Column",     // 👈 Loads per Week
  revenueVsFuel: "Line",      // 👈 Revenue vs Fuel Cost
  deadheadPercent: "Doughnut",// 👈 Deadhead %
  topBrokers: "Bar",          // 👈 Top Brokers
  onTimeDelivery: "Bar",      // 👈 On-Time Delivery %
  earningsShare: "Pie"        // 👈 Driver Earnings Share
});



  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = 'https://api-backend.full-trucking-service.com/api';

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || 'dark');
    } catch (err) {
      setTheme('dark');
    }
  };

  fetchTheme();
}, []);

  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };
  
 const downloadChartAsPDF = (chartId, chartTitle) => {
  const input = document.getElementById(chartId);
  if (!input) {
   
    return;
  }

  html2canvas(input).then(canvas => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    if (!chartTitle || typeof chartTitle !== "string") {
      chartTitle = "Chart Export";
    }

    pdf.text(chartTitle, 10, 10);
    pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
    pdf.save(`${chartTitle.replace(/\s+/g, "_")}.pdf`);
  }).catch(error => {
   
  });
};

const handleDownloadExcelDriverDashboard = () => {
  if (!driverDetails) return;

  const workbook = XLSX.utils.book_new();

  const completedLoadsRaw = (driverLoadsData || []).filter(
  load => load.status?.toLowerCase() === "completed"
);

const totalRateCompleted = completedLoadsRaw.reduce((sum, l) => sum + (l.rate || 0), 0);
const totalMilesCompleted = completedLoadsRaw.reduce((sum, l) => sum + (l.miles || 0), 0);

const completedLoads = completedLoadsRaw.map(load => ({
  "Load Number": load.loadNumber,
  "Status": load.status,
  "Rate": load.rate,
  "Miles": load.miles,
  "Total Rate": totalRateCompleted,
  "Total Miles": totalMilesCompleted,
  "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
  "Truck": load.truck?.plate || "N/A",
  "Completed At": new Date(load.updatedAt || load.date).toLocaleString(),
  "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
  "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
  "Notes": load.notes || ""
}));

  const wsCompleted = XLSX.utils.json_to_sheet(completedLoads);
  XLSX.utils.book_append_sheet(workbook, wsCompleted, "Completed Loads");

  // === Sheet 2: Open Loads ===
  const openLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
    "Truck": load.truck?.plate || "N/A",
    "Created At": new Date(load.createdAt).toLocaleString(),
    "Updated At": new Date(load.updatedAt).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsOpen = XLSX.utils.json_to_sheet(openLoads);
  XLSX.utils.book_append_sheet(workbook, wsOpen, "Open Loads");

const driverPayDetails = completedLoadsRaw.map(load => ({
  "Load Number": load.loadNumber,
  "Rate": load.rate || 0,
  "Miles": load.miles || 0,
  "Completed At": new Date(load.updatedAt || load.date).toLocaleString()
}));

driverPayDetails.push({
  "Load Number": "TOTAL",
  "Rate": totalRateCompleted,
  "Miles": totalMilesCompleted,
  "Completed At": "-"
});


  // totalul DriverPay (suma rate-urilor)
  const totalDriverPay = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  driverPayDetails.push({
    "Load Number": "TOTAL",
    "Rate": totalDriverPay,
    "Miles": completedLoads.reduce((sum, l) => sum + (l.miles || 0), 0),
    "Completed At": "-"
  });

  const wsDriverPay = XLSX.utils.json_to_sheet(driverPayDetails);
  XLSX.utils.book_append_sheet(workbook, wsDriverPay, "DriverPay");

  // === Sheet 4: Fuel Usage ===
  const fuelData = [{
    "Driver": `${driverDetails.firstName} ${driverDetails.lastName}`,
    "Fuel Usage": fuelUsage || 0,
    "Period": timeRange || "N/A",
  }];
  const wsFuel = XLSX.utils.json_to_sheet(fuelData);
  XLSX.utils.book_append_sheet(workbook, wsFuel, "Fuel");

  // === Sheet 5: Rate Evolution ===
  if (rateEvolution?.labels?.length) {
    const rateData = rateEvolution.labels.map((label, idx) => ({
      "Date": label,
      "Rate": rateEvolution.values[idx],
    }));
    const wsRate = XLSX.utils.json_to_sheet(rateData);
    XLSX.utils.book_append_sheet(workbook, wsRate, "Rate Evolution");
  }

  // === Salvare ===
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `DriverDashboard_${driverDetails.firstName}_${driverDetails.lastName}.xlsx`);
};


const handleDownloadPdfDriverDashboard = () => {
  if (!driverDetails) return;

  const doc = new jsPDF();
  const driverName = `${driverDetails.firstName} ${driverDetails.lastName}`;

  const completedLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() === "completed"
  );
  const openLoads = (driverLoadsData || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  );

  const totalDriverPay = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  // Titlu
  doc.setFontSize(18);
  doc.text(`Driver Dashboard Report: ${driverName}`, 14, 20);

  // Rezumat
  doc.setFontSize(12);
  doc.text(`${driverName} has ${completedLoads.length} Completed Loads and ${openLoads.length} Open Loads.`, 14, 30);
  doc.text(`Total DriverPay: $${totalDriverPay}`, 14, 38);
  doc.text(`Fuel Usage: ${fuelUsage || 0} L`, 14, 46);

  // === Completed Loads Table
  if (completedLoads.length > 0) {
    const completedData = completedLoads.map(load => [
      load.loadNumber,
      load.rate,
      load.miles,
      new Date(load.updatedAt || load.date).toLocaleDateString()
    ]);

    completedData.push([
      "TOTAL",
      totalDriverPay,
      completedLoads.reduce((s, l) => s + (l.miles || 0), 0),
      "-"
    ]);

    doc.autoTable({
      head: [["Completed Load #", "Rate", "Miles", "Completed At"]],
      body: completedData,
      startY: 60,
    });
  }

  // === Open Loads Table
  if (openLoads.length > 0) {
    const openData = openLoads.map(load => [
      load.loadNumber,
      load.status,
      load.rate,
      load.miles,
      new Date(load.createdAt).toLocaleDateString()
    ]);

    doc.autoTable({
      head: [["Open Load #", "Status", "Rate", "Miles", "Created At"]],
      body: openData,
      startY: doc.lastAutoTable.finalY + 10,
    });
  }

  doc.save(`DriverDashboard_${driverDetails.firstName}_${driverDetails.lastName}.pdf`);
};


  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/drivers`, config);
      setDrivers(response.data || []);
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedDriver) {
      fetchDriverDetails(selectedDriver._id);
    }
  }, [selectedDriver]);

  const fetchDriverDetails = async (driverId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/drivers/${driverId}`, config);
      setDriverDetails(response.data || {});
      fetchDriverStats(driverId);
    } catch (error) {
      
      setDriverDetails({});
    } finally {
      setLoading(false);
    }
  };

const handleShowLoads = async (driverId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment?driverId=${driverId}`,
      config
    );

    setDriverLoadsList(response.data || []);
    setShowLoadsModal(true);
  } catch (err) {
    console.error("Error fetching driver loads:", err);
    setDriverLoadsList([]);
    setShowLoadsModal(true);
  }
};


  useEffect(() => {
    if (selectedDriver) {
      fetchDriverStats(selectedDriver._id);
    }
  }, [selectedDriver, timeRange, customStartDate, customEndDate]);
  
const fetchDriverLoadStatusData = async (driverId) => {
  try {
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?driverId=${driverId}`,
      config
    );

    const filtered = (loadsResponse.data || []).filter(load => {
      // în DB câmpul e "driver", care poate fi fie un ObjectId simplu, fie un obiect populat
      const loadDriverId =
        load.driver?._id?.toString() || load.driver?.toString();

      return loadDriverId === driverId.toString();
    });

    console.log("DEBUG filtered loads for driver:", driverId, filtered);

    setDriverLoadsData(filtered);
  } catch (err) {
    console.error("Error fetching driver load status data:", err);
    setDriverLoadsData([]);
  }
};


useEffect(() => {
  if (selectedDriver?._id) {
    fetchDriverLoadStatusData(selectedDriver._id);
  }
}, [selectedDriver]);

const fetchDriverStats = async (driverId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // ✅ Loads DOAR pentru driverul selectat
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?driverId=${driverId}`,
      config
    );

    const loads = (loadsResponse.data || []).filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });
    
    // ✅ Earnings per Mile
    if (loads.length > 0) {
      const totalMiles = loads.reduce((acc, load) => acc + (Number(load.miles) || 0), 0);
      const totalEarnings = loads.reduce((acc, load) => acc + (Number(load.rate) || 0), 0);

      const earningsPerMile = totalMiles > 0 
        ? totalEarnings / totalMiles 
        : 0;

      setEarningsPerMile([{
        driver: selectedDriver.firstName + " " + selectedDriver.lastName,
        value: parseFloat(earningsPerMile.toFixed(2))
      }]);
    } else {
      setEarningsPerMile([]);
    }

    // ✅ calcule pentru Load Status
    setDriverLoads({
      complete: loads.filter(load => load.status?.toLowerCase() === "completed").length,
      canceled: loads.filter(load => load.status?.toLowerCase() === "canceled").length,
      open: loads.filter(load => !["completed", "canceled"].includes(load.status?.toLowerCase())).length,
    });

    // ✅ calcule pentru Rate Evolution
    const rateData = {};
    loads.forEach(load => {
      const date = new Date(load.date || load.createdAt);
      const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
      rateData[label] = (rateData[label] || 0) + (parseFloat(load.rate) || 0);
    });

    setRateEvolution({
      labels: Object.keys(rateData),
      values: Object.values(rateData)
    });

    // ✅ Average Load Distance
    const avgDistance = loads.length > 0
      ? loads.reduce((acc, load) => acc + (Number(load.miles) || 0), 0) / loads.length
      : 0;

    const driverLabel = selectedDriver
      ? [selectedDriver.firstName, selectedDriver.lastName].filter(Boolean).join(" ")
      : "Unknown";

    setAvgLoadDistance([{
      driver: driverLabel,
      value: parseFloat(avgDistance?.toFixed(2)) || 0
    }]);

    // ✅ Fuel Usage
    const fuelResponse = await axios.get(
      `https://api-backend.full-trucking-service.com/api/fuel-reports/driver/${driverId}`,
      config
    );

    const fuelReports = (fuelResponse.data || []).filter(report => {
      const reportDate = new Date(report.createdAt);
      return reportDate >= startDate && reportDate <= endDate;
    });

    setFuelUsage(
      fuelReports.reduce((acc, report) => acc + (parseFloat(report.grandTotal) || 0), 0)
    );

    // ✅ Payroll
    const payrollResponse = await axios.get(`${apiUrl}/totalpays?driverId=${driverId}`, config);
    const payrolls = (payrollResponse.data || []).filter(pay => {
      const payDate = new Date(pay.startDate);
      return payDate >= startDate && payDate <= endDate;
    });

    setTotalPay(
      payrolls.reduce((acc, pay) => acc + (parseFloat(pay.totalWithAdjustments) || 0), 0)
    );

const revenue = loads.reduce((acc, l) => acc + (Number(l.rate || l.totalRate || l.revenue || 0)), 0);
const fuelTotal = fuelReports.reduce((acc, r) => acc + (Number(r.grandTotal || r.totalCost || r.amount || 0)), 0);

console.log("DEBUG Revenue vs Fuel Cost:", { revenue, fuelTotal, loadsCount: loads.length, fuelCount: fuelReports.length });

setRevenueVsFuelData([
  { category: "Revenue", value: revenue },
  { category: "Fuel Cost", value: fuelTotal }
]);

// ✅ Deadhead %
const totalMiles = loads.reduce((acc, l) => acc + (Number(l.miles || l.distance || 0)), 0);
const totalDh = loads.reduce((acc, l) => acc + (Number(l.dh || l.deadheadMiles || l.emptyMiles || 0)), 0);

setDeadheadData([{
  driver: driverLabel,
  value: totalMiles > 0 ? (totalDh / totalMiles) * 100 : 0
}]);

// ✅ Top Brokers
const brokers = {};
loads.forEach(l => {
  const brokerName = l.broker?.name || l.brokerName || "Unknown";
  brokers[brokerName] = (brokers[brokerName] || 0) + (Number(l.rate || l.totalRate || 0));
});

setTopBrokersData(
  Object.entries(brokers).map(([broker, value]) => ({ broker, value }))
);

const cpmData = {};
loads.forEach(load => {
  const miles = Number(load.miles) || 0;
  const rate = Number(load.rate) || 0;
  if (miles > 0 && rate > 0) {
    const cpm = (rate / miles) * 100;

    const date = new Date(load.date || load.createdAt);
    const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });

    if (!cpmData[label]) cpmData[label] = [];
    cpmData[label].push(cpm);
  }
});

const labels = Object.keys(cpmData);
const values = labels.map(label => {
  const arr = cpmData[label];
  const avg = arr.reduce((a, b) => a + b, 0) / arr.length;
  return parseFloat(avg.toFixed(2));
});
// === Revenue vs Fuel timeline ===
const revenueFuelTimeline = {};
loads.forEach(load => {
  const date = new Date(load.date || load.createdAt);
  const label = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

  if (!revenueFuelTimeline[label]) {
    revenueFuelTimeline[label] = { revenue: 0, fuel: 0 };
  }
  revenueFuelTimeline[label].revenue += parseFloat(load.rate) || 0;
});

// Fuel timeline
fuelReports.forEach(report => {
  const date = new Date(report.createdAt);
  const label = date.toLocaleDateString("en-US", { month: "short", day: "numeric" });

  if (!revenueFuelTimeline[label]) {
    revenueFuelTimeline[label] = { revenue: 0, fuel: 0 };
  }
  revenueFuelTimeline[label].fuel += parseFloat(report.grandTotal) || 0;
});

// Salvăm timeline
setRevenueVsFuelTimeline({
  labels: Object.keys(revenueFuelTimeline),
  revenue: Object.values(revenueFuelTimeline).map(v => v.revenue),
  fuel: Object.values(revenueFuelTimeline).map(v => v.fuel),
});


setCentsPerMile({ labels, values });
  } catch (error) {
    console.error("Error fetching driver stats:", error);
  }
};

const fetchDriverPays = async () => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/driverpays?raw=1",
      config
    );

    const driverPayData = response.data || [];

    // grupăm după driverId
    const grouped = driverPayData.reduce((acc, dp) => {
      const id = dp.driverId;
      const amount = dp.totalWithAdjustments || dp.totalPay || 0;
      acc[id] = (acc[id] || 0) + amount;
      return acc;
    }, {});

    setDriverPays(grouped);
  } catch (err) {
    console.error("❌ Error fetching driver pays:", err);
    setDriverPays({});
  }
};

useEffect(() => {
  fetchDriverPays();
}, []);


const fetchAllLoads = async () => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/loads",
      config
    );
    setLoads(response.data || []);
  } catch (err) {
    console.error("❌ Error fetching all loads:", err);
    setLoads([]);
  }
};

useEffect(() => {
  fetchAllLoads();
}, []);


useEffect(() => {
  if (!loads || loads.length === 0 || !drivers || drivers.length === 0) return;

  const data = loads
    .filter(load => Number(load.miles) > 0 && Number(load.rate) > 0)
    .map(load => {
      const miles = Number(load.miles) || 0;
      const rate = Number(load.rate) || 0;
      const cpm = miles > 0 ? (rate / miles) * 100 : 0;

      // caut driver-ul după id
      const driverInfo = drivers.find(d => d._id === load.driverId);
      const driverName = driverInfo
        ? `${driverInfo.firstName} ${driverInfo.lastName}`
        : "Unknown";

      return {
        id: load._id,
        driver: driverName,
        value: parseFloat(cpm.toFixed(2))
      };
    });

  console.log("📊 Cents per Mile data (with drivers):", data);
  setCentsPerMile(data);
}, [loads, drivers]);

const handleAddWidget = async (metric) => {
  try {
    const payload = {
      clientId,
      type: "chart",
      metric, // ex: "averageLoadDistance"
      value: kpiData[metric] || [], // aici trebuie să mapezi valorile corecte
      chartType: "bar" // default, dar îl poți schimba pe viitor
    };

    const res = await axios.post(
      "https://api-backend.full-trucking-service.com/api/widgets",
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setCharts([...charts, res.data]);
    setShowAddModal(false);
  } catch (err) {
    console.error("❌ Error saving widget:", err);
  }
};
useEffect(() => {
  if (!loads || loads.length === 0) return;

  // === Average Load Distance ===
  const avgDistance = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!avgDistance[label]) avgDistance[label] = { total: 0, count: 0 };
    avgDistance[label].total += Number(l.miles) || 0;
    avgDistance[label].count++;
  });
  setAvgLoadDistanceData(
    Object.entries(avgDistance).map(([label, obj]) => ({
      period: label,
      value: obj.total / obj.count
    }))
  );

  // === Loads per Month ===
  const loadsByMonth = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!loadsByMonth[label]) loadsByMonth[label] = 0;
    loadsByMonth[label]++;
  });
  setLoadsPerWeekData(
    Object.entries(loadsByMonth).map(([period, count]) => ({ period, count }))
  );

  // === Revenue vs Fuel ===
  const revFuel = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!revFuel[label]) revFuel[label] = { revenue: 0, fuel: 0 };
    revFuel[label].revenue += Number(l.rate) || 0;
    revFuel[label].fuel += Number(l.fuelCost) || 0;
  });
  setRevenueVsFuelData(
    Object.entries(revFuel).map(([period, obj]) => ({
      period,
      revenue: obj.revenue,
      fuel: obj.fuel
    }))
  );

  // === Deadhead % ===
  const deadhead = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!deadhead[label]) deadhead[label] = { totalDead: 0, totalMiles: 0 };
    deadhead[label].totalDead += Number(l.deadheadMiles) || 0;
    deadhead[label].totalMiles += Number(l.miles) || 0;
  });
  setDeadheadData(
    Object.entries(deadhead).map(([period, obj]) => ({
      period,
      value: obj.totalMiles > 0 ? (obj.totalDead / obj.totalMiles) * 100 : 0
    }))
  );

  // === Top Brokers === (nu are legătură cu lunile, păstrăm grupare pe broker)
  const brokers = {};
  loads.forEach(l => {
    if (!l.broker?.name) return;
    if (!brokers[l.broker.name]) brokers[l.broker.name] = 0;
    brokers[l.broker.name] += Number(l.rate) || 0;
  });
  setTopBrokersData(
    Object.entries(brokers).map(([broker, value]) => ({ broker, value }))
  );

  // === On-Time Delivery % ===
  const onTime = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!onTime[label]) onTime[label] = { onTime: 0, total: 0 };
    onTime[label].onTime += Number(l.onTimeDeliveries) || 0;
    onTime[label].total += Number(l.totalDeliveries) || 0;
  });
  setOnTimeDeliveryData(
    Object.entries(onTime).map(([period, obj]) => ({
      period,
      value: obj.total > 0 ? (obj.onTime / obj.total) * 100 : 0
    }))
  );

  // === Earnings Share ===
  const earnings = {};
  loads.forEach(l => {
    const label = new Date(l.createdAt).toLocaleDateString("en-US", { month: "short", year: "numeric" });
    if (!earnings[label]) earnings[label] = 0;
    earnings[label] += Number(l.rate) || 0;
  });
  setEarningsShareData(
    Object.entries(earnings).map(([period, value]) => ({ period, value }))
  );

}, [loads]);


useEffect(() => {
  if (!loads || loads.length === 0) return;

  const dataByDriver = {};

  loads.forEach(load => {
    const driverName = load.driver?.firstName + " " + load.driver?.lastName || "Unknown";
    const miles = Number(load.miles) || 0;
    const rate = Number(load.rate) || 0;

    if (!dataByDriver[driverName]) {
      dataByDriver[driverName] = { totalMiles: 0, totalEarnings: 0 };
    }

    dataByDriver[driverName].totalMiles += miles;
    dataByDriver[driverName].totalEarnings += rate;
  });

  const formatted = Object.entries(dataByDriver).map(([driver, values]) => {
    const earningsPerMile = values.totalMiles > 0 
      ? values.totalEarnings / values.totalMiles 
      : 0;
    return { driver, value: parseFloat(earningsPerMile.toFixed(2)) };
  });

  console.log("💰 Earnings per Mile data:", formatted);
  setEarningsPerMile(formatted);
}, [loads]);

useEffect(() => {
  const savedCharts = localStorage.getItem("driverDashboardCharts");
  if (savedCharts) {
    setCharts(JSON.parse(savedCharts));
  }
}, []);

const getDriverOpenLoadStatus = (driverDetails) => {
  if (!driverDetails) return "";

  const safeLoads = Array.isArray(driverLoadsData) ? driverLoadsData : [];
  const driverName = `${driverDetails.firstName || ""} ${driverDetails.lastName || ""}`.trim();

  // ✅ Open loads pentru acest șofer
  const openLoads = safeLoads.filter(
    load => !["completed", "canceled"].includes(load.status?.toLowerCase())
  );

  if (openLoads.length > 0) {
    const openLoad = openLoads[0];
    const openedAt = new Date(openLoad.date || openLoad.createdAt);
    const diffDays = Math.floor((Date.now() - openedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Driver ${driverName} has an Open Load (#${openLoad.loadNumber || openLoad._id}) open for ${diffDays} days.`;
  } else if (safeLoads.length > 0) {
    const sorted = [...safeLoads].sort(
      (a, b) => new Date(b.date || b.updatedAt || b.createdAt) - new Date(a.date || a.updatedAt || a.createdAt)
    );
    const lastLoad = sorted[0];
    const closedAt = new Date(lastLoad.date || lastLoad.updatedAt || lastLoad.createdAt);
    const diffDays = Math.floor((Date.now() - closedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Driver ${driverName} has not done a load for ${diffDays} days. Last load was (#${lastLoad.loadNumber || lastLoad._id}) on ${closedAt.toLocaleDateString("en-US")}.`;
  } else {
    return `Driver ${driverName} has no load history.`;
  }
};


  return (
<div
  className={`${styles.driverdashboard} ${
    theme === 'light' ? styles.driverdashboardLight : ''
  }`}
>


      {/* Side Menu */}
      <div className={styles.sidebarToggleDriver} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebardriverdashboard} ${isSidebarOpen ? styles.sidebarOpenDriver : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>



      {/* ✅ Lista șoferilor */}
      <div className={styles.mainContentdriverdashboard}>
        <h2 className={styles.titledriverdashboard}>Driver Dashboard</h2>

        <input type="text" placeholder="Search..." className={styles.searchBardriverdashboard} />

        {loading ? (
          <p>Loading...</p>
        ) : !selectedDriver ? (
          <table className={styles.tabledriverdashboard}>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Truck</th>
                <th>Email</th>
                <th>Phone</th>
                <th>View Details</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((driver) => (
                <tr key={driver._id}>
                  <td>{driver.firstName || "No data"}</td>
                  <td>{driver.lastName || "No data"}</td>
                  <td>{driver.truckNumber || "No data"}</td>
                  <td>{driver.email || "No data"}</td>
                  <td>{driver.phone || "No data"}</td>
                  <td>
                    <button onClick={() => setSelectedDriver(driver)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            <button className={styles.backButtondriverdashboard} onClick={() => setSelectedDriver(null)}>⬅ Back to Drivers</button>

{driverDetails ? (
  <div className={styles.detailsSectiondriverdashboard}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h3>
        Driver: {driverDetails.firstName} {driverDetails.lastName}
      </h3>
      <button 
        className={styles.seeLoadsButton} 
        onClick={() => handleShowLoads(driverDetails._id)}
      >
        See the Loads
      </button>
    </div>

    {/* Toggle details */}
    {!showMore ? (
      <button 
        className={styles.seeMoreButton} 
        onClick={() => setShowMore(true)}
      >
        See more about {driverDetails.firstName}
      </button>
    ) : (
      <>
        <div className={styles.driverExtraDetails}>
          <p><strong>Email:</strong> {driverDetails.email || "N/A"}</p>
          <p><strong>Phone:</strong> {driverDetails.phone || "N/A"}</p>
          <p><strong>Address:</strong> {driverDetails.address || "N/A"}</p>
          <p><strong>Truck:</strong> {driverDetails.truckNumber || "N/A"}</p>
          <p><strong>License Number:</strong> {driverDetails.licenseNumber || "N/A"}</p>
          <p><strong>License Expiry Date:</strong> {driverDetails.licenseExpiryDate || "N/A"}</p>
          <p><strong>Last Drug Test:</strong> {driverDetails.lastDrugTestDate || "N/A"}</p>
          <p><strong>Hire Date:</strong> {driverDetails.hireDate || "N/A"}</p>
          <p><strong>Termination Date:</strong> {driverDetails.terminationDate || "N/A"}</p>
          <p><strong>Settlement:</strong> {driverDetails.settlement || "N/A"}</p>
          <p><strong>Birthday:</strong> {driverDetails.dateOfBirth || "N/A"}</p>
          <p><strong>License Type:</strong> {driverDetails.licenseType || "N/A"}</p>
          <p><strong>License State:</strong> {driverDetails.licenseState || "N/A"}</p>
          <p><strong>Last Medical:</strong> {driverDetails.lastMedical || "N/A"}</p>
          <p><strong>Next Medical:</strong> {driverDetails.nextMedical || "N/A"}</p>
          <p><strong>Last Alcohol Test:</strong> {driverDetails.lastAlcoholTest || "N/A"}</p>
          <p><strong>Fuel Card Number:</strong> {driverDetails.fuelCardNumber || "N/A"}</p>
          <p><strong>Fuel Card Expires:</strong> {driverDetails.fuelCardExpires || "N/A"}</p>
          <p><strong>Fleet Division:</strong> {driverDetails.fleetDivision || "N/A"}</p>
        </div>

        <button 
          className={styles.hideMoreDriverButton} 
          onClick={() => setShowMore(false)}
        >
          Hide details
        </button>
      </>
    )}
  </div>
) : (
  <p>No details available.</p>
)}
<div className={styles.driverLoadStatusBox}>
  {driverDetails ? (
    <p>{getDriverOpenLoadStatus(driverDetails, loads || [])}</p>
  ) : (
    <p>No driver selected.</p>
  )}
</div>

{showLoadsModal && (
  <div className={styles.DriverDashboardLoadOverlay}>
    <div className={styles.DriverDashboardLoadModal}>
      <button 
        className={styles.DriverDashboardLoadClose} 
        onClick={() => setShowLoadsModal(false)}
      >
        ✕
      </button>

      <h3 className={styles.DriverDashboardLoadTitle}>
        Loads for {driverDetails.firstName} {driverDetails.lastName}
      </h3>

      {driverLoadsList.length > 0 ? (
        <div className={styles.DriverDashboardLoadWrapper}>
          <table className={styles.DriverDashboardLoadTable}>
            <thead>
              <tr>
                <th>Load #</th>
                <th>Status</th>
                <th>Rate</th>
                <th>Miles</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {driverLoadsList.map(load => (
                <tr key={load._id}>
                  <td>{load.loadNumber || "-"}</td>
                  <td>
<span
  className={
    ["completed", "complete"].includes(load.status?.toLowerCase())
      ? styles.DriverDashboardStatusComplete
      : load.status?.toLowerCase() === "canceled"
      ? styles.DriverDashboardStatusCanceled
      : styles.DriverDashboardStatusOpen
  }
>
  {["completed", "complete"].includes(load.status?.toLowerCase())
    ? "Completed"
    : load.status?.toLowerCase() === "canceled"
    ? "Canceled"
    : "Open"}
</span>



                  </td>
                  <td>${load.rate || "-"}</td>
                  <td>{load.miles || "-"}</td>
                  <td>{new Date(load.date || load.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className={styles.DriverDashboardNoLoads}>No loads found for this driver.</p>
      )}
    </div>
  </div>
)}


{showAddModal && (
  <div className={styles.ModalDriverDashboardOverlay}>
    <div className={styles.ModalDriverDashboardContent}>
      <div className={styles.ModalDriverDashboardHeader}>
        <h3>Select Widgets</h3>
        <button 
          className={styles.ModalDriverDashboardClose} 
          onClick={() => setShowAddModal(false)}
        >
          ✖
        </button>
      </div>

      <div className={styles.ModalDriverDashboardOptions}>
        {allChartOptions.map(opt => (
          <label 
            key={opt.key} 
            className={styles.ModalDriverDashboardOption}
          >
            <input
              type="checkbox"
              checked={charts.includes(opt.key)}
              onChange={e => {
                if (e.target.checked) {
                  setCharts([...charts, opt.key]);
                } else {
                  setCharts(charts.filter(c => c !== opt.key));
                }
              }}
            />
            {opt.label}
          </label>
        ))}
      </div>

   <button 
  className={styles.ModalDriverDashboardDone}
  onClick={() => {
    localStorage.setItem("driverDashboardCharts", JSON.stringify(charts)); // salvează
    setShowAddModal(false);
  }}
>
  Done
</button>
    </div>
  </div>
)}
<div style={{ display: "flex", gap: "10px" }}>
  <button 
    onClick={handleDownloadExcelDriverDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#22c55e", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download Excel Driver Dashboard
  </button>
  <button 
    onClick={handleDownloadPdfDriverDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download PDF Driver Dashboard
  </button>
</div>

<div className={styles.chartControlsdriverdashboard}>
            <label>Time Range:</label>
            <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
              <option value="day">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>

            {timeRange === "custom" && (
              <div>
                <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
                <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
              </div>
            )}
          </div>
<button 
  className={styles.addWidgetButton} 
  onClick={() => setShowAddModal(true)}
>
  + Add New Widget
</button>
<div className={styles.chartsGrid}>
  {/* === Average Load Distance === */}
{charts.includes("avgLoadDistance") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Average Load Distance</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="avgLoadDistance"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.avgLoadDistance === "Bar" && (
        <Bar
          data={{
            labels: avgLoadDistanceData.map(d => d.period),   // <<--- lunile
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),   // <<--- valorile
              backgroundColor: "#3b82f6",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.avgLoadDistance === "Column" && (
        <Bar
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.avgLoadDistance === "Line" && (
        <Line
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              label: "Average Miles",
              data: avgLoadDistanceData.map(d => d.value),
              borderColor: "#3b82f6",
              backgroundColor: "rgba(59,130,246,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.avgLoadDistance === "Pie" && (
        <Pie
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.avgLoadDistance === "Doughnut" && (
        <Doughnut
          data={{
            labels: avgLoadDistanceData.map(d => d.period),
            datasets: [{
              data: avgLoadDistanceData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.avgLoadDistance === "Gauge" && (
        <GaugeChart 
          id="avgLoadGauge"
          nrOfLevels={20}
          percent={avgLoadDistanceData.length ? avgLoadDistanceData[0].value / 1000 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Loads per Week === */}
{charts.includes("loadsPerWeek") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Loads per Week</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="loadsPerWeek"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.loadsPerWeek === "Bar" && (
        <Bar
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.loadsPerWeek === "Column" && (
        <Bar
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: "#3b82f6",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.loadsPerWeek === "Line" && (
        <Line
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              label: "Loads",
              data: loadsPerWeekData.map(d => d.count),
              borderColor: "#22c55e",
              backgroundColor: "rgba(34,197,94,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.loadsPerWeek === "Pie" && (
        <Pie
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.loadsPerWeek === "Doughnut" && (
        <Doughnut
          data={{
            labels: loadsPerWeekData.map(d => d.period),
            datasets: [{
              data: loadsPerWeekData.map(d => d.count),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.loadsPerWeek === "Gauge" && (
        <GaugeChart 
          id="loadsPerWeekGauge"
          nrOfLevels={20}
          percent={loadsPerWeekData.length ? loadsPerWeekData[0].count / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Revenue vs Fuel Cost === */}
{charts.includes("revenueVsFuel") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Revenue vs Fuel Cost</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="revenueVsFuel"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === COLUMN === */}
      {chartTypes.revenueVsFuel === "Column" && (
        <Bar
          data={{
            labels: revenueVsFuelData.map(d => d.category),   // <-- aici category
            datasets: [{
              label: "Amount",
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],        // revenue = albastru, fuel = roșu
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === BAR === */}
      {chartTypes.revenueVsFuel === "Bar" && (
        <Bar
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              label: "Amount",
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

{/* === LINE (pe timp) === */}
{chartTypes.revenueVsFuel === "Line" && (
  <Line
    data={{
      labels: revenueVsFuelTimeline.labels,
      datasets: [
        {
          label: "Revenue",
          data: revenueVsFuelTimeline.revenue,
          borderColor: "#22c55e",
          backgroundColor: "rgba(34,197,94,0.3)",
          fill: false,
          tension: 0.4,
        },
        {
          label: "Fuel Cost",
          data: revenueVsFuelTimeline.fuel,
          borderColor: "#ef4444",
          backgroundColor: "rgba(239,68,68,0.3)",
          fill: false,
          tension: 0.4,
        }
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          title: { display: true, text: "Time" }
        },
        y: {
          title: { display: true, text: "Amount ($)" }
        }
      }
    }}
  />
)}


      {/* === PIE === */}
      {chartTypes.revenueVsFuel === "Pie" && (
        <Pie
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.revenueVsFuel === "Doughnut" && (
        <Doughnut
          data={{
            labels: revenueVsFuelData.map(d => d.category),
            datasets: [{
              data: revenueVsFuelData.map(d => d.value),
              backgroundColor: ["#3b82f6", "#ef4444"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.revenueVsFuel === "Gauge" && (
        <GaugeChart
          id="revenueVsFuelGauge"
          nrOfLevels={20}
          percent={revenueVsFuelData.length ? revenueVsFuelData[0].value / (revenueVsFuelData[0].value + revenueVsFuelData[1].value) : 0}
          colors={["#ef4444", "#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Deadhead % === */}
{charts.includes("deadhead") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Deadhead %</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="deadhead"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.deadhead === "Bar" && (
        <Bar
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.deadhead === "Column" && (
        <Bar
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.deadhead === "Line" && (
        <Line
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              label: "Deadhead %",
              data: deadheadData.map(d => d.value),
              borderColor: "#f59e0b",
              backgroundColor: "rgba(245,158,11,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.deadhead === "Pie" && (
        <Pie
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              data: deadheadData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.deadhead === "Doughnut" && (
        <Doughnut
          data={{
            labels: deadheadData.map((_, i) => `Load ${i+1}`),
            datasets: [{
              data: deadheadData.map(d => d.value),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.deadhead === "Gauge" && (
        <GaugeChart 
          id="deadheadGauge"
          nrOfLevels={20}
          percent={deadheadData.length ? deadheadData[0].value / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === On-Time Delivery % === */}
{charts.includes("onTimeDelivery") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>On-Time Delivery %</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="onTimeDelivery"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.onTimeDelivery === "Bar" && (
        <Bar
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.onTimeDelivery === "Column" && (
        <Bar
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: "#22c55e",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.onTimeDelivery === "Line" && (
        <Line
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              label: "On-Time %",
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              borderColor: "#22c55e",
              backgroundColor: "rgba(34,197,94,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.onTimeDelivery === "Pie" && (
        <Pie
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.onTimeDelivery === "Doughnut" && (
        <Doughnut
          data={{
            labels: onTimeDeliveryData.map(d => d.driver || ""),
            datasets: [{
              data: onTimeDeliveryData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.onTimeDelivery === "Gauge" && (
        <GaugeChart 
          id="onTimeDeliveryGauge"
          nrOfLevels={20}
          percent={onTimeDeliveryData.length ? (onTimeDeliveryData[0].value ?? 0) / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Driver Earnings Share === */}
{charts.includes("earningsShare") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Driver Earnings Share</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="earningsShare"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.earningsShare === "Bar" && (
        <Bar
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.earningsShare === "Column" && (
        <Bar
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: "#f59e0b",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.earningsShare === "Line" && (
        <Line
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              label: "Earnings",
              data: earningsShareData.map(d => d.value ?? 0),
              borderColor: "#f59e0b",
              backgroundColor: "rgba(245,158,11,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.earningsShare === "Pie" && (
        <Pie
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.earningsShare === "Doughnut" && (
        <Doughnut
          data={{
            labels: earningsShareData.map(d => d.driver || ""),
            datasets: [{
              data: earningsShareData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.earningsShare === "Gauge" && (
        <GaugeChart 
          id="earningsShareGauge"
          nrOfLevels={20}
          percent={earningsShareData.length ? (earningsShareData[0].value ?? 0) / 10000 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}

{/* === Top Brokers === */}
{charts.includes("topBrokers") && (
  <div className={styles.chartContainerdriverdashboard}>
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>Top Brokers</h4>
      <div className={styles.chartMenuWrapper}>
        <ChartMenu
          chartKey="topBrokers"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
    </div>

    <div className={styles.chartContentdriverdashboard}>
      {/* === BAR (orizontal) === */}
      {chartTypes.topBrokers === "Bar" && (
        <Bar
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: "#6366f1",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* === COLUMN (vertical) === */}
      {chartTypes.topBrokers === "Column" && (
        <Bar
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: "#6366f1",
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "x" }}
        />
      )}

      {/* === LINE === */}
      {chartTypes.topBrokers === "Line" && (
        <Line
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              label: "Loads",
              data: topBrokersData.map(d => d.value ?? 0),
              borderColor: "#6366f1",
              backgroundColor: "rgba(99,102,241,0.3)",
              tension: 0.4,
              fill: true,
            }],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* === PIE === */}
      {chartTypes.topBrokers === "Pie" && (
        <Pie
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chartTypes.topBrokers === "Doughnut" && (
        <Doughnut
          data={{
            labels: topBrokersData.map(d => d.broker || ""),
            datasets: [{
              data: topBrokersData.map(d => d.value ?? 0),
              backgroundColor: ["#3b82f6","#22c55e","#f59e0b","#ef4444","#6366f1"],
            }],
          }}
        />
      )}

      {/* === GAUGE === */}
      {chartTypes.topBrokers === "Gauge" && (
        <GaugeChart 
          id="topBrokersGauge"
          nrOfLevels={20}
          percent={topBrokersData.length ? (topBrokersData[0].value ?? 0) / 100 : 0}
          colors={["#ef4444","#22c55e"]}
        />
      )}
    </div>
  </div>
)}
</div>

<div className={styles.chartsGrid}>
  {/* 📊 Load Status */}
<div className={styles.chartContainerdriverdashboard} id="loadStatus">
  <div className={styles.chartHeaderdriverdashboard}>
  <h4>Load Status Comparison</h4>
  <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="loadStatus"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>


  <div className={styles.chartContentdriverdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Bar Chart */}
    {chartTypes.loadStatus === "Bar" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Graph */}
    {chartTypes.loadStatus === "Line" && (
      <Line
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status Over Time",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.loadStatus === "Pie" && (
      <Pie
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

  {/* ✅ Gauge Chart */}
  {chartTypes.loadStatus === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Complete Loads", "Remaining Loads"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled + driverLoads.open],
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.loadStatus === "Column" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.loadStatus === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [driverLoads.complete, driverLoads.canceled, driverLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>


     {/* 📊 Rate Evolution */}
<div className={styles.chartContainerdriverdashboard} id="rateEvolution">
<div className={styles.chartHeaderdriverdashboard}>
  <h4>Rate Evolution Over Time</h4>
  <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="rateEvolution"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>

  <div className={styles.chartContentdriverdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>

    {/* ✅ Line Graph */}
    {chartTypes.rateEvolution === "Line" && (
      <Line
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  
    {/* ✅ Gauge Chart */}
    {chartTypes.rateEvolution === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Revenue Generated", "Remaining Target"],
          datasets: [{
            data: [rateEvolution.values.reduce((acc, val) => acc + val, 0), Math.max(100000 - rateEvolution.values.reduce((acc, val) => acc + val, 0), 0)], // Exemplu: 100.000 ca obiectiv
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
    {/* ✅ Bar Chart */}
    {chartTypes.rateEvolution === "Bar" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.rateEvolution === "Column" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.rateEvolution === "Pie" && (
      <Pie
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.rateEvolution === "Doughnut" && (
      <Doughnut
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>

{/* 💰 Earnings per Mile */}
<div className={styles.chartContainerdriverdashboard} id="earningsPerMile">
  <div className={styles.chartHeaderdriverdashboard}>
    <h4>Earnings per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="earningsPerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContentdriverdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.earningsPerMile === "Bar" && (
      <Bar
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.earningsPerMile === "Column" && (
      <Bar
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: "y", // face coloanele orizontale
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.earningsPerMile === "Line" && (
      <Line
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            label: "Earnings per Mile ($)",
            data: earningsPerMile.map(e => e.value),
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.3)",
            tension: 0.4,
            fill: true,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.earningsPerMile === "Pie" && (
      <Pie
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            data: earningsPerMile.map(e => e.value),
            backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.earningsPerMile === "Doughnut" && (
      <Doughnut
        data={{
          labels: earningsPerMile.map(e => e.driver),
          datasets: [{
            data: earningsPerMile.map(e => e.value),
            backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

{/* ✅ Gauge (semicircle) */}
{chartTypes.earningsPerMile === "Gauge" && (
  <Doughnut
    data={{
      labels: ["Avg Earnings/Mile", "Remaining to $3.00"],
      datasets: [{
        data: [
          earningsPerMile.reduce((a, e) => a + e.value, 0) / (earningsPerMile.length || 1),
          3 - (earningsPerMile.reduce((a, e) => a + e.value, 0) / (earningsPerMile.length || 1))
        ],
        backgroundColor: ["#3b82f6", "#e0e0e0"],
        borderWidth: 0,
      }],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      circumference: 180,
      rotation: -90,
      cutout: "75%",
      plugins: {
        legend: { display: false },
      },
    }}
  />
)}

  </div>
</div>



{/* 📊 Cents per Mile */}
<div className={styles.chartContainerdriverdashboard} id="centsPerMile">
  <div className={styles.chartHeaderdriverdashboard}>
    <h4>Cents per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="centsPerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContentdriverdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.centsPerMile === "Bar" && (
      <Bar
        data={{
          labels: centsPerMile.labels, // lunile/ziua
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values, // valorile CPM
            backgroundColor: "#22c55e",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.centsPerMile === "Column" && (
      <Bar
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values,
            backgroundColor: "#22c55e",
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: "y",
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.centsPerMile === "Line" && (
      <Line
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            label: "Cents per Mile",
            data: centsPerMile.values,
            borderColor: "#22c55e",
            backgroundColor: "rgba(34,197,94,0.3)",
            tension: 0.4,
            fill: true,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.centsPerMile === "Pie" && (
      <Pie
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            data: centsPerMile.values,
            backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.centsPerMile === "Doughnut" && (
      <Doughnut
        data={{
          labels: centsPerMile.labels,
          datasets: [{
            data: centsPerMile.values,
            backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Gauge (semicircle) */}
    {chartTypes.centsPerMile === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Avg CPM", "Remaining to 300 CPM"],
          datasets: [{
            data: [
              centsPerMile.values.reduce((a, v) => a + v, 0) / (centsPerMile.values.length || 1),
              300 - (centsPerMile.values.reduce((a, v) => a + v, 0) / (centsPerMile.values.length || 1))
            ],
            backgroundColor: ["#22c55e", "#e0e0e0"],
            borderWidth: 0,
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180,
          rotation: -90,
          cutout: "75%",
          plugins: {
            legend: { display: false },
          },
        }}
      />
    )}
  </div>
</div>
{/* 📊 Fuel Usage */}
<div className={styles.chartContainerdriverdashboard} id="fuelUsage">
<div className={styles.chartHeaderdriverdashboard}>
  <h4>Fuel Usage</h4>
  <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="fuelUsage"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>

  <div className={styles.chartContentdriverdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Doughnut Chart */}
    {chartTypes.fuelUsage === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Bar Chart */}
    {chartTypes.fuelUsage === "Bar" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.fuelUsage === "Column" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.fuelUsage === "Pie" && (
      <Pie
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

     {/* ✅ Gauge Chart */}
     {chartTypes.fuelUsage === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Fuel Used", "Remaining"],
          datasets: [{
            data: [fuelUsage, Math.max(10000 - fuelUsage, 0)], // Exemplu: 10.000 este limita maximă
            backgroundColor: ["#3b82f6", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.fuelUsage === "Line" && (
      <Line
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Fuel ($)",
            data: [fuelUsage],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>
{/* 📊 DriverPay pentru driverul selectat */}
{selectedDriver && (
  <div className={styles.chartContainerdriverdashboard} id="driverPay">
    <div className={styles.chartHeaderdriverdashboard}>
      <h4>
        DriverPay – {selectedDriver.firstName} {selectedDriver.lastName}
      </h4>
      <ChartMenu
        chartKey="driverPay"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div
      className={styles.chartContentdriverdashboard}
      style={{
        width: "600px",
        height: "350px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* ✅ Bar */}
      {chartTypes.driverPay === "Bar" && (
        <Bar
          data={{
            labels: ["DriverPay"],
            datasets: [
              {
                label: "Total ($)",
                data: [driverPays[selectedDriver._id] || 0],
                backgroundColor: "green",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Column */}
      {chartTypes.driverPay === "Column" && (
        <Bar
          data={{
            labels: ["DriverPay"],
            datasets: [
              {
                label: "Total ($)",
                data: [driverPays[selectedDriver._id] || 0],
                backgroundColor: "green",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: "y",
          }}
        />
      )}

      {/* ✅ Pie */}
      {chartTypes.driverPay === "Pie" && (
        <Pie
          data={{
            labels: ["DriverPay"],
            datasets: [
              {
                data: [driverPays[selectedDriver._id] || 0],
                backgroundColor: ["green"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Doughnut */}
      {chartTypes.driverPay === "Doughnut" && (
        <Doughnut
          data={{
            labels: ["DriverPay"],
            datasets: [
              {
                data: [driverPays[selectedDriver._id] || 0],
                backgroundColor: ["green"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Gauge */}
      {chartTypes.driverPay === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Total Earned", "Remaining to Goal"],
            datasets: [
              {
                data: [
                  driverPays[selectedDriver._id] || 0,
                  Math.max(100000 - (driverPays[selectedDriver._id] || 0), 0),
                ],
                backgroundColor: ["green", "#e0e0e0"],
                borderWidth: 0,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "75%",
            plugins: {
              legend: { display: false },
              tooltip: { enabled: true },
            },
          }}
        />
      )}

      {/* ✅ Line */}
      {chartTypes.driverPay === "Line" && (
        <Line
          data={{
            labels: ["DriverPay"],
            datasets: [
              {
                label: "Total ($)",
                data: [driverPays[selectedDriver._id] || 0],
                borderColor: "green",
                backgroundColor: "rgba(46, 204, 113, 0.2)",
                tension: 0.4,
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}
    </div>
  </div>
  
  
)}
</div>


{/* === Google Map - doar pentru driverul selectat === */}
<h4>Map Overview</h4>
{driverDetails && driverDetails.location && driverDetails.location.latitude && driverDetails.location.longitude ? (
  
    <GoogleMap
      mapContainerStyle={{ height: "400px", width: "100%" }}
      center={{
        lat: parseFloat(driverDetails.location.latitude),
        lng: parseFloat(driverDetails.location.longitude),
      }}
      zoom={8} // zoom mai aproape de șofer
    >
      <Marker
        position={{
          lat: parseFloat(driverDetails.location.latitude),
          lng: parseFloat(driverDetails.location.longitude),
        }}
        label={{
          text: `${driverDetails.firstName} ${driverDetails.lastName}`,
          fontSize: "12px",
          fontWeight: "bold",
        }}
      />
    </GoogleMap>

) : (
  <p>No location available for the selected driver.</p>
)}


        </>
      )}
    </div>
  </div>
);
};

const TruckDashboard = ({ onNavigate }) => {
  const [trucks, setTrucks] = useState([]);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [truckDetails, setTruckDetails] = useState(null);
  const [loading, setLoading] = useState(false);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [showLoadsModal, setShowLoadsModal] = useState(false);
const [truckLoadsList, setTruckLoadsList] = useState([]);
const [showMore, setShowMore] = useState(false);
const [truckDriverPays, setTruckDriverPays] = useState([]);
const [truckRevenue, setTruckRevenue] = useState([]);
const [truckCosts, setTruckCosts] = useState({});
const [loads, setLoads] = useState([]);

  const [timeRange, setTimeRange] = useState("month");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const [truckLoads, setTruckLoads] = useState({ complete: 0, canceled: 0, open: 0 });
  const [rateEvolution, setRateEvolution] = useState({ labels: [], values: [] });
  const [fuelUsage, setFuelUsage] = useState(0);
const allTruckChartOptions = [
  { key: "payrollPerMile", label: "Payroll per Mile" },
  { key: "profitLoss", label: "Profit / Loss" },
  { key: "avgRatePerLoad", label: "Average Rate per Load" },
];
const [charts, setCharts] = useState(() => {
  const saved = localStorage.getItem("truckDashboardCharts");
  return saved ? JSON.parse(saved) : [];
});
const [showAddModal, setShowAddModal] = useState(false);
const [theme, setTheme] = useState('dark');

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const apiUrl = 'https://api-backend.full-trucking-service.com/api';

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || 'dark');
    } catch (err) {
      setTheme('dark');
    }
  };

  fetchTheme();
}, []);


const [chartTypes, setChartTypes] = useState({
  loadStatus: "Pie",
  rateEvolution: "Line",
  fuelUsage: "Doughnut",
  totalDriverPay: "Bar",
  truckCosts: "Bar",  
  ratePerMile: "Bar",

  // 👇 noile charturi
  payrollPerMile: "Bar",
  profitLoss: "Bar",
  avgRatePerLoad: "Line",
});


  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
    fetchTrucks();
  }, []);

useEffect(() => {
  const fetchTruckLoads = async () => {
    if (!selectedTruck?._id) return;
    try {
      const res = await axios.get(
        `${apiUrl}/loads/by-assignment?truckId=${selectedTruck._id}`,
        config
      );
      setTruckLoadsList(res.data || []);
    } catch (err) {
      console.error("❌ Error fetching truck loads:", err);
    }
  };
  fetchTruckLoads();
}, [selectedTruck]);


  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };
  
 const downloadChartAsPDF = (chartId, chartTitle) => {
  const input = document.getElementById(chartId);
  if (!input) {

    return;
  }

  html2canvas(input).then(canvas => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    if (!chartTitle || typeof chartTitle !== "string") {
      chartTitle = "Chart Export";
    }

    pdf.text(chartTitle, 10, 10);
    pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
    pdf.save(`${chartTitle.replace(/\s+/g, "_")}.pdf`);
  }).catch(error => {
 
  });
};

const fetchLoads = async (truckId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    // === 🔹 Setăm intervalul în funcție de timeRange ===
    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // === 🔹 Fetch loads
    const response = await axios.get(
      `${apiUrl}/loads?truckId=${truckId}`,
      config
    );
    const data = response.data || [];

    // filtrează după interval de timp
    const filtered = data.filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });

    setLoads(filtered);
  } catch (err) {
    console.error("❌ Error fetching loads:", err);
    setLoads([]);
  }
};

useEffect(() => {
  if (selectedTruck?._id) {
    fetchLoads(selectedTruck._id);
  }
}, [selectedTruck, timeRange, customStartDate, customEndDate]);

const fetchTruckDriverPays = async (truckId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/driverpays?truckId=${truckId}`,
      config
    );
    setTruckDriverPays(response.data?.data || []);
  } catch (err) {
    console.error("Error fetching driver pays for truck:", err);
    setTruckDriverPays([]);
  }
};

// 📌 Fetch driver pays când selectezi un truck
useEffect(() => {
  if (truckDetails?._id) {
    fetchTruckDriverPays(truckDetails._id);
  }
}, [truckDetails?._id]);


const handleDownloadExcelTruckDashboard = () => {
  if (!truckDetails) return;

  const workbook = XLSX.utils.book_new();

  // === Sheet 1: Completed Loads ===
  const completedLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() === "completed"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": load.driver ? `${load.driver.firstName || ""} ${load.driver.lastName || ""}` : "N/A",
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Completed At": new Date(load.updatedAt || load.date).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsCompleted = XLSX.utils.json_to_sheet(completedLoads);
  XLSX.utils.book_append_sheet(workbook, wsCompleted, "Completed Loads");

  // === Sheet 2: Open Loads ===
  const openLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  ).map(load => ({
    "Load Number": load.loadNumber,
    "Status": load.status,
    "Rate": load.rate,
    "Miles": load.miles,
    "Driver": load.driver ? `${load.driver.firstName || ""} ${load.driver.lastName || ""}` : "N/A",
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Created At": new Date(load.createdAt).toLocaleString(),
    "Updated At": new Date(load.updatedAt).toLocaleString(),
    "Shipper": load.shippers?.map(s => s.address).join(", ") || "N/A",
    "Consignee": load.consignees?.map(c => c.address).join(", ") || "N/A",
    "Notes": load.notes || ""
  }));
  const wsOpen = XLSX.utils.json_to_sheet(openLoads);
  XLSX.utils.book_append_sheet(workbook, wsOpen, "Open Loads");

  // === Sheet 3: Truck Costs (dacă ai metrici) ===
  const truckCostsData = [{
    "Truck": truckDetails.truckNumber || truckDetails.licensePlate || "N/A",
    "Total Completed Loads": completedLoads.length,
    "Total Miles": completedLoads.reduce((s, l) => s + (l["Miles"] || 0), 0),
    "Total Rate": completedLoads.reduce((s, l) => s + (l["Rate"] || 0), 0),
  }];
  const wsTruckCosts = XLSX.utils.json_to_sheet(truckCostsData);
  XLSX.utils.book_append_sheet(workbook, wsTruckCosts, "Truck Costs");

  // === Salvare ===
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `TruckDashboard_${truckDetails.truckNumber || truckDetails.licensePlate}.xlsx`);
};

const handleDownloadPdfTruckDashboard = () => {
  if (!truckDetails) return;

  const doc = new jsPDF();
  const truckName = truckDetails.truckNumber || truckDetails.licensePlate || "Truck";

  const completedLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() === "completed"
  );
  const openLoads = (truckLoadsList || []).filter(
    load => load.status?.toLowerCase() !== "completed" && load.status?.toLowerCase() !== "canceled"
  );

  const totalRate = completedLoads.reduce((sum, load) => sum + (load.rate || 0), 0);

  // Titlu
  doc.setFontSize(18);
  doc.text(`Truck Dashboard Report: ${truckName}`, 14, 20);

  // Rezumat
  doc.setFontSize(12);
  doc.text(`${truckName} has ${completedLoads.length} Completed Loads and ${openLoads.length} Open Loads.`, 14, 30);
  doc.text(`Total Revenue: $${totalRate}`, 14, 38);

  // === Completed Loads Table
  if (completedLoads.length > 0) {
    const completedData = completedLoads.map(load => [
      load.loadNumber,
      load.rate,
      load.miles,
      new Date(load.updatedAt || load.date).toLocaleDateString()
    ]);

    completedData.push([
      "TOTAL",
      totalRate,
      completedLoads.reduce((s, l) => s + (l.miles || 0), 0),
      "-"
    ]);

    doc.autoTable({
      head: [["Completed Load #", "Rate", "Miles", "Completed At"]],
      body: completedData,
      startY: 60,
    });
  }

  // === Open Loads Table
  if (openLoads.length > 0) {
    const openData = openLoads.map(load => [
      load.loadNumber,
      load.status,
      load.rate,
      load.miles,
      new Date(load.createdAt).toLocaleDateString()
    ]);

    doc.autoTable({
      head: [["Open Load #", "Status", "Rate", "Miles", "Created At"]],
      body: openData,
      startY: doc.lastAutoTable.finalY + 10,
    });
  }

  doc.save(`TruckDashboard_${truckName}.pdf`);
};

  const fetchTrucks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/trucks`, config);
      setTrucks(response.data || []);
    } catch (error) {
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTruck) {
      fetchTruckDetails(selectedTruck._id);
    }
  }, [selectedTruck ]);

// ✅ Calculăm Rate per Mile
const ratePerMileData = loads
  .filter(load => load.miles > 0) // doar loaduri cu mile > 0
  .map(load => ({
    date: new Date(load.date || load.createdAt).toLocaleDateString(),
    value: load.rate / load.miles // rate per mile
  }));

  
  const fetchTruckDetails = async (truckId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/trucks/${truckId}`, config);
      
      if (!response.data || Object.keys(response.data).length === 0) {
        console.warn("No truck details found");
        setTruckDetails(null);
        return;
      }
  
      setTruckDetails(response.data);
      fetchTruckStats(truckId);
    } catch (error) {
   
      setTruckDetails(null);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    if (selectedTruck) {
      fetchTruckStats(selectedTruck._id);
    }
  }, [selectedTruck, timeRange, customStartDate, customEndDate]);


  

const handleShowTruckLoads = async (truckId) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment?truckId=${truckId}`,
      config
    );
    setTruckLoadsList(response.data || []);
    setShowLoadsModal(true);
  } catch (err) {
    console.error("Error fetching truck loads:", err);
    setTruckLoadsList([]);
    setShowLoadsModal(true);
  }
};


const getTruckOpenLoadStatus = (truckDetails, truckLoadsList) => {
  if (!truckDetails) return "";

  const safeLoads = Array.isArray(truckLoadsList) ? truckLoadsList : [];
  const truckName = truckDetails.truckNumber || truckDetails.licensePlate || "Truck";

  // ✅ Open loads pentru acest truck
  const openLoads = safeLoads.filter(
    load => !["completed", "canceled"].includes(load.status?.toLowerCase())
  );

  if (openLoads.length > 0) {
    const openLoad = openLoads[0];
    const openedAt = new Date(openLoad.date || openLoad.createdAt);
    const diffDays = Math.floor((Date.now() - openedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Truck ${truckName} has an Open Load (#${openLoad.loadNumber || openLoad._id}) open for ${diffDays} days.`;
  } else if (safeLoads.length > 0) {
    const sorted = [...safeLoads].sort(
      (a, b) => new Date(b.date || b.updatedAt || b.createdAt) - new Date(a.date || a.updatedAt || a.createdAt)
    );
    const lastLoad = sorted[0];
    const closedAt = new Date(lastLoad.date || lastLoad.updatedAt || lastLoad.createdAt);
    const diffDays = Math.floor((Date.now() - closedAt.getTime()) / (1000 * 60 * 60 * 24));
    return `Truck ${truckName} has not done a load for ${diffDays} days. Last load was (#${lastLoad.loadNumber || lastLoad._id}) on ${closedAt.toLocaleDateString("en-US")}.`;
  } else {
    return `Truck ${truckName} has no load history.`;
  }
};


const fetchTruckStats = async (truckId) => {
  try {
    let startDate = new Date();
    let endDate = new Date();

    // === 🔹 Setăm intervalul în funcție de timeRange ===
    if (timeRange !== "custom") {
      switch (timeRange) {
        case "day":
          break;
        case "week":
          startDate.setDate(endDate.getDate() - 7);
          break;
        case "month":
          startDate.setDate(1);
          break;
        case "year":
          startDate = new Date(startDate.getFullYear(), 0, 1);
          break;
      }
    } else if (customStartDate && customEndDate) {
      startDate = new Date(customStartDate);
      endDate = new Date(customEndDate);
    }

    // === 🔹 Loads (Revenue + Status) ===
    const loadsResponse = await axios.get(
      `${apiUrl}/loads/by-assignment?truckId=${truckId}`,
      config
    );
    const loads = (loadsResponse.data || []).filter(load => {
      const loadDate = new Date(load.date || load.createdAt);
      return loadDate >= startDate && loadDate <= endDate;
    });

    // ✅ Status (Complete / Canceled / Open)
    setTruckLoads({
      complete: loads.filter(load => load.status?.toLowerCase() === "complete").length,
      canceled: loads.filter(load => load.status?.toLowerCase() === "canceled").length,
      open: loads.filter(load => !["complete", "canceled"].includes(load.status?.toLowerCase())).length,
    });

    // ✅ Revenue
    const revenue = loads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    setTruckRevenue(revenue);

    // ✅ Rate Evolution
    const rateData = {};
    loads.forEach(load => {
      const date = new Date(load.date || load.createdAt);
      const label = date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
      rateData[label] = (rateData[label] || 0) + (parseFloat(load.rate) || 0);
    });
    setRateEvolution({ labels: Object.keys(rateData), values: Object.values(rateData) });

    // === 🔹 Fuel Reports ===
    const fuelResponse = await axios.get(
      `${apiUrl}/fuel-reports/truck/${truckId}`,
      config
    );
    const fuelReports = (fuelResponse.data || []).filter(report => {
      const reportDate = new Date(report.createdAt);
      return reportDate >= startDate && reportDate <= endDate;
    });
    setFuelUsage(
      fuelReports.reduce((acc, report) => acc + (parseFloat(report.grandTotal) || 0), 0)
    );
const truckResponse = await axios.get(`${apiUrl}/trucks/${truckId}`, config);
const truck = truckResponse.data;

if (truck && truck.reports) {
  const aggregatedCosts = truck.reports.reduce(
    (acc, rep) => {
      acc.insuranceCost += rep.insuranceCost || 0;
      acc.maintenanceCost += rep.maintenanceCost || 0;
      acc.leasingRate += rep.leasingRate || 0;
      acc.purchaseCost += rep.purchaseCost || 0;
      acc.serviceCosts += rep.serviceCosts || 0;
      acc.maut += rep.maut || 0;
      return acc;
    },
    { insuranceCost: 0, maintenanceCost: 0, leasingRate: 0, purchaseCost: 0, serviceCosts: 0, maut: 0 }
  );

  setTruckCosts(aggregatedCosts);
}

    // === 🔹 DriverPays ===
    const paysResponse = await axios.get(
      `${apiUrl}/driverpays?truckId=${truckId}`,
      config
    );
    const driverPays = (paysResponse.data?.data || []).filter(pay => {
      const payDate = new Date(pay.createdAt);
      return payDate >= startDate && payDate <= endDate;
    });
    setTruckDriverPays(driverPays);

  } catch (error) {
    console.error("❌ Error fetching truck stats:", error);
    setTruckLoads({ complete: 0, canceled: 0, open: 0 });
    setRateEvolution({ labels: [], values: [] });
    setFuelUsage(0);
    setTruckRevenue(0);
    setTruckDriverPays([]);
  }
};


// ✅ Payroll per Mile
const payrollPerMile = truckDriverPays.length && loads.length
  ? (
      truckDriverPays.reduce(
        (s, p) => s + (parseFloat(p.totalWithAdjustments || p.totalPay) || 0), 
        0
      ) / loads.reduce((s, l) => s + (parseFloat(l.miles) || 0), 0)
    ).toFixed(2)
  : 0;

// ✅ Profit / Loss
const totalCosts = Object.values(truckCosts || {}).reduce((a, b) => a + (b || 0), 0);
const profitLoss = (truckRevenue || 0) - totalCosts;

// ✅ Average Rate per Load
const avgRatePerLoad = loads.length
  ? (
      loads.reduce((a, l) => a + (parseFloat(l.rate) || 0), 0) / loads.length
    ).toFixed(2)
  : 0;
       return (
    <div
  className={`${styles.truckdashboard} ${
    theme === 'light' ? styles.truckdashboardLight : ''
  }`}
>

      {/* Side Menu */}
      <div className={styles.sidebarToggleTruck} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebartruckdashboard} ${isSidebarOpen ? styles.sidebarOpenTruck : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>


      {/* ✅ Main Content */}
      <div className={styles.mainContenttruckdashboard}>
        <h2 className={styles.titletruckdashboard}>Truck Dashboard</h2>

        {/* 📌 Truck Table */}
        {!selectedTruck ? (
          <table className={styles.tabletruckdashboard}>
            <thead>
              <tr>
                <th>Truck Number</th>
                <th>Model</th>
                <th>Year</th>
                <th>VIN</th>
                <th>License Plate</th>
                <th>View Details</th>
              </tr>
            </thead>
            <tbody>
              {trucks.map(truck => (
                <tr key={truck._id}>
                  <td>{truck.truckNumber}</td>
                  <td>{truck.truckType}</td>
                  <td>{truck.year}</td>
                  <td>{truck.VIN}</td>
                  <td>{truck.licensePlate}</td>
                  <td>
                    <button onClick={() => setSelectedTruck(truck)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            {/* 📌 Truck Details */}
            <button className={styles.backButtontruckdashboard} onClick={() => setSelectedTruck(null)}>⬅ Back to Trucks</button>
            <div className={styles.detailsSectiontruckdashboard}>
{truckDetails ? (
  <div>
    {/* HEADER cu Truck Number, See More și See Loads */}
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      {/* Stânga: Titlu + buton sub el */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" }}>
        <h3>Truck: {truckDetails.truckNumber}</h3>
        {!showMore ? (
          <button 
            className={styles.seeMoreButton} 
            onClick={() => setShowMore(true)}
          >
            See More About the Truck ({truckDetails.truckNumber})
          </button>
        ) : (
          <button 
            className={styles.hideMoreDriverButton} 
            onClick={() => setShowMore(false)}
          >
            Hide details about the Truck ({truckDetails.truckNumber})
          </button>
        )}
      </div>

      {/* Dreapta: buton See Loads */}
      <button 
        className={styles.seeLoadsButton} 
        onClick={() => handleShowTruckLoads(truckDetails._id)}
      >
        See Loads
      </button>
    </div>

    {/* DETALII vizibile doar când e activ showMore */}
    {showMore && (
      <>
        <p><strong>Model:</strong> {truckDetails.truckType || "No data"}</p>
        <p><strong>Year:</strong> {truckDetails.year || "No data"}</p>
        <p><strong>VIN:</strong> {truckDetails.VIN || "No data"}</p>
        <p><strong>License Plate:</strong> {truckDetails.licensePlate || "No data"}</p>
        <p><strong>Insurance Expiry:</strong> {truckDetails.insuranceExpiryDate || "No data"}</p>
      </>
    )}
  </div>
) : (
  <p>Loading truck details...</p>
)}


            </div>
{showLoadsModal && (
  <div className={styles.DriverDashboardLoadOverlay}>
    <div className={styles.DriverDashboardLoadModal}>
      <button 
        className={styles.DriverDashboardLoadClose} 
        onClick={() => setShowLoadsModal(false)}
      >
        ✕
      </button>

      <h3 className={styles.DriverDashboardLoadTitle}>
        Loads for {truckDetails.truckNumber}
      </h3>

      {truckLoadsList.length > 0 ? (
        <div className={styles.DriverDashboardLoadWrapper}>
          <table className={styles.DriverDashboardLoadTable}>
            <thead>
              <tr>
                <th>Load #</th>
                <th>Status</th>
                <th>Rate</th>
                <th>Miles</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {truckLoadsList.map(load => (
                <tr key={load._id}>
                  <td>{load.loadNumber || "-"}</td>
                  <td>{load.status || "-"}</td>
                  <td>${load.rate || "-"}</td>
                  <td>{load.miles || "-"}</td>
                  <td>{new Date(load.date || load.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className={styles.TruckDashboardNoLoads}>No loads found for this truck.</p>
      )}
    </div>
  </div>
)}
          <div className={styles.driverLoadStatusBox}>
  {truckDetails ? (
    <p>{getTruckOpenLoadStatus(truckDetails, truckLoadsList || [])}</p>
  ) : (
    <p>No truck selected.</p>
  )}
</div>
<div style={{ display: "flex", gap: "10px" }}>
  <button 
    onClick={handleDownloadExcelTruckDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#22c55e", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download Excel Truck Dashboard
  </button>
  <button 
    onClick={handleDownloadPdfTruckDashboard}
    style={{ padding: "8px 14px", backgroundColor: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
  >
    Download PDF Truck Dashboard
  </button>
</div>

            <div className={styles.chartControlstruckdashboard}>
            <label>Time Range:</label>
            <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
              <option value="day">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>

            {timeRange === "custom" && (
              <div>
                <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
                <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
              </div>
            )}
          </div>
          

          <button 
  className={styles.addWidgetButton} 
  onClick={() => setShowAddModal(true)}
>
  + Add New Widget
</button>
{showAddModal && (
  <div className={styles.ModalDriverDashboardOverlay}>
    <div className={styles.ModalDriverDashboardContent}>
      <div className={styles.ModalDriverDashboardHeader}>
        <h3>Select Widgets</h3>
        <button 
          className={styles.ModalDriverDashboardClose} 
          onClick={() => setShowAddModal(false)}
        >
          ✖
        </button>
      </div>

      <div className={styles.ModalDriverDashboardOptions}>
        {allTruckChartOptions.map(opt => (
          <label key={opt.key} className={styles.ModalDriverDashboardOption}>
            <input
              type="checkbox"
              checked={charts.includes(opt.key)}
              onChange={e => {
                if (e.target.checked) {
                  setCharts([...charts, opt.key]);
                } else {
                  setCharts(charts.filter(c => c !== opt.key));
                }
              }}
            />
            {opt.label}
          </label>
        ))}
      </div>

      <button 
        className={styles.ModalDriverDashboardDone}
        onClick={() => {
          localStorage.setItem("truckDashboardCharts", JSON.stringify(charts));
          setShowAddModal(false);
        }}
      >
        Done
      </button>
    </div>
  </div>
)}

<div className={styles.chartsGrid}>
  {/* === Payroll per Mile === */}
  {charts.includes("payrollPerMile") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Payroll per Mile</h4>
        <ChartMenu
          chartKey="payrollPerMile"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.payrollPerMile === "Bar" && (
          <Bar
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], backgroundColor: "#3b82f6" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Column" && (
          <Bar
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], backgroundColor: "#3b82f6" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Line" && (
          <Line
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ label: "$/mile", data: [payrollPerMile], borderColor: "#3b82f6", backgroundColor: "rgba(59,130,246,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Pie" && (
          <Pie
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ data: [payrollPerMile], backgroundColor: ["#3b82f6"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Payroll per Mile"],
              datasets: [{ data: [payrollPerMile], backgroundColor: ["#3b82f6"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.payrollPerMile === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Used", "Remaining"],
              datasets: [{
                data: [payrollPerMile, Math.max(5 - payrollPerMile, 0)],
                backgroundColor: ["#3b82f6", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}

  {/* === Profit / Loss === */}
  {charts.includes("profitLoss") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Profit / Loss</h4>
        <ChartMenu
          chartKey="profitLoss"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.profitLoss === "Bar" && (
          <Bar
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], backgroundColor: profitLoss >= 0 ? "#22c55e" : "#ef4444" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Column" && (
          <Bar
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], backgroundColor: profitLoss >= 0 ? "#22c55e" : "#ef4444" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Line" && (
          <Line
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ label: "Amount", data: [profitLoss], borderColor: profitLoss >= 0 ? "#22c55e" : "#ef4444", backgroundColor: "rgba(34,197,94,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Pie" && (
          <Pie
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ data: [profitLoss], backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Profit / Loss"],
              datasets: [{ data: [profitLoss], backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.profitLoss === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Value", "Remaining"],
              datasets: [{
                data: [Math.abs(profitLoss), Math.max(10000 - Math.abs(profitLoss), 0)],
                backgroundColor: [profitLoss >= 0 ? "#22c55e" : "#ef4444", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}

  {/* === Average Rate per Load === */}
  {charts.includes("avgRatePerLoad") && (
    <div className={styles.chartContainerdriverdashboard}>
      <div className={styles.chartHeaderdriverdashboard}>
        <h4>Average Rate per Load</h4>
        <ChartMenu
          chartKey="avgRatePerLoad"
          chartTypes={chartTypes}
          handleChartTypeChange={handleChartTypeChange}
          downloadChartAsPDF={downloadChartAsPDF}
        />
      </div>
      <div className={styles.chartContentdriverdashboard}>
        {chartTypes.avgRatePerLoad === "Bar" && (
          <Bar
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], backgroundColor: "#6366f1" }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Column" && (
          <Bar
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], backgroundColor: "#6366f1" }],
            }}
            options={{ indexAxis: "x", responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Line" && (
          <Line
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ label: "$", data: [avgRatePerLoad], borderColor: "#6366f1", backgroundColor: "rgba(99,102,241,0.3)", tension: 0.4 }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Pie" && (
          <Pie
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ data: [avgRatePerLoad], backgroundColor: ["#6366f1"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Avg Rate per Load"],
              datasets: [{ data: [avgRatePerLoad], backgroundColor: ["#6366f1"] }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.avgRatePerLoad === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Value", "Remaining"],
              datasets: [{
                data: [avgRatePerLoad, Math.max(10 - avgRatePerLoad, 0)],
                backgroundColor: ["#6366f1", "#e5e7eb"],
              }],
            }}
            options={{ rotation: -90, circumference: 180, responsive: true, maintainAspectRatio: false }}
          />
        )}
      </div>
    </div>
  )}
</div>


<div className={styles.chartsGrid}>
  {/* 📊 Load Status */}
<div className={styles.chartContainertruckdashboard} id="loadStatus">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Load Status Comparison</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="loadStatus"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
  </div>

  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Bar Chart */}
    {chartTypes.loadStatus === "Bar" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Graph */}
    {chartTypes.loadStatus === "Line" && (
      <Line
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status Over Time",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.loadStatus === "Pie" && (
      <Pie
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

  {/* ✅ Gauge Chart */}
  {chartTypes.loadStatus === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Complete Loads", "Remaining Loads"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled + truckLoads.open],
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.loadStatus === "Column" && (
      <Bar
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            label: "Load Status",
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.loadStatus === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Complete", "Canceled", "Open"],
          datasets: [{
            data: [truckLoads.complete, truckLoads.canceled, truckLoads.open],
            backgroundColor: ["#4caf50", "#f44336", "#ff9800"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>


     {/* 📊 Rate Evolution */}
<div className={styles.chartContainertruckdashboard} id="rateEvolution">
  <div className={styles.chartHeadertruckdashboard}>
   
    <h4>Rate Evolution Over Time</h4>
     <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="rateEvolution"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
  </div>
  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>

    {/* ✅ Line Graph */}
    {chartTypes.rateEvolution === "Line" && (
      <Line
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
            fill: true,
            pointBackgroundColor: "#3b82f6",
            pointBorderWidth: 2,
            borderWidth: 2,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  
    {/* ✅ Gauge Chart */}
    {chartTypes.rateEvolution === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Revenue Generated", "Remaining Target"],
          datasets: [{
            data: [rateEvolution.values.reduce((acc, val) => acc + val, 0), Math.max(100000 - rateEvolution.values.reduce((acc, val) => acc + val, 0), 0)], // Exemplu: 100.000 ca obiectiv
            backgroundColor: ["#4caf50", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
    {/* ✅ Bar Chart */}
    {chartTypes.rateEvolution === "Bar" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.rateEvolution === "Column" && (
      <Bar
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            label: "Revenue ($)",
            data: rateEvolution.values,
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.rateEvolution === "Pie" && (
      <Pie
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.rateEvolution === "Doughnut" && (
      <Doughnut
        data={{
          labels: rateEvolution.labels,
          datasets: [{
            data: rateEvolution.values,
            backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>
{/* 📊 Fuel Usage */}
<div className={styles.chartContainertruckdashboard} id="fuelUsage">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Fuel Usage</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="fuelUsage"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>
  <div className={styles.chartContenttruckdashboard} style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}>
    
    {/* ✅ Doughnut Chart */}
    {chartTypes.fuelUsage === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Bar Chart */}
    {chartTypes.fuelUsage === "Bar" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.fuelUsage === "Column" && (
      <Bar
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Total Fuel ($)",
            data: [fuelUsage],
            backgroundColor: "#3b82f6",
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.fuelUsage === "Pie" && (
      <Pie
        data={{
          labels: ["Fuel Used"],
          datasets: [{
            data: [fuelUsage],
            backgroundColor: ["#3b82f6"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

     {/* ✅ Gauge Chart */}
     {chartTypes.fuelUsage === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Fuel Used", "Remaining"],
          datasets: [{
            data: [fuelUsage, Math.max(10000 - fuelUsage, 0)], // Exemplu: 10.000 este limita maximă
            backgroundColor: ["#3b82f6", "#e0e0e0"],
            borderWidth: 0
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // ✅ Face graficul semicircular (Gauge)
          rotation: -90, // ✅ Aliniază la bază ca un contor real
          cutout: "75%", // ✅ Grosimea semicercului
          plugins: {
            legend: { display: false },
            tooltip: { enabled: true },
          },
        }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.fuelUsage === "Line" && (
      <Line
        data={{
          labels: ["Fuel Usage"],
          datasets: [{
            label: "Fuel ($)",
            data: [fuelUsage],
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            tension: 0.4,
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    )}
  </div>
</div>

{/* 📊 Total Driver Pay */}
<div className={styles.chartContainertruckdashboard} id="totalDriverPay">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Total Driver Pay for Truck {truckDetails?.truckNumber}</h4>
    <div className={styles.chartMenuWrapper}>
    <ChartMenu
      chartKey="totalDriverPay"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
</div>
  <div 
    className={styles.chartContenttruckdashboard} 
    style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    {truckDriverPays.length > 0 ? (
      <>
        {/* ✅ Bar Chart */}
        {chartTypes.totalDriverPay === "Bar" && (
          <Bar
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: "#3b82f6",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Column Chart */}
        {chartTypes.totalDriverPay === "Column" && (
          <Bar
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: "#3b82f6",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {/* ✅ Pie Chart */}
        {chartTypes.totalDriverPay === "Pie" && (
          <Pie
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Doughnut Chart */}
        {chartTypes.totalDriverPay === "Doughnut" && (
          <Doughnut
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()} - ${new Date(pay.endDate).toLocaleDateString()}`
              ),
              datasets: [{
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Gauge Chart */}
        {chartTypes.totalDriverPay === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Total Pay Earned", "Remaining to Goal"],
              datasets: [{
                data: [
                  truckDriverPays.reduce((sum, p) => sum + (p.totalWithAdjustments || p.totalPay || 0), 0),
                  Math.max(100000 - truckDriverPays.reduce((sum, p) => sum + (p.totalWithAdjustments || p.totalPay || 0), 0), 0)
                ],
                backgroundColor: ["#3b82f6", "#e0e0e0"],
                borderWidth: 0
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "75%",
              plugins: { legend: { display: false }, tooltip: { enabled: true } },
            }}
          />
        )}

        {/* ✅ Line Chart */}
        {chartTypes.totalDriverPay === "Line" && (
          <Line
            data={{
              labels: truckDriverPays.map(pay => 
                `${new Date(pay.startDate).toLocaleDateString()}`
              ),
              datasets: [{
                label: "Driver Pay ($)",
                data: truckDriverPays.map(pay => pay.totalWithAdjustments || pay.totalPay || 0),
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59, 130, 246, 0.2)",
                tension: 0.4,
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}
      </>
    ) : (
      <p>No DriverPays found for this truck.</p>
    )}
  </div>
</div>
{/* 📊 Truck Costs */}
<div className={styles.chartContainertruckdashboard} id="truckCosts">
  <div className={styles.chartHeadertruckdashboard}>
  <h4>Truck Costs</h4>
  <div className={styles.chartMenuWrapper}>
    
    <ChartMenu
      chartKey="truckCosts"
      chartTypes={chartTypes}
      handleChartTypeChange={handleChartTypeChange}
      downloadChartAsPDF={downloadChartAsPDF}
    />
  </div>
    </div>

  <div
    className={styles.chartContenttruckdashboard}
    style={{ width: "600px", height: "350px", display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    {/* ✅ Bar Chart */}
    {chartTypes.truckCosts === "Bar" && (
      <Bar
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Column Chart */}
    {chartTypes.truckCosts === "Column" && (
      <Bar
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
        options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.truckCosts === "Pie" && (
      <Pie
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.truckCosts === "Doughnut" && (
      <Doughnut
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              backgroundColor: ["#22c55e", "#3b82f6", "#f59e0b", "#ef4444", "#6366f1", "#14b8a6"],
            },
          ],
        }}
      />
    )}

    {/* ✅ Gauge Chart */}
    {chartTypes.truckCosts === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Costs", "Remaining to Goal"],
          datasets: [
            {
              data: [
                Object.values(truckCosts).reduce((a, b) => a + b, 0),
                Math.max(100000 - Object.values(truckCosts).reduce((a, b) => a + b, 0), 0),
              ],
              backgroundColor: ["#ef4444", "#e0e0e0"],
              borderWidth: 0,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180,
          rotation: -90,
          cutout: "75%",
          plugins: { legend: { display: false } },
        }}
      />
    )}

    {/* ✅ Line Chart */}
    {chartTypes.truckCosts === "Line" && (
      <Line
        data={{
          labels: ["Insurance", "Maintenance", "Leasing", "Purchase", "Service", "Maut"],
          datasets: [
            {
              label: "Cost ($)",
              data: [
                truckCosts.insuranceCost,
                truckCosts.maintenanceCost,
                truckCosts.leasingRate,
                truckCosts.purchaseCost,
                truckCosts.serviceCosts,
                truckCosts.maut,
              ],
              borderColor: "#3b82f6",
              backgroundColor: "rgba(59,130,246,0.2)",
              tension: 0.4,
            },
          ],
        }}
      />
    )}
  </div>
</div>
{/* 📊 Rate per Mile */}
<div className={styles.chartContainertruckdashboard} id="ratePerMile">
  <div className={styles.chartHeadertruckdashboard}>
    <h4>Rate per Mile</h4>
    <div className={styles.chartMenuWrapper}>
      <ChartMenu
        chartKey="ratePerMile"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div
    className={styles.chartContenttruckdashboard}
    style={{
      width: "600px",
      height: "350px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {ratePerMileData.length > 0 ? (
      <>
        {/* ✅ Bar Chart */}
        {chartTypes.ratePerMile === "Bar" && (
          <Bar
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: "#3b82f6",
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Column Chart */}
        {chartTypes.ratePerMile === "Column" && (
          <Bar
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: "#3b82f6",
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              indexAxis: "y",
            }}
          />
        )}

        {/* ✅ Pie Chart */}
        {chartTypes.ratePerMile === "Pie" && (
          <Pie
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: [
                    "#3b82f6",
                    "#22c55e",
                    "#f59e0b",
                    "#ef4444",
                    "#6366f1",
                  ],
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Doughnut Chart */}
        {chartTypes.ratePerMile === "Doughnut" && (
          <Doughnut
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  data: ratePerMileData.map((r) => r.value),
                  backgroundColor: [
                    "#3b82f6",
                    "#22c55e",
                    "#f59e0b",
                    "#ef4444",
                    "#6366f1",
                  ],
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* ✅ Gauge Chart */}
        {chartTypes.ratePerMile === "Gauge" && (
          <Doughnut
            data={{
              labels: ["Avg Rate/Mile", "Gap to $5.00"],
              datasets: [
                {
                  data: [
                    ratePerMileData.reduce((a, b) => a + b.value, 0) /
                      ratePerMileData.length,
                    Math.max(
                      5 -
                        ratePerMileData.reduce((a, b) => a + b.value, 0) /
                          ratePerMileData.length,
                      0
                    ),
                  ],
                  backgroundColor: ["#22c55e", "#e0e0e0"],
                  borderWidth: 0,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "75%",
              plugins: { legend: { display: false } },
            }}
          />
        )}

        {/* ✅ Line Chart */}
        {chartTypes.ratePerMile === "Line" && (
          <Line
            data={{
              labels: ratePerMileData.map((r) => r.date),
              datasets: [
                {
                  label: "Rate per Mile ($)",
                  data: ratePerMileData.map((r) => r.value),
                  borderColor: "#3b82f6",
                  backgroundColor: "rgba(59,130,246,0.2)",
                  tension: 0.4,
                },
              ],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}
      </>
    ) : (
      <p>No loads found for this truck.</p>
    )}
  </div>
</div>

</div>
        </>
      )}
    </div>
  </div>
);
};

const Dashboard = ({ onNavigate, drivers = [], trucks = [], loads = [], fuelReports = [], iftaReports = [], driverPays = [] }) => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [isLoadingDashboard, setIsLoadingDashboard] = useState(true);
const [userSettings, setUserSettings] = useState({});

// --- EMPLOYEES / PAYROLLS ---
const [employees, setEmployees] = useState([]);
const [employeesPayrolls, setEmployeesPayrolls] = useState([]); // [{ name, total }]
// --- DRIVERPAYS (din colectia DriverPay) ---
const [driverPaysAll, setDriverPaysAll] = useState([]);
const [kpiData, setKpiData] = useState({});
const [brokers, setBrokers] = useState([]);
const [selectedItem, setSelectedItem] = useState(null);
const [clientData, setClientData] = useState(null);
const [aiSuggestion, setAiSuggestion] = useState([]);
const [showAIModal, setShowAIModal] = useState(false);
const [isThinking, setIsThinking] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState("");
  const [open, setOpen] = useState(false);
  const [showStrategyModal, setShowStrategyModal] = useState(false);
const [loadingStrategy, setLoadingStrategy] = useState(false);
const [planText, setPlanText] = useState("");
// === STATE PENTRU DRIVER/TRUCK DETALII ===
const [selectedDriver, setSelectedDriver] = useState(null);
const [selectedTruck, setSelectedTruck] = useState(null);
const [lastLoads, setLastLoads] = useState([]);
const [lastLoad, setLastLoad] = useState(null);

const [routeData, setRouteData] = useState(null);
const [shipperMarker, setShipperMarker] = useState(null);
const [consigneeMarker, setConsigneeMarker] = useState(null);
const [overviewOpen, setOverviewOpen] = useState(false);

// === derive daysAgo (NU rescrie lastLoad) ===
let daysAgo = null;
if (lastLoad) {
  const loadDate = new Date(lastLoad.createdAt);
  daysAgo = Math.floor(
    (Date.now() - loadDate.getTime()) / (1000 * 60 * 60 * 24)
  );
}

// ✅ Google Maps API key
const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const [dashboardData, setDashboardData] = useState({
    
    totalDrivers: 0,
    totalTrucks: 0,
    totalLoads: 0,
    totalMiles: 0,
    totalRevenue: 0,
    loadsPerDriver: [],
    loadsPerTruck: [],
    monthlyRevenue: [],
    fuelPerMile: 0,
    topRates: [],
    completeLoads: 0,
    canceledLoads: 0,
    incompleteLoads: 0,
    fuelCosts: [],
    driverPayments: [],
 
  });
  const [progressGoals, setProgressGoals] = useState(() => {
    return JSON.parse(localStorage.getItem("progressGoals")) || [];
  });
  const [goal, setGoal] = useState(50000);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const [newGoalType, setNewGoalType] = useState("monthly");
  const [newGoalValue, setNewGoalValue] = useState(50000);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [tasks, setTasks] = useState([]);
  const [taskInput, setTaskInput] = useState("");
  const [newTask, setNewTask] = useState("");
  const [tasksByDate, setTasksByDate] = useState({}); // { "YYYY-M-D": [task, ...] }
const [isLoadingTasks, setIsLoadingTasks] = useState(false);
const [kpis, setKpis] = useState([]);
const [showAddModal, setShowAddModal] = useState(false);
const [newWidgetType, setNewWidgetType] = useState(""); // "chart" | "kpi" | "card"
const [charts, setCharts] = useState([]);
const [cards, setCards] = useState([]);
// sus în componentă, lângă celelalte state-uri
const [accountsReceivable, setAccountsReceivable] = useState([]); 

const [showAddTaskModal, setShowAddTaskModal] = useState(false);
const [showEditTaskModal, setShowEditTaskModal] = useState(false);
const [editTask, setEditTask] = useState(null); // task-ul curent pt edit
const [payrolls, setPayrolls] = useState([]);
const [maintenanceReports, setMaintenanceReports] = useState([]);

// Formular Add/Edit Task
const [taskForm, setTaskForm] = useState({
  title: "",
  description: "",
  status: "open",
  priority: "medium",
  assignedTo: "",     // ObjectId sau "" (opțional)
});

// util: "2025-1-10"
const toDateKey = (d) => `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
// util: verificare interval lunar curent
const getMonthRange = (date) => {
  const start = new Date(date.getFullYear(), date.getMonth(), 1);
  const end = new Date(date.getFullYear(), date.getMonth()+1, 0);
  // format string exact ca în model (String date)
  const startKey = `${start.getFullYear()}-${start.getMonth()+1}-${1}`;
  const endKey   = `${end.getFullYear()}-${end.getMonth()+1}-${end.getDate()}`;
  return { startKey, endKey };
};
  const [selectedDate, setSelectedDate] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 40.7128, lng: -74.006 });
  const [timeRange, setTimeRange] = useState(""); // By default, show monthly data
  const [customStartDate, setCustomStartDate] = useState(""); 
  const [customEndDate, setCustomEndDate] = useState("");
  const [activeSection, setActiveSection] = useState('dashboard'); // Dashboard implicit
  const [driverPayrolls, setDriverPayrolls] = useState([]);
  const [fuelCostsData, setFuelCostsData] = useState([]);
  const [isLoadingFuelData, setIsLoadingFuelData] = useState(true); // ⬅️ Flag pentru UI
  const [selectedDispatcher, setSelectedDispatcher] = useState(null);
const [modalOpen, setModalOpen] = useState(false);
const [activeLoad, setActiveLoad] = useState(null);
const [dispatchers, setDispatchers] = useState([]);
const [dispatcherTimeRange, setDispatcherTimeRange] = useState("month"); // Default pe lună
const [customDispatcherStartDate, setCustomDispatcherStartDate] = useState(""); 
const [customDispatcherEndDate, setCustomDispatcherEndDate] = useState("");
// calculează nr. de luni între două date
const diffInMonths = (a, b) => (b.getFullYear() - a.getFullYear()) * 12 + (b.getMonth() - a.getMonth());



  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const token = sessionStorage.getItem("token");
  const clientId = localStorage.getItem('clientId'); 
 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  const [chartTypes, setChartTypes] = useState({
    monthlyRevenue: "Line",
    completeLoads: "Doughnut",
    loadsPerDriver: "Bar",
    loadsPerTruck: "Bar",
    fuelCosts: "Line",
    driverPayrolls: "Bar",
    iftaTaxes: "Pie",
    iftaHistory: "Line",
  newChartKey: "Bar",
  driverPayComparison: "Bar",
  });
  
  const handleChartTypeChange = (chartKey, newType) => {
    setChartTypes(prev => ({ ...prev, [chartKey]: newType }));
  };

  const downloadChartAsPDF = (chartId, chartTitle) => {
    const input = document.getElementById(chartId);
    if (!input) {
    
      return;
    }
  
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.text(chartTitle, 10, 10);
      pdf.addImage(imgData, "PNG", 10, 20, 180, 100);
      pdf.save(`${chartTitle}.pdf`);
    });
  };

  const getCoordinatesFromAddress = async (address) => {
  try {
    const response = await axios.get(
      "https://api-backend.full-trucking-service.com/api/geocode",
      { params: { address } }
    );

    if (response.data.status !== "OK" || !response.data.results.length) {
      return null;
    }

    const location = response.data.results[0].geometry.location;
    return { lat: location.lat, lng: location.lng };
  } catch (err) {
    console.error("❌ Geocoding failed for", address, err);
    return null;
  }
};

useEffect(() => {
  const fetchCoords = async () => {
    if (!lastLoads || lastLoads.length === 0) return;

    const load = lastLoads[0];
    const shipperAddr = load.shippers?.[0]?.address;
    const consigneeAddr = load.consignees?.[0]?.address;

    const shipperCoords = shipperAddr ? await getCoordinatesFromAddress(shipperAddr) : null;
    const consigneeCoords = consigneeAddr ? await getCoordinatesFromAddress(consigneeAddr) : null;

    if (shipperCoords) setMapCenter(shipperCoords); // 📌 centrezi harta pe shipper
    setRouteData({
      route: [shipperCoords, consigneeCoords].filter(Boolean),
    });
  };

  fetchCoords();
}, [lastLoads]);

const fetchLastLoads = async ({ driverId = null, truckId = null }) => {
  try {
    const response = await axios.get(
      `https://api-backend.full-trucking-service.com/api/loads/by-assignment`,
      {
        params: { driverId, truckId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (response.status === 200 && Array.isArray(response.data)) {
      const sliced = response.data.slice(0, 10);
      setLastLoads(sliced);
      setLastLoad(sliced.length > 0 ? sliced[0] : null); // ✅ updatează separat
    } else {
      setLastLoads([]);
      setLastLoad(null);
    }
  } catch (error) {
    console.error("❌ Error fetching loads:", error);
    setLastLoads([]);
    setLastLoad(null);
  }
};


// când selectezi un șofer
useEffect(() => {
  if (selectedDriver) {
    fetchLastLoads({ driverId: selectedDriver._id });
  }
}, [selectedDriver]);

// când selectezi un camion
useEffect(() => {
  if (selectedTruck) {
    fetchLastLoads({ truckId: selectedTruck._id });
  }
}, [selectedTruck]);

  
  const fetchDispatchers = async () => {
    try {
      const clientId = localStorage.getItem('clientId');
      if (!clientId) {
    
        return;
      }
  
      const response = await axios.get(`${apiUrl}/dispatchers?clientId=${clientId}`, config);
  
      setDispatchers(response.data);
    } catch (error) {
   
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchDispatchers();  // ✅ Asigură că se încarcă dispecerii
  }, []);
  
  
  const listDriverPays = useMemo(
  () => (Array.isArray(driverPaysAll) ? driverPaysAll : []),
  [driverPaysAll]
);

const driverPayComparison = useMemo(() => {
  const { startDate, endDate } = getTimeWindowDP(timeRange, customStartDate, customEndDate);

  const totalsByDriver = new Map();
  listDriverPays.forEach((dp) => {
    const s = dp.startDate ? new Date(dp.startDate) : null;
    const e = dp.endDate ? new Date(dp.endDate) : null;
    const created = dp.createdAt ? new Date(dp.createdAt) : null;

    const overlaps = (s && e)
      ? !(e < startDate || s > endDate)
      : (created ? (created >= startDate && created <= endDate) : true);

    if (!overlaps) return;

    const name = resolveDriverName(dp, drivers);
    const val = Number(dp.totalWithAdjustments ?? dp.totalPay ?? 0) || 0;
    totalsByDriver.set(name, (totalsByDriver.get(name) || 0) + val);
  });

  return Array.from(totalsByDriver.entries())
    .map(([name, total]) => ({ name, total }))
    .sort((a, b) => b.total - a.total);
}, [listDriverPays, drivers, timeRange, customStartDate, customEndDate]);

// REPLACE function fetchDriverPaysAll
const fetchDriverPaysAll = async () => {
  const acc = [];
  const limit = 200;  // ≤ hard-cap backend
  let page = 1;

  for (;;) {
    const res = await axios.get(`${apiUrl}/driverpays`, {
      ...config,
      params: { page, limit, raw: 1 }   // raw=1 => backend returnează direct array
    });
    const items = Array.isArray(res.data) ? res.data : [];
    if (!items.length) break;
    acc.push(...items);
    if (items.length < limit) break;    // ultima pagină
    page += 1;
  }

  setDriverPaysAll(acc);
};


useEffect(() => {
  fetchDriverPaysAll();
}, []);

const askAI = async () => {
  setShowAIModal(true);   // ✅ deschide modalul imediat
  setIsThinking(true);    // ✅ arată loader
  setAiSuggestion([]);    // ✅ curăță sugestiile vechi

  try {
    const res = await fetch(`${apiUrl}/ai/dashboard/suggestion`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kpiData, dashboardData, fuelReports, drivers }),
    });
    const data = await res.json();

    setTimeout(() => { // mic delay să pară că GPT-ul "scrie"
      setAiSuggestion(data.suggestions || []);
      setIsThinking(false);
    }, 1200);
  } catch (err) {
    console.error("AI fetch failed:", err);
    setIsThinking(false);
    setAiSuggestion(["⚠️ Failed to fetch AI suggestions."]);
  }
};


const parseCurrency = (val) => {
  if (!val) return 0;
  if (typeof val === "number") return val;
  return Number(String(val).replace(/[^0-9.-]+/g, "")); // elimină $, ¢, etc.
};

const calculateKPIData = (
  drivers = [],
  trucks = [],
  loads = [],
  driverPays = [],
  iftaReports = [],
  brokers = [],
  fuelReports = []
) => {


  // === Base counts ===
  const totalDrivers  = drivers?.length || 0;
  const totalTrucks   = trucks?.length || 0;
  const totalDispatch = brokers?.length || 0;

  // === Loads ===
  const totalMiles   = loads.reduce((a, l) => a + (Number(l.miles || 0) + Number(l.dh || 0)), 0);
  const totalRevenue = loads.reduce((a, l) => a + (Number(l.rate || 0)), 0);

const totalPayroll = driverPays.reduce((sum, pay) => {
  if (pay.totalWithAdjustments) return sum + parseCurrency(pay.totalWithAdjustments);
  if (pay.totalPay) return sum + parseCurrency(pay.totalPay);
  return sum;
}, 0);

const fuelFromReports = fuelReports.reduce(
  (sum, r) => sum + parseCurrency(r.grandTotal), 0
);

const totalFuelCosts = iftaReports.reduce(
  (a, f) => a + parseCurrency(f.fuelTaxPaid), 0
);



const totalIftaMiles   = iftaReports.reduce((a, f) => a + parseCurrency(f.milesDriven), 0);
const totalFuelGallons = iftaReports.reduce((a, f) => a + parseCurrency(f.fuelConsumed), 0);

  const totalFuel = fuelFromReports + totalFuelCosts;

  // === Maintenance ===
  const totalMaint = trucks.reduce((sum, t) => {
    if (!t?.serviceHistory?.length) return sum;
    return sum + t.serviceHistory.reduce((s, h) => s + (Number(h.cost) || 0), 0);
  }, 0);

  // === KPI ===
  const utilizationRate = totalTrucks > 0
    ? ((new Set(loads.map(l => String(l.truck))).size / totalTrucks) * 100).toFixed(2)
    : 0;

  const revenuePerTruck  = totalTrucks > 0 ? (totalRevenue / totalTrucks).toFixed(2) : 0;
  const revenuePerDriver = totalDrivers > 0 ? (totalRevenue / totalDrivers).toFixed(2) : 0;

  const totalCosts = totalPayroll + totalMaint + totalFuel;

  const profitMargin = totalRevenue > 0
    ? (((totalRevenue - totalCosts) / totalRevenue) * 100).toFixed(2)
    : 0;

  const operatingRatio = totalRevenue > 0
    ? ((totalCosts / totalRevenue) * 100).toFixed(2)
    : 0;

  const iftaCompliance = iftaReports.length
    ? ((iftaReports.filter(r => r.paidIfta === "Yes").length / iftaReports.length) * 100).toFixed(2)
    : 0;

  const driverTurnover = drivers.length
    ? ((drivers.filter(d => d.notMoreWorking && d.notMoreWorkingTime).length / drivers.length) * 100).toFixed(2)
    : 0;

  const payPerMile = totalMiles > 0 ? (totalPayroll / totalMiles).toFixed(2) : 0;
  const maintCostPerMile = totalMiles > 0 ? (totalMaint / totalMiles).toFixed(2) : 0;
  const fuelEfficiency = totalFuelGallons > 0 ? (totalIftaMiles / totalFuelGallons).toFixed(2) : 0;

  const nextServiceDue = trucks.length
    ? Math.min(...trucks.map(t => ((t.nextServiceMiles || 0) - (t.miles || 0)) || Infinity))
    : 0;

  const topClients = loads.length
    ? Object.entries(
        loads.reduce((acc, l) => {
          const name = l.brokerName || l.clientName || "Unknown";
          acc[name] = (acc[name] || 0) + (Number(l.rate || 0));
          return acc;
        }, {})
      ).sort((a, b) => b[1] - a[1]).slice(0, 5)
    : [];

  const repeatLoads = loads.length
    ? (() => {
        const byClient = {};
        loads.forEach(l => {
          const name = l.brokerName || l.clientName || "Unknown";
          byClient[name] = (byClient[name] || 0) + 1;
        });
        const repeat = Object.values(byClient).filter(c => c > 1).length;
        return ((repeat / Object.keys(byClient).length) * 100).toFixed(2);
      })()
    : 0;

  const loadsPerDispatcher = totalDispatch > 0
    ? (loads.length / totalDispatch).toFixed(2)
    : 0;

  const revenuePerDispatcher = totalDispatch > 0
    ? (totalRevenue / totalDispatch).toFixed(2)
    : 0;

  return {
    utilizationRate,
    revenuePerTruck,
    revenuePerDriver,
    profitMargin,
    operatingRatio,
    iftaCompliance,
    driverTurnover,
    payPerMile,
    maintCostPerMile,
    fuelEfficiency,
    nextServiceDue,
    topClients,
    repeatLoads,
    loadsPerDispatcher,
    revenuePerDispatcher,
  };
};


useEffect(() => {
  const hasData =
    (drivers?.length || 0) > 0 ||
    (trucks?.length || 0) > 0 ||
    (loads?.length || 0) > 0 ||
    (driverPaysAll?.length || 0) > 0 ||
    (iftaReports?.length || 0) > 0 ||
    (brokers?.length || 0) > 0 ||
    (fuelCostsData?.length || 0) > 0;

  if (hasData) {
    const kpiResult = calculateKPIData(
      drivers,
      trucks,
      loads,
      driverPaysAll,
      iftaReports,
      brokers,
      fuelCostsData
    );
    setKpiData(kpiResult);
  }
}, [drivers, trucks, loads, driverPaysAll, iftaReports, brokers, fuelCostsData]);


  const fetchEmployees = async () => {
  try {
    const res = await axios.get(`${apiUrl}/employees`, config);
    setEmployees(res.data || []);
  } catch (e) {
    setEmployees([]);
  }
};

useEffect(() => {
  fetchEmployees();
}, []);

const generatePlan = async () => {
  setLoadingStrategy(true);
  try {
    const res = await fetch("https://api-backend.full-trucking-service.com/api/ai/dashboard/strategie", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    clientId,
    kpiData,
    dashboardData,
    fuelReports,
    drivers
  })
});

    console.log("Status:", res.status);   // 👈 vezi statusul
    const data = await res.json();
    console.log("Data:", data);           // 👈 vezi exact ce trimite backend-ul

    setPlanText(data.plan);
  } catch (err) {
    console.error("AI fetch error", err);
  }
  setLoadingStrategy(false);
};

const downloadPDFStrategy = async (clientId) => {
  try {
    const res = await fetch(
      `https://api-backend.full-trucking-service.com/api/ai/dashboard/downloadStrategie?clientId=${clientId}`
    );

    if (!res.ok) throw new Error("Failed to fetch strategy");

    const data = await res.json();

    if (!data.plan) {
      alert("No strategy found!");
      return;
    }

    const doc = new jsPDF();

    // === HEADER simplu ===
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text("AI Strategy Plan", 105, 20, { align: "center" });
    };

    // === FOOTER simplu ===
    const addFooter = () => {
      const pageHeight = doc.internal.pageSize.height;
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.text(`Page ${pageCount}`, 10, pageHeight - 10);
      doc.text(
        "Generated by Full Trucking Service",
        105,
        pageHeight - 10,
        { align: "center" }
      );
    };

    addHeader();

    let startY = 40;

    // === Împărțim textul în linii pt PDF ===
    const lines = doc.splitTextToSize(data.plan, 180);

    doc.autoTable({
      startY,
      body: lines.map((line) => [line]),
      theme: "plain",
      styles: { fontSize: 10, textColor: "#000000", cellPadding: 2 },
      columnStyles: { 0: { halign: "left" } },
    });

    addFooter();

    // ✅ Salvăm PDF-ul
    doc.save("ai-strategy-plan.pdf");
  } catch (err) {
    console.error("PDF Download Error:", err);
  }
};

const getTimeWindow = () => {
  const now = new Date();
  let startDate = new Date(0); // all-time fallback
  let endDate = new Date();

  if (!timeRange) {
    // all time
    startDate = new Date(0);
  } else if (timeRange === "custom" && customStartDate && customEndDate) {
    startDate = new Date(customStartDate);
    endDate = new Date(customEndDate);
  } else {
    startDate = new Date();
    endDate = new Date();
    switch (timeRange) {
      case "day":
        // azi deja ok
        break;
      case "week":
        startDate.setDate(endDate.getDate() - 7);
        break;
      case "month":
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      case "year":
        startDate = new Date(now.getFullYear(), 0, 1);
        break;
      default:
        startDate = new Date(0);
    }
  }
  return { startDate, endDate };
};


const computeEmployeesPayrolls = useCallback(() => {
  const { startDate, endDate } = getTimeWindow();

  const rows = (employees || []).map(emp => {
    const fullName =
      `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || (emp.email || "Unnamed");

    const sum = (emp.payrolls || []).reduce((acc, p) => {
      // filtrare după intervalul selectat
      const s = p.startDate ? new Date(p.startDate) : null;
      const e = p.endDate ? new Date(p.endDate) : null;

      // Dacă am ambele capete, folosim overlap logic cel mai sigur
      // (payroll intersectează fereastra [startDate, endDate])
      const overlaps =
        (s && e)
          ? !(e < startDate || s > endDate)
          : // dacă nu avem ambele date, permităm intrarea dacă createdAt e în interval
            (p.createdAt ? (new Date(p.createdAt) >= startDate && new Date(p.createdAt) <= endDate) : true);

      if (!overlaps) return acc;

      // alegem o valoare pentru payroll:
      const val = Number(p.total ?? p.gross ?? 0) || 0;
      return acc + val;
    }, 0);

    return { name: fullName, total: sum };
  });

  // poți ordona desc după total ca să fie mai clar:
  rows.sort((a, b) => b.total - a.total);

  setEmployeesPayrolls(rows);
}, [employees, timeRange, customStartDate, customEndDate]);

useEffect(() => {
  computeEmployeesPayrolls();
}, [computeEmployeesPayrolls]);


  const fetchDashboardData = async () => {
    try {
      setIsLoadingDashboard(true);
      const response = await axios.get("https://api-backend.full-trucking-service.com/api/dashboard", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        withCredentials: true,
      });
  
    if (response.data) {
  setTasks((response.data.tasks || []).reduce((acc, task) => {
    acc[task.date] = task.tasks;
    return acc;
  }, {}));

  // 🔧 Normalizare goals ca să avem mereu id/type/value/progress
  const normalizedGoals = (response.data.goals || []).map((g) => ({
    id: String(g.id ?? g._id ?? g.goalId ?? ""),   // id sigur (string)
    type: g.type ?? "custom",
    value: Number(g.value) || 0,
    progress: Number(g.progress) || 0,
    _raw: g, // îl păstrăm în caz că îți trebuie
  }));

  setProgressGoals(normalizedGoals);
}

} catch (error) {
    // poți loga dacă vrei
  } finally {
    setIsLoadingDashboard(false); // 🟢 oprește loader
  }
};
useEffect(() => {
  if (!selectedGoal && progressGoals.length > 0) {
    setSelectedGoal(progressGoals[0]);
  }
}, [progressGoals]); // 🔹 scos `selectedGoal` din dependențe

const statusOptions = [
  { value: "open", label: "open" },
  { value: "in_progress", label: "in_progress" },
  { value: "done", label: "done" },
  { value: "canceled", label: "canceled" },
];
  const fetchDriverLoadStatus = async (driverId) => {
    try {
        const response = await axios.get(`${apiUrl}/loads/incomplete`, config);

        if (!response.data || response.data.length === 0) {
            setActiveLoad({ message: "No active load", lastLoadTime: "No data" });
            return;
        }

        // Filtrăm doar încărcăturile șoferului
        const driverLoads = response.data.filter(load => load.driver === driverId);

        if (driverLoads.length > 0) {
            setActiveLoad(driverLoads[0]);
            return;
        }

        // Preluăm toate încărcăturile pentru șofer
        const completedLoadsResponse = await axios.get(`${apiUrl}/loads`, config);

        if (!completedLoadsResponse.data || completedLoadsResponse.data.length === 0) {
            setActiveLoad({ message: "No loads history", lastLoadTime: "No data" });
            return;
        }

        // Selectăm doar încărcăturile finalizate sau anulate ale șoferului
        const completedLoads = completedLoadsResponse.data.filter(
            load => load.driver === driverId && ["Completed", "Cancelled"].includes(load.status)
        );

        if (completedLoads.length === 0) {
            setActiveLoad({ message: "No loads history", lastLoadTime: "No data" });
            return;
        }

        // Găsim cel mai recent load bazat pe `createdAt`
        const lastCompletedLoad = completedLoads.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )[0];

        // Calculăm diferența de zile între `createdAt` și data actuală
        const lastLoadDate = new Date(lastCompletedLoad.createdAt);
        const today = new Date();
        const timeDiff = Math.floor((today - lastLoadDate) / (1000 * 60 * 60 * 24));

        setActiveLoad({ 
            message: "No active load", 
            lastLoadTime: timeDiff > 0 ? timeDiff : "Today"
        });

    } catch (error) {
      
        setActiveLoad({ message: "Error fetching data", lastLoadTime: "No data" });
    }
};


  const fetchFuelReportDashboard = async () => {
    try {
      setIsLoadingFuelData(true); // 🔄 Pornim indicatorul de încărcare
    
  
      const response = await axios.get(`${apiUrl}/fuel-reports`, config);
      
  
      if (!response.data || response.data.length === 0) {
        console.warn("⚠️ No fuel reports found in database.");
        setIsLoadingFuelData(false);
        return;
      }
  
      if (!clientId) {

        setIsLoadingFuelData(false);
        return;
      }
  
      // 🔥 Filtrăm doar rapoartele pentru clientul curent
      const clientFuelReports = response.data.filter(
        report => report.clientId?.toString() === clientId.toString()
      );
  
   
  
      if (clientFuelReports.length === 0) {
        console.warn("⚠️ No fuel reports found for this client.");
        setIsLoadingFuelData(false);
        return;
      }
  
      // 🔥 Grupăm datele pentru chart
      const fuelData = clientFuelReports.reduce((acc, report) => {
        const date = new Date(report.createdAt).toLocaleDateString();
        if (!acc[date]) {
          acc[date] = { date, fuelSubtotal: 0, otherCosts: 0, grandTotal: 0 };
        }
  
        acc[date].fuelSubtotal += parseFloat(report.fuelSubtotal) || 0;
        acc[date].otherCosts += parseFloat(report.otherCosts) || 0;
        acc[date].grandTotal += parseFloat(report.grandTotal) || 0;
        return acc;
      }, {});
  
      const formattedFuelReports = Object.values(fuelData).sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
  

  
      setFuelCostsData(formattedFuelReports); // ✅ Setăm datele DOAR dacă avem rezultate
      setIsLoadingFuelData(false);
      
    } catch (error) {
      
      setIsLoadingFuelData(false);
    }
  };
  
  // ✅ Apelăm doar dacă există `clientId`
  useEffect(() => {
    if (clientId) {
      fetchFuelReportDashboard();
    }
  }, [clientId]);
  

  
  const fetchDriverPayrolls = async () => {
    try {
      const response = await axios.get(`${apiUrl}/totalpays`, config);
  
      if (response.status === 200) {
     
  
        if (response.data.length === 0) {
          console.warn("⚠️ No payroll data found in TotalPay collection");
        }
  
        // Grupăm plățile per șofer
        const payrollData = response.data.reduce((acc, pay) => {
          if (!pay.driverId) return acc;
          const driverName = `${pay.driverId.firstName} ${pay.driverId.lastName}`;
  
          if (!acc[driverName]) {
            acc[driverName] = 0;
          }
  
          acc[driverName] += pay.totalWithAdjustments;
          return acc;
        }, {});
  
       
  
        // Convertim în array pentru chart
        setDriverPayrolls(Object.keys(payrollData).map(name => ({
          name,
          total: payrollData[name]
        })));
      }
    } catch (error) {
   
    }
  };

  useEffect(() => {
    if (drivers.length > 0) {
      fetchDriverPayrolls();
    }
  }, [drivers]);
  

  const openDispatcherModal = (dispatcher) => {
    setSelectedDispatcher(dispatcher);
    setModalOpen(true);
  };
  
  const closeDispatcherModal = () => {
    setSelectedDispatcher(null);
    setModalOpen(false);
    setActiveLoad(null); // 📌 Resetăm și statusul load-ului
  };
  
  // Definim intervalul de timp selectat pentru DISPECERI
let dispatcherStartDate = new Date();
let dispatcherEndDate = new Date();

if (dispatcherTimeRange !== "custom") {
  switch (dispatcherTimeRange) {
    case "week":
      dispatcherStartDate.setDate(dispatcherEndDate.getDate() - 7);
      break;
    case "month":
      dispatcherStartDate.setDate(1);
      break;
    case "year":
      dispatcherStartDate = new Date(dispatcherEndDate.getFullYear(), 0, 1);
      break;
  }
} else if (customDispatcherStartDate && customDispatcherEndDate) {
  dispatcherStartDate = new Date(customDispatcherStartDate);
  dispatcherEndDate = new Date(customDispatcherEndDate);
}

  
  const fetchActiveLoad = async (entityId, type) => {
    try {
      const response = await axios.get(`${apiUrl}/loads/active?${type}Id=${entityId}`, config);
      if (response.data) {
        setActiveLoad(response.data);
      } else {
        setActiveLoad(null);
      }
    } catch (error) {
    
      setActiveLoad(null);
    }
  };

  const addNewGoal = async () => {
    if (!clientId || !newGoalType || !newGoalValue) return;
    try {
      const response = await axios.post(
        `${apiUrl}/dashboard/goals`,
        { type: newGoalType, value: newGoalValue, startDate: customStartDate, endDate: customEndDate },
        config
      );
  
      if (response.status === 201) {
     
        fetchDashboardData(); // 🔹 Actualizează dashboard-ul
      }
    } catch (error) {

    }
  };
  
  
  const updateProgress = async (goalId, value) => {
    if (!clientId) return;
    try {
      const response = await axios.post(`${apiUrl}/dashboard/goals/update`, {
        clientId,
        goalId,
        progress: value,
      }, config);
  
      if (response.data) {
        fetchDashboardData();
      }
    } catch (error) {
      
    }
  };
  
  // ===== TASKS API =====

// Fetch pe luna din calendar (pentru toate zilele)
const fetchTasksForMonth = async () => {
  try {
    setIsLoadingTasks(true);
    const { startKey, endKey } = getMonthRange(calendarDate);
    const res = await axios.get(`${apiUrl}/tasks?from=${startKey}&to=${endKey}`, config);

    const items = res.data?.items || res.data || []; // suportă ambele
    // grupăm pe date
    const grouped = items.reduce((acc, t) => {
      const k = t.date || "";
      if (!acc[k]) acc[k] = [];
      acc[k].push(t);
      return acc;
    }, {});
    setTasksByDate(grouped);
  } catch (err) {
    // console.error('fetchTasksForMonth', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Create
const createTask = async () => {
  if (!selectedDate || !taskForm.title.trim()) return;
  try {
    setIsLoadingTasks(true);
    const payload = {
      title: taskForm.title.trim(),
      description: (taskForm.description || "").trim(),
      status: taskForm.status,
      priority: taskForm.priority,
      assignedTo: taskForm.assignedTo || null,
      date: selectedDate, // cheia tip "YYYY-M-D"
    };
    const res = await axios.post(`${apiUrl}/tasks`, payload, config);
    // reîncarcă luna
    await fetchTasksForMonth();
    setShowAddTaskModal(false);
    setTaskForm({ title: "", description: "", status: "open", priority: "medium", assignedTo: "" });
  } catch (err) {
    // console.error('createTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Update “status” rapid din listă
const updateTaskStatus = async (taskId, newStatus) => {
  try {
    setIsLoadingTasks(true);
    await axios.put(`${apiUrl}/tasks/${taskId}`, { status: newStatus }, config);
    await fetchTasksForMonth();
  } catch (err) {
    // console.error('updateTaskStatus', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Open edit modal (prefill)
const startEditTask = (task) => {
  setEditTask(task);
  setTaskForm({
    title: task.title || "",
    description: task.description || "",
    status: task.status || "open",
    priority: task.priority || "medium",
    assignedTo: task.assignedTo?._id || task.assignedTo || "",
  });
  setShowEditTaskModal(true);
};

// Confirm edit (PUT)
const saveEditTask = async () => {
  if (!editTask?._id) return;
  try {
    setIsLoadingTasks(true);
    await axios.put(`${apiUrl}/tasks/${editTask._id}`, {
      title: taskForm.title,
      description: taskForm.description,
      status: taskForm.status,
      priority: taskForm.priority,
      assignedTo: taskForm.assignedTo || null,
      date: editTask.date, // data nu se schimbă în acest flux
    }, config);
    await fetchTasksForMonth();
    setShowEditTaskModal(false);
    setEditTask(null);
  } catch (err) {
    // console.error('saveEditTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};

// Delete
const deleteTask = async (taskId) => {
  try {
    setIsLoadingTasks(true);
    await axios.delete(`${apiUrl}/tasks/${taskId}`, config);
    await fetchTasksForMonth();
    setShowEditTaskModal(false);
    setEditTask(null);
  } catch (err) {
    // console.error('deleteTask', err);
  } finally {
    setIsLoadingTasks(false);
  }
};


  useEffect(() => {
    const savedTasks = JSON.parse(localStorage.getItem("tasks")) || {};
    setTasks(savedTasks);
  }, []);

  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  const getDaysInMonth = () => {
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = () => {
    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();
    return new Date(year, month, 1).getDay();
  };

  const handlePrevMonth = () => {
    setCalendarDate((prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCalendarDate((prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
  fetchTasksForMonth();
}, [calendarDate]); // reîncarcă task-urile când user-ul schimbă luna

  const handleTaskAdd = async () => {
    if (!clientId || !newTask || !selectedDate) return;
    try {
      const response = await axios.post(
        `${apiUrl}/dashboard/tasks`,
        { date: selectedDate, task: newTask },
        config
      );
  
      if (response.status === 201) {
       
        setNewTask(""); // 🔹 Golește input-ul după adăugare
        fetchDashboardData(); // 🔹 Actualizează dashboard-ul cu datele noi
      }
    } catch (error) {
      
    }
  };
  
  
const renderCalendarDays = () => {
  const totalDays = getDaysInMonth();
  const firstDayIndex = getFirstDayOfMonth();
  const days = [];

  const today = new Date();
  const todayKey = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

  for (let i = 0; i < firstDayIndex; i++) {
    days.push(
      <div key={`empty-${i}`} className={styles.emptyultimatedashboardoverview}></div>
    );
  }

  for (let day = 1; day <= totalDays; day++) {
    const dateKey = `${calendarDate.getFullYear()}-${calendarDate.getMonth() + 1}-${day}`;
    const taskList = tasksByDate[dateKey] || [];

    // ✅ doar taskuri active (nu done/canceled)
    const hasActiveTasks = taskList.some(
      (t) => t.status !== "done" && t.status !== "canceled"
    );

    days.push(
      <div
        key={day}
        className={[
          styles.day,
          hasActiveTasks ? styles.taskDay : "",
          dateKey === todayKey ? styles.todayDay : "",
          selectedDate === dateKey ? styles.selectedDay : "",
        ].join(" ")}
        onClick={() => handleDateClick(dateKey)}
      >
        <span>{day}</span>
        {/* ❌ scos complet <p>{taskList.length} tasks</p> */}
      </div>
    );
  }

  return days;
};




  useEffect(() => {
    if (drivers.length && trucks.length && loads.length) {
      calculateDashboardData();
    }
  }, [drivers, trucks, loads, fuelReports, iftaReports, driverPays, timeRange, customStartDate, customEndDate]);  
  const calculateDashboardData = () => {
    if (!loads || loads.length === 0) {
        console.warn("⚠️ No load data available, setting default values.");
        setDashboardData((prevData) => ({
            ...prevData,
            completeLoads: 0,
            canceledLoads: 0,
            incompleteLoads: 0,
            totalDrivers: 0,
            totalTrucks: 0,
            totalLoads: 0,
            totalMiles: 0,
            totalRevenue: 0,
            loadsPerDriver: [],
            loadsPerTruck: [],
            monthlyRevenue: { labels: [], values: [] },
        }));
        return;
    }


    const now = new Date();
    let filteredLoads = [...loads];


    const driverLastLoad = {};
    loads.forEach(load => {
        if (load.status?.toLowerCase() === "complete" && load.driver) {
            const loadDate = new Date(load.deliveryTime || load.shippers?.[0]?.deliveryTime || load.createdAt);
            if (!driverLastLoad[load.driver] || loadDate > driverLastLoad[load.driver]) {
                driverLastLoad[load.driver] = loadDate;
            }
        }
    });
  
let startDate = new Date();
let endDate = new Date();

const getLoadDate = (load) =>
  new Date(load.date || load?.shippers?.[0]?.pickUpTime || load.createdAt);

if (!timeRange) {
  // All Time → ia de la primul load până la ultimul
  filteredLoads = [...loads];
  const allDates = loads.map(getLoadDate).filter(d => !isNaN(d));
  if (allDates.length) {
    startDate = new Date(Math.min(...allDates));
    endDate   = new Date(Math.max(...allDates));
  } else {
    startDate = new Date(0);
    endDate   = new Date();
  }
} else if (timeRange === "custom" && customStartDate && customEndDate) {
  startDate = new Date(customStartDate);
  endDate   = new Date(customEndDate);
  filteredLoads = loads.filter(load => {
    const ld = getLoadDate(load);
    return ld >= startDate && ld <= endDate;
  });
} else {
  const now = new Date();
  startDate = new Date();
  endDate   = new Date();
  switch (timeRange) {
    case "day": break;
    case "week": startDate.setDate(now.getDate() - 7); break;
    case "month": startDate = new Date(now.getFullYear(), now.getMonth(), 1); break;
    case "year":  startDate = new Date(now.getFullYear(), 0, 1); break;
  }
  filteredLoads = loads.filter(load => {
    const ld = getLoadDate(load);
    return ld >= startDate && ld <= endDate;
  });
}

// ✅ calculează spanOverYear **după** ce ai setat corect ferestrele
const today = new Date();
const clampedEnd = endDate > today ? today : endDate; // nu trecem în viitor
const spanOverYear = !timeRange && diffInMonths(startDate, clampedEnd) > 12;

// ✅ generează etichetele
const revenueData = {};
if (!timeRange) {
  if (spanOverYear) {
    // pe ani
    let current = new Date(startDate.getFullYear(), 0, 1);
    const last  = new Date(clampedEnd.getFullYear(), 0, 1);
    while (current <= last) {
      revenueData[String(current.getFullYear())] = 0;
      current.setFullYear(current.getFullYear() + 1);
    }
  } else {
    // pe luni
    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const last  = new Date(clampedEnd.getFullYear(), clampedEnd.getMonth(), 1);
    while (current <= last) {
      const label = current.toLocaleString("en-US", { month: "short", year: "numeric" });
      revenueData[label] = 0;
      current.setMonth(current.getMonth() + 1);
    }
  }
} else {
  // păstrezi logica ta existentă (dacă vrei, poți optimiza “year” să avanseze lună cu lună)
  let current = new Date(startDate);
  while (current <= endDate) {
    let label;
    switch (timeRange) {
      case "day":
        label = current.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
        current.setHours(current.getHours() + 1);
        break;
      case "week":
        label = current.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
        current.setDate(current.getDate() + 1);
        break;
      case "month":
        label = `Week ${Math.ceil(current.getDate() / 7)} ${current.toLocaleString("en-US", { month: "short" })}`;
        current.setDate(current.getDate() + 1);
        break;
      case "year":
        label = current.toLocaleString("en-US", { month: "short", year: "numeric" });
        // 👉 pentru year e mai corect să avansezi cu o lună:
        current.setMonth(current.getMonth() + 1);
        break;
    }
    revenueData[label] = 0;
  }
}
filteredLoads.forEach(load => {
  const ld = getLoadDate(load);
  if (isNaN(ld)) return;

  let label;
  if (!timeRange) {
    label = spanOverYear
      ? String(ld.getFullYear())
      : ld.toLocaleString("en-US", { month: "short", year: "numeric" });
  } else {
    switch (timeRange) {
      case "day":
        label = ld.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
        break;
      case "week":
        label = ld.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
        break;
      case "month":
        label = `Week ${Math.ceil(ld.getDate() / 7)} ${ld.toLocaleString("en-US", { month: "short" })}`;
        break;
      case "year":
        label = ld.toLocaleString("en-US", { month: "short", year: "numeric" });
        break;
      default:
        return; // ❗️nu mai băgăm în "Unknown"
    }
  }
  revenueData[label] = (revenueData[label] || 0) + (parseFloat(load.rate) || 0);
});

    // 🔹 Calculăm metricile DOAR pentru încărcăturile filtrate
    const totalDrivers = drivers.length;
    const totalTrucks = trucks.length;
    const totalLoads = filteredLoads.length;
    const totalMiles = filteredLoads.reduce((acc, load) => acc + (parseFloat(load.miles) || 0), 0);
    const totalRevenue = filteredLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
// 🔹 Revenue per Mile
const revenuePerMile = totalMiles > 0 ? totalRevenue / totalMiles : 0;

    const loadsPerDriver = drivers.map(driver => ({
        name: `${driver.firstName} ${driver.lastName}`,
        count: filteredLoads.filter(load => load.driver === driver._id).length,
    }));

    const loadsPerTruck = trucks.map(truck => ({
        name: truck.truckNumber,
        count: filteredLoads.filter(load => load.truck === truck._id).length,
    }));

// 🔹 Grupare load-uri pe zile
const loadsByDate = filteredLoads.reduce((acc, load) => {
  const date = new Date(load.createdAt).toLocaleDateString();
  if (!acc[date]) {
    acc[date] = { date, totalRevenue: 0, totalMiles: 0 };
  }
  acc[date].totalRevenue += parseFloat(load.rate) || 0;
  acc[date].totalMiles += parseFloat(load.miles) || 0;
  return acc;
}, {});

// 🔹 Convertim în array sortat
const loadsByDateArray = Object.values(loadsByDate).sort(
  (a, b) => new Date(a.date) - new Date(b.date)
);

    // 🔹 Compare Dispatchers Chart Data
const dispatcherStats = [];

dispatchers.forEach(dispatcher => {
    const dispatcherLoads = filteredLoads.filter(load => load.dispatcher === dispatcher._id);
    const totalRevenue = dispatcherLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);

    dispatcherStats.push({
        name: `${dispatcher.firstName} ${dispatcher.lastName}`,
        loadCount: dispatcherLoads.length,
        totalRevenue
    });
});



    // ETA Delay Tracker
const avgTruckSpeed = 55; // mph - viteză medie estimată
let totalDelayHours = 0;
let delayCount = 0;

filteredLoads.forEach(load => {
    const pickup = new Date(load.shippers?.[0]?.pickUpTime || load.pickUpTime);
    const delivery = new Date(load.shippers?.[0]?.deliveryTime || load.deliveryTime);
    const miles = parseFloat(load.miles) || 0;

    if (!isNaN(pickup) && !isNaN(delivery) && miles > 0) {
        const plannedHours = (delivery - pickup) / (1000 * 60 * 60); // în ore
        const theoreticalHours = miles / avgTruckSpeed; // în ore

        const delay = plannedHours - theoreticalHours; // ore
        totalDelayHours += delay;
        delayCount++;
    }
});

const averageDelayHours = delayCount > 0 ? totalDelayHours / delayCount : 0;

// 🔹 Adăugăm în dashboardData

    // 🔹 Calculăm Dispatch Efficiency per dispatcher
const dispatchEfficiency = dispatchers.map(dispatcher => {
  const loadsAssigned = filteredLoads.filter(load => load.dispatcher === dispatcher._id).length;
  const efficiency = totalDrivers > 0 ? ((loadsAssigned / totalDrivers) * 100).toFixed(2) : 0;

  return {
    name: `${dispatcher.firstName} ${dispatcher.lastName}`,
    loadsAssigned,
    efficiency: parseFloat(efficiency)
  };
});


    // 🔹 Calculează performanța șoferilor
const driverPerformance = drivers.map(driver => {
    const driverLoads = filteredLoads.filter(load => load.driver === driver._id && load.status?.toLowerCase() === "completed");
    const totalRevenue = driverLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    return {
        name: `${driver.firstName} ${driver.lastName}`,
        totalRevenue,
        completedLoads: driverLoads.length
    };
});

// 🔹 Calculează pentru camioane
const truckPerformance = trucks.map(truck => {
    const truckLoads = filteredLoads.filter(load => load.truck === truck._id && load.status?.toLowerCase() === "completed");
    const totalRevenue = truckLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0);
    return {
        name: truck.truckNumber,
        totalRevenue,
        completedLoads: truckLoads.length
    };
});

// 🔹 Sortează și ia top 3
const topDriversByRevenue = [...driverPerformance].sort((a, b) => b.totalRevenue - a.totalRevenue).slice(0, 3);
const topDriversByLoads = [...driverPerformance].sort((a, b) => b.completedLoads - a.completedLoads).slice(0, 3);

const topTrucksByRevenue = [...truckPerformance].sort((a, b) => b.totalRevenue - a.totalRevenue).slice(0, 3);
const topTrucksByLoads = [...truckPerformance].sort((a, b) => b.completedLoads - a.completedLoads).slice(0, 3);



    const validLoads = filteredLoads.map(load => {
        let formattedDate = "Unknown Date";

        // Verificăm mai multe surse pentru data încărcăturii
        const potentialDate = load.date || load.shippers?.[0]?.pickUpTime || load.createdAt;

        if (potentialDate) {
            const dateObj = new Date(potentialDate);
            if (!isNaN(dateObj.getTime())) {
                formattedDate = dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
            } else {
                console.warn("⚠️ Invalid date detected:", potentialDate);
            }
        }

        return {
            ...load,
            rate: !load.rate || isNaN(parseFloat(load.rate)) ? 0 : parseFloat(load.rate),
            date: formattedDate
        };
    });

    const monthlyRevenue = validLoads.reduce((acc, load) => {
        acc[load.date] = (acc[load.date] || 0) + load.rate;
        return acc;
    }, {});

    const fuelCosts = fuelReports.map(report => ({
      date: new Date(report.createdAt).toLocaleDateString(),
      total: report.grandTotal || 0,
      fuel: report.fuelSubtotal || 0,
      other: report.otherCosts || 0
    }));

    // 🔹 Calculăm plățile pentru șoferi
    const driverPayments = driverPays.map(pay => ({
      driver: `${pay.driver?.firstName || "No data"} ${pay.driver?.lastName || ""}`,
      totalPay: pay.totalPay || 0
    }));
// ---- PROFIT METRICS ----

// total fuel costs (din fuelReports map-uit mai sus în `fuelCosts`)
const totalFuelCosts = fuelCosts.reduce((acc, r) => acc + (parseFloat(r.total) || 0), 0);

// total driver pay (din driverPayments map-uit chiar mai sus)
const totalDriverPay = driverPayments.reduce((acc, p) => acc + (parseFloat(p.totalPay) || 0), 0);

// profit estimat pe întreg intervalul selectat
const estimatedProfit = totalRevenue - totalFuelCosts - totalDriverPay;
const bucketLabel = (dateObj) => {
  if (!timeRange) {
    // All Time
    return spanOverYear
      ? String(dateObj.getFullYear())                                         // ➜ ani
      : dateObj.toLocaleString("en-US", { month: "short", year: "numeric" }); // ➜ luni
  }

  switch (timeRange) {
    case "day":
      return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
    case "week":
      return dateObj.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" });
    case "month":
      return `Week ${Math.ceil(dateObj.getDate() / 7)} ${dateObj.toLocaleString("en-US", { month: "short" })}`;
    case "year":
      return dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
    default:
      return dateObj.toLocaleString("en-US", { month: "short", year: "numeric" });
  }
};


// agregăm fuel pe același set de label-uri ca revenueData
const labels = Object.keys(revenueData);
const fuelByLabel = Object.fromEntries(labels.map(l => [l, 0]));

fuelReports.forEach(report => {
  const d = new Date(report.createdAt);
  const l = bucketLabel(d);
  if (l in fuelByLabel) {
    fuelByLabel[l] += parseFloat(report.grandTotal || report.total || 0) || 0;
  }
});

// Notă: driverPays nu are date per plată; distribuim egal totalDriverPay pe numărul de etichete
const driverPayPerLabel = labels.length ? (totalDriverPay / labels.length) : 0;

// calculăm profit în timp pe aceleași etichete
const profitValues = labels.map(l => {
  const rev = revenueData[l] || 0;
  const fuel = fuelByLabel[l] || 0;
  return rev - fuel - driverPayPerLabel;
});


    const completeLoads = filteredLoads.filter(load => load.status?.toLowerCase() === "completed").length;
    const canceledLoads = filteredLoads.filter(load => 
      load.status?.toLowerCase() === "cancelled" || load.status?.toLowerCase() === "canceled"
  ).length;
  
   const incompleteLoads = filteredLoads.filter(load => 
    load.status && !["completed", "canceled", "cancelled"].includes(load.status.toLowerCase())
).length;
    setDashboardData({
      fuelCosts,
      driverPayments,
      totalDrivers: drivers.length,
      totalTrucks: trucks.length,
      totalLoads: filteredLoads.length,
      totalMiles: filteredLoads.reduce((acc, load) => acc + (parseFloat(load.miles) || 0), 0),
      totalRevenue: filteredLoads.reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0),
      loadsPerDriver: drivers.map(driver => ({
          name: `${driver.firstName} ${driver.lastName}`,
          count: filteredLoads.filter(load => load.driver === driver._id).length,
      })),
      loadsPerTruck: trucks.map(truck => ({
          name: truck.truckNumber,
          count: filteredLoads.filter(load => load.truck === truck._id).length,
      })),
      monthlyRevenue: {
          labels: Object.keys(revenueData),
          values: Object.values(revenueData),
      },
      completeLoads,  // ✅ Acum corect
      canceledLoads,  // ✅ Acum corect
      incompleteLoads,
      topDriversByRevenue,
  topDriversByLoads,
  topTrucksByRevenue,
  topTrucksByLoads,
  estimatedProfit,
fuelCosts,
  driverPayments,
   dispatchEfficiency,
   averageDelayHours: parseFloat(averageDelayHours.toFixed(2)),
averageDelayMinutes: parseFloat((averageDelayHours * 60).toFixed(0)),
revenuePerMile,
dispatcherComparison: dispatcherStats,
 loadsByDate: loadsByDateArray


    });
};


const saveKpi = async () => {
  const category = document.getElementById("category").value;
  const name = document.getElementById("name").value;
  const value = document.getElementById("value").value;
  const unit = document.getElementById("unit").value;
  const target = document.getElementById("target").value;

  try {
    const res = await axios.post(`${apiUrl}/kpi`, {
      category, name, value, unit, target
    }, config);

    setKpis([...kpis, res.data.result]);
    setShowAddModal(false);
  } catch (err) {
    console.error("❌ Error saving KPI", err);
  }
};

useEffect(() => {
  const fetchKpis = async () => {
    try {
if (!clientId) return;

const res = await axios.get(`${apiUrl}/widgets/${clientId}`, config);

      const widgets = (res.data || []).map(w => ({
        ...w,
        id: w._id   // aici facem alias la _id
      }));

      setKpis(widgets.filter(w => w.type === "kpi"));
      setCards(widgets.filter(w => w.type === "card"));
      setCharts(widgets.filter(w => w.type === "chart"));
    } catch (err) {
      console.error("❌ Error fetching KPIs", err);
    }
  };

  fetchKpis();
}, [clientData?._id]);

const handleAddWidget = async () => {
  let metric = "";

  if (newWidgetType === "kpi") {
    metric = document.getElementById("kpiMetric").value;
  } else if (newWidgetType === "card") {
    metric = document.getElementById("cardMetric").value;
  } else if (newWidgetType === "chart") {
    metric = document.getElementById("chartMetric").value;
  }

  const metricMap = {
    utilizationRate: "utilizationRate",
    revenuePerTruck: "revenuePerTruck",
    revenuePerDriver: "revenuePerDriver",
    profitMargin: "profitMargin",
    operatingRatio: "operatingRatio",
    iftaCompliance: "iftaCompliance",
    driverTurnover: "driverTurnover",
    payPerMile: "payPerMile",
    maintCostPerMile: "maintCostPerMile",
    fuelEfficiency: "fuelEfficiency",
    nextServiceDue: "nextServiceDue",
    repeatLoads: "repeatLoads",
    loadsPerDispatcher: "loadsPerDispatcher",
    revenuePerDispatcher: "revenuePerDispatcher",
    loadsPerDriver: "loadsPerDriver",
    loadsPerTruck: "loadsPerTruck"
  };

  const kpiKey = metricMap[metric] || metric;

  // aici diferențiem: dacă e chart => trimitem array, altfel number simplu
  let metricValue = null;

 if (newWidgetType === "chart") {
  const rawVal = kpiData[kpiKey];

  if (Array.isArray(rawVal)) {
    // dacă e deja array (ex: topClients)
    metricValue = rawVal;
  } else if (typeof rawVal === "object") {
    // dacă e obiect cu key:value → transformăm în array
    metricValue = Object.entries(rawVal).map(([name, total]) => ({ name, total }));
  } else {
    // fallback: single number → îl punem într-un array ca să nu crape bar chart
    metricValue = [{ name: kpiKey, total: Number(rawVal) || 0 }];
  }
} else {
  metricValue = kpiData[kpiKey] ?? 0;
}

  try {
    const payload = {
  clientId,
  type: newWidgetType, // "kpi" | "card" | "chart"
  metric: kpiKey,
  value: metricValue,
  chartType: newWidgetType === "chart" 
    ? (document.getElementById("chartType").value === "column" ? "bar" : document.getElementById("chartType").value)
    : null,
};
    const res = await axios.post(
      "https://api-backend.full-trucking-service.com/api/widgets",
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const savedWidget = res.data;

    if (savedWidget.type === "kpi") {
      setKpis([...kpis, savedWidget]);
    } else if (savedWidget.type === "card") {
      setCards([...cards, savedWidget]);
    } else if (savedWidget.type === "chart") {
      setCharts([...charts, savedWidget]);
    }

    setShowAddModal(false);
  } catch (err) {
    console.error("Error saving widget:", err);
  }
};


// la montare
useEffect(() => {
  if (!clientData?._id) return;

  const fetchWidgets = async () => {
    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/widgets/${clientData._id}`
      );

      const all = res.data;
      setKpis(all.filter(w => w.type === "kpi"));
      setCards(all.filter(w => w.type === "card"));
      setCharts(all.filter(w => w.type === "chart"));
    } catch (err) {
      console.error("❌ Error fetching widgets", err);
    }
  };

  fetchWidgets();
}, [clientData]);



const handleDeleteKPI = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setKpis(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting KPI:", err);
  }
};

const handleDeleteCard = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setCards(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting Card:", err);
  }
};

const handleDeleteChart = async (id) => {
  try {
    await axios.delete(
      `https://api-backend.full-trucking-service.com/api/widgets/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    setCharts(prev => prev.filter(w => w._id !== id && w.id !== id));
  } catch (err) {
    console.error("Error deleting Chart:", err);
  }
};


const computeAchievedForGoal = useCallback((goal) => {
  if (!goal) return 0;

  // dacă backend-ul ți-a salvat progress numeric și > 0, îl folosim ca atare
  const progressNum = Number(goal.progress);
  if (Number.isFinite(progressNum) && progressNum > 0) {
    return progressNum;
  }

  // altfel derivăm suma rate-urilor din loads pe intervalul goal-ului
  const now = new Date();
  let start = null;
  let end = null;

  if (goal.startDate && goal.endDate) {
    start = new Date(goal.startDate);
    end = new Date(goal.endDate);
  } else {
    // mapăm după tip: daily/weekly/monthly/yearly
    end = new Date(now);
    const type = String(goal.type || "").toLowerCase();
    switch (type) {
      case "daily":
        start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        break;
      case "weekly":
        start = new Date(now);
        start.setDate(now.getDate() - 6);
        start.setHours(0, 0, 0, 0);
        break;
      case "monthly":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        break;
      case "yearly":
        start = new Date(now.getFullYear(), 0, 1);
        break;
      default:
        // fallback: tot istoricul
        start = new Date(0);
    }
  }

  const relevantLoads = (loads || []).filter((load) => {
    const d = new Date(load.date || load?.shippers?.[0]?.pickUpTime || load.createdAt);
    return !isNaN(d) && d >= start && d <= end;
  });

  const total = relevantLoads.reduce((acc, l) => acc + (parseFloat(l.rate) || 0), 0);
  return total;
}, [loads]);

  return (
    
 
<div
  className={`${styles.ultimatedashboardoverview} ${
    userSettings?.theme === 'light' ? styles.ultimatePageLight : ''
  }`}
>



      {/* Side Menu */}
      <div className={styles.sidebarToggle} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebarultimatedashboardoverview} ${isSidebarOpen ? styles.sidebarOpen : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
  
{/* AI Button */}
<div className={styles.aiButtonWrapper}>
  <button className={styles.aiButton} onClick={askAI}>
    Ask AI for Suggestions
  </button>
</div>




</aside>
<Loader isLoading={isLoadingDashboard} />


      {/* Main Content */}
      <div className={styles.mainContentultimatedashboardoverview}>
      <div className={styles.dashboardTitleContainer}>
</div>

{/* === Header Actions Row === */}
<div className={styles.headerActionsRow}>
  <button 
    className={styles.addWidgetButton} 
    onClick={() => setShowAddModal(true)}
  >
    + Add New Widget
  </button>

  <button
    onClick={() => {
      setShowStrategyModal(true);
      generatePlan();
    }}
    className={styles.strategyButton}
  >
    Make a Strategy Plan with AI
  </button>
</div>


{/* === MODAL STRATEGIE === */}
{showStrategyModal && (
  <div className={styles.strategyOverlay}>
    <div className={styles.strategyPanel}>
      <button 
        className={styles.closeButton}
        onClick={() => setShowStrategyModal(false)}
      >
        ✕
      </button>

      <h2 className={styles.strategyTitle}>AI Strategy Plan</h2>

      {loadingStrategy ? (
        <p className={styles.loadingText}>Calculating strategy...</p>
      ) : planText ? (
        <div className={styles.strategyContent}>
          <pre className={styles.strategyText}>{planText}</pre>
        </div>
      ) : (
        <p className={styles.noPlan}>No plan generated yet.</p>
      )}

 <div className={styles.strategyActions}>
  <button 
    onClick={() => downloadPDFStrategy(clientId)} 
    className={styles.downloadButton}
  >
    Download PDF
  </button>
</div>

    </div>
  </div>
)}


{showAddModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher}>
      <h3>Add New Widget</h3>

      {/* Tipul widgetului */}
      <select value={newWidgetType} onChange={(e) => setNewWidgetType(e.target.value)}>
        <option value="">Select type...</option>
        <option value="chart">Chart</option>
        <option value="kpi">KPI</option>
        <option value="card">Card</option>
      </select>

      {/* Dacă e Chart */}
      {newWidgetType === "chart" && (
        <div>
          <h4>Select chart type:</h4>
          <select id="chartType">
            <option value="bar">Bar</option>
            <option value="line">Line</option>
            <option value="column">Column</option>
            <option value="doughnut">Doughnut</option>
            <option value="pie">Pie</option>
            <option value="gauge">Gauge</option>
          </select>

          <h4>Select chart metric:</h4>
          <select id="chartMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Dacă e KPI */}
      {newWidgetType === "kpi" && (
        <div>
          <h4>Select KPI metric</h4>
          <select id="kpiMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Dacă e Card */}
      {newWidgetType === "card" && (
        <div>
          <h4>Select card metric</h4>
          <select id="cardMetric">
            <option value="utilization">Utilization rate</option>
            <option value="revPerTruck">Revenue per truck/driver</option>
            <option value="profitMargin">Profit margin %</option>
            <option value="operatingRatio">Operating ratio (OR)</option>
            <option value="arAging">AR aging 30/60/90</option>
            <option value="ifta">IFTA compliance</option>
            <option value="driverTurnover">Driver turnover %</option>
            <option value="payPerMile">Avg pay per mile</option>
            <option value="maintCost">Maintenance cost per mile</option>
            <option value="fuelEff">Fuel efficiency MPG</option>
            <option value="nextService">Next service due</option>
            <option value="topClients">Top 5 clients by revenue</option>
            <option value="repeatLoads">Repeat loads %</option>
            <option value="loadsDispatcher">Loads per dispatcher</option>
            <option value="revDispatcher">Revenue per dispatcher</option>
          </select>
        </div>
      )}

      {/* Butoane */}
      <button onClick={handleAddWidget}>Add</button>
      <button onClick={() => setShowAddModal(false)}>Close</button>
    </div>
  </div>
)}

{showAIModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div 
      className={styles.modalContentDispatcher} 
      style={{ maxWidth: 600, width: "100%", padding: "20px", borderRadius: "12px" }}
    >
      <button 
        className={styles.closeButtonDispatcher} 
        onClick={() => setShowAIModal(false)}
        style={{ position: "absolute", top: 15, right: 15 }}
      >
        ✕
      </button>

      <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px" }}>
        AI Dashboard Insights
      </h3>

      {isThinking ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 30 }}>
          <div className={styles.loaderBubbles}>
            <span></span><span></span><span></span>
          </div>
        </div>
      ) : aiSuggestion.length > 0 ? (
        <ul style={{ marginTop: 10, listStyle: "none", padding: 0 }}>
          {aiSuggestion.map((s, i) => (
            <li 
              key={i} 
              style={{ 
                marginBottom: 12, 
                lineHeight: "1.6", 
                background: "rgba(255,255,255,0.05)", 
                padding: "10px 14px", 
                borderRadius: "8px", 
                
                animation: `fadeIn 0.3s ease forwards ${i * 0.2}s` 
              }}
            >
              {s}
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ marginTop: 20, color: "#999" }}>No suggestions received.</p>
      )}
    </div>
  </div>
)}

{/* Select Time Range */}
<div className={styles.timeFilterultimatedashboardoverview}>
  <label htmlFor="timeRange">Select Time Range:</label>
  <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
      <option value="">All Time</option>
    <option value="day">Today</option>
    <option value="week">This Week</option>
    <option value="month">This Month</option>
    <option value="year">This Year</option>
    <option value="custom">Custom Range</option>
  </select>

  {timeRange === "custom" && (
    <div className={styles.customDatePickerultimatedashboardoverview}>
      <label>From: <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} /></label>
      <label>To: <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} /></label>
    </div>
  )}
</div>
<div className={styles.statsdashboardoverview}>
  <div className={styles.statCardultimatedashboardoverview}><h4>Total Drivers</h4><p>{dashboardData.totalDrivers}</p></div>
  <div className={styles.statCardultimatedashboardoverview}><h4>Total Trucks</h4><p>{dashboardData.totalTrucks}</p></div>
  <div className={styles.statultimatedashboardoverview}><h4>Total Loads</h4><p>{dashboardData.totalLoads}</p></div>
<div className={styles.statultimatedashboardoverview}>
  <h4>Total Miles</h4>
  <p>{dashboardData.totalMiles?.toFixed(2)}</p>
</div>
  <div className={styles.statultimatedashboardoverview}><h4>Total Revenue</h4><p>${dashboardData.totalRevenue}</p></div>
  <div className={styles.statultimatedashboardoverview}><h4>Estimated Profit</h4><p>${dashboardData.estimatedProfit?.toFixed(2)}</p></div>
  <div className={styles.statultimatedashboardoverview}><h4>Revenue per Mile</h4><p>${dashboardData.revenuePerMile?.toFixed(2)}</p></div>
  <div className={styles.statultimatedashboardoverview}><h4>ETA Delay Tracker</h4><p>{dashboardData.averageDelayHours?.toFixed(2)} hrs</p><small>({dashboardData.averageDelayMinutes} min)</small></div>
</div>


<div className={styles.sectionDivider} />
        <div className={styles.calendarSectionultimatedashboardoverview}>
          {/* Calendar */}
          <div className={styles.calendarContainerultimatedashboardoverview}>
            <div className={styles.calendarHeaderultimatedashboardoverview}>
  <button className={styles.calendarButton} onClick={handlePrevMonth}>
    <FaChevronLeft />
  </button>
  <h2>
    {calendarDate.toLocaleString("default", { month: "long", year: "numeric" })}
  </h2>
  <button className={styles.calendarButton} onClick={handleNextMonth}>
    <FaChevronRight />
  </button>
</div>

            <div className={styles.weekDaysultimatedashboardoverview}>
              {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map((day) => (
                <div key={day} className={styles.weekDayultimatedashboardoverview}>{day}</div>
              ))}
            </div>

            <div className={styles.calendarDaysultimatedashboardoverview}>{renderCalendarDays()}</div>
          </div>

       {/* Tasks Panel */}
{selectedDate && (
  <div className={styles.toDoListultimatedashboardoverview}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h3>Tasks for {selectedDate}</h3>
      <button onClick={() => {
        setTaskForm({ title: "", description: "", status: "open", priority: "medium", assignedTo: "" });
        setShowAddTaskModal(true);
      }}>
        + Add Task
      </button>
    </div>

    {isLoadingTasks ? (
      <p>Loading tasks...</p>
    ) : (
      <>
        {Array.isArray(tasksByDate[selectedDate]) && tasksByDate[selectedDate].length > 0 ? (
          <ul style={{ listStyle: "none", padding: 0, marginTop: 10 }}>
            {tasksByDate[selectedDate].map((t) => (
              <li key={t._id} className={styles.taskCard}>
                <div className={styles.taskHeader}>
                  <span className={styles.taskTitle}>{t.title}</span>
                  <div className={styles.taskBadges}>
                    <span className={`${styles.badge} ${styles[`status_${t.status}`]}`}>{t.status}</span>
                    <span className={`${styles.badge} ${styles[`priority_${t.priority}`]}`}>{t.priority}</span>
                  </div>
                </div>

                {t.description ? <p className={styles.taskDesc}>{t.description}</p> : null}

                <div className={styles.taskActions}>
                  <select
                    value={t.status}
                    onChange={(e) => updateTaskStatus(t._id, e.target.value)}
                    className={styles.taskStatusSelect}
                    title="Quick status update"
                  >
                    <option value="open">open</option>
                    <option value="in_progress">in_progress</option>
                    <option value="done">done</option>
                    <option value="canceled">canceled</option>
                  </select>

                  <button onClick={() => startEditTask(t)}>Edit</button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No tasks on this day yet.</p>
        )}
      </>
    )}
  </div>
)}
  </div>
{/* ========== ADD TASK MODAL ========== */}
{showAddTaskModal && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher} style={{ maxWidth: 520, width: '100%' }}>
      <button className={styles.closeButtonDispatcher} onClick={() => setShowAddTaskModal(false)}>✕</button>
      <h3>Add New Task</h3>
      <p style={{ opacity: .8, marginTop: -6 }}>Date: <b>{selectedDate}</b></p>

      <div className={styles.formGroupultimateaddload}>
        <label>Title</label>
        <input
          value={taskForm.title}
          onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
          placeholder="Task title"
          className={styles.inputFieldultimateaddload}
        />
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Description</label>
        <textarea
          value={taskForm.description}
          onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
          placeholder="Short description..."
          className={styles.textareaFieldultimateaddload}
        />
      </div>

      <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
          <label>Status</label>
          <select
            value={taskForm.status}
            onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="open">open</option>
            <option value="in_progress">in_progress</option>
            <option value="done">done</option>
            <option value="canceled">canceled</option>
          </select>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Priority</label>
          <select
            value={taskForm.priority}
            onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
        </div>
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Assigned To</label>
        <select
          value={taskForm.assignedTo}
          onChange={(e) => setTaskForm({ ...taskForm, assignedTo: e.target.value })}
          className={styles.selectFieldultimateaddload}
        >
          <option value="">Unassigned</option>
          {/* Poți lista drivers + dispatchers, sau doar drivers */}
          {drivers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
          {dispatchers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName} (dispatcher)
            </option>
          ))}
        </select>
      </div>

      <button className={styles.addButtonConsigneeultimateaddload} onClick={createTask} disabled={isLoadingTasks}>
        {isLoadingTasks ? 'Saving...' : 'Add Task'}
      </button>
    </div>
  </div>
)}

{/* ========== EDIT TASK MODAL ========== */}
{showEditTaskModal && editTask && (
  <div className={styles.modalOverlayDispatcher}>
    <div className={styles.modalContentDispatcher} style={{ maxWidth: 520, width: '100%' }}>
      <button className={styles.closeButtonDispatcher} onClick={() => { setShowEditTaskModal(false); setEditTask(null); }}>✕</button>
      <h3>Edit Task</h3>
      <p style={{ opacity: .8, marginTop: -6 }}>Date: <b>{editTask.date}</b></p>

      <div className={styles.formGroupultimateaddload}>
        <label>Title</label>
        <input
          value={taskForm.title}
          onChange={(e) => setTaskForm({ ...taskForm, title: e.target.value })}
          placeholder="Task title"
          className={styles.inputFieldultimateaddload}
        />
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Description</label>
        <textarea
          value={taskForm.description}
          onChange={(e) => setTaskForm({ ...taskForm, description: e.target.value })}
          placeholder="Short description..."
          className={styles.textareaFieldultimateaddload}
        />
      </div>

      <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
          <label>Status</label>
          <select
            value={taskForm.status}
            onChange={(e) => setTaskForm({ ...taskForm, status: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="open">open</option>
            <option value="in_progress">in_progress</option>
            <option value="done">done</option>
            <option value="canceled">canceled</option>
          </select>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Priority</label>
          <select
            value={taskForm.priority}
            onChange={(e) => setTaskForm({ ...taskForm, priority: e.target.value })}
            className={styles.selectFieldultimateaddload}
          >
            <option value="low">low</option>
            <option value="medium">medium</option>
            <option value="high">high</option>
          </select>
        </div>
      </div>

      <div className={styles.formGroupultimateaddload}>
        <label>Assigned To</label>
        <select
          value={taskForm.assignedTo}
          onChange={(e) => setTaskForm({ ...taskForm, assignedTo: e.target.value })}
          className={styles.selectFieldultimateaddload}
        >
          <option value="">Unassigned</option>
          {drivers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName}
            </option>
          ))}
          {dispatchers.map(d => (
            <option key={d._id} value={d._id}>
              {d.firstName} {d.lastName} (dispatcher)
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
        <button className={styles.addButtonConsigneeultimateaddload} onClick={saveEditTask} disabled={isLoadingTasks}>
          {isLoadingTasks ? 'Saving...' : 'Save'}
        </button>
        <button className={styles.removeButtonConsigneeultimateaddload} onClick={() => deleteTask(editTask._id)} disabled={isLoadingTasks}>
          {isLoadingTasks ? 'Deleting...' : 'Delete'}
        </button>
      </div>
    </div>
  </div>
)}

{/* === KPIs === */}
<div className={styles.kpiContainer}>
  {kpis.map((kpi, i) => (
    <div 
      key={kpi.id || kpi._id || i}   // ✅ asigură key unic
      className={styles.kpiCard}
      onClick={() => setSelectedItem({ type: "kpi", id: kpi.id || kpi._id })}
      style={{ position: "relative", cursor: "pointer" }}
    >
      <h4>{kpi.metric}</h4>
      <p>
        {typeof kpi.value === "object" ? JSON.stringify(kpi.value) : kpi.value}
      </p>

      {selectedItem?.type === "kpi" && selectedItem.id === (kpi.id || kpi._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteKPI(kpi.id || kpi._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>

{/* === CARDS === */}
<div className={styles.cardContainer}>
  {cards.map((card, i) => (
    <div 
      key={card.id || card._id || i}   // ✅ asigură key unic
      className={styles.card}
      onClick={() => setSelectedItem({ type: "card", id: card.id || card._id })}
      style={{ position: "relative", cursor: "pointer" }}
    >
      <h4>{card.metric}</h4>
      <p>
        {typeof card.value === "object" ? JSON.stringify(card.value) : card.value}
      </p>

      {selectedItem?.type === "card" && selectedItem.id === (card.id || card._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteCard(card.id || card._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>
{/* === CHARTS === */}
<div className={styles.chartsContainer}>
  {charts.map((chart, i) => (
    <div 
      key={chart.id || chart._id || i}   // ✅ key unic
      className={styles.chartBox} 
      onClick={() => setSelectedItem({ type: "chart", id: chart.id || chart._id })}
      style={{ position: "relative", cursor: "pointer", height: "400px", padding: "15px", margin: "15px" }}
    >
      <h4>{chart.metric} ({chart.chartType})</h4>

      {/* === BAR / COLUMN === */}
      {chart.chartType === "bar" && (
        <Bar
          data={{
            labels: Array.isArray(chart.value)
              ? chart.value.map((c, idx) => c.name || c[0] || `Item ${idx + 1}`)
              : ["Value"],
            datasets: [{
              label: chart.metric,
              data: Array.isArray(chart.value)
                ? chart.value.map(c => c.total || c[1] || 0)
                : [Number(chart.value) || 0],
              backgroundColor: "#3b82f6"
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 20 }, // 🔹 micșorează graficul
            plugins: {
              legend: {
                labels: {
                  boxWidth: 15,
                  font: { size: 12 }
                }
              }
            },
            indexAxis: chart.originalType === "column" ? "y" : "x"
          }}
        />
      )}

      {/* === PIE === */}
      {chart.chartType === "pie" && (
        <Pie
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"]
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            },
            radius: "100%" // 🔹 micșorează cercul
          }}
        />
      )}

      {/* === LINE === */}
      {chart.chartType === "line" && (
        <Line
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              label: chart.metric,
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              fill: false,
              borderColor: "#22c55e",
              tension: 0.3
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            }
          }}
        />
      )}

      {/* === DOUGHNUT === */}
      {chart.chartType === "doughnut" && (
        <Doughnut
          data={{
            labels: Array.isArray(chart.value) 
              ? chart.value.map((c, idx) => c[0] || c.name || `item-${idx}`) 
              : ["Value"],
            datasets: [{
              data: Array.isArray(chart.value) 
                ? chart.value.map(c => c[1] || c.total) 
                : [chart.value],
              backgroundColor: ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#6366f1"]
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: 40 },
            plugins: {
              legend: {
                labels: { font: { size: 12 }, boxWidth: 15 }
              }
            },
            cutout: "70%" // 🔹 face cercul mai mic
          }}
        />
      )}

      {/* === GAUGE === */}
      {chart.chartType === "gauge" && (
        <Doughnut
          data={{
            labels: ["Value", "Remainder"],
            datasets: [{
              data: [Number(chart.value) || 0, 100 - (Number(chart.value) || 0)],
              backgroundColor: ["#f59e0b", "#1e293b"],
              borderWidth: 0
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            rotation: -90,
            circumference: 180,
            layout: { padding: 40 },
            plugins: { legend: { display: false } }
          }}
        />
      )}

      {/* === DELETE BUTTON === */}
      {selectedItem?.type === "chart" && selectedItem.id === (chart.id || chart._id) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteChart(chart.id || chart._id);
          }}
          style={{
            position: "absolute",
            top: "5px",
            right: "5px",
            background: "#ef4444",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "4px 8px",
            cursor: "pointer"
          }}
        >
          Delete
        </button>
      )}
    </div>
  ))}
</div>




   <div className={styles.topPerformanceSection}>
  <h3>Top Performing Drivers / Trucks</h3>
  
  <div className={styles.performanceContainer}>
    <div>
      <h4>Drivers by Revenue</h4>
      <ul>
        {dashboardData.topDriversByRevenue?.map((d, i) => (
          <li key={i}>{d.name} - ${d.totalRevenue.toFixed(2)}</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Drivers by Completed Loads</h4>
      <ul>
        {dashboardData.topDriversByLoads?.map((d, i) => (
          <li key={i}>{d.name} - {d.completedLoads} loads</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Trucks by Revenue</h4>
      <ul>
        {dashboardData.topTrucksByRevenue?.map((t, i) => (
          <li key={i}>{t.name} - ${t.totalRevenue.toFixed(2)}</li>
        ))}
      </ul>
    </div>

    <div>
      <h4>Trucks by Completed Loads</h4>
      <ul>
        {dashboardData.topTrucksByLoads?.map((t, i) => (
          <li key={i}>{t.name} - {t.completedLoads} loads</li>
        ))}
      </ul>
    </div>
  </div>
</div>
<div className={styles.dispatcherOverviewFull}>
  <h2 className={styles.sectionTitle}>Dispatchers Overview</h2>

  {/* Selector interval */}
  <div className={styles.dispatcherTimeFilter}>
    <label htmlFor="dispatcherTimeRange">Select Time Range:</label>
    <select
      id="dispatcherTimeRange"
      value={dispatcherTimeRange}
      onChange={(e) => setDispatcherTimeRange(e.target.value)}
    >
      <option value="week">This Week</option>
      <option value="month">This Month</option>
      <option value="year">This Year</option>
      <option value="custom">Custom Range</option>
    </select>

    {dispatcherTimeRange === "custom" && (
      <div className={styles.customDispatcherDatePicker}>
        <label>
          From:
          <input
            type="date"
            value={customDispatcherStartDate}
            onChange={(e) => setCustomDispatcherStartDate(e.target.value)}
          />
        </label>
        <label>
          To:
          <input
            type="date"
            value={customDispatcherEndDate}
            onChange={(e) => setCustomDispatcherEndDate(e.target.value)}
          />
        </label>
      </div>
    )}
  </div>

  {/* Tabel Overview */}
  <table className={styles.dispatcherTable}>
    <thead>
      <tr>
        <th>Dispatcher</th>
        <th>Drivers</th>
        <th>Trucks</th>
        <th>Total Rate ($)</th>
      </tr>
    </thead>
    <tbody>
      {dispatchers.map((dispatcher) => (
        <tr
          key={dispatcher._id}
          onClick={() => setSelectedDispatcher(dispatcher)} // 👉 aici deschidem modalul
          className={styles.dispatcherRow}
        >
          <td>{dispatcher.firstName} {dispatcher.lastName}</td>
          <td>{dispatcher.drivers?.length || 0}</td>
          <td>{dispatcher.trucks?.length || 0}</td>
          <td>
            {loads && loads.length > 0
              ? loads
                  .filter((load) => {
                    if (!dispatcher.drivers || dispatcher.drivers.length === 0) return false;
                    const isDriverAssigned = dispatcher.drivers.some((driver) => driver._id === load.driver);
                    if (!isDriverAssigned) return false;
                    const loadDate = new Date(load.createdAt);
                    return loadDate >= dispatcherStartDate && loadDate <= dispatcherEndDate;
                  })
                  .reduce((acc, load) => acc + (parseFloat(load.rate) || 0), 0)
                  .toFixed(2)
              : "0.00"}
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {/* Modal Detalii Dispatcher */}
  {selectedDispatcher && (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContentLarge}>
        <div className={styles.modalHeader}>
          <h3>
            {selectedDispatcher.firstName} {selectedDispatcher.lastName} - Details
          </h3>
          <button
            className={styles.closeBtn}
            onClick={() => {
              setSelectedDispatcher(null);
              setSelectedDriver(null);
              setSelectedTruck(null);
              setLastLoads([]);
            }}
          >
            ×
          </button>
        </div>

        <div className={styles.dispatcherDetailBody}>
          {/* Sidebar */}
          <div className={styles.dispatcherSidebar}>
            <h4>Drivers</h4>
            <ul>
              {selectedDispatcher.drivers.map((driver) => (
                <li key={driver._id} onClick={() => setSelectedDriver(driver)}>
                  {driver.firstName} {driver.lastName}
                </li>
              ))}
            </ul>

            <h4>Trucks</h4>
            <ul>
              {selectedDispatcher.trucks.map((truck) => (
                <li key={truck._id} onClick={() => setSelectedTruck(truck)}>
                  {truck.truckNumber} - {truck.licensePlate}
                </li>
              ))}
            </ul>
          </div>

          {/* Content dreapta */}
          <div className={styles.dispatcherContent}>
            {selectedDriver ? (
              <div className={styles.driverDetails}>
                <h4>{selectedDriver.firstName} {selectedDriver.lastName} - Status</h4>

      {lastLoad ? (
  <div className={styles.lastLoadStatus}>
    <p><strong>Last Load:</strong> #{lastLoad.loadNumber}</p>
    <p><strong>Status:</strong> {lastLoad.status}</p>

    {lastLoad.status?.toLowerCase() === "completed" ? (
      <p>
        <strong>Driver has been without a load for:</strong> {daysAgo} days
      </p>
    ) : lastLoad.status?.toLowerCase() === "open" ? (
      <p>
        <strong>Active Load in progress:</strong><br />
        From <em>{lastLoad.shippers?.[0]?.address || "N/A"}</em> →
        <em>{lastLoad.consignees?.[0]?.address || "N/A"}</em><br />
        For <strong>${lastLoad.rate}</strong><br />
        Pickup Date:{" "}
        <strong>
          {lastLoad.pickupDate
            ? new Date(lastLoad.pickupDate).toLocaleDateString()
            : "N/A"}
        </strong>
      </p>
    ) : (
      <p><strong>Status:</strong> {lastLoad.status}</p>
    )}

    <p>
      <strong>Route:</strong>{" "}
      {lastLoad.shippers?.[0]?.address} →
      {lastLoad.consignees?.[0]?.address}
    </p>
  </div>
) : (
  <p>No loads found for this driver.</p>
)}



                <button
                  onClick={() => fetchLastLoads({ driverId: selectedDriver._id })}
                  className={styles.lastLoadsBtn}
                >
                  Last Loads
                </button>
{lastLoads && lastLoads.length > 0 && (
  <div className={styles.lastLoadsList}>
    <h5>Last 10 Loads</h5>
    <ul>
      {lastLoads.map((load) => {
        const loadDate = new Date(load.createdAt).toLocaleDateString();
        return (
          <li key={load._id}>
            #{load.loadNumber} - {load.status} - {load.rate}$
            <br />
            {load.shippers?.[0]?.address} → {load.consignees?.[0]?.address}
            <br />
            <small>Date: {loadDate}</small>
          </li>
        );
      })}
    </ul>
  </div>
)}


              </div>
            ) : (
              <p>Select a driver or truck to see details.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )}
</div>




{/* Dispatch Efficiency Section */}
<div className={styles.dispatchEfficiencyContainer}>
  <h3>Dispatch Efficiency</h3>
  <table className={styles.dispatchEfficiencyTable}>
    <thead>
      <tr>
        <th>Dispatcher</th>
        <th>Loads Assigned</th>
        <th>Efficiency %</th>
      </tr>
    </thead>
    <tbody>
      {dashboardData.dispatchEfficiency?.map((d, index) => (
        <tr key={index}>
          <td>{d.name}</td>
          <td style={{ textAlign: "center" }}>{d.loadsAssigned}</td>
          <td
            style={{
              textAlign: "center",
              color:
                d.efficiency >= 70
                  ? "#4ade80" // verde
                  : d.efficiency >= 40
                  ? "#facc15" // galben
                  : "#f87171", // roșu
            }}
          >
            {d.efficiency}%
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


<div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="monthlyRevenue">
    <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Rate Evolution Over Time</h4>
      <ChartMenu
        chartKey="monthlyRevenue"
        chartTitle="Rate Evolution Over Time"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
         className="chart-menu"
      />
    </div>

    <div style={{ width: "600px", height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {chartTypes.monthlyRevenue === "Line" && (
        <Line
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                borderColor: "#3b82f6",
                backgroundColor: "rgba(59, 130, 246, 0.2)",
                tension: 0.4,
                fill: true,
                pointBackgroundColor: "#3b82f6",
                pointBorderWidth: 2,
                borderWidth: 2,
                cubicInterpolationMode: "monotone",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: { grid: { display: false } },
              y: {
                beginAtZero: true,
                grid: { color: "rgba(200, 200, 200, 0.2)" },
                ticks: {
                  callback: function (value) {
                    return "$" + value.toLocaleString();
                  },
                },
              },
            },
            elements: {
              line: { borderJoinStyle: "round" },
              point: { radius: 5, hoverRadius: 7 },
            },
            plugins: {
              legend: { display: true, position: "top" },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return `Revenue: $${context.raw.toLocaleString()}`;
                  },
                },
              },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {chartTypes.monthlyRevenue === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: "#3b82f6",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true, // 🔹 Evită întinderea la infinit
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {chartTypes.monthlyRevenue === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true, // 🔹 Evită întinderea la infinit
            plugins: {
              legend: { display: true },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

         {/* ✅ Column Chart (folosim Bar Chart cu layout vertical) */}
         {chartTypes.monthlyRevenue === "Column" && (
        <Bar
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                label: "Revenue ($)",
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: "#ff9800",
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            indexAxis: "y", // 🔹 Transformat într-un Column Chart
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.monthlyRevenue === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.monthlyRevenue.labels || ["No Data"],
            datasets: [
              {
                data: dashboardData.monthlyRevenue.values || [0],
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: { display: true },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}

  {/* ✅ Gauge Chart */}
  {chartTypes.monthlyRevenue === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Revenue", "Remaining"],
            datasets: [
              {
                data: [
                  dashboardData.totalRevenue,
                  100000 - dashboardData.totalRevenue, // Simulează un obiectiv
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
            plugins: {
              legend: { display: false },
            },
          }}
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      )}
    </div>
  </div>
  <div className={styles.chartsultimatedashboardoverview}>
<div className={styles.chartContainerultimatedashboardoverview} id="completeLoads">
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Loads by Status</h4>
    <ChartMenu
      chartKey="completeLoads"
      chartTitle="Loads by Status (Completed / Canceled / Open)"

        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview} style={{ width: "600px", height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      {chartTypes.completeLoads === "Doughnut" && (
  <Doughnut
    data={{
      labels: ["Completed", "Canceled", "Open"],       // ← AICI
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,             // “Open”
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: true } },
    }}
  />
)}

    {chartTypes.completeLoads === "Bar" && (
  <Bar
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          label: "Load Status",
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false }}
  />
)}

{chartTypes.completeLoads === "Column" && (
  <Bar
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          label: "Load Status",
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
  />
)}

     {chartTypes.completeLoads === "Pie" && (
  <Pie
    data={{
      labels: ["Completed", "Canceled", "Open"],        // ← AICI
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            dashboardData.canceledLoads,
            dashboardData.incompleteLoads,
          ],
          backgroundColor: ["#4caf50", "#ff5722", "#ffc107"],
        },
      ],
    }}
    options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: true } } }}
  />
)}
{chartTypes.completeLoads === "Gauge" && (
  <Doughnut
    data={{
      labels: ["Completed", "Remaining"],
      datasets: [
        {
          data: [
            dashboardData.completeLoads,
            (dashboardData.canceledLoads || 0) + (dashboardData.incompleteLoads || 0),
          ],
          backgroundColor: ["#4caf50", "#e0e0e0"],
        },
      ],
    }}
    options={{
      responsive: true,
      maintainAspectRatio: false,
      circumference: 180,
      rotation: -90,
      cutout: "80%",
      plugins: { legend: { display: false } },
    }}
  />
)}

    </div>
  </div>
</div>
  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="dispatcherComparison">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Compare Dispatchers</h4>
   
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      <Bar
        data={{
          labels: dashboardData.dispatcherComparison?.map(d => d.name),
          datasets: [
            {
              label: "Number of Loads",
              data: dashboardData.dispatcherComparison?.map(d => d.loadCount),
              backgroundColor: "rgba(54, 162, 235, 0.7)"
            },
            {
              label: "Total Revenue ($)",
              data: dashboardData.dispatcherComparison?.map(d => d.totalRevenue),
              backgroundColor: "rgba(255, 99, 132, 0.7)"
            }
          ]
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: { beginAtZero: true }
          }
        }}
      />
    </div>
  </div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
  {/* ✅ Loads per Driver */}
  <div className={styles.chartContainerultimatedashboardoverview} id="loadsPerDriver">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Loads per Driver</h4>
      <ChartMenu
        chartKey="loadsPerDriver"
        chartTitle="Loads per Driver"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      {/* ✅ Bar Chart */}
      {chartTypes.loadsPerDriver === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: "blue",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Column Chart */}
      {chartTypes.loadsPerDriver === "Column" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: "blue",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* ✅ Pie Chart */}
      {chartTypes.loadsPerDriver === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.loadsPerDriver === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.loadsPerDriver.map((d) => d.name),
            datasets: [
              {
                data: dashboardData.loadsPerDriver.map((d) => d.count),
                backgroundColor: ["#3b82f6", "#ff9800", "#4caf50", "#e91e63"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Gauge Chart */}
      {chartTypes.loadsPerDriver === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Loads Assigned", "Remaining Capacity"],
            datasets: [
              {
                data: [
                  dashboardData.loadsPerDriver.reduce((acc, d) => acc + d.count, 0),
                  100 - dashboardData.loadsPerDriver.reduce((acc, d) => acc + d.count, 0),
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
          }}
        />
      )}
    </div>
  </div>
</div>
{/* 🔹 Revenue per Mile Trend */}
<div className={styles.chartContainerultimatedashboardoverview}>
  <div className={styles.chartHeaderultimatedashboardoverview}>
    <h4>Revenue per Mile Trend</h4>
  </div>
  <div className={styles.chartContentultimatedashboardoverview}>
    <Line
      data={{
        labels: (dashboardData.loadsByDate || []).map(d => d.date),
        datasets: [
          {
            label: "Revenue per Mile ($)",
            data: (dashboardData.loadsByDate || []).map(d =>
              d.totalMiles > 0 ? (d.totalRevenue / d.totalMiles).toFixed(2) : 0
            ),
            borderColor: "#00c6ff",
            backgroundColor: "rgba(0, 198, 255, 0.2)",
            tension: 0.3,
            fill: true,
          },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: true, labels: { color: "#fff" } },
        },
        scales: {
          x: {
            ticks: { color: "#fff" },
            grid: { color: "rgba(255,255,255,0.1)" },
          },
          y: {
            ticks: { color: "#fff" },
            grid: { color: "rgba(255,255,255,0.1)" },
          },
        },
      }}
    />
  </div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
  {/* ✅ Loads per Truck */}
  <div className={styles.chartContainerultimatedashboardoverview} id="loadsPerTruck">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Loads per Truck</h4>
      <ChartMenu
        chartKey="loadsPerTruck"
        chartTitle="Loads per Truck"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    <div className={styles.chartContentultimatedashboardoverview}>
      {/* ✅ Bar Chart */}
      {chartTypes.loadsPerTruck === "Bar" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: "orange",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Column Chart */}
      {chartTypes.loadsPerTruck === "Column" && (
        <Bar
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                label: "Loads",
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: "orange",
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
        />
      )}

      {/* ✅ Pie Chart */}
      {chartTypes.loadsPerTruck === "Pie" && (
        <Pie
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: ["#f4a261", "#264653", "#2a9d8f", "#e76f51"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Doughnut Chart */}
      {chartTypes.loadsPerTruck === "Doughnut" && (
        <Doughnut
          data={{
            labels: dashboardData.loadsPerTruck.map((t) => t.name),
            datasets: [
              {
                data: dashboardData.loadsPerTruck.map((t) => t.count),
                backgroundColor: ["#f4a261", "#264653", "#2a9d8f", "#e76f51"],
              },
            ],
          }}
          options={{ responsive: true, maintainAspectRatio: false }}
        />
      )}

      {/* ✅ Gauge Chart */}
      {chartTypes.loadsPerTruck === "Gauge" && (
        <Doughnut
          data={{
            labels: ["Loads Assigned", "Remaining Capacity"],
            datasets: [
              {
                data: [
                  dashboardData.loadsPerTruck.reduce((acc, t) => acc + t.count, 0),
                  100 - dashboardData.loadsPerTruck.reduce((acc, t) => acc + t.count, 0),
                ],
                backgroundColor: ["#4caf50", "#e0e0e0"],
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: "80%",
          }}
        />
      )}
    </div>
  </div>
</div>
</div>

<div className={styles.chartsultimatedashboardoverview}>
<div className={styles.chartContainerultimatedashboardoverview} id="fuelCosts">
  <div className={styles.chartHeaderultimatedashboardoverview}>
    {/* 🔹 Titlul centrat */}
    <h4 className={styles.chartTitleCenterultimatedashboardoverview}>Fuel Costs Over Time</h4>

    {/* 🔹 Meniul plasat în dreapta */}
    <div className={styles.chartMenuRightultimatedashboardoverview}>
      <ChartMenu
        chartKey="fuelCosts"
        chartTitle="Fuel Costs Over Time"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>
  </div>

  <div className={styles.chartContentultimatedashboardoverview}>
{/* ✅ Gestionăm corect mesajele de încărcare și eroare */}
{isLoadingFuelData ? (
  <p style={{ textAlign: "center", fontWeight: "bold" }}>⏳ Loading fuel data...</p>
) : fuelCostsData && fuelCostsData.length > 0 ? (
  <div className={styles.chartContentultimatedashboardoverview}>
    {/* ✅ Line Chart */}
    {chartTypes.fuelCosts === "Line" && (
      <Line
        data={{
          labels: fuelCostsData.map(f => f.date),
          datasets: [
            { label: "Fuel Subtotal", data: fuelCostsData.map(f => f.fuelSubtotal), borderColor: "blue", fill: false },
            { label: "Other Costs", data: fuelCostsData.map(f => f.otherCosts), borderColor: "red", fill: false },
            { label: "Grand Total", data: fuelCostsData.map(f => f.grandTotal), borderColor: "green", fill: false },
          ],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Bar Chart */}
    {chartTypes.fuelCosts === "Bar" && (
      <Bar
        data={{
          labels: fuelCostsData.map(f => f.date),
          datasets: [{ label: "Fuel Costs", data: fuelCostsData.map(f => f.grandTotal), backgroundColor: "blue" }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Pie Chart */}
    {chartTypes.fuelCosts === "Pie" && (
      <Pie
        data={{
          labels: ["Fuel Subtotal", "Other Costs"],
          datasets: [{
            data: [
              fuelCostsData.reduce((acc, f) => acc + f.fuelSubtotal, 0),
              fuelCostsData.reduce((acc, f) => acc + f.otherCosts, 0)
            ],
            backgroundColor: ["blue", "red"],
          }],
        }}
        options={{ responsive: true, maintainAspectRatio: false }}
      />
    )}

    {/* ✅ Doughnut Chart */}
    {chartTypes.fuelCosts === "Doughnut" && (
          <Doughnut
            data={{
              labels: ["Fuel Subtotal", "Other Costs", "Grand Total"],
              datasets: [{
                data: [
                  fuelCostsData.reduce((acc, f) => acc + f.fuelSubtotal, 0),
                  fuelCostsData.reduce((acc, f) => acc + f.otherCosts, 0),
                  fuelCostsData.reduce((acc, f) => acc + f.grandTotal, 0),
                ],
                backgroundColor: ["blue", "red", "green"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

 {chartTypes.fuelCosts === "Column" && (
          <Bar
            data={{
              labels: fuelCostsData.map(f => f.date),
              datasets: [
                { label: "Fuel Subtotal", data: fuelCostsData.map(f => f.fuelSubtotal), backgroundColor: "blue" },
                { label: "Other Costs", data: fuelCostsData.map(f => f.otherCosts), backgroundColor: "red" },
                { label: "Grand Total", data: fuelCostsData.map(f => f.grandTotal), backgroundColor: "green" },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              indexAxis: "y", // 🔹 Transformat într-un Column Chart (orizontal)
            }}
          />
        )}

    {/* ✅ Gauge Chart */}
    {chartTypes.fuelCosts === "Gauge" && (
      <Doughnut
        data={{
          labels: ["Fuel Costs", "Remaining"],
          datasets: [{
            data: [
              fuelCostsData.reduce((acc, f) => acc + f.grandTotal, 0),
              100000 - fuelCostsData.reduce((acc, f) => acc + f.grandTotal, 0)
            ],
            backgroundColor: ["blue", "#e0e0e0"],
          }],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180,
          rotation: -90,
          cutout: "80%",
        }}
      />
    )}
  </div>
) : (
  <p style={{ textAlign: "center", fontWeight: "bold" }}>⚠️ No fuel report data available</p>
)}
  
  </div>
    </div>
  </div>
  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="estimatedProfit">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Estimated Profit Over Time</h4>
  
    </div>

   <div className={styles.chartContentultimatedashboardoverview}>
  {(() => {
    const profit = Number(dashboardData.estimatedProfit) || 0;
    const revenue = Number(dashboardData.totalRevenue) || 0;

    // dacă revenue e 0, punem [0,1] ca să se vadă semidonutul gri
    const remaining = Math.max(0, revenue - profit);
    const dataValues = revenue > 0
      ? [Math.max(0, profit), remaining]
      : [0, 1];

    return (
      <Doughnut
        data={{
          labels: ["Estimated Profit", "Remaining vs Revenue"],
          datasets: [
            {
              data: dataValues,
              backgroundColor: ["#4caf50", "#e0e0e0"],
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          circumference: 180, // semicerc
          rotation: -90,      // începe de sus
          cutout: "80%",      // aspect de gauge
          plugins: { legend: { display: false } },
        }}
      />
    );
  })()}
</div>
</div>
</div>
<div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="driverPayComparison">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>DriverPay Comparison</h4>
      <ChartMenu
        chartKey="driverPayComparison"
        chartTitle="DriverPay Comparison"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    {driverPayComparison.length === 0 ? (
      <p style={{ textAlign: "center", fontWeight: "bold" }}>⚠️ No DriverPay data available</p>
    ) : (
      <div className={styles.chartContentultimatedashboardoverview}>
        {/* Bar */}
        {chartTypes.driverPayComparison === "Bar" && (
          <Bar
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                label: "Total Pay ($)",
                data: driverPayComparison.map(d => d.total),
                backgroundColor: "teal",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* Column (orizontal) */}
        {chartTypes.driverPayComparison === "Column" && (
          <Bar
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                label: "Total Pay ($)",
                data: driverPayComparison.map(d => d.total),
                backgroundColor: "teal",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {/* Pie */}
        {chartTypes.driverPayComparison === "Pie" && (
          <Pie
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                data: driverPayComparison.map(d => d.total),
                backgroundColor: ["#14b8a6", "#f59e0b", "#ef4444", "#3b82f6", "#8b5cf6", "#22c55e"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* Doughnut */}
        {chartTypes.driverPayComparison === "Doughnut" && (
          <Doughnut
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                data: driverPayComparison.map(d => d.total),
                backgroundColor: ["#14b8a6", "#f59e0b", "#ef4444", "#3b82f6", "#8b5cf6", "#22c55e"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* Line */}
        {chartTypes.driverPayComparison === "Line" && (
          <Line
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                label: "Total Pay ($)",
                data: driverPayComparison.map(d => d.total),
                borderColor: "teal",
                fill: false
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {/* Gauge (semidonut) */}
        {chartTypes.driverPayComparison === "Gauge" && (
          <Doughnut
            data={{
              labels: driverPayComparison.map(d => d.name),
              datasets: [{
                data: driverPayComparison.map(d => d.total),
                backgroundColor: ["#14b8a6", "#f59e0b", "#ef4444", "#3b82f6", "#8b5cf6", "#22c55e"],
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
            }}
          />
        )}
      </div>
    )}
  </div>
</div>

  <div className={styles.chartsultimatedashboardoverview}>
  <div className={styles.chartContainerultimatedashboardoverview} id="employeesPayrolls">
    <div className={styles.chartHeaderultimatedashboardoverview}>
      <h4>Payrolls Comparison</h4>
      <ChartMenu
        chartKey="driverPayrolls"             // păstrează cheia ca să nu schimbi meniurile existente
        chartTitle="Payrolls Comparison"
        chartTypes={chartTypes}
        handleChartTypeChange={handleChartTypeChange}
        downloadChartAsPDF={downloadChartAsPDF}
      />
    </div>

    {employeesPayrolls.length === 0 ? (
      <p style={{ textAlign: "center", fontWeight: "bold" }}>
        ⚠️ No payroll data available
      </p>
    ) : (
      <div className={styles.chartContentultimatedashboardoverview}>
        {chartTypes.driverPayrolls === "Bar" && (
          <Bar
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: "green",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Column" && (
          <Bar
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: "green",
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false, indexAxis: "y" }}
          />
        )}

        {chartTypes.driverPayrolls === "Pie" && (
          <Pie
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Doughnut" && (
          <Doughnut
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Line" && (
          <Line
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                label: "Total Pay ($)",
                data: employeesPayrolls.map(e => e.total),
                borderColor: "green",
                fill: false
              }],
            }}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        )}

        {chartTypes.driverPayrolls === "Gauge" && (
          <Doughnut
            data={{
              labels: employeesPayrolls.map(e => e.name),
              datasets: [{
                data: employeesPayrolls.map(e => e.total),
                backgroundColor: ["#4caf50", "#ff5722", "#ffc107", "#3b82f6", "#8e44ad", "#2ecc71"],
              }],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              circumference: 180,
              rotation: -90,
              cutout: "80%",
            }}
          />
        )}
      </div>
    )}
  </div>
</div>

 
        <div className={styles.progressSectionultimatedashboardoverview}>
      <h4>Manage Progress Goals</h4>

      {/* Adaugă un nou obiectiv */}
      <div className={styles.addGoalultimatedashboardoverview}>
        <label>Goal Type:</label>
        <select value={newGoalType} onChange={(e) => setNewGoalType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
          <option value="custom">Custom Range</option>
        </select>

        {newGoalType === "custom" && (
          <div>
            <label>From:</label>
            <input type="date" value={customStartDate} onChange={(e) => setCustomStartDate(e.target.value)} />
            <label>To:</label>
            <input type="date" value={customEndDate} onChange={(e) => setCustomEndDate(e.target.value)} />
          </div>
        )}

        <label>Target Revenue ($):</label>
        <input type="number" value={newGoalValue} onChange={(e) => setNewGoalValue(Number(e.target.value))} />

        <button onClick={addNewGoal}>Add Goal</button>
      </div>

      {/* Selectează un obiectiv existent */}
      <div className={styles.goalSelectorultimatedashboardoverview}>
        <label>Select a goal:</label>
       <select
  value={selectedGoal?.id || ""}
  onChange={(e) => {
    const val = e.target.value; // string
    const found = progressGoals.find((g) => String(g.id) === String(val));
    setSelectedGoal(found || null);
  }}
>
  <option value="">-- Select --</option>
  {progressGoals.map((goal) => (
    <option key={goal.id} value={goal.id}>
      {goal.type?.toUpperCase()} - ${goal.value}
    </option>
  ))}
</select>

      </div>
{selectedGoal && (() => {
  const achieved = computeAchievedForGoal(selectedGoal);        // 💡 suma reală atinsă
  const target = Number(selectedGoal.value) || 0;
  const pct = target > 0 ? Math.max(0, Math.min(100, (achieved / target) * 100)) : 0;

  const containerStyle = {
    width: "100%",
    height: "20px",
    background: "rgba(0,0,0,0.1)",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    margin: "8px 0",
  };
  const barStyle = {
    width: `${pct}%`,
    height: "100%",
    background: "linear-gradient(90deg, #22c55e, #16a34a)",
    transition: "width 300ms ease",
  };
  const labelStyle = {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#111827",
  };

  return (
    <div className={styles.progressContainerultimatedashboardoverview}>
      <h4>Progress for {selectedGoal.type?.toUpperCase()} Goal</h4>

      <div className={styles.progressBarContainer} style={containerStyle}>
        <div className={styles.progressBar} style={barStyle} />
        <span className={styles.progressLabel} style={labelStyle}>
          {pct.toFixed(2)}%
        </span>
      </div>

      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <small><strong>Tracked:</strong> ${achieved.toLocaleString()} / ${target.toLocaleString()}</small>
      </div>

      <label style={{marginTop:8, display:"block"}}>Update Progress (override):</label>
      <input
        type="number"
        value={Number.isFinite(selectedGoal.progress) ? selectedGoal.progress : 0}
        onChange={(e) => {
          const val = Number(e.target.value) || 0;
          setSelectedGoal((prev) => (prev ? { ...prev, progress: val } : prev)); // UI instant
          updateProgress(selectedGoal.id, val); // trimite la server
        }}
      />
    </div>
  );
})()}


    </div>
{/* Google Map */}
<h4>Map Overview</h4>
<GoogleMap
  mapContainerStyle={{ height: "400px", width: "100%" }}
  center={mapCenter}
  zoom={5}
>
  {/* ✅ Markere pentru locația șoferilor */}
  {drivers
    .filter(driver => driver.location && driver.location.latitude && driver.location.longitude)
    .map((driver, idx) => (
      <Marker
        key={`driver-${idx}`}
        position={{
          lat: parseFloat(driver.location.latitude),
          lng: parseFloat(driver.location.longitude),
        }}
        label={{
          text: `${driver.firstName} ${driver.lastName}`,
          fontSize: "12px",
          fontWeight: "bold"
        }}
      />
    ))}

  {/* ✅ Markere pentru loads */}
  {loads
    .filter(load => load.latitude && load.longitude)
    .map((load, index) => (
      <Marker
        key={`load-${index}`}
        position={{
          lat: parseFloat(load.latitude),
          lng: parseFloat(load.longitude),
        }}
        icon={{
          url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
        }}
      />
    ))}
</GoogleMap>

      </div>
    </div>
  );
};

const LoadsDashboard = ({ onNavigate, loads, drivers, trucks }) => {
  const [selectedStatus, setSelectedStatus] = useState("Open");
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const itemsPerPage = 25;

  useEffect(() => {
    filterLoads();
  }, [selectedStatus, selectedDriver, loads, startDate, endDate]);

  const filterLoads = () => {
    let filtered = loads.filter(
      (load) =>
        (selectedStatus === "Open" && !["Completed"].includes(load.status)) ||
        load.status === selectedStatus
    );
    

    if (selectedDriver) {
      filtered = filtered.filter((load) => load.driver === selectedDriver.value);
    }
    if (startDate && endDate) {
      filtered = filtered.filter(
        (load) =>
          new Date(load.createdAt) >= startDate && new Date(load.createdAt) <= endDate
      );
    }
    setFilteredLoads(filtered);
  };

  const paginatedLoads = filteredLoads.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    setCurrentPage(1);
  };

  const handleDriverChange = (driver) => {
    setSelectedDriver(driver);
    setCurrentPage(1);
  };

  const handleLoadClick = (load) => {
    setSelectedLoad(load);
  };

  const closeDetails = () => {
    setSelectedLoad(null);
  };

  const averageRate = (loadsArray) =>
    loadsArray.length
      ? loadsArray.reduce((total, load) => total + load.rate, 0) / loadsArray.length
      : 0;

  const statusDistributionData = {
    labels: ["Open", "Completed", "Cancelled"],
    datasets: [
      {
        label: "Percentage of Loads",
        data: [
          loads.filter((load) => load.status === "Open").length,
          loads.filter((load) => load.status === "Completed").length,
          loads.filter((load) => load.status === "Cancelled").length,
        ],
        backgroundColor: ["#36A2EB", "#4BC0C0", "#FF6384"],
      },
    ],
  };

  const driverPerformanceData = {
    labels: drivers.map((driver) => `${driver.firstName} ${driver.lastName}`),
    datasets: [
      {
        label: "Number of Loads",
        data: drivers.map(
          (driver) => loads.filter((load) => load.driver === driver._id).length
        ),
        backgroundColor: drivers.map(
          (_, index) =>
            `hsl(${(index / drivers.length) * 360}, 70%, 50%)` // Culori dinamice
        ),
      },
    ],
  };
  const completedLoads = loads.filter((load) => load.status === "Completed");
  const cancelledLoads = loads.filter((load) => load.status === "Cancelled");
  const openLoads = loads.filter((load) => !["Completed", "Cancelled"].includes(load.status));


  const rateComparisonData = {
    labels: ["Open", "Completed", "Cancelled"],
    datasets: [
      {
        label: "Average Rate",
        data: [
          averageRate(openLoads),
          averageRate(completedLoads),
          averageRate(cancelledLoads),
        ],
        borderColor: "#36A2EB",
        backgroundColor: "rgba(54,162,235,0.2)",
        fill: true,
      },
    ],
  };

       return (
    <div
  className={`${styles.loaddashboard} ${
    theme === "light" ? styles.loaddashboardLight : ""
  }`}
>

      {/* Side Menu */}
      <div className={styles.sidebarToggleLoad} onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
  ☰
</div>

      <aside className={`${styles.sidebarLoadDashboard} ${isSidebarOpen ? styles.sidebarOpenLoad : ''}`}>
  <ul>
    <li onClick={() => onNavigate('dashboard')}>Overview</li>
    <li onClick={() => onNavigate('driver-dashboard')}>Drivers</li>
    <li onClick={() => onNavigate('truck-dashboard')}>Trucks</li>
    <li onClick={() => onNavigate('load-dashboard')}>Loads</li>
  </ul>
</aside>

{/* ✅ Toolbar de filtre pe toată lățimea paginii */}
<div className={styles.filtersloaddashboardContainer}>
  {/* Stânga: Status + Driver */}
  <div className={styles.filtersLeft}>
    <Select
      className={styles.customLoadDashboardSelect}
      classNamePrefix="customLoadDashboardSelect"
      options={[
        { value: "Open", label: "Open" },
        { value: "Completed", label: "Completed" },
        { value: "Cancelled", label: "Cancelled" },
      ]}
      value={{ value: selectedStatus, label: selectedStatus }}
      onChange={(option) => handleStatusChange(option.value)}
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "black",
          color: "white",
          border: "1px solid #555",
        }),
        singleValue: (base) => ({ ...base, color: "white" }),
        menu: (base) => ({ ...base, backgroundColor: "black" }),
        option: (base, { isSelected }) => ({
          ...base,
          backgroundColor: isSelected ? "#333" : "black",
          color: "white",
          ":hover": { backgroundColor: "#444" },
        }),
      }}
    />

    <Select
      className={styles.customLoadDashboardSelect}
      classNamePrefix="customLoadDashboardSelect"
      options={drivers.map((driver) => ({
        value: driver._id,
        label: `${driver.firstName} ${driver.lastName}`,
      }))}
      value={selectedDriver}
      onChange={handleDriverChange}
      placeholder="Select Driver"
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "black",
          color: "white",
          border: "1px solid #555",
        }),
        singleValue: (base) => ({ ...base, color: "white" }),
        menu: (base) => ({ ...base, backgroundColor: "black" }),
        option: (base, { isSelected }) => ({
          ...base,
          backgroundColor: isSelected ? "#333" : "black",
          color: "white",
          ":hover": { backgroundColor: "#444" },
        }),
      }}
    />
  </div>

  {/* Dreapta: Date Pickers */}
  <div className={styles.filtersRight}>
    <DatePicker
      className={styles.customDatePicker}
      selected={startDate}
      onChange={(date) => setStartDate(date)}
      placeholderText="Start Date"
    />
    <DatePicker
      className={styles.customDatePicker}
      selected={endDate}
      onChange={(date) => setEndDate(date)}
      placeholderText="End Date"
    />
  </div>
</div>


      {/* Tabel cu loads */}
      <div className={styles.tableContainerloaddashboard}>
        <table className={styles.tableloaddashboard}>
          <thead>
            <tr>
              <th>Dispatcher</th>
              <th>Load Number</th>
              <th>Broker</th>
              <th>Equipment</th>
              <th>Driver</th>
              <th>Team Drivers</th>
              <th>Truck</th>
              <th>Shippers & Consignees</th>
              <th>Notes</th>
              <th>Rate</th>
              <th>Added Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedLoads.map((load) => (
              <tr key={load._id} onClick={() => handleLoadClick(load)}>
                <td>{load.dispatcher}</td>
                <td>{load.loadNumber}</td>
                <td>{load.brokerName}</td>
                <td>{load.equipment}</td>
              <td>
  {drivers.find((driver) => driver._id === load.driver) 
    ? `${drivers.find((driver) => driver._id === load.driver).firstName} ${drivers.find((driver) => driver._id === load.driver).lastName}` 
    : "No data"}
</td>

                <td>
                  {load.teamDrivers
                    .map((id) => drivers.find((driver) => driver._id === id)?.firstName)
                    .join(", ") || "No data"}
                </td>
               <td>
  {trucks.find((truck) => truck._id === load.truck) 
    ? `Truck ${trucks.find((truck) => truck._id === load.truck).truckNumber}` 
    : "No data"}
</td>

                <td>
                  {load.shippers.map((shipper) => shipper.address).join(", ")} to{" "}
                  {load.consignees.map((consignee) => consignee.address).join(", ")}
                </td>
                <td>{load.notes}</td>
                <td>${load.rate}</td>
                <td>{new Date(load.createdAt).toLocaleDateString()}</td>
                <td>{load.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginare */}
      <div className={styles.paginationloaddashboard}>
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button
          disabled={currentPage === Math.ceil(filteredLoads.length / itemsPerPage)}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Next
        </button>
      </div>

      {/* Detalii despre încărcătură */}
      {selectedLoad && (
        <div className={styles.loadDetailsloaddashboard}>
          <button onClick={closeDetails} className={styles.closeButtonloaddashboard}>
            Close
          </button>
          <h2>{selectedLoad.loadNumber} is {selectedLoad.status}</h2>
          <p>
            in {selectedLoad.shippers.map((s) => s.address).join(", ")} to{" "}
            {selectedLoad.consignees.map((c) => c.address).join(", ")} for ${selectedLoad.rate} on{" "}
            {new Date(selectedLoad.createdAt).toLocaleDateString()}
          </p>
          <div>
            <h4>Status Progress</h4>
            <ul>
              {getStatusProgress(selectedLoad.status).map(({ status, completed }) => (
                <li
                  key={status}
                  style={{
                    color: completed ? "green" : "gray",
                    fontWeight: completed ? "bold" : "normal",
                  }}
                >
                  {status}
                </li>
              ))}
            </ul>
          </div>
      
    {/* 🔥 Status Progress pentru Payment Status */}
    <div>
      <h4>Payment Status Progress</h4>
      <ul>
        {getPaymentProgress(selectedLoad.paymentStatus).map(({ status, completed }) => (
          <li
            key={status}
            style={{
              color: completed ? "green" : "gray",
              fontWeight: completed ? "bold" : "normal",
            }}
          >
            {status}
          </li>
        ))}
      </ul>
    </div>
  </div>
)}
 {/* === Chart-uri și statistici === */}
<div className={styles.chartsGridLoadDashboard}>
  
  {/* Status Distribution */}
  <div className={styles.chartBoxLoadDashboard}>
    <h3 className={styles.chartTitleLoadDashboard}>Status Distribution</h3>
    <div className={styles.chartWrapperLoadDashboard}>
      <Bar 
        data={statusDistributionData} 
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: true, position: "top" } }
        }}
      />
    </div>
  </div>

  {/* Driver Performance */}
  <div className={styles.chartBoxLoadDashboard}>
    <h3 className={styles.chartTitleLoadDashboard}>Driver Performance</h3>
    <div className={styles.chartWrapperLoadDashboard}>
      <Pie 
        data={driverPerformanceData} 
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: true, position: "bottom" } }
        }}
      />
    </div>
  </div>

  {/* Rate Comparison */}
  <div className={`${styles.chartBoxLoadDashboard} ${styles.fullWidthChartLoadDashboard}`}>
    <h3 className={styles.chartTitleLoadDashboard}>Rate Comparison</h3>
    <div className={styles.chartWrapperLoadDashboard}>
      <Line
        data={rateComparisonData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: "top" },
            tooltip: { enabled: true }
          },
          scales: {
            x: {
              title: { display: true, text: "Status", color: "#bbb" },
              grid: { display: false }
            },
            y: {
              title: { display: true, text: "Average Rate ($)", color: "#bbb" },
              beginAtZero: true,
              ticks: { stepSize: 500 }
            }
          }
        }}
      />
    </div>
  </div>

</div>

</div>

  );
};

const getStatusProgress = (status) => {
  const statusesMap = {
    Pending: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Open: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Assigned: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Dispatched: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    "On Route": ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    "In Progress": ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Delivered: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered"],
    Completed: ["Pending", "Open", "Assigned", "Dispatched", "On Route", "In Progress", "Delivered", "Completed"],
    Cancelled: ["Pending", "Open", "In Yard", "Refused", "Un-Loading", "Cancelled"],
  };

  const progressStatuses = statusesMap[status] || [];
  const currentIndex = progressStatuses.indexOf(status);

  return progressStatuses.map((s, index) => ({
    status: s,
    completed: index <= currentIndex, // Marchează statusurile completate
  }));
};

const getPaymentProgress = (paymentStatus) => {
  const paymentMap = [
    "Not Paid",
    "Pending Payment",
    "Payment in Progress",
    "Paid"
  ];
  const currentIndex = paymentMap.indexOf(paymentStatus);

  return paymentMap.map((status, index) => ({
    status,
    completed: index <= currentIndex,
  }));
};

const Drivers = ({ drivers = [], setDrivers, trucks = [] }) => {
  const { notify } = useNotification();
  const [limits, setLimits] = useState({ numberOfDrivers: 0 });
  const [selectedDriver, setSelectedDriver] = useState(null); // Stochează șoferul selectat
  const [driverData, setDriverData] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    hireDate: '',
    truckNumber: '',
    email: '',
    mobilePhone: '',
    phone: '',
    address: '',
    licenseNumber: '',
    licenseExpiryDate: '',
    passportExpiryDate: '',
    lastMedical: '',
    nextMedical: '',
    lastDrugTest: '',
    lastAlcoholTest: '',
    fuelCardNumber: '',
    fuelCardExpiryDate: '',
    fleetDivision: '',
    settlement: '',
    settlementAmount: '',
    licenseType: '',
    licenseState: '',
    emergencyContactFirstName: '',
    emergencyContactLastName: '',
    emergencyContactRelation: '',
    emergencyContactPhone: '',
    employeeRecordsChecklist: {
      copyOfLicense: false,
      preEmploymentDrugTest: false,
      longMedicalForm: false,
      copyOfRoadTest: false,
      enrolledInDrugTestingProgram: false,
      certificateOfCompliance: false,
      inquiryToPreviousEmployers: false,
      nonMotorCarrierActivityForm: false,
      inquiryToStateAgencies: false,
      proofOfReceivingFMCSRHandbook: false,
    },
    annualCertificationOfViolations: '',
    employmentApplication: '',
    annualMVRReview: '',
    internalNotes: '',
    notes: '',
        // Bank Details (EU + US)
    bankPayMethod: '', // 'EU_IBAN' | 'US_ACH'
    bankAccountHolder: '',
    bankName: '',
    bankIban: '',
    bankBic: '',
    bankSwift: '',
    bankRoutingNumber: '',
    bankAccountNumber: '',
    bankAccountType: '',
    driverType: 'employee',
driverNumber: '',


  });

  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [licenseExpired, setLicenseExpired] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);



  const token = sessionStorage.getItem('token'); 
  const clientId = localStorage.getItem('clientId'); 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  useEffect(() => {
    const fetchDriverLimit = async () => {
      try {
        const response = await axios.get(`${apiUrl}/clients`, config);
        setLimits({
          numberOfDrivers: response.data.numberOfDrivers,
        });
      } catch (error) {
       
      }
    };
    
    fetchDriverLimit();
  }, []);

  const fetchDrivers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/drivers`, config);
      setDrivers(response.data);
    } catch (error) {
      
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  const fetchNotMoreWorkingDrivers = async () => {
    try {
        const response = await axios.get(`${apiUrl}/drivers/notMoreWorking`, config);
        setDrivers(response.data);
    } catch (error) {
   
    }
};
const handleViewDriverDetails = async (driverId) => {
  try {
      const response = await axios.get(`${apiUrl}/drivers/${driverId}`, config);
      setSelectedDriver(response.data);
  } catch (error) {
    
  }
};


  useEffect(() => {
    if (driverData.licenseExpiryDate) {
      const today = new Date().toISOString().split('T')[0];
      setLicenseExpired(driverData.licenseExpiryDate < today);
    }
  }, [driverData.licenseExpiryDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDriverData({ ...driverData, [name]: value });
  };

  const handleCheckboxChange = (e, field) => {
    const [section, fieldName] = field.split('.');
    if (section === 'employeeRecordsChecklist') {
      setDriverData({
        ...driverData,
        employeeRecordsChecklist: {
          ...driverData.employeeRecordsChecklist,
          [fieldName]: e.target.checked,
        },
      });
    } else {
      setDriverData({ ...driverData, [field]: e.target.checked });
    }
  };

  const handleMarkNotMoreWorking = async (index, date) => {
    const driverId = drivers[index]._id;
    try {
      const response = await axios.put(
        `${apiUrl}/drivers/${driverId}/notMoreWorking`,
        { notMoreWorking: true, notMoreWorkingTime: date },
        config
      );
      if (response.status === 200) {
        fetchDrivers(); // Reîncarcă lista de șoferi
      } else {
       notify('Failed to update driver.', 'error');

      }
    } catch (error) {
  
    }
  };
  
  const handleSettlementChange = (e) => {
    const selectedSettlement = e.target.value;
    
    // Resetăm câmpurile în funcție de metoda selectată
    const resetData = {
      normalMileRate: selectedSettlement === 'Per mile pay' ? driverData.normalMileRate : undefined,
      dhMileRate: selectedSettlement === 'Per mile pay' ? driverData.dhMileRate : undefined,
      hourlyRate: selectedSettlement === 'Hourly pay' ? driverData.hourlyRate : undefined,
      hoursWorked: selectedSettlement === 'Hourly pay' ? driverData.hoursWorked : undefined,
      teamDriver: selectedSettlement === 'Team driver pay' ? driverData.teamDriver : undefined,
      teamPercentage: selectedSettlement === 'Team driver pay' ? driverData.teamPercentage : undefined,
      settlementAmount: selectedSettlement !== 'Per mile pay' && selectedSettlement !== 'Hourly pay' ? driverData.settlementAmount : undefined,
    };
  
    setDriverData({
      ...driverData,
      settlement: selectedSettlement,
      ...resetData,
    });
  };
  

 const handleSubmit = async () => {
  if (editingIndex === null && drivers.length >= limits.numberOfDrivers) {
    notify('You cannot add more drivers than the allowed limit.', 'error');
    return;
  }

  const dataToSend = {
    ...driverData, // 🔥 Aici trimitem TOT driverData!

    // 🔥 Asigurăm corectitudinea numerelor
    settlementAmount: Number(driverData.settlementAmount) || 0,
    hourlyRate: Number(driverData.hourlyRate) || 0,
    hoursWorked: Number(driverData.hoursWorked) || 0,
    normalMileRate: Number(driverData.normalMileRate) || 0,
    dhMileRate: Number(driverData.dhMileRate) || 0,
    teamPercentage: Number(driverData.teamPercentage) || 0,

    // 🔥 Convertim datele la format corect (ISO)
    licenseExpiryDate: driverData.licenseExpiryDate || null,
    hireDate: driverData.hireDate || null,
    terminationDate: driverData.terminationDate || null,
    dateOfBirth: driverData.dateOfBirth || null,
     passportExpires: driverData.passportExpiryDate || null,
    lastMedical: driverData.lastMedical || null,
    nextMedical: driverData.nextMedical || null,
    lastDrugTestDate: driverData.lastDrugTest || null,
    lastAlcoholTest: driverData.lastAlcoholTest || null,
     fuelCardExpires: driverData.fuelCardExpiryDate || null,

    // 🔥 Asigurăm sub-obiectele complete
    medicalInfo: {
      lastMedical: driverData.lastMedical || null,
      nextMedical: driverData.nextMedical || null,
      lastAlcoholTest: driverData.lastAlcoholTest || null,
    },
    corporateInfo: {
      fuelCardNumber: driverData.fuelCardNumber || '',
     fuelCardExpires: driverData.fuelCardExpiryDate || null,
      fleetDivision: driverData.fleetDivision || '',
    },
     checklist: { ...driverData.employeeRecordsChecklist }, 

    location: driverData.location || {},
    payrollDocuments: driverData.payrollDocuments || [],
    recurringDeductions: driverData.recurringDeductions || [],
    recurringAdditions: driverData.recurringAdditions || [],
    notMoreWorking: driverData.notMoreWorking || false,
    notMoreWorkingTime: driverData.notMoreWorkingTime || null,
    bankDetails: {
      payMethod: driverData.bankPayMethod || null,
      accountHolder: driverData.bankAccountHolder || '',
      bankName: driverData.bankName || '',
      iban: driverData.bankIban || '',
      bic: driverData.bankBic || '',
      swift: driverData.bankSwift || '',
      routingNumber: driverData.bankRoutingNumber || '',
      accountNumber: driverData.bankAccountNumber || '',
      accountType: driverData.bankAccountType || '',
    },

    clientId, // 🔥 Inclus ID-ul clientului
  };

  try {
    
    let response;
    if (editingIndex !== null) {
      const driverId = drivers[editingIndex]._id;
      response = await axios.put(`${apiUrl}/drivers/${driverId}`, dataToSend, config);
    } else {
      response = await axios.post(`${apiUrl}/drivers`, dataToSend, config);
    }

    if (response.status === 200 || response.status === 201) {
      notify(editingIndex !== null ? 'Driver updated successfully!' : 'Driver added successfully!', 'success');
      fetchDrivers(); // 🔥 Reîncărcăm lista driverilor
    } else {
      notify(response.data.error || 'Failed to save driver.', 'error');
    }
const initialDriverData = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  hireDate: '',
  terminationDate: '',
  truckNumber: '',
  email: '',
  mobilePhone: '',
  phone: '',
  address: '',
  licenseNumber: '',
  licenseExpiryDate: '',
  passportExpiryDate: '',
  lastMedical: '',
  nextMedical: '',
  lastDrugTest: '',
  lastAlcoholTest: '',
  fuelCardNumber: '',
  fuelCardExpiryDate: '',
  fleetDivision: '',
  settlement: '',
  settlementAmount: 0,
  normalMileRate: 0,
  dhMileRate: 0,
  hourlyRate: 0,
  hoursWorked: 0,
  teamDriver: '',
  teamPercentage: 50,
  licenseType: '',
  licenseState: '',
  emergencyContactFirstName: '',
  emergencyContactLastName: '',
  emergencyContactRelation: '',
  emergencyContactPhone: '',
  employeeRecordsChecklist: {
    copyOfLicense: false,
    preEmploymentDrugTest: false,
    longMedicalForm: false,
    copyOfRoadTest: false,
    enrolledInDrugTestingProgram: false,
    certificateOfCompliance: false,
    inquiryToPreviousEmployers: false,
    nonMotorCarrierActivityForm: false,
    inquiryToStateAgencies: false,
    proofOfReceivingFMCSRHandbook: false,
  },
  recurringDeductions: [],
  recurringAdditions: [],
  internalNotes: '',
  annualCertificationOfViolations: '',
  employmentApplication: '',
  annualMVRReview: '',
  notes: '',
  payrollDocuments: [],
  location: {
    latitude: null,
    longitude: null,
    updatedAt: null,
  },
  notMoreWorking: false,
  notMoreWorkingTime: null,
  expoPushToken: '',
  socketId: '',
    // Bank Details (EU + US)
  bankPayMethod: '',
  bankAccountHolder: '',
  bankName: '',
  bankIban: '',
  bankBic: '',
  bankSwift: '',
  bankRoutingNumber: '',
  bankAccountNumber: '',
  bankAccountType: '',

};

    // 🔥 Resetăm form și edit
    setDriverData(initialDriverData);
    setEditingIndex(null);
  } catch (error) {
    notify(error.response?.data?.error || 'Failed to save driver. Please try again.', 'error');
  }
};
const formatDate = (date) => date ? new Date(date).toISOString().split('T')[0] : '';  

const handleEdit = async (index) => {
  const driverId = drivers[index]._id;
  try {
    const response = await axios.get(`${apiUrl}/drivers/${driverId}`, config);
    const driverToEdit = response.data;

    const formatDate = (date) => date ? new Date(date).toISOString().split('T')[0] : '';

    const updatedDriverData = {
      firstName: driverToEdit.firstName || '',
      lastName: driverToEdit.lastName || '',
      dateOfBirth: formatDate(driverToEdit.dateOfBirth),
      hireDate: formatDate(driverToEdit.hireDate),
      terminationDate: formatDate(driverToEdit.terminationDate),
      truckNumber: driverToEdit.truckNumber || '',
      email: driverToEdit.email || '',
      mobilePhone: driverToEdit.mobilePhone || '',
      phone: driverToEdit.phone || '',
      address: driverToEdit.address || '',
      licenseNumber: driverToEdit.licenseNumber || '',
      licenseExpiryDate: formatDate(driverToEdit.licenseExpiryDate),
      passportExpiryDate: formatDate(driverToEdit.passportExpires),
      lastMedical: formatDate(driverToEdit.medicalInfo?.lastMedical),
      nextMedical: formatDate(driverToEdit.medicalInfo?.nextMedical),
      lastDrugTest: formatDate(driverToEdit.lastDrugTestDate || driverToEdit.medicalInfo?.lastDrugTest),
      lastAlcoholTest: formatDate(driverToEdit.medicalInfo?.lastAlcoholTest),
      fuelCardNumber: driverToEdit.corporateInfo?.fuelCardNumber || '',
      fuelCardExpiryDate: formatDate(driverToEdit.corporateInfo?.fuelCardExpires),
      fleetDivision: driverToEdit.corporateInfo?.fleetDivision || '',
      settlement: driverToEdit.settlement || '',
      settlementAmount: driverToEdit.settlementAmount || '',
      normalMileRate: driverToEdit.normalMileRate || '',
      dhMileRate: driverToEdit.dhMileRate || '',
      hourlyRate: driverToEdit.hourlyRate || '',
      hoursWorked: driverToEdit.hoursWorked || '',
      teamDriver: driverToEdit.teamDriver || '',
      teamPercentage: driverToEdit.teamPercentage || '',
      licenseType: driverToEdit.licenseType || '',
      licenseState: driverToEdit.licenseState || '',
      emergencyContactFirstName: driverToEdit.emergencyContact?.firstName || '',
      emergencyContactLastName: driverToEdit.emergencyContact?.lastName || '',
      emergencyContactRelation: driverToEdit.emergencyContact?.relation || '',
      emergencyContactPhone: driverToEdit.emergencyContact?.phone || '',
      employeeRecordsChecklist: {
        copyOfLicense: driverToEdit.checklist?.copyOfLicense || false,
        preEmploymentDrugTest: driverToEdit.checklist?.preEmploymentDrugTest || false,
        longMedicalForm: driverToEdit.checklist?.longMedicalForm || false,
        copyOfRoadTest: driverToEdit.checklist?.copyOfRoadTest || false,
        enrolledInDrugTestingProgram: driverToEdit.checklist?.enrolledInDrugTestingProgram || false,
        certificateOfCompliance: driverToEdit.checklist?.certificateOfCompliance || false,
        inquiryToPreviousEmployers: driverToEdit.checklist?.inquiryToPreviousEmployers || false,
        nonMotorCarrierActivityForm: driverToEdit.checklist?.nonMotorCarrierActivityForm || false,
        inquiryToStateAgencies: driverToEdit.checklist?.inquiryToStateAgencies || false,
        proofOfReceivingFMCSRHandbook: driverToEdit.checklist?.proofOfReceivingFMCSRHandbook || false,
      },
      recurringDeductions: driverToEdit.recurringDeductions || [],
      recurringAdditions: driverToEdit.recurringAdditions || [],
      internalNotes: driverToEdit.internalNotes || '',
      annualCertificationOfViolations: driverToEdit.annualCertificationOfViolations || '',
      employmentApplication: driverToEdit.employmentApplication || '',
      annualMVRReview: driverToEdit.annualMVRReview || '',
      notes: driverToEdit.notes || '',
      payrollDocuments: driverToEdit.payrollDocuments || [],
      location: driverToEdit.location || {},
      notMoreWorking: driverToEdit.notMoreWorking || false,
      notMoreWorkingTime: formatDate(driverToEdit.notMoreWorkingTime),
      expoPushToken: driverToEdit.expoPushToken || '',
      socketId: driverToEdit.socketId || '',
            // Bank Details
      bankPayMethod: driverToEdit.bankDetails?.payMethod || '',
      bankAccountHolder: driverToEdit.bankDetails?.accountHolder || '',
      bankName: driverToEdit.bankDetails?.bankName || '',
      bankIban: driverToEdit.bankDetails?.iban || '',
      bankBic: driverToEdit.bankDetails?.bic || '',
      bankSwift: driverToEdit.bankDetails?.swift || '',
      bankRoutingNumber: driverToEdit.bankDetails?.routingNumber || '',
      bankAccountNumber: driverToEdit.bankDetails?.accountNumber || '',
      bankAccountType: driverToEdit.bankDetails?.accountType || '',
      driverType: driverToEdit.driverType || 'employee',
driverNumber: driverToEdit.driverNumber || '',


    };

    setDriverData(updatedDriverData);
    setEditingIndex(index);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } catch (error) {
    notify(error.response?.data?.error || 'Failed to fetch driver data.', 'error');
  }
};

  

  const confirmDeleteDriver = async (index) => {
    try {
      const driverId = drivers[index]._id;
      await axios.delete(`${apiUrl}/drivers/${driverId}`, config);
      setDrivers((prevDrivers) => prevDrivers.filter((_, i) => i !== index));
    } catch (error) {

      notify('Failed to delete driver.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };

  const filteredDrivers = drivers.filter(
    (driver) =>
      driver.clientId === clientId &&
      (driver.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        driver.lastName.toLowerCase().includes(searchQuery.toLowerCase()))
  );
const employerDrivers = filteredDrivers.filter(
  d => d.driverType === 'employee'
);

const ownerOperatorDrivers = filteredDrivers.filter(
  d => d.driverType === 'owner_operator'
);

  return (
   <div
  className={`${styles.ultimatedriversSection} ${
    theme === "light" ? styles.ultimatedriversSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatedrivers}>Add or Edit Driver</h3>
      {licenseExpired && <p className={styles.expiredMessageultimatedrivers}>The driver's license has expired!</p>}
      <form className={styles.driverFormultimatedrivers}>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>First Name*</label>
            <input
              name="firstName"
              value={driverData.firstName}
              onChange={handleChange}
              placeholder="First Name"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Last Name*</label>
            <input
              name="lastName"
              value={driverData.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Date Of Birth</label>
            <input
              name="dateOfBirth"
              type="date"
              value={driverData.dateOfBirth}
              onChange={handleChange}
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Hire Date</label>
            <input
              name="hireDate"
              type="date"
              value={driverData.hireDate}
              onChange={handleChange}
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>
         <div className={styles.formRowultimatedrivers}>
  <div className={styles.formGroupultimatedrivers}>
    <label>Driver Type*</label>
    <select
      name="driverType"
      value={driverData.driverType}
      onChange={handleChange}
      required
      className={styles.selectFieldultimatedrivers}
    >
      <option value="employee">Employee Driver</option>
      <option value="owner_operator">Owner Operator</option>
    </select>
  </div>

  <div className={styles.formGroupultimatedrivers}>
    <label>Driver Number*</label>
    <input
      name="driverNumber"
      value={driverData.driverNumber}
      onChange={handleChange}
      placeholder="DR-001"
      required
      className={styles.inputFieldultimatedrivers}
    />
  </div>
</div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Truck Number*</label>
            <select
              name="truckNumber"
              value={driverData.truckNumber}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatedrivers}
            >
              <option value="">Select Truck</option>
              {trucks.map((truck) => (
                <option key={truck._id} value={truck.truckNumber}>
                  {truck.truckNumber}
                </option>
              ))}
            </select>
          </div>
 
          <div className={styles.formGroupultimatedrivers}>
            <label>Email*</label>
            <input
              name="email"
              value={driverData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Mobile Phone*</label>
            <input
              name="mobilePhone"
              value={driverData.mobilePhone}
              onChange={handleChange}
              placeholder="Mobile Phone"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={driverData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Address*</label>
            <input
              name="address"
              value={driverData.address}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <h4>Emergency Contact</h4>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>First Name</label>
            <input
              name="emergencyContactFirstName"
              value={driverData.emergencyContactFirstName}
              onChange={handleChange}
              placeholder="First Name"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Last Name</label>
            <input
              name="emergencyContactLastName"
              value={driverData.emergencyContactLastName}
              onChange={handleChange}
              placeholder="Last Name"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>Relation</label>
            <input
              name="emergencyContactRelation"
              value={driverData.emergencyContactRelation}
              onChange={handleChange}
              placeholder="Relation"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>Phone</label>
            <input
              name="emergencyContactPhone"
              value={driverData.emergencyContactPhone}
              onChange={handleChange}
              placeholder="Phone"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>

        <h4>Pay Settings</h4>
        <div className={styles.formGroupultimatedrivers}>
  <label>Settlement*</label>
  <select
    name="settlement"
    value={driverData.settlement}
    onChange={handleSettlementChange}
    required
    className={styles.selectFieldultimatedrivers}
  >
    <option value="">Select Payment Method</option>
    <option value="Hourly pay">Hourly pay</option>
    <option value="Per mile pay">Per mile pay</option>
    <option value="Fixed salary">Fixed salary</option>
    <option value="Percentage of the load">Percentage of the load</option>
    <option value="Team driver pay">Team driver pay</option>
  </select>
</div>
        {driverData.settlement === 'Per mile pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter amount per normal mile ($)*</label>
      <input
        name="normalMileRate"
        type="number"
        step="0.01"
        value={driverData.normalMileRate || ''}
        onChange={handleChange}
        placeholder="Enter amount per normal mile"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter amount per DH mile ($)*</label>
      <input
        name="dhMileRate"
        type="number"
        step="0.01"
        value={driverData.dhMileRate || ''}
        onChange={handleChange}
        placeholder="Enter amount per DH mile"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Hourly pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Hourly Rate ($)*</label>
      <input
        name="hourlyRate"
        type="number"
        step="0.01"
        value={driverData.hourlyRate || ''}
        onChange={handleChange}
        placeholder="Enter hourly rate"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Hours Worked*</label>
      <input
        name="hoursWorked"
        type="number"
        step="0.1"
        value={driverData.hoursWorked || ''}
        onChange={handleChange}
        placeholder="Enter hours worked"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Team driver pay' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Select Co-Driver</label>
      <select
        name="teamDriver"
        value={driverData.teamDriver || ''}
        onChange={handleChange}
        required
        className={styles.selectFieldultimatedrivers}
      >
        <option value="">Select Co-Driver</option>
        {drivers.map((driver) => (
          <option key={driver._id} value={driver._id}>
            {driver.firstName} {driver.lastName}
          </option>
        ))}
      </select>
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Team Pay Percentage (%)</label>
      <input
        name="teamPercentage"
        type="number"
        step="1"
        value={driverData.teamPercentage || ''}
        onChange={handleChange}
        placeholder="Enter team pay percentage"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Pay Amount for Main Driver ($)*</label>
      <input
        name="settlementAmount"
        type="number"
        step="0.01"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter pay amount for main driver"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Percentage of the load' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Enter Percentage of Load Revenue (%)</label>
      <input
        name="settlementAmount"
        type="number"
        step="1"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter percentage of load (e.g., 20 for 20%)"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.settlement === 'Fixed salary' && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Fixed Salary Amount ($)</label>
      <input
        name="settlementAmount"
        type="number"
        step="0.01"
        value={driverData.settlementAmount || ''}
        onChange={handleChange}
        placeholder="Enter fixed salary amount"
        required
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

<h4>Bank Details</h4>

<div className={styles.formRowultimatedrivers}>
  <div className={styles.formGroupultimatedrivers}>
    <label>Payment Method</label>
    <select
      name="bankPayMethod"
      value={driverData.bankPayMethod}
      onChange={handleChange}
      className={styles.selectFieldultimatedrivers}
    >
      <option value="">Select</option>
      <option value="EU_IBAN">EU (IBAN)</option>
      <option value="US_ACH">US (ACH)</option>
    </select>
  </div>

  <div className={styles.formGroupultimatedrivers}>
    <label>Account Holder</label>
    <input
      name="bankAccountHolder"
      value={driverData.bankAccountHolder}
      onChange={handleChange}
      placeholder="Account holder name"
      className={styles.inputFieldultimatedrivers}
    />
  </div>
</div>

<div className={styles.formRowultimatedrivers}>
  <div className={styles.formGroupultimatedrivers}>
    <label>Bank Name</label>
    <input
      name="bankName"
      value={driverData.bankName}
      onChange={handleChange}
      placeholder="Bank name"
      className={styles.inputFieldultimatedrivers}
    />
  </div>
</div>

{driverData.bankPayMethod === "EU_IBAN" && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>IBAN</label>
      <input
        name="bankIban"
        value={driverData.bankIban}
        onChange={handleChange}
        placeholder="DE00 0000 0000 0000 0000 00"
        className={styles.inputFieldultimatedrivers}
      />
    </div>

    <div className={styles.formGroupultimatedrivers}>
      <label>BIC</label>
      <input
        name="bankBic"
        value={driverData.bankBic}
        onChange={handleChange}
        placeholder="BIC"
        className={styles.inputFieldultimatedrivers}
      />
    </div>

    <div className={styles.formGroupultimatedrivers}>
      <label>SWIFT (optional)</label>
      <input
        name="bankSwift"
        value={driverData.bankSwift}
        onChange={handleChange}
        placeholder="SWIFT"
        className={styles.inputFieldultimatedrivers}
      />
    </div>
  </div>
)}

{driverData.bankPayMethod === "US_ACH" && (
  <div className={styles.formRowultimatedrivers}>
    <div className={styles.formGroupultimatedrivers}>
      <label>Routing Number</label>
      <input
        name="bankRoutingNumber"
        value={driverData.bankRoutingNumber}
        onChange={handleChange}
        placeholder="9-digit routing number"
        className={styles.inputFieldultimatedrivers}
      />
    </div>

    <div className={styles.formGroupultimatedrivers}>
      <label>Account Number</label>
      <input
        name="bankAccountNumber"
        value={driverData.bankAccountNumber}
        onChange={handleChange}
        placeholder="Account number"
        className={styles.inputFieldultimatedrivers}
      />
    </div>

    <div className={styles.formGroupultimatedrivers}>
      <label>Account Type</label>
      <select
        name="bankAccountType"
        value={driverData.bankAccountType}
        onChange={handleChange}
        className={styles.selectFieldultimatedrivers}
      >
        <option value="">Select</option>
        <option value="checking">Checking</option>
        <option value="savings">Savings</option>
      </select>
    </div>
  </div>
)}

        <h4>Licensing Info</h4>
        <div className={styles.formRowultimatedrivers}>
          <div className={styles.formGroupultimatedrivers}>
            <label>License Type</label>
            <select
              name="licenseType"
              value={driverData.licenseType}
              onChange={handleChange}
              className={styles.selectFieldultimatedrivers}
            >
              <option value="">Select License Type</option>
              <option value="CDL-A">CDL-A</option>
              <option value="CDL-B">CDL-B</option>
              <option value="NonCommercial">NonCommercial</option>
            </select>
          </div>
          <div className={styles.formGroupultimatedrivers}>
            <label>License State</label>
            <input
              name="licenseState"
              value={driverData.licenseState}
              onChange={handleChange}
              placeholder="Enter State"
              className={styles.inputFieldultimatedrivers}
            />
          </div>
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>License Number*</label>
          <input
            name="licenseNumber"
            value={driverData.licenseNumber}
            onChange={handleChange}
            placeholder="License Number"
            required
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>License Expires*</label>
          <input
            name="licenseExpiryDate"
            type="date"
            value={driverData.licenseExpiryDate}
            onChange={handleChange}
            required
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <div className={styles.formGroupultimatedrivers}>
          <label>Passport Expires</label>
          <input
            name="passportExpiryDate"
            type="date"
            value={driverData.passportExpiryDate}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Medical Info</h4>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Medical</label>
          <input
            name="lastMedical"
            type="date"
            value={driverData.lastMedical}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Next Medical</label>
          <input
            name="nextMedical"
            type="date"
            value={driverData.nextMedical}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Drug Test</label>
          <input
            name="lastDrugTest"
            type="date"
            value={driverData.lastDrugTest}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Last Alcohol Test</label>
          <input
            name="lastAlcoholTest"
            type="date"
            value={driverData.lastAlcoholTest}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Corporate Info</h4>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fuel Card Number</label>
          <input
            name="fuelCardNumber"
            value={driverData.fuelCardNumber}
            onChange={handleChange}
            placeholder="Fuel Card Number"
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fuel Card Expires</label>
          <input
            name="fuelCardExpiryDate"
            type="date"
            value={driverData.fuelCardExpiryDate}
            onChange={handleChange}
            className={styles.inputFieldultimatedrivers}
          />
        </div>
        <div className={styles.formGroupultimatedrivers}>
          <label>Fleet / Division</label>
          <input
            name="fleetDivision"
            value={driverData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet / Division"
            className={styles.inputFieldultimatedrivers}
          />
        </div>

        <h4>Employee Records Checklist</h4>
        <div className={styles.formGroupultimatedrivers}>
        <label>
  <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.copyOfLicense || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.copyOfLicense')}
  />
  Copy of License
</label>

          <label>
          <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.preEmploymentDrugTest || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.preEmploymentDrugTest')}
  />
            Pre-Employment Drug Test
          </label>
          <label>
  <input
    type="checkbox"
    checked={driverData.employeeRecordsChecklist?.longMedicalForm || false}
    onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.longMedicalForm')}
  />
  Long Medical Form
</label>

          <label>
            <input
              type="checkbox"
              checked={driverData.employeeRecordsChecklist.copyOfRoadTest}
              onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.copyOfRoadTest')}
            />
            Copy of Road Test
          </label>
          <label>
            <input
              type="checkbox"
              checked={driverData.employeeRecordsChecklist.enrolledInDrugTestingProgram}
              onChange={(e) => handleCheckboxChange(e, 'employeeRecordsChecklist.enrolledInDrugTestingProgram')}
            />
            Enrolled in Drug Testing Program
          </label>
          {/* Add more checklist items as needed */}
        </div>

        <h4>Internal Notes</h4>
        <div className={styles.formGroupultimatedrivers}>
          <textarea
            name="internalNotes"
            value={driverData.internalNotes}
            onChange={handleChange}
            placeholder="Internal Notes"
            className={styles.textareaFieldultimatedrivers}
          />
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatedrivers}>
          {editingIndex !== null ? 'Update Driver' : 'Add Driver'}
        </button>
      </form>

      <h3 className={styles.titleultimatedrivers}>Search Drivers</h3>
      <input
        type="text"
        placeholder="Search by driver name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatedrivers}
      />
     {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this driver?"
    onConfirm={() => confirmDeleteDriver(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

<h3 className={styles.titleultimatedrivers}>
  Employee Drivers (Employers)
</h3>

<ul className={styles.driverListultimatedrivers}>
  {employerDrivers.length === 0 && (
    <li className={styles.emptyStateultimatedrivers}>
      No employee drivers found
    </li>
  )}

  {employerDrivers.map((driver, index) => {
    const realIndex = drivers.findIndex(d => d._id === driver._id);

    return (
      <li key={driver._id} className={styles.driverListItemultimatedrivers}>
        {driver.firstName} {driver.lastName}
        <span className={styles.driverTag}>EMPLOYEE</span>

        <button
          onClick={() => handleEdit(realIndex)}
          className={styles.editButtonultimatedrivers}
        >
          Edit
        </button>

        <button
          onClick={() => setDeleteTarget(realIndex)}
          className={styles.deleteButtonultimatedrivers}
        >
          Delete
        </button>

        <button
          onClick={() => {
            const date = prompt(
              'Enter the date from which the driver is not working (YYYY-MM-DD):'
            );
            if (date) handleMarkNotMoreWorking(realIndex, date);
          }}
          className={styles.notMoreWorkingButtonultimatedrivers}
        >
          Not More Working
        </button>
      </li>
    );
  })}
</ul>
<h3 className={styles.titleultimatedrivers}>
  Owner Operators
</h3>

<ul className={styles.driverListultimatedrivers}>
  {ownerOperatorDrivers.length === 0 && (
    <li className={styles.emptyStateultimatedrivers}>
      No owner operators found
    </li>
  )}

  {ownerOperatorDrivers.map((driver, index) => {
    const realIndex = drivers.findIndex(d => d._id === driver._id);

    return (
      <li key={driver._id} className={styles.driverListItemultimatedrivers}>
        {driver.firstName} {driver.lastName}
        <span className={styles.ownerTag}>OWNER OPERATOR</span>

        <button
          onClick={() => handleEdit(realIndex)}
          className={styles.editButtonultimatedrivers}
        >
          Edit
        </button>

        <button
          onClick={() => setDeleteTarget(realIndex)}
          className={styles.deleteButtonultimatedrivers}
        >
          Delete
        </button>

        <button
          onClick={() => {
            const date = prompt(
              'Enter the date from which the driver is not working (YYYY-MM-DD):'
            );
            if (date) handleMarkNotMoreWorking(realIndex, date);
          }}
          className={styles.notMoreWorkingButtonultimatedrivers}
        >
          Not More Working
        </button>
      </li>
    );
  })}
</ul>

<h3 className={styles.titleultimatedrivers}>Not More Working Drivers</h3>
<ul className={styles.driverListultimatedrivers}>
  {drivers
    .filter((driver) => driver.notMoreWorking)
    .map((driver, index) => (
      <li key={index} className={styles.driverListItemultimatedrivers}>
        {driver.firstName} {driver.lastName} (Not working since: {new Date(driver.notMoreWorkingTime).toLocaleDateString()})
        <button onClick={() => handleViewDriverDetails(driver._id)} className={styles.viewDetailsButtonultimatedrivers}>
          View Details
        </button>
      </li>
    ))}
</ul>
<button onClick={fetchNotMoreWorkingDrivers} className={styles.viewNotWorkingButtonultimatedrivers}>
  View Not More Working Drivers
</button>

{/* Modal for displaying driver details */}
{selectedDriver && (
  <div className={styles.driverDetailsModalultimatedrivers}>
    <h3>Driver Details</h3>
    <p><strong>First Name:</strong> {selectedDriver.firstName || 'No data'}</p>
    <p><strong>Last Name:</strong> {selectedDriver.lastName || 'No data'}</p>
    <p><strong>Email:</strong> {selectedDriver.email || 'No data'}</p>
    <p><strong>Phone:</strong> {selectedDriver.phone || 'No data'}</p>
    <p><strong>Address:</strong> {selectedDriver.address || 'No data'}</p>
    <p><strong>License Number:</strong> {selectedDriver.licenseNumber || 'No data'}</p>
    <p><strong>License Expiry Date:</strong> {selectedDriver.licenseExpiryDate ? new Date(selectedDriver.licenseExpiryDate).toLocaleDateString() : 'No data'}</p>
    <p><strong>License Type:</strong> {selectedDriver.licenseType || 'No data'}</p>
    <p><strong>License State:</strong> {selectedDriver.licenseState || 'No data'}</p>
    <p><strong>Passport Expires:</strong> {selectedDriver.passportExpires ? new Date(selectedDriver.passportExpires).toLocaleDateString() : 'No data'}</p>
    <p><strong>Date of Birth:</strong> {selectedDriver.dateOfBirth ? new Date(selectedDriver.dateOfBirth).toLocaleDateString() : 'No data'}</p>
    <p><strong>Hire Date:</strong> {selectedDriver.hireDate ? new Date(selectedDriver.hireDate).toLocaleDateString() : 'No data'}</p>
    <p><strong>Termination Date:</strong> {selectedDriver.terminationDate ? new Date(selectedDriver.terminationDate).toLocaleDateString() : 'No data'}</p>
    <p><strong>Truck Number:</strong> {selectedDriver.truckNumber || 'No data'}</p>
    <p><strong>Driver Type:</strong> {selectedDriver.driverType === 'owner_operator' ? 'Owner Operator' : 'Employee Driver'}</p>
<p><strong>Driver Number:</strong> {selectedDriver.driverNumber || 'No data'}</p>

    <p><strong>Settlement:</strong> {selectedDriver.settlement || 'No data'}</p>
  
    <p><strong>Settlement Amount:</strong> {selectedDriver.settlementAmount ?? 'No data'}</p>
    <p><strong>Normal Mile Rate:</strong> {selectedDriver.normalMileRate ?? 'No data'}</p>
    <p><strong>DH Mile Rate:</strong> {selectedDriver.dhMileRate ?? 'No data'}</p>
    <p><strong>Hourly Rate:</strong> {selectedDriver.hourlyRate ?? 'No data'}</p>
    <p><strong>Hours Worked:</strong> {selectedDriver.hoursWorked ?? 'No data'}</p>
    <p><strong>Team Driver:</strong> {selectedDriver.teamDriver || 'No data'}</p>
    <p><strong>Team Percentage:</strong> {selectedDriver.teamPercentage ?? 'No data'}</p>
    <p><strong>Bank Details:</strong></p>
<ul>
  <li>Method: {selectedDriver.bankDetails?.payMethod || 'No data'}</li>
  <li>Account Holder: {selectedDriver.bankDetails?.accountHolder || 'No data'}</li>
  <li>Bank Name: {selectedDriver.bankDetails?.bankName || 'No data'}</li>
  <li>IBAN: {selectedDriver.bankDetails?.iban || 'No data'}</li>
  <li>BIC: {selectedDriver.bankDetails?.bic || 'No data'}</li>
  <li>SWIFT: {selectedDriver.bankDetails?.swift || 'No data'}</li>
  <li>Routing: {selectedDriver.bankDetails?.routingNumber || 'No data'}</li>
  <li>Account: {selectedDriver.bankDetails?.accountNumber || 'No data'}</li>
  <li>Type: {selectedDriver.bankDetails?.accountType || 'No data'}</li>
</ul>

    <p><strong>Not More Working:</strong> {selectedDriver.notMoreWorking ? 'Yes' : 'No'}</p>
    <p><strong>Not More Working Date:</strong> {selectedDriver.notMoreWorkingTime ? new Date(selectedDriver.notMoreWorkingTime).toLocaleDateString() : 'No data'}</p>
    <p><strong>Medical Info:</strong></p>
    <ul>
      <li>Last Medical: {selectedDriver.medicalInfo?.lastMedical ? new Date(selectedDriver.medicalInfo.lastMedical).toLocaleDateString() : 'No data'}</li>
      <li>Next Medical: {selectedDriver.medicalInfo?.nextMedical ? new Date(selectedDriver.medicalInfo.nextMedical).toLocaleDateString() : 'No data'}</li>
      <li>Last Alcohol Test: {selectedDriver.medicalInfo?.lastAlcoholTest ? new Date(selectedDriver.medicalInfo.lastAlcoholTest).toLocaleDateString() : 'No data'}</li>
    </ul>
    <p><strong>Corporate Info:</strong></p>
    <ul>
      <li>Fuel Card Number: {selectedDriver.corporateInfo?.fuelCardNumber || 'No data'}</li>
      <li>Fuel Card Expiry Date: {selectedDriver.corporateInfo?.fuelCardExpires ? new Date(selectedDriver.corporateInfo.fuelCardExpires).toLocaleDateString() : 'No data'}</li>
      <li>Fleet Division: {selectedDriver.corporateInfo?.fleetDivision || 'No data'}</li>
    </ul>
    <p><strong>Checklist:</strong></p>
    <ul>
      <li>Copy of License: {selectedDriver.checklist?.copyOfLicense ? 'Yes' : 'No'}</li>
      <li>Pre-Employment Drug Test: {selectedDriver.checklist?.preEmploymentDrugTest ? 'Yes' : 'No'}</li>
      <li>Long Medical Form: {selectedDriver.checklist?.longMedicalForm ? 'Yes' : 'No'}</li>
      <li>Proof of Receiving FMCSR: {selectedDriver.checklist?.proofOfReceivingFMCSR ? 'Yes' : 'No'}</li>
    </ul>
    <p><strong>Recurring Deductions:</strong> {selectedDriver.recurringDeductions?.length ? selectedDriver.recurringDeductions.map((d, i) => `${d.service}: $${d.amount}`).join(', ') : 'No data'}</p>
    <p><strong>Recurring Additions:</strong> {selectedDriver.recurringAdditions?.length ? selectedDriver.recurringAdditions.map((a, i) => `${a.service}: $${a.amount}`).join(', ') : 'No data'}</p>
    <p><strong>Internal Notes:</strong> {selectedDriver.internalNotes || 'No data'}</p>
    <p><strong>Annual Certification Of Violations:</strong> {selectedDriver.annualCertificationOfViolations || 'No data'}</p>
    <p><strong>Employment Application:</strong> {selectedDriver.employmentApplication || 'No data'}</p>
    <p><strong>Annual MVR Review:</strong> {selectedDriver.annualMVRReview || 'No data'}</p>
    <p><strong>Expo Push Token:</strong> {selectedDriver.expoPushToken || 'No data'}</p>
    <p><strong>Socket ID:</strong> {selectedDriver.socketId || 'No data'}</p>
    <p><strong>Location:</strong> Lat: {selectedDriver.location?.latitude ?? 'No data'}, Long: {selectedDriver.location?.longitude ?? 'No data'}</p>
    <p><strong>Created At:</strong> {selectedDriver.createdAt ? new Date(selectedDriver.createdAt).toLocaleDateString() : 'No data'}</p>
    <button onClick={() => setSelectedDriver(null)} className={styles.closeButtonultimatedrivers}>
      Close
    </button>
  </div>
)}

</div>
);
};


const Trucks = ({ trucks, setTrucks, drivers = [], trailers = [] }) => {
  const formatDate = (date) => date ? new Date(date).toISOString().split('T')[0] : '';
  const { notify } = useNotification();
  const [limits, setLimits] = useState({ numberOfTrucks: 0 });
 const [companyName, setCompanyName] = useState('');


  const [truckData, setTruckData] = useState({
    truckNumber: '',
    licensePlate: '',
    VIN: '',
    truckType: '',
    fuelType: '',
    miles: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    driver: '',
    owner: '',
    trailer: '',
    settlement: '',
    settlementAmount: '',
    normalMileRate: '',
    dhMileRate: '',
    hourlyRate: '',
    hoursWorked: '',
    teamDriver: '',
    teamPercentage: '',
    notes: '',
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");
const employeeDrivers = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'employee')
  : [];

const ownerOperators = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'owner_operator')
  : [];


useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
setCompanyName(res.data.companyName);

    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const token = sessionStorage.getItem('token'); // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId'); // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true, // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTruckData({ ...truckData, [name]: value });
  };

  const handleSettlementChange = (e) => {
    const selectedSettlement = e.target.value;
    const resetData = {
      normalMileRate: selectedSettlement === 'Per mile pay' ? truckData.normalMileRate : undefined,
      dhMileRate: selectedSettlement === 'Per mile pay' ? truckData.dhMileRate : undefined,
      hourlyRate: selectedSettlement === 'Hourly pay' ? truckData.hourlyRate : undefined,
      hoursWorked: selectedSettlement === 'Hourly pay' ? truckData.hoursWorked : undefined,
      teamDriver: selectedSettlement === 'Team driver pay' ? truckData.teamDriver : undefined,
      teamPercentage: selectedSettlement === 'Team driver pay' ? truckData.teamPercentage : undefined,
      settlementAmount: selectedSettlement !== 'Per mile pay' && selectedSettlement !== 'Hourly pay' ? truckData.settlementAmount : undefined,
    };

    setTruckData({
      ...truckData,
      settlement: selectedSettlement,
      ...resetData,
    });
  };

  const handleSubmit = async () => {
    if (editingIndex === null && trucks.length >= limits.numberOfTrucks) {
    notify('You cannot add more trucks than the allowed limit.', 'error');
      return;
    }
    const validDriver = truckData.driver || null;
    const validTrailer = truckData.trailer || null;
    const dataToSend = {
        truckNumber: truckData.truckNumber, // Singurul câmp obligatoriu
        ...(truckData.licensePlate && { licensePlate: truckData.licensePlate }),
        ...(truckData.VIN && { VIN: truckData.VIN }),
        ...(truckData.owner && { owner: truckData.owner }),
        ...(truckData.truckType && { truckType: truckData.truckType }),
        ...(truckData.fuelType && { fuelType: truckData.fuelType }),
        ...(truckData.miles && { miles: truckData.miles }),
        ...(truckData.inspectionDate && { inspectionDate: truckData.inspectionDate }),
        ...(truckData.maintenanceDate && { maintenanceDate: truckData.maintenanceDate }),
        ...(truckData.insurancePolicyNumber && { insurancePolicyNumber: truckData.insurancePolicyNumber }),
        ...(truckData.insuranceExpiryDate && { insuranceExpiryDate: truckData.insuranceExpiryDate }),
        ...(truckData.fleetDivision && { fleetDivision: truckData.fleetDivision }),
        ...(validDriver && { driver: validDriver }),
        ...(validTrailer && { trailer: validTrailer }),
        ...(truckData.notes && { notes: truckData.notes }),
        ...(truckData.settlement && { settlement: truckData.settlement }),
        ...(truckData.settlementAmount && { settlementAmount: truckData.settlementAmount }),
        ...(truckData.normalMileRate && { normalMileRate: truckData.normalMileRate }),
        ...(truckData.dhMileRate && { dhMileRate: truckData.dhMileRate }),
        ...(truckData.hourlyRate && { hourlyRate: truckData.hourlyRate }),
        ...(truckData.hoursWorked && { hoursWorked: truckData.hoursWorked }),
        ...(truckData.teamDriver && { teamDriver: truckData.teamDriver }),
        ...(truckData.teamPercentage && { teamPercentage: truckData.teamPercentage }),
        clientId,
      };
      
    

    if (editingIndex !== null) {
      try {
        const response = await axios.put(`${apiUrl}/trucks/${trucks[editingIndex]._id}`, dataToSend, config);
        const updatedTrucks = [...trucks];
        updatedTrucks[editingIndex] = response.data.truck;
        setTrucks(updatedTrucks);
        setEditingIndex(null);
      } catch (error) {
   
      }
    } else {
      try {
        const response = await axios.post(`${apiUrl}/trucks`, dataToSend, config);
        setTrucks([...trucks, response.data.truck]);
      } catch (error) {
   
      }
    }

    setTruckData({
      truckNumber: '',
      licensePlate: '',
      VIN: '',
      truckType: '',
      fuelType: '',
      miles: '',
      inspectionDate: '',
      maintenanceDate: '',
      insurancePolicyNumber: '',
      insuranceExpiryDate: '',
      fleetDivision: '',
      driver: '',
      trailer: '',
      settlement: '',
      settlementAmount: '',
      normalMileRate: '',
      dhMileRate: '',
      hourlyRate: '',
      hoursWorked: '',
      teamDriver: '',
      teamPercentage: '',
      notes: '',
    });
  };

  useEffect(() => {
    const fetchTruckLimit = async () => {
      try {
        const response = await axios.get(`${apiUrl}/clients`, config);
        setLimits({
          numberOfTrucks: response.data.numberOfTrucks,
        });
      } catch (error) {
   
      }
    };
    
    fetchTruckLimit();
  }, []);

  const handleEdit = (index) => {
  const truckToEdit = trucks[index];
  setEditingIndex(index);
  setTruckData({
    truckNumber: truckToEdit.truckNumber || '',
    licensePlate: truckToEdit.licensePlate || '',
    VIN: truckToEdit.VIN || '',
    truckType: truckToEdit.truckType || '',
    fuelType: truckToEdit.fuelType || '',
    miles: truckToEdit.miles || '',
    inspectionDate: formatDate(truckToEdit.inspectionDate),
    maintenanceDate: formatDate(truckToEdit.maintenanceDate),
    insurancePolicyNumber: truckToEdit.insurancePolicyNumber || '',
    insuranceExpiryDate: formatDate(truckToEdit.insuranceExpiryDate),
    fleetDivision: truckToEdit.fleetDivision || '',
    driver: truckToEdit.driver || '',
    owner: truckToEdit.owner || '',
    trailer: truckToEdit.trailer || '',
    settlement: truckToEdit.settlement || '',
    settlementAmount: truckToEdit.settlementAmount || '',
    normalMileRate: truckToEdit.normalMileRate || '',
    dhMileRate: truckToEdit.dhMileRate || '',
    hourlyRate: truckToEdit.hourlyRate || '',
    hoursWorked: truckToEdit.hoursWorked || '',
    teamDriver: truckToEdit.teamDriver || '',
    teamPercentage: truckToEdit.teamPercentage || '',
    notes: truckToEdit.notes || '',
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


  const confirmDeleteTruck = async (index) => {
    try {
      const truckId = trucks[index]._id;
      await axios.delete(`${apiUrl}/trucks/${truckId}`, config);
      setTrucks((prevTrucks) => prevTrucks.filter((_, i) => i !== index));
    } catch (error) {

      notify('Failed to delete truck.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrucks = trucks.filter(truck =>
    truck.truckNumber && truck.truckNumber.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
  className={`${styles.ultimatetrucksSection} ${
    theme === "light" ? styles.ultimatetrucksSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatetrucks}>Add or Edit Truck</h3>
      <form className={styles.truckFormultimatetrucks}>
        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Number*</label>
            <input
              name="truckNumber"
              value={truckData.truckNumber}
              onChange={handleChange}
              placeholder="Truck Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={truckData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <h4>Pay Settings</h4>
        <div className={styles.formGroupultimatetrucks}>
          <label>Settlement*</label>
          <select
            name="settlement"
            value={truckData.settlement}
            onChange={handleSettlementChange}
            required
            className={styles.selectFieldultimatetrucks}
          >
            <option value="">Select Payment Method</option>
            <option value="Hourly pay">Hourly pay</option>
            <option value="Per mile pay">Per mile pay</option>
            <option value="Fixed salary">Fixed salary</option>
            <option value="Percentage of the load">Percentage of the load</option>
            <option value="Team driver pay">Team driver pay</option>
          </select>
        </div>

        {truckData.settlement === 'Per mile pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per normal mile ($)*</label>
              <input
                name="normalMileRate"
                type="number"
                step="0.01"
                value={truckData.normalMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter amount per DH mile ($)*</label>
              <input
                name="dhMileRate"
                type="number"
                step="0.01"
                value={truckData.dhMileRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Hourly pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hourly Rate ($)*</label>
              <input
                name="hourlyRate"
                type="number"
                step="0.01"
                value={truckData.hourlyRate || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Hours Worked*</label>
              <input
                name="hoursWorked"
                type="number"
                step="0.1"
                value={truckData.hoursWorked || ''}
                onChange={handleChange}
                required
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Team driver pay' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Select Co-Driver</label>
              <input
                name="teamDriver"
                value={truckData.teamDriver || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Team Pay Percentage (%)</label>
              <input
                name="teamPercentage"
                type="number"
                step="1"
                value={truckData.teamPercentage || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Percentage of the load' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Enter Percentage of Load Revenue (%)</label>
              <input
                name="settlementAmount"
                type="number"
                step="1"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        {truckData.settlement === 'Fixed salary' && (
          <div className={styles.formRowultimatetrucks}>
            <div className={styles.formGroupultimatetrucks}>
              <label>Fixed Salary Amount ($)</label>
              <input
                name="settlementAmount"
                type="number"
                step="0.01"
                value={truckData.settlementAmount || ''}
                onChange={handleChange}
                className={styles.inputFieldultimatetrucks}
              />
            </div>
          </div>
        )}

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={truckData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Truck Type*</label>
            <select
              name="truckType"
              value={truckData.truckType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Type</option>
              <option value="Semi-truck">Semi-truck</option>
              <option value="Trailer">Trailer</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Fuel Type*</label>
            <select
              name="fuelType"
              value={truckData.fuelType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Fuel Type</option>
              <option value="Diesel">Diesel</option>
              <option value="Gasoline">Gasoline</option>
            </select>
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Miles*</label>
            <input
              name="miles"
              value={truckData.miles}
              onChange={handleChange}
              placeholder="Miles"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Driver*</label>
            <select
              name="driver"
              value={truckData.driver}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Driver</option>
            {employeeDrivers.map(driver => (
  <option key={driver._id} value={driver._id}>
    {driver.firstName} {driver.lastName}
  </option>
))}

            </select>
          </div>

<select
  name="owner"
  value={truckData.owner}
  onChange={handleChange}
  className={styles.selectFieldultimatetrucks}
>
  {companyName && (
    <option value={companyName}>
      {companyName} (Company)
    </option>
  )}

  {ownerOperators.map(owner => (
    <option
      key={owner._id}
      value={`${owner.firstName} ${owner.lastName}`}
    >
      {owner.firstName} {owner.lastName} (Owner Operator)
    </option>
  ))}
</select>




          <div className={styles.formGroupultimatetrucks}>
            <label>Trailer*</label>
            <select
              name="trailer"
              value={truckData.trailer}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrucks}
            >
              <option value="">Select Trailer</option>
              {Array.isArray(trailers) && trailers.map((trailer) => (
                <option key={trailer._id} value={trailer._id}>
                  {trailer.trailerNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={truckData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={truckData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrucks}>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={truckData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
          <div className={styles.formGroupultimatetrucks}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={truckData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrucks}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrucks}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={truckData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrucks}
          />
        </div>
        
        <div className={styles.formGroupultimatetrucks}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={truckData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrucks}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrucks}>
          {editingIndex !== null ? 'Update Truck' : 'Add Truck'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrucks}>Search Trucks</h3>
      <input
        type="text"
        placeholder="Search by truck number"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrucks}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this truck?"
    onConfirm={() => confirmDeleteTruck(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimatetrucks}>Existing Trucks</h3>
      <ul className={styles.truckListultimatetrucks}>
        {filteredTrucks.map((truck, index) => (
          <li key={index} className={styles.truckListItemultimatetrucks}>
            {truck.truckNumber}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrucks}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrucks}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
};


const Trailers = ({ trailers = [], setTrailers }) => {
  const { notify } = useNotification();
  const [trailerData, setTrailerData] = useState({
    trailerNumber: '',
    licensePlate: '',
    VIN: '',
    trailerType: '',
    capacity: '',
    length: '',
    inspectionDate: '',
    maintenanceDate: '',
    insurancePolicyNumber: '',
    insuranceExpiryDate: '',
    fleetDivision: '',
    notes: ''
  });

  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; 
  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [alarms, setAlarms] = useState({ inspectionAlarm: false, maintenanceAlarm: false, insuranceAlarm: false });
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token'); 
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    withCredentials: true,
  };

  // Fetch trailers
  const fetchTrailers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/trailers`, config);
      setTrailers(response.data);
    } catch (error) {
    
    }
  };

  useEffect(() => {
    fetchTrailers();
  }, []);

  // Function to check if any date has expired or reached the current date
  const checkAlarms = () => {
    const today = new Date().toISOString().split('T')[0];
    setAlarms({
      inspectionAlarm: trailerData.inspectionDate && trailerData.inspectionDate <= today,
      maintenanceAlarm: trailerData.maintenanceDate && trailerData.maintenanceDate <= today,
      insuranceAlarm: trailerData.insuranceExpiryDate && trailerData.insuranceExpiryDate <= today,
    });
  };

  useEffect(() => {
    checkAlarms();
  }, [trailerData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrailerData({ ...trailerData, [name]: value });
  };

  const handleSubmit = async () => {
    if (editingIndex !== null) {
      const updatedTrailers = [...trailers];
      updatedTrailers[editingIndex] = { ...trailerData };
      setTrailers(updatedTrailers);
      setEditingIndex(null);
    } else {
      try {
        const response = await axios.post(`${apiUrl}/trailers`, trailerData, config);
        if (response.status === 201) {
          setTrailers([...trailers, response.data]);
        }
      } catch (error) {
        
      }
    }

    setTrailerData({
      trailerNumber: '',
      licensePlate: '',
      VIN: '',
      trailerType: '',
      capacity: '',
      length: '',
      inspectionDate: '',
      maintenanceDate: '',
      insurancePolicyNumber: '',
      insuranceExpiryDate: '',
      fleetDivision: '',
      notes: ''
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setTrailerData(trailers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteTrailer = async (index) => {
    try {
      const trailerId = trailers[index]._id;
      await axios.delete(`${apiUrl}/trailers/${trailerId}`, config);
      setTrailers((prevTrailers) => prevTrailers.filter((_, i) => i !== index));
    } catch (error) {
 
      notify('Failed to delete trailer.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredTrailers = trailers.filter(
    (trailer) => 
      trailer?.trailerNumber?.toLowerCase().includes(searchQuery.toLowerCase()) || 
      trailer?.VIN?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div
  className={`${styles.ultimatetrailersSection} ${
    theme === "light" ? styles.ultimatetrailersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatetrailers}>Add or Edit Trailer</h3>
      {alarms.inspectionAlarm && <p className={styles.alarmMessageultimatetrailers}>Inspection date has expired!</p>}
      {alarms.maintenanceAlarm && <p className={styles.alarmMessageultimatetrailers}>Maintenance date has expired!</p>}
      {alarms.insuranceAlarm && <p className={styles.alarmMessageultimatetrailers}>Insurance has expired!</p>}

      <form className={styles.trailerFormultimatetrailers}>
        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Number*</label>
            <input
              name="trailerNumber"
              value={trailerData.trailerNumber}
              onChange={handleChange}
              placeholder="Trailer Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>License Plate*</label>
            <input
              name="licensePlate"
              value={trailerData.licensePlate}
              onChange={handleChange}
              placeholder="License Plate"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>VIN*</label>
            <input
              name="VIN"
              value={trailerData.VIN}
              onChange={handleChange}
              placeholder="VIN"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Trailer Type*</label>
            <select
              name="trailerType"
              value={trailerData.trailerType}
              onChange={handleChange}
              required
              className={styles.selectFieldultimatetrailers}
            >
              <option value="">Select Type</option>
              <option value="Platform">Platform</option>
              <option value="Refrigerated">Refrigerated</option>
              <option value="Container">Container</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Capacity*</label>
            <input
              name="capacity"
              value={trailerData.capacity}
              onChange={handleChange}
              placeholder="Capacity"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Length*</label>
            <input
              name="length"
              value={trailerData.length}
              onChange={handleChange}
              placeholder="Length"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Inspection Date*</label>
            <input
              name="inspectionDate"
              type="date"
              value={trailerData.inspectionDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Maintenance Date*</label>
            <input
              name="maintenanceDate"
              type="date"
              value={trailerData.maintenanceDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formRowultimatetrailers}>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Policy Number*</label>
            <input
              name="insurancePolicyNumber"
              value={trailerData.insurancePolicyNumber}
              onChange={handleChange}
              placeholder="Insurance Policy Number"
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
          <div className={styles.formGroupultimatetrailers}>
            <label>Insurance Expiry Date*</label>
            <input
              name="insuranceExpiryDate"
              type="date"
              value={trailerData.insuranceExpiryDate}
              onChange={handleChange}
              required
              className={styles.inputFieldultimatetrailers}
            />
          </div>
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Fleet Division*</label>
          <input
            name="fleetDivision"
            value={trailerData.fleetDivision}
            onChange={handleChange}
            placeholder="Fleet Division"
            required
            className={styles.inputFieldultimatetrailers}
          />
        </div>

        <div className={styles.formGroupultimatetrailers}>
          <label>Notes</label>
          <textarea
            name="notes"
            value={trailerData.notes}
            onChange={handleChange}
            placeholder="Notes"
            className={styles.textareaFieldultimatetrailers}
          ></textarea>
        </div>

        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatetrailers}>
          {editingIndex !== null ? 'Update Trailer' : 'Add Trailer'}
        </button>
      </form>

      <h3 className={styles.titleultimatetrailers}>Search Trailers</h3>
      <input
        type="text"
        placeholder="Search by trailer number or VIN"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatetrailers}
      />
  {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this trailer?"
    onConfirm={() => confirmDeleteTrailer(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatetrailers}>Existing Trailers</h3>
      <ul className={styles.trailerListultimatetrailers}>
        {filteredTrailers.map((trailer, index) => (
          <li key={index} className={styles.trailerListItemultimatetrailers}>
            {trailer.trailerNumber} ({trailer.VIN})
    
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatetrailers}>Edit</button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatetrailers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
};


const Employees = ({ employees, setEmployees }) => {
  const { notify } = useNotification();
  const [employeeData, setEmployeeData] = useState({
    firstName: '',
    lastName: '',
    employeeId: '',
    email: '',
    phone: '',
    address: '',
    gender: '',
    residenceCountry: '',
    jobTitle: '',
    position: '',
    hireDate: '',
    terminationDate: '',
    contractType: '',
    payType: '',
    payAmount: '',
    commissionPercentage: '',
    notes: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const token = sessionStorage.getItem('token');
  const clientId = localStorage.getItem('clientId');
  const config = {
    headers: { 'Authorization': `Bearer ${token}` },
    withCredentials: true,
  };

  const fetchEmployees = async () => {
    try {
      const { data } = await axios.get(`${apiUrl}/employees`, config);
      setEmployees(data);
    } catch (err) {
    
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeData({ ...employeeData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const dataToSend = { ...employeeData, clientId };
      if (editingIndex !== null) {
        const employeeId = employees[editingIndex]._id;
        const response = await axios.put(`${apiUrl}/employees/${employeeId}`, dataToSend, config);
        const updatedEmployees = [...employees];
        updatedEmployees[editingIndex] = response.data;
        setEmployees(updatedEmployees);
        setEditingIndex(null);
      } else {
        const response = await axios.post(`${apiUrl}/employees`, dataToSend, config);
        setEmployees([...employees, response.data]);
      }
      setEmployeeData({
        firstName: '',
        lastName: '',
        employeeId: '',
        email: '',
        phone: '',
        address: '',
        gender: '',
        residenceCountry: '',
        jobTitle: '',
        position: '',
        hireDate: '',
        terminationDate: '',
        contractType: '',
        payType: '',
        payAmount: '',
        commissionPercentage: '',
        notes: '',
      });
    } catch (error) {
     
    }
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEmployeeData(employees[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteEmployee = async (index) => {
    try {
      const employeeId = employees[index]._id;
      await axios.delete(`${apiUrl}/employees/${employeeId}`, config);
      setEmployees((prev) => prev.filter((_, i) => i !== index));
    } catch (error) {
    
      notify('Failed to delete employee.', 'error');
    }
    setDeleteTarget(null);
  };

  const filteredEmployees = employees.filter(emp =>
    `${emp.firstName} ${emp.lastName}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
   <div
  className={`${styles.employeeSection} ${
    theme === "light" ? styles.employeeSectionLight : ""
  }`}
>

      <h3 className={styles.titleemployeeSection}>Add or Edit Employee</h3>
      <form className={styles.formemployeeSection}>
        <div className={styles.formRowemployeeSection}>
          <input name="firstName" value={employeeData.firstName} onChange={handleChange} placeholder="First Name*" />
          <input name="lastName" value={employeeData.lastName} onChange={handleChange} placeholder="Last Name*" />
        </div>
        <div className={styles.formRowemployeeSection}>
  <input
    name="employeeId"
    value={employeeData.employeeId}
    onChange={handleChange}
    placeholder="Employee ID"
  />
</div>
        <div className={styles.formRowemployeeSection}>
          <input name="email" value={employeeData.email} onChange={handleChange} placeholder="Email" />
          <input name="phone" value={employeeData.phone} onChange={handleChange} placeholder="Phone" />
        </div>
        <div className={styles.formRowemployeeSection}>
          <input name="address" value={employeeData.address} onChange={handleChange} placeholder="Address" />
          <select name="gender" value={employeeData.gender} onChange={handleChange}>
            <option value="">Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <select name="residenceCountry" value={employeeData.residenceCountry} onChange={handleChange}>
            <option value="">Residence Country</option>
            <option value="USA">USA</option>
            <option value="Canada">Canada</option>
            <option value="South America">South America</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className={styles.formRowemployeeSection}>
          <input name="jobTitle" value={employeeData.jobTitle} onChange={handleChange} placeholder="Job Title" />
          <input name="position" value={employeeData.position} onChange={handleChange} placeholder="Position" />
        </div>
        <div className={styles.formRowemployeeSection}>
          <input type="date" name="hireDate" value={employeeData.hireDate} onChange={handleChange} />
          <input type="date" name="terminationDate" value={employeeData.terminationDate} onChange={handleChange} />
        </div>
        <div className={styles.formRowemployeeSection}>
          <select name="contractType" value={employeeData.contractType} onChange={handleChange}>
            <option value="">Contract Type</option>
            <option value="Permanent">Permanent</option>
            <option value="Temporary">Temporary</option>
            <option value="Contract">Contract</option>
            <option value="Internship">Internship</option>
          </select>
          <select name="payType" value={employeeData.payType} onChange={handleChange}>
            <option value="">Pay Type</option>
            <option value="Hourly">Hourly</option>
            <option value="Fixed salary">Fixed salary</option>
            <option value="Commission">Commission</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
          </select>
        </div>
        <div className={styles.formRowemployeeSection}>
  {employeeData.payType !== 'Commission' && (
    <input
      name="payAmount"
      type="number"
      value={employeeData.payAmount}
      onChange={handleChange}
      placeholder="Pay Amount"
    />
  )}
  {employeeData.payType === 'Commission' && (
    <input
      name="commissionPercentage"
      type="number"
      value={employeeData.commissionPercentage}
      onChange={handleChange}
      placeholder="Commission %"
    />
  )}
</div>

        <div className={styles.formRowemployeeSection}>
          <textarea name="notes" value={employeeData.notes} onChange={handleChange} placeholder="Notes" />
        </div>
        <button type="button" onClick={handleSubmit} className={styles.submitButtonemployeeSection}>
          {editingIndex !== null ? 'Update Employee' : 'Add Employee'}
        </button>
      </form>

      <h3 className={styles.titleemployeeSection}>Search Employees</h3>
      <input
        type="text"
        placeholder="Search by name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputemployeeSection}
      />

      {deleteTarget !== null && (
        <DeleteNotifications
          message="Are you sure you want to delete this employee?"
          onConfirm={() => confirmDeleteEmployee(deleteTarget)}
          onCancel={() => setDeleteTarget(null)}
        />
      )}

      <h3 className={styles.titleemployeeSection}>Existing Employees</h3>
      <ul className={styles.employeeListemployeeSection}>
        {filteredEmployees.map((emp, index) => (
          <li key={index} className={styles.employeeListItememployeeSection}>
            {emp.firstName} {emp.lastName} ({emp.jobTitle})
            <button onClick={() => handleEdit(index)} className={styles.editButtonemployeeSection}>
              Edit
            </button>
            <button onClick={() => setDeleteTarget(index)} className={styles.deleteButtonemployeeSection}>
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
// Componenta Brokers
const Brokers = ({ brokers, setBrokers }) => {
  const { notify } = useNotification();
  const [brokerData, setBrokerData] = useState({
    brokerName: '',
    brokerAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrokerData({ ...brokerData, [name]: value });
  };

  const handleSubmit = async () => {
    
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing broker
      const updatedBrokers = [...brokers];
      updatedBrokers[editingIndex] = brokerData;
      setBrokers(updatedBrokers);
      setEditingIndex(null);
    } else {
      // Add new broker
      try {
        const dataToSend = { ...brokerData, clientId };
        const response = await axios.post(`${apiUrl}/brokers`, dataToSend, config);
        setBrokers([...brokers, response.data]);
      } catch (error) {
   
      }
    }
    setBrokerData({
      brokerName: '',
      brokerAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setBrokerData(brokers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteBroker = async (index) => {
    try {
      const brokerId = brokers[index]._id;
      await axios.delete(`${apiUrl}/brokers/${brokerId}`, config);
      setBrokers((prevBrokers) => prevBrokers.filter((_, i) => i !== index));
    } catch (error) {
     
      notify('Failed to delete broker.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredBrokers = brokers.filter(broker =>
    broker.brokerName && broker.brokerName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <div
  className={`${styles.ultimatebrokersSection} ${
    theme === "light" ? styles.ultimatebrokersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimatebrokers}>Add or Edit Broker</h3>
      <form className={styles.brokerFormultimatebrokers}>
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Broker Name*</label>
            <input
              name="brokerName"
              value={brokerData.brokerName}
              onChange={handleChange}
              placeholder="Broker Name"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Address*</label>
            <input
              name="address"
              value={brokerData.brokerAddress}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimatebrokers}>
          <div className={styles.formGroupultimatebrokers}>
            <label>Email*</label>
            <input
              name="email"
              value={brokerData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
          <div className={styles.formGroupultimatebrokers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={brokerData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimatebrokers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimatebrokers}>
          {editingIndex !== null ? 'Update Broker' : 'Add Broker'}
        </button>
      </form>
  
      <h3 className={styles.titleultimatebrokers}>Search Brokers</h3>
      <input
        type="text"
        placeholder="Search by broker name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimatebrokers}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this broker?"
    onConfirm={() => confirmDeleteBroker(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimatebrokers}>Existing Brokers</h3>
      <ul className={styles.brokerListultimatebrokers}>
        {filteredBrokers.map((broker, index) => (
          <li key={index} className={styles.brokerListItemultimatebrokers}>
            {broker.brokerName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimatebrokers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimatebrokers}
>
  Delete
</button>
          </li>
        ))}
      </ul>
    </div>
  );
  
};



// Componenta Shippers
const Shippers = ({ shippers, setShippers }) => {
  const { notify } = useNotification();
  const [shipperData, setShipperData] = useState({
    shipperName: '',
    shipperAddress: '',
    email: '',
    phone: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShipperData({ ...shipperData, [name]: value });
  };

  const handleSubmit = async () => { 
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing shipper
      const updatedShippers = [...shippers];
      updatedShippers[editingIndex] = shipperData;
      setShippers(updatedShippers);
      setEditingIndex(null);
    } else {
      // Add new shipper
      try {
        const dataToSend = { ...shipperData, clientId };  // Adaugă clientId la datele de trimis
        const response = await axios.post(`${apiUrl}/shippers`, shipperData,config);
        setShippers([...shippers, response.data]);
      } catch (error) {
        
      }
    }
    setShipperData({
      shipperName: '',
      shipperAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setShipperData(shippers[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteShipper = async (index) => {
    try {
      const shipperId = shippers[index]._id;
      await axios.delete(`${apiUrl}/shippers/${shipperId}`, config);
      setShippers((prevShippers) => prevShippers.filter((_, i) => i !== index));
    } catch (error) {
    
      notify('Failed to delete shipper.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  
  const filteredShippers = shippers.filter(shipper =>
    shipper.shipperName && shipper.shipperName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  
  return (
    <div
  className={`${styles.ultimateshippersSection} ${
    theme === "light" ? styles.ultimateshippersSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimateshippers}>Add or Edit Shipper</h3>
      <form className={styles.shipperFormultimateshippers}>
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Shipper Name*</label>
            <input
              name="shipperName"
              value={shipperData.shipperName}
              onChange={handleChange}
              placeholder="Shipper Name"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Address*</label>
            <input
              name="shipperAddress"
              value={shipperData.shipperAddressultimateshippers}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateshippers}>
          <div className={styles.formGroupultimateshippers}>
            <label>Email*</label>
            <input
              name="email"
              value={shipperData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
          <div className={styles.formGroupultimateshippers}>
            <label>Phone*</label>
            <input
              name="phone"
              value={shipperData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateshippers}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateshippers}>
          {editingIndex !== null ? 'Update Shipper' : 'Add Shipper'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateshippers}>Search Shippers</h3>
      <input
        type="text"
        placeholder="Search by shipper name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateshippers}
      />
           {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this shipper?"
    onConfirm={() => confirmDeleteShipper(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}
      <h3 className={styles.titleultimateshippers}>Existing Shippers</h3>
      <ul className={styles.shipperListultimateshippers}>
        {filteredShippers.map((shipper, index) => (
          <li key={index} className={styles.shipperListItemultimateshippers}>
            {shipper.shipperName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateshippers}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateshippers}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
}  

// Componenta Consignees
const Consignees = ({ consignees, setConsignees }) => {
  const { notify } = useNotification();
  const [consigneeData, setConsigneeData] = useState({
    consigneeName: '',
    consigneeAddress: '',
    email: '',
    phone: '',
    notes: '',
  });

  const [editingIndex, setEditingIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  
  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
        // Adaugă Content-Type
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setConsigneeData({ ...consigneeData, [name]: value });
  };

  const handleSubmit = async () => {
    const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
    const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json',
      },
      withCredentials: true,  // Trimite și cookies pentru autentificare
    };
    if (editingIndex !== null) {
      // Update existing consignee
      const updatedConsignees = [...consignees];
      updatedConsignees[editingIndex] = consigneeData;
      setConsignees(updatedConsignees);
      setEditingIndex(null);
    } else {
      // Add new consignee
      try {
        const dataToSend = { ...consigneeData, clientId };
        const response = await axios.post(`${apiUrl}/consignees`, consigneeData, config);
       setConsignees([...consignees, response.data]);
      } catch (error) {
  
      }
    }
    setConsigneeData({
      consigneeName: '',
      consigneeAddress: '',
      email: '',
      phone: '',
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setConsigneeData(consignees[index]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const confirmDeleteConsignee = async (index) => {
    try {
      const consigneeId = consignees[index]._id;
      await axios.delete(`${apiUrl}/consignees/${consigneeId}`, config);
      setConsignees((prevConsignees) => prevConsignees.filter((_, i) => i !== index));
    } catch (error) {
 
      notify('Failed to delete consignee.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  

  const filteredConsignees = consignees.filter(consignee =>
    consignee.consigneeName && consignee.consigneeName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  return (
    <div
  className={`${styles.ultimateconsigneesSection} ${
    theme === "light" ? styles.ultimateconsigneesSectionLight : ""
  }`}
>

      <h3 className={styles.titleultimateconsignees}>Add or Edit Consignee</h3>
      <form className={styles.consigneeFormultimateconsignees}>
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Consignee Name*</label>
            <input
              name="consigneeName"
              value={consigneeData.consigneeName}
              onChange={handleChange}
              placeholder="Consignee Name"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Address*</label>
            <input
              name="consigneeAddress"
              value={consigneeData.consigneeAddressultimateconsignees}
              onChange={handleChange}
              placeholder="Address"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <div className={styles.formRowultimateconsignees}>
          <div className={styles.formGroupultimateconsignees}>
            <label>Email*</label>
            <input
              name="email"
              value={consigneeData.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
          <div className={styles.formGroupultimateconsignees}>
            <label>Phone*</label>
            <input
              name="phone"
              value={consigneeData.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className={styles.inputFieldultimateconsignees}
            />
          </div>
        </div>
  
        <button type="button" onClick={handleSubmit} className={styles.submitButtonultimateconsignees}>
          {editingIndex !== null ? 'Update Consignee' : 'Add Consignee'}
        </button>
      </form>
  
      <h3 className={styles.titleultimateconsignees}>Search Consignees</h3>
      <input
        type="text"
        placeholder="Search by consignee name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className={styles.searchInputultimateconsignees}
      />
              {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this consignee?"
    onConfirm={() => confirmDeleteConsignee(deleteTarget)}
    onCancel={() => setDeleteTarget(null)}
  />
)}

      <h3 className={styles.titleultimateconsignees}>Existing Consignees</h3>
      <ul className={styles.consigneeListultimateconsignees}>
        {filteredConsignees.map((consignee, index) => (
          <li key={index} className={styles.consigneeListItemultimateconsignees}>
            {consignee.consigneeName}
            <button onClick={() => handleEdit(index)} className={styles.editButtonultimateconsignees}>
              Edit
            </button>
            <button 
  onClick={() => setDeleteTarget(index)} 
  className={styles.deleteButtonultimateconsignees}
>
  Delete
</button>

          </li>
        ))}
      </ul>
    </div>
  );
  
};
const statusOrder = [
  "Open",
  "Pending",
  "Dispatched",
  "Assigned",
  "In Progress",
  "On Route",
  "Delivered",
  "Completed",
];

const LoadFinder = ({ loads }) => {
  const [search, setSearch] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoad, setSelectedLoad] = useState(null);
    const [theme, setTheme] = useState("dark");

  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(response.data);
      } catch (error) {
       
      }
    };

    fetchDrivers();
  }, []);

  useEffect(() => {
    const activeLoads = loads
      .filter((load) => !["Completed", "Cancelled"].includes(load.status))
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(activeLoads);
  }, [loads]);

  // ✅ Corectat funcția pentru a găsi numele șoferului corect
  const getDriverName = (driverId) => {
    if (!driverId) return "No Driver";

    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : "Unknown Driver";
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const query = e.target.value.toLowerCase();

    const filtered = loads
      .filter(
        (load) =>
          !["Completed", "Cancelled"].includes(load.status) &&
          (load.loadNumber.toLowerCase().includes(query) ||
            (load.driver && getDriverName(load.driver).toLowerCase().includes(query)) ||
            (load.clientId && load.clientId.toLowerCase().includes(query)))
      )
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setFilteredLoads(filtered);
  };

  const getNextStatus = (currentStatus) => {
    const index = statusOrder.indexOf(currentStatus);
    return index !== -1 && index < statusOrder.length - 1 ? statusOrder[index + 1] : "Completed";
  };

  const handleNextStatus = async () => {
    if (!selectedLoad) return;

    const nextStatus = getNextStatus(selectedLoad.status);

    try {
      const response = await axios.put(
        `${apiUrl}/loads/${selectedLoad._id}`,
        { status: nextStatus },
        config
      );

      if (response.status === 200) {
        setFilteredLoads((prevLoads) =>
          prevLoads
            .map((load) =>
              load._id === selectedLoad._id ? { ...load, status: nextStatus } : load
            )
            .filter((load) => load.status !== "Completed")
        );
        setSelectedLoad((prev) => (prev ? { ...prev, status: nextStatus } : null));
      }
    } catch (error) {

    }
  };

  return (
   <div
  className={`${styles.loadFinderSection} ${
    theme === "light" ? styles.loadFinderSectionLight : ""
  }`}
>


      <h2>Load Tracker</h2>
      <input
        type="text"
        placeholder="Search by Load #, Driver, Client ID"
        value={search}
        onChange={handleSearch}
        className={styles.searchInputloadFinder}
      />

      <ul className={styles.loadListloadFinder}>
        {filteredLoads.map((load) => (
          <li
            key={load._id}
            className={styles.loadItemloadFinder}
            onClick={() => setSelectedLoad(load)}
          >
            <strong>Load #:</strong> {load.loadNumber} <br />
            <strong>Dispatcher:</strong> {load.dispatcher} <br />
            <strong>Driver:</strong> {getDriverName(load.driver)} <br />
            <strong>Status:</strong> {load.status} <br />
          </li>
        ))}
      </ul>

      {/* 🔥 Modal pentru schimbarea statusului, afișat pe mijlocul ecranului */}
      {selectedLoad && (
        <>
          <div className={styles.modalBackdrop} onClick={() => setSelectedLoad(null)}></div>
          <div className={styles.modalContainer}>
            <h3>Load Details</h3>
            <p>
              <strong>Dispatcher:</strong> {selectedLoad.dispatcher}
            </p>
            <p>
              <strong>Load #:</strong> {selectedLoad.loadNumber}
            </p>
            <p>
              <strong>Driver:</strong> {getDriverName(selectedLoad.driver)}
            </p>
            <p>
              <strong>Status:</strong> {selectedLoad.status}
            </p>
            <p>
              <strong>Payment Status:</strong> {selectedLoad.paymentStatus}
            </p>
            <button className={styles.nextButtonloadFind} onClick={handleNextStatus}>
              Next Status: {getNextStatus(selectedLoad.status)}
            </button>
            <button className={styles.closeButtonloadFinder} onClick={() => setSelectedLoad(null)}>
              Close
            </button>
          </div>
        </>
      )}
    </div>
  );
};


const LoadManager = ({ loads, setLoads,selectedLoadId }) => {
  const { notify } = useNotification();
  const [editingLoad, setEditingLoad] = useState(null);
  const [search, setSearch] = useState('');
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [selectedDispatcher, setSelectedDispatcher] = useState('');
  const [theme, setTheme] = useState("dark");

  const [selectedTruck, setSelectedTruck] = useState("");
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [minRate, setMinRate] = useState('');
const [maxRate, setMaxRate] = useState('');
const [pickupStart, setPickupStart] = useState('');
const [pickupEnd, setPickupEnd] = useState('');
const [deliveryStart, setDeliveryStart] = useState('');
const [deliveryEnd, setDeliveryEnd] = useState('');
const [createdStart, setCreatedStart] = useState('');
const [createdEnd, setCreatedEnd] = useState('');

const [selectedStatuses, setSelectedStatuses] = useState([]);
  const editSectionRef = useRef(null);

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  };
  useEffect(() => {
    if (selectedLoadId) {
      const selectedLoad = loads.find((load) => load._id === selectedLoadId);
      if (selectedLoad) {
        setEditingLoad(selectedLoad); // Setăm `editingLoad` pentru a deschide editorul
      }
    }
  }, [selectedLoadId, loads]);
  useEffect(() => {
  if (editingLoad) {
    setSelectedTruck(editingLoad.truck ? String(editingLoad.truck) : '');
    setSelectedDriver(editingLoad.driver || '');
  }
}, [editingLoad]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const driversRes = await axios.get(`${apiUrl}/drivers`, config);
        setDrivers(driversRes.data);

        const trucksRes = await axios.get(`${apiUrl}/trucks`, config);
setTrucks(trucksRes.data.map(t => ({ ...t, _id: String(t._id) })));
      } catch (error) {
        
      }
    };
    fetchData();
  }, []);


  useEffect(() => {
    const filtered = loads.filter((load) => {
      const searchTerm = search.toLowerCase();
      const driverName = drivers.find((d) => d._id === load.driver);
      const truckObj = trucks.find((t) => t._id === String(load.truck));

      const matchesSearch =
        (load.loadNumber && load.loadNumber.toLowerCase().includes(searchTerm)) ||
        (load.brokerName && load.brokerName.toLowerCase().includes(searchTerm)) ||
        (load.brokerAddress && load.brokerAddress.toLowerCase().includes(searchTerm)) ||
        (load.notes && load.notes.toLowerCase().includes(searchTerm)) ||
        (driverName && `${driverName.firstName} ${driverName.lastName}`.toLowerCase().includes(searchTerm)) ||
        (truckObj && truckObj.plate && truckObj.plate.toLowerCase().includes(searchTerm)) ||
        (load.dispatcher && load.dispatcher.toLowerCase().includes(searchTerm));
    
const matchesDriver = selectedDriver ? String(load.driver) === String(selectedDriver) : true;
const matchesTruck = selectedTruck ? String(load.truck) === String(selectedTruck) : true;

      const matchesDispatcher = selectedDispatcher ? load.dispatcher.toLowerCase().includes(selectedDispatcher.toLowerCase()) : true;
    
      const matchesRate =
        (!minRate || parseFloat(load.rate) >= parseFloat(minRate)) &&
        (!maxRate || parseFloat(load.rate) <= parseFloat(maxRate));
    
      const matchesStatus = selectedStatuses.length > 0 ? selectedStatuses.includes(load.status) : true;
    
      const pickupTimes = load.shippers.map(s => new Date(s.pickUpTime));
      const deliveryTimes = load.consignees.map(c => new Date(c.deliveryTime));
      const createdAt = new Date(load.createdAt);
    
      const matchesPickup = (!pickupStart || pickupTimes.some(t => t >= new Date(pickupStart))) &&
                            (!pickupEnd || pickupTimes.some(t => t <= new Date(pickupEnd)));
    
      const matchesDelivery = (!deliveryStart || deliveryTimes.some(t => t >= new Date(deliveryStart))) &&
                              (!deliveryEnd || deliveryTimes.some(t => t <= new Date(deliveryEnd)));
    
      const matchesCreated = (!createdStart || createdAt >= new Date(createdStart)) &&
                             (!createdEnd || createdAt <= new Date(createdEnd));
    
      return matchesSearch && matchesDriver && matchesTruck && matchesDispatcher &&
             matchesRate && matchesStatus && matchesPickup && matchesDelivery && matchesCreated;
    });
    
  
    setFilteredLoads(filtered);
  }, [search, loads, selectedDriver, selectedTruck, minRate, maxRate, selectedStatuses]);
  
{/* Rate Range Filter */}
<div className={styles.filterGroup}>
  <label>Rate From:</label>
  <input type="number" value={minRate} onChange={(e) => setMinRate(e.target.value)} />

  <label>To:</label>
  <input type="number" value={maxRate} onChange={(e) => setMaxRate(e.target.value)} />
</div>

{/* Status Filter */}
<select
  multiple
  value={selectedStatuses}
  onChange={(e) => {
    const options = Array.from(e.target.selectedOptions).map(o => o.value);
    setSelectedStatuses(options);
  }}
>
  <option value="Pending">Pending</option>
  <option value="Open">Open</option>
  <option value="Refused">Refused</option>
  <option value="Assigned">Assigned</option>
  <option value="Dispatched">Dispatched</option>
  <option value="On Route">On Route</option>
  <option value="In Progress">In Progress</option>
  <option value="Delivered">Delivered</option>
  <option value="(Un)Loading">Un-Loading</option>
  <option value="Completed">Completed</option>
  <option value="Cancelled">Cancelled</option>
  <option value="In Yard">In Yard</option>
</select>


  const getDriverName = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    return driver ? `${driver.firstName} ${driver.lastName}` : 'Unknown Driver';
  };

  const handleSelectLoad = (loadIndex) => {
    setEditingLoad(filteredLoads[loadIndex]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditingLoad({ ...editingLoad, [name]: value });
  };

  const handleDriverChange = (e) => {
    const newDriverId = e.target.value;
    setSelectedDriver(newDriverId);
    setEditingLoad({ ...editingLoad, driver: newDriverId });
  };

  const handleTruckChange = (e) => {
    const newTruckId = e.target.value;
    setSelectedTruck(newTruckId);
    setEditingLoad({ ...editingLoad, truck: newTruckId });
  };

  const handleSave = async () => {
    try {
      if (editingLoad && editingLoad._id) {
        await axios.put(`${apiUrl}/loads/${editingLoad._id}`, editingLoad, config);
        setLoads((prevLoads) =>
          prevLoads.map((load) =>
            load._id === editingLoad._id ? editingLoad : load
          )
        );
        notify('Load updated successfully','success');
      }
    } catch (error) {
      
    }
  };

  const handleDelete = (loadId) => {
    setDeleteTarget(loadId); // Setăm ID-ul pentru notificare
  
    // 🔥 Dăm scroll la secțiunea de editare cu un mic delay
    setTimeout(() => {
      if (editSectionRef.current) {
        editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 200); // Delay pentru a permite UI-ului să se actualizeze
  };
  
  useEffect(() => {
    if (deleteTarget !== null) {
      setTimeout(() => {
        if (editSectionRef.current) {
          editSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [deleteTarget]);
  
  
  const confirmDeleteLoad = async () => {
    if (!deleteTarget) return;
  
    try {
      await axios.delete(`${apiUrl}/loads/${deleteTarget}`, config);
      setLoads((prevLoads) => prevLoads.filter((load) => load._id !== deleteTarget));
      setEditingLoad(null);
      notify('Load deleted successfully', 'success');
    } catch (error) {
    
      notify('Failed to delete load.', 'error');
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  const exportToExcel = () => {
  const data = filteredLoads.map(load => ({
    'Load #': load.loadNumber,
    'Broker Name': load.brokerName,
    'Broker Address': load.brokerAddress,
    'Rate': load.rate,
    'Shippers': load.shippers.map(s => `${s.name}, ${s.address}, ${s.pickUpTime ? new Date(s.pickUpTime).toLocaleString() : ''}`).join('\n'),
    'Consignees': load.consignees.map(c => `${c.name}, ${c.address}, ${c.deliveryTime ? new Date(c.deliveryTime).toLocaleString() : ''}`).join('\n'),
    'Dispatcher': load.dispatcher,
    'Status': load.status,
    'Driver': drivers.find(d => d._id === load.driver) ? `${drivers.find(d => d._id === load.driver).firstName} ${drivers.find(d => d._id === load.driver).lastName}` : '',
    'Truck': (() => {
      const truckId = typeof load.truck === 'object' ? load.truck?._id : load.truck;
      const truck = trucks.find(t => String(t._id) === String(truckId));
      return truck?.truckNumber || '';
    })(),
    'Miles': load.miles,
    'DH': load.dh,
    'Notes': load.notes,
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Loads');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `loads_export_${new Date().toISOString().slice(0,10)}.xlsx`);
};

  return (
   <div
  className={`${styles.ultimateloadManagerSection} ${
    theme === "light" ? styles.ultimateloadManagerSectionLight : ""
  }`}
>

      <h2 className={styles.titleultimateloadManager}>Load Scheduler</h2>
  
      <input
        type="text"
        placeholder="Search by Load Number or Driver"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInputultimateloadManager}
      />
 

      <div className={styles.filtersContainer}>
        {/* Rate Filter */}
        <div className={styles.filterGroup}>
          <label>Rate:</label>
          <input
            type="number"
            value={minRate}
            onChange={(e) => setMinRate(e.target.value)}
            placeholder="From"
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="number"
            value={maxRate}
            onChange={(e) => setMaxRate(e.target.value)}
            placeholder="To"
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Dispatcher Filter */}
        <div className={styles.filterGroup}>
          <label>Dispatcher:</label>
          <input
            type="text"
            value={selectedDispatcher}
            onChange={(e) => setSelectedDispatcher(e.target.value)}
            placeholder="Type dispatcher name"
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
      {/* Truck Filter */}
<div className={styles.filterGroup}>
  <label>Truck:</label>
  <select
    value={typeof selectedTruck === 'object' ? selectedTruck._id : selectedTruck}
    onChange={(e) => setSelectedTruck(e.target.value)}
    className={styles.selectFieldultimateloadManager}
  >
    <option value="">All Trucks</option>
    {trucks.map((truck) => (
      <option key={truck._id} value={truck._id}>
        {truck.truckNumber || "No Truck Number"}
      </option>
    ))}
  </select>
</div>

  
        {/* Driver Filter */}
        <div className={styles.filterGroup}>
          <label>Driver:</label>
          <select
            value={selectedDriver}
            onChange={(e) => setSelectedDriver(e.target.value)}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">All Drivers</option>
            {drivers.map((driver) => (
              <option key={driver._id} value={driver._id}>
                {driver.firstName} {driver.lastName}
              </option>
            ))}
          </select>
        </div>
  
        {/* Status Filter */}
        <div className={styles.filterGroup}>
          <label>Status:</label>
          <select
            multiple
            value={selectedStatuses}
            onChange={(e) =>
              setSelectedStatuses(Array.from(e.target.selectedOptions).map((o) => o.value))
            }
            className={styles.selectFieldultimateloadManager}
          >
            <option value="Pending">Pending</option>
            <option value="Open">Open</option>
            <option value="Refused">Refused</option>
            <option value="Assigned">Assigned</option>
            <option value="Dispatched">Dispatched</option>
            <option value="On Route">On Route</option>
            <option value="In Progress">In Progress</option>
            <option value="Delivered">Delivered</option>
            <option value="(Un)Loading">Un-Loading</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="In Yard">In Yard</option>
          </select>
        </div>
  
        {/* Pick-up Time Filter */}
        <div className={styles.filterGroup}>
          <label>Pick-up Time:</label>
          <input
            type="datetime-local"
            value={pickupStart}
            onChange={(e) => setPickupStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="datetime-local"
            value={pickupEnd}
            onChange={(e) => setPickupEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Delivery Time Filter */}
        <div className={styles.filterGroup}>
          <label>Delivery Time:</label>
          <input
            type="datetime-local"
            value={deliveryStart}
            onChange={(e) => setDeliveryStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="datetime-local"
            value={deliveryEnd}
            onChange={(e) => setDeliveryEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
  
        {/* Created Date Filter */}
        <div className={styles.filterGroup}>
          <label>Created Date:</label>
          <input
            type="date"
            value={createdStart}
            onChange={(e) => setCreatedStart(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
          <input
            type="date"
            value={createdEnd}
            onChange={(e) => setCreatedEnd(e.target.value)}
            className={styles.inputFieldultimateloadManager}
          />
        </div>
      </div>
   <button onClick={exportToExcel} className={styles.exportButtonultimateloadManager}>
  Export to Excel
</button>
      <div className={styles.tableWrapper}>
      <table className={styles.ultimateloadManagerloadTable}>
        <thead>
          <tr>
            <th>Load #</th>
            <th>Broker Name</th>
            <th>Broker Address</th>
            <th>Rate</th>
            <th>Shippers</th>
            <th>Consignees</th>
            <th>Dispatcher</th>
            <th>Status</th>
            <th>Driver</th>
            <th>Truck</th>
            <th>Miles</th>
            <th>DH</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {filteredLoads.map((load, index) => (
            <tr key={index} onClick={() => handleSelectLoad(index)} className={styles.ultimateloadManagerloadRow}>
              <td>{load.loadNumber}</td>
              <td>{load.brokerName}</td>
              <td>{load.brokerAddress}</td>
              <td>${load.rate}</td>
              <td>
                {load.shippers.map((shipper, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {shipper.name} <br />
                    <strong>Address:</strong> {shipper.address} <br />
                    <strong>Pick-up Time:</strong> {shipper.pickUpTime ? new Date(shipper.pickUpTime).toLocaleString() : 'No data'}
                  </div>
                ))}
              </td>
              <td>
                {load.consignees.map((consignee, idx) => (
                  <div key={idx}>
                    <strong>Name:</strong> {consignee.name} <br />
                    <strong>Address:</strong> {consignee.address} <br />
                    <strong>Delivery Time:</strong> {consignee.deliveryTime ? new Date(consignee.deliveryTime).toLocaleString() : 'No data'}
                  </div>
                ))}
              </td>
              <td>{load.dispatcher}</td>
              <td>{load.status}</td>
              <td>{load.driver ? drivers.find(d => d._id === load.driver)?.firstName || "Unknown" : "No Driver"}</td>
     <td>
  {(() => {
    if (!load.truck) return "No Truck";
    const truckId = typeof load.truck === 'object' ? load.truck?._id : load.truck;
    const truck = trucks.find(t => String(t._id) === String(truckId));
    return truck?.truckNumber || "Unknown";
  })()}
</td>




              <td>{load.miles}</td>
              <td>{load.dh}</td>
              <td>{load.notes}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {editingLoad ? (
  <div ref={editSectionRef} className={styles.editLoadFormultimateloadManager}>
    <h3>Edit Load</h3>
    <button onClick={() => setEditingLoad(null)} className={styles.closeButtonultimateloadManager}>
      ✕
    </button>

    {/* Load Number */}
    <label>Load #:</label>
    <input
      name="loadNumber"
      value={editingLoad.loadNumber}
      disabled // Disable edit pentru loadNumber
      className={styles.inputFieldultimateloadManager}
    />

    {/* Broker Information */}
    <label>Broker Name:</label>
    <input
      name="brokerName"
      value={editingLoad.brokerName || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    <label>Broker Address:</label>
    <input
      name="brokerAddress"
      value={editingLoad.brokerAddress || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Rate */}
    <label>Rate:</label>
    <input
      name="rate"
      type="number"
      value={editingLoad.rate || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Status */}
    <label>Status:</label>
    <select
      name="status"
      value={editingLoad.status || ''}
      onChange={handleChange}
      className={styles.selectFieldultimateloadManager}
    >
              <option value="Pending">Pending</option>
              <option value="Open">Open</option>
              <option value="Refused">Refused</option>
              <option value="Assigned">Assigned</option>
              <option value="Dispatched">Dispatched</option>
              <option value="On Route">On Route</option>
              <option value="In Progress">In Progress</option>
              <option value="Delivered">Delivered</option>
              <option value="(Un)Loading">Un-Loading</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
              <option value="In Yard">In Yard</option>

    </select>
  {/* Payment Status */}
  <label>Payment Status:</label>
          <select
            name="paymentStatus"
            value={editingLoad.paymentStatus || ''}
            onChange={handleChange}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">Select Payment Status</option>
            <option value="Not Paid">Not Paid</option>
            <option value="Pending Payment">Pending Payment</option>
            <option value="Payment in Progress">Payment in Progress</option>
            <option value="Payment Cancelled">Payment Cancelled</option>
            <option value="Paid">Paid</option>
            <option value="Paid in Installments">Paid in Installments</option>
          </select>

     {/* Driver Selector */}
     <label>Driver:</label>
          <select
            value={selectedDriver}
            onChange={handleDriverChange}
            className={styles.selectFieldultimateloadManager}
          >
            <option value="">Select Driver</option>
            {drivers.map((driver) => (
              <option key={driver._id} value={driver._id}>
                {driver.firstName} {driver.lastName}
              </option>
            ))}
          </select>

          {/* Truck Selector */}
          <label>Truck:</label>
<select
  value={typeof selectedTruck === 'object' ? selectedTruck._id : selectedTruck}
  onChange={handleTruckChange}
  className={styles.selectFieldultimateloadManager}
>
  <option value="">Select Truck</option>
  {trucks.map((truck) => (
    <option key={truck._id} value={truck._id}>
      {truck.truckNumber}
    </option>
  ))}
</select>



    {/* Miles and DH */}
    <label>Miles:</label>
    <input
      name="miles"
      type="number"
      value={editingLoad.miles || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    <label>DH:</label>
    <input
      name="dh"
      type="number"
      value={editingLoad.dh || ''}
      onChange={handleChange}
      className={styles.inputFieldultimateloadManager}
    />

    {/* Notes */}
    <label>Notes:</label>
    <textarea
      name="notes"
      value={editingLoad.notes || ''}
      onChange={handleChange}
      className={styles.textareaFieldultimateloadManager}
    />

    {/* Shippers */}
    <label>Shippers:</label>
    {editingLoad.shippers.map((shipper, index) => (
      <div key={index} className={styles.subFormultimateloadManager}>
        <label>Name:</label>
        <input
          value={shipper.name || ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].name = e.target.value;
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Address:</label>
        <input
          value={shipper.address || ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].address = e.target.value;
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Pick-up Time:</label>
        <input
          type="datetime-local"
          value={shipper.pickUpTime ? new Date(shipper.pickUpTime).toISOString().slice(0, -1) : ''}
          onChange={(e) => {
            const updatedShippers = [...editingLoad.shippers];
            updatedShippers[index].pickUpTime = new Date(e.target.value);
            setEditingLoad({ ...editingLoad, shippers: updatedShippers });
          }}
          className={styles.inputFieldultimateloadManager}
        />
      </div>
    ))}

    {/* Consignees */}
    <label>Consignees:</label>
    {editingLoad.consignees.map((consignee, index) => (
      <div key={index} className={styles.subFormultimateloadManager}>
        <label>Name:</label>
        <input
          value={consignee.name || ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].name = e.target.value;
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Address:</label>
        <input
          value={consignee.address || ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].address = e.target.value;
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
        <label>Delivery Time:</label>
        <input
          type="datetime-local"
          value={consignee.deliveryTime ? new Date(consignee.deliveryTime).toISOString().slice(0, -1) : ''}
          onChange={(e) => {
            const updatedConsignees = [...editingLoad.consignees];
            updatedConsignees[index].deliveryTime = new Date(e.target.value);
            setEditingLoad({ ...editingLoad, consignees: updatedConsignees });
          }}
          className={styles.inputFieldultimateloadManager}
        />
      </div>
    ))}
     {deleteTarget !== null && (
  <DeleteNotifications
    message="Are you sure you want to delete this load?"
    onConfirm={confirmDeleteLoad}
    onCancel={() => setDeleteTarget(null)}
  />
)}

    {/* Save and Delete Buttons */}
    <button onClick={handleSave} className={styles.saveButtonultimateloadManager}>Save</button>
    <button onClick={() => handleDelete(editingLoad._id)} className={styles.deleteButtonultimateloadManager}>
  Delete
</button>

  </div>
) : (
  <p>No load selected</p>
)}

    </div>
  );
};


const AccountingManager = () => {
  const { notify } = useNotification();
  const [openInvoices, setOpenInvoices] = useState([]);
  const [sentInvoices, setSentInvoices] = useState([]);
  const [factoringEmail, setFactoringEmail] = useState('');
  const [factoringMessage, setFactoringMessage] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [activeTab, setActiveTab] = useState('open');
  const [isLoading, setIsLoading] = useState(false);
const [theme, setTheme] = useState("dark");

  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    fetchInvoices();
    fetchFactoringDetails();
  }, []);

  const fetchInvoices = async () => {
    setIsLoading(true);
    try {
        const response = await axios.get(`${apiUrl}/invoices`, config);
        const invoices = response.data;

        const sentInvoicesResponse = await axios.get(`${apiUrl}/factoring-invoices`, config);
        const sentIds = new Set(sentInvoicesResponse.data.map(inv => inv.invoiceId.toString())); // ✅ Folosim `Set` pentru căutare rapidă

        const filteredOpenInvoices = invoices.filter(inv => !sentIds.has(inv._id.toString()));

        setOpenInvoices(filteredOpenInvoices);
        setSentInvoices(sentInvoicesResponse.data);
    } catch (error) {
        
    } finally {
        setIsLoading(false);
    }
};


  const fetchFactoringDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/factoring`, config);
      if (response.data) {
        setFactoringEmail(response.data.email || '');
        setFactoringMessage(response.data.message || '');
      }
    } catch (error) {
      
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectInvoice = (invoiceId) => {
    setSelectedInvoices((prev) =>
      prev.includes(invoiceId) ? prev.filter((id) => id !== invoiceId) : [...prev, invoiceId]
    );
  };
  const handleDownloadSelectedInvoicesExcel = () => {
    if (selectedInvoices.length === 0) {
      notify("No invoices selected for download!" ,'error');
      return;
    }
  
    const selectedData = openInvoices
      .filter((inv) => selectedInvoices.includes(inv._id))
      .map((inv) => ({
        "Broker Name": inv.brokerName,
        "Invoice Number": inv.invoiceNumber,
        "Invoice Date": inv.invoiceDate ? new Date(inv.invoiceDate).toLocaleDateString() : "Invalid Date",
        "Load Number": inv.loadNumber,
        "Amount": `$${inv.rate ? inv.rate.toFixed(2) : "0.00"}`,
        "Driver Name": inv.driverName || "No data",
        "Notes": inv.notes || "",
      }));
  
    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Invoices");
  
    XLSX.writeFile(wb, "Selected_Invoices.xlsx");
  };
  const handleSendMultipleFactoringEmails = async () => {
    if (selectedInvoices.length === 0) {
      notify('No invoices selected!' , 'error');
      return;
    }

    if (!factoringEmail || !factoringMessage) {
      notify('Factoring email or message missing! Save them first.' ,'error');
      return;
    }

    for (const invoiceId of selectedInvoices) {
      if (!uploadedFiles[invoiceId] || uploadedFiles[invoiceId].length === 0) {
        notify(`Invoice ${invoiceId} has no uploaded files!` , 'error');
        return;
      }
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append('email', factoringEmail);
    formData.append('message', factoringMessage);
    formData.append('invoiceIds', JSON.stringify(selectedInvoices));

    selectedInvoices.forEach((invoiceId) => {
      uploadedFiles[invoiceId].forEach((file) => {
        formData.append('files', file);
      });
    });

    try {
      await axios.post(`${apiUrl}/factoring/send-multiple`, formData, config);

      for (const invoiceId of selectedInvoices) {
        const invoice = openInvoices.find(inv => inv._id === invoiceId);
        if (invoice) {
          await axios.post(`${apiUrl}/factoring-invoices`, {
            invoiceId: invoice._id,
            brokerName: invoice.brokerName,
            invoiceNumber: invoice.invoiceNumber,
            invoiceDate: invoice.invoiceDate,
            loadNumber: invoice.loadNumber,
            rate: invoice.rate,
            driverName: invoice.driverName,
            notes: invoice.notes
          }, config);
        }
      }


      setSentInvoices(prev => [...prev, ...selectedInvoices.map(id => openInvoices.find(inv => inv._id === id))]);
      setOpenInvoices(prev => prev.filter(inv => !selectedInvoices.includes(inv._id)));

      setSelectedInvoices([]);
      setUploadedFiles({});
      notify('Factoring emails sent and invoices moved to "Sent"!', 'success');
      fetchInvoices();
    } catch (error) {
     
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileUpload = (event, invoiceId) => {
    const files = event.target.files;
    if (!files.length) return;

    setUploadedFiles((prev) => ({
      ...prev,
      [invoiceId]: [...(prev[invoiceId] || []), ...Array.from(files)],
    }));
  };

  const handleTabChange = async (tab) => {
    setIsLoading(true);
  
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("tab", tab);
    window.history.pushState({}, "", newUrl.toString());
  
    setActiveTab(tab);
  
    if (tab === "open") {
      await fetchInvoices(); // ✅ Reîncarcă ambele liste pentru a evita duplicarea!
    }
  
    setTimeout(() => setIsLoading(false), 1000);
  };
  
  
  

  return (
   <div
  className={`${styles.ultimateaccountingManager} ${
    theme === "light" ? styles.ultimateaccountingManagerLight : ""
  }`}
>

      <h2>Accounting Manager</h2>

      {/* ✅ Loader pentru toate acțiunile */}
      <Loader isLoading={isLoading} text="Loading..." />

      <div className={styles.tabContainerultimateaccountingManager}>
        <button className={activeTab === 'open' ? styles.activeTabultimateaccountingManager : ''} onClick={() => handleTabChange('open')}>
          Open Invoices
        </button>
        <button className={activeTab === 'sent' ? styles.activeTabultimateaccountingManager : ''} onClick={() => handleTabChange('sent')}>
          Sent Invoices
        </button>
      </div>

      <div className={styles.factoringSectionultimateaccountingManager}>
        <h3>Factoring Details</h3>
        <input
          type="email"
          placeholder="Enter Factoring Email"
          value={factoringEmail}
          onChange={(e) => setFactoringEmail(e.target.value)}
          className={styles.inputFieldultimateaccountingManager}
        />
        <textarea
          placeholder="Enter Message"
          value={factoringMessage}
          onChange={(e) => setFactoringMessage(e.target.value)}
          className={styles.textareaFieldultimateaccountingManager}
        />
      </div>

      {/* ✅ Buton pentru trimiterea invoice-urilor selectate */}
<button
  onClick={handleSendMultipleFactoringEmails}
  disabled={selectedInvoices.length === 0 || isLoading}
  className={styles.sendFactoringButtonultimateaccountingManager}
>
  {isLoading ? "Sending..." : "Send Selected Invoices to Factoring"}
</button>

{/* ✅ Buton pentru descărcarea invoice-urilor selectate ca Excel */}
<button
  onClick={handleDownloadSelectedInvoicesExcel}
  disabled={selectedInvoices.length === 0}
  className={styles.downloadExcelButtonultimateaccountingManager}
>
  Download Selected Invoices to Excel
</button>


      {activeTab === 'open' ? (
        <table className={styles.invoiceTableultimateaccountingManager}>
          <thead>
            <tr>
              <th></th>
              <th>DEBNAME</th>
              <th>INV_ID</th>
              <th>INV_DATE</th>
              <th>PO_NO</th>
              <th>INVAMT</th>
              <th>Name</th>
              <th>Additional Note</th>
              <th>Upload Docs</th>
            </tr>
          </thead>
          <tbody>
            {openInvoices.map((invoice) => (
              <tr key={invoice._id}>
                <td>
                  <input type="checkbox" checked={selectedInvoices.includes(invoice._id)} onChange={() => handleSelectInvoice(invoice._id)} />
                </td>
                <td>{invoice.brokerName}</td>
                <td>{invoice.invoiceNumber}</td>
                <td>{invoice.invoiceDate ? new Date(invoice.invoiceDate).toLocaleDateString() : 'Invalid Date'}</td>
                <td>{invoice.loadNumber}</td>
                <td>${invoice.rate ? invoice.rate.toFixed(2) : '0.00'}</td>
                <td>{invoice.driverName || 'No data'}</td>
                <td>{invoice.notes || ''}</td>
                <td>
                  <input type="file" multiple onChange={(e) => handleFileUpload(e, invoice._id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className={styles.invoiceTableultimateaccountingManager}>
          <thead>
            <tr>
              <th>DEBNAME</th>
              <th>INV_ID</th>
              <th>INV_DATE</th>
              <th>PO_NO</th>
              <th>INVAMT</th>
              <th>Name</th>
              <th>Additional Note</th>
            </tr>
          </thead>
          <tbody>
            {sentInvoices.map((invoice) => (
              <tr key={invoice.invoiceId}>
                <td>{invoice.brokerName}</td>
                <td>{invoice.invoiceNumber}</td>
                <td>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                <td>{invoice.loadNumber}</td>
                <td>${invoice.rate.toFixed(2)}</td>
                <td>{invoice.driverName || 'No data'}</td>
                <td>{invoice.notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const DriverPayManager = () => {
  const [driverPays, setDriverPays] = useState([]);
  const [filteredPays, setFilteredPays] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedPays, setSelectedPays] = useState([]);
  const [selectedPay, setSelectedPay] = useState(null);
const [drivers, setDrivers] = useState([]);
const [selectedDriverId, setSelectedDriverId] = useState("");

  const token = sessionStorage.getItem("token");

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  useEffect(() => {
    const fetchAllPays = async () => {
      try {
        const res = await axios.get(
          "https://api-backend.full-trucking-service.com/api/driverpays?limit=200",
          config
        );

        const list = res.data?.data || [];
        setDriverPays(list);
        setFilteredPays(list);
      } catch (err) {
        setDriverPays([]);
        setFilteredPays([]);
      }
    };

    fetchAllPays();
  }, []);

  useEffect(() => {
  const fetchDrivers = async () => {
    try {
      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/drivers",
        config
      );
      setDrivers(res.data || []);
    } catch (err) {
      setDrivers([]);
    }
  };

  fetchDrivers();
}, []);
useEffect(() => {
  let data = [...driverPays];

  // Filter by driver
  if (selectedDriverId) {
    data = data.filter(p => p.driverId?._id === selectedDriverId);
  }

  // Filter by date
  if (startDate) {
    data = data.filter(p => new Date(p.startDate) >= new Date(startDate));
  }

  if (endDate) {
    data = data.filter(p => new Date(p.endDate) <= new Date(endDate));
  }

  // Search ONLY settlement number
  if (searchTerm) {
    const term = searchTerm.toLowerCase();
    data = data.filter(p =>
      (p.settlementNumber || "")
        .toLowerCase()
        .includes(term)
    );
  }

  setFilteredPays(data);

}, [searchTerm, startDate, endDate, selectedDriverId, driverPays]);


  const toggleSelect = (id) => {
    setSelectedPays(prev =>
      prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
  };
const generateExistingPDF = (pay) => {

  const doc = new jsPDF();

  const {
    payDetails = [],
    totalPay = 0,
    totalWithAdjustments = 0,
    recurringAddition = [],
    recurringDeduction = [],
    pdfSettings = {}
  } = pay;

  const driver = pay.driverId || {};
  const logo = pay.logo;

  const {
    settlementSubtitle,
    extraHeaderLine,
    showSettlementNumber,
    showDriverNumber,
    showTruckNumber,
    showPhone,
    showEmail
  } = pdfSettings;

  const today = pay.paymentDate
    ? new Date(pay.paymentDate).toISOString().split("T")[0]
    : new Date().toISOString().split("T")[0];

  // ================= HEADER =================
  const addHeader = () => {

    if (logo && typeof logo === "string") {
      doc.addImage(logo, "PNG", 10, 10, 55, 25);
    }

    doc.setFontSize(16);
    doc.text("DRIVER SETTLEMENT", 105, 20, { align: "center" });

    if (settlementSubtitle) {
      doc.setFontSize(10);
      doc.text(settlementSubtitle, 105, 26, { align: "center" });
    }

    doc.setFontSize(10);

    let y = 45;

    doc.text(
      `Driver Name: ${driver.firstName || ""} ${driver.lastName || ""}`,
      10,
      y
    );
    y += 6;

    doc.text(
      `Driver Address: ${driver.address || "N/A"}`,
      10,
      y
    );
    y += 6;

    doc.text(
      `Start Date: ${new Date(pay.startDate).toLocaleDateString()}`,
      10,
      y
    );
    y += 6;

    doc.text(
      `End Date: ${new Date(pay.endDate).toLocaleDateString()}`,
      10,
      y
    );
    y += 6;

    doc.text(`Payment Date: ${today}`, 10, y);
    y += 8;

    // OPTIONAL FIELDS

    if (showSettlementNumber) {
      doc.text(`Settlement #: ${pay.settlementNumber}`, 140, 45);
    }

    let rightY = 55;

    if (showDriverNumber) {
      doc.text(
        `Driver #: ${driver.driverNumber || "N/A"}`,
        140,
        rightY
      );
      rightY += 6;
    }

    if (showTruckNumber) {
      doc.text(
        `Truck: ${driver.truckNumber || "N/A"}`,
        140,
        rightY
      );
      rightY += 6;
    }

    if (showPhone) {
      doc.text(
        `Phone: ${driver.phone || ""}`,
        140,
        rightY
      );
      rightY += 6;
    }

    if (showEmail) {
      doc.text(
        `Email: ${driver.email || ""}`,
        140,
        rightY
      );
      rightY += 6;
    }

    if (extraHeaderLine) {
      doc.text(extraHeaderLine, 10, y + 4);
    }
  };

  // ================= FOOTER =================
  const addFooter = () => {

    const pageHeight = doc.internal.pageSize.height;
    const pageCount = doc.internal.getNumberOfPages();

    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);

    if (doc.lastAutoTable && doc.lastAutoTable.finalY + 30 > pageHeight) {
      doc.addPage();
      addHeader();
    }

    doc.text(`Page ${pageCount}`, 10, pageHeight - 10);

    doc.text(
      'Thank you for your business!',
      105,
      pageHeight - 20,
      { align: 'center' }
    );

    doc.text(
      `${pay.companyName || ""}`,
      105,
      pageHeight - 15,
      { align: 'center' }
    );
  };

  // ================= START =================
  addHeader();

  let startY = 100;

  // ================= LOADS =================
  payDetails.forEach((detail, index) => {

    if (startY > doc.internal.pageSize.height - 40) {
      doc.addPage();
      addHeader();
      addFooter();
      startY = 30;
    }

    doc.setFontSize(8);

    const pickupDetails =
      detail.shippers?.length > 0
        ? detail.shippers.map((shipper) => {
            if (!shipper.pickUpTime || isNaN(new Date(shipper.pickUpTime))) {
              return `Unknown Date - ${shipper.address || "No data"}`;
            }
            return `${new Date(shipper.pickUpTime).toLocaleString()} - ${shipper.address || "No data"}`;
          }).join("\n")
        : "No data";

    const deliveryDetails =
      detail.consignees?.length > 0
        ? detail.consignees.map((consignee) => {
            if (!consignee.deliveryTime || isNaN(new Date(consignee.deliveryTime))) {
              return `Unknown Date - ${consignee.address || "No data"}`;
            }
            return `${new Date(consignee.deliveryTime).toLocaleString()} - ${consignee.address || "No data"}`;
          }).join("\n")
        : "No data";

    doc.autoTable({
      startY,
      body: [
        [
          { content: `Load #`, styles: { fontStyle: 'bold', halign: 'left' } },
          `${index + 1}`,
          ''
        ],
        [
          { content: 'Pickup:', styles: { fontStyle: 'bold', halign: 'left' } },
          { content: pickupDetails, colSpan: 2 }
        ],
        [
          { content: 'Delivery:', styles: { fontStyle: 'bold', halign: 'left' } },
          { content: deliveryDetails, colSpan: 2 }
        ],
        [
          { content: 'Rate', styles: { fontStyle: 'bold', halign: 'left' } },
          `$${detail.rate}`,
          ''
        ],
        [
          'Notes',
          detail.notes || 'No notes available',
          {
            content: `Total Pay: $${detail.pay.toFixed(2)}`,
            styles: { fontStyle: 'bold', halign: 'right' }
          }
        ]
      ],
      theme: 'grid',
      styles: {
        textColor: "#000000",
        lineWidth: 0.75,
        fontSize: 8,
        cellPadding: 1.5
      },
      margin: { top: 10, left: 10, right: 10 },
      columnStyles: {
        0: { halign: 'left' },
        1: { halign: 'left' },
        2: { halign: 'right' }
      }
    });

    startY = doc.lastAutoTable.finalY + 10;
  });

  // ================= SUB TOTAL =================
  doc.setFontSize(10);
  doc.text('Sub-Total', 10, startY);
  startY += 10;

  doc.autoTable({
    startY,
    body: [['Sub-Total', `$${totalPay.toFixed(2)}`]],
    theme: 'grid',
    styles: {
      textColor: "#000000",
      lineWidth: 0.75,
      fontSize: 8,
      cellPadding: 1.5
    },
    margin: { top: 10, left: 10, right: 10 },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'right' }
    }
  });

  // ================= RECURRING ADDITIONS =================
  startY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text('Recurring Additions', 10, startY);
  startY += 10;

  doc.autoTable({
    startY,
    head: [['Service', 'Amount']],
    body: recurringAddition.map((add) => [
      `${add.type} – ${add.description} – ${add.date || ""}`,
      `$${parseFloat(add.amount || 0).toFixed(2)}`
    ]),
    theme: 'grid',
    styles: {
      textColor: "#000000",
      lineWidth: 0.75,
      fontSize: 8,
      cellPadding: 1.5
    },
    margin: { top: 10, left: 10, right: 10 },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'right' }
    }
  });

  // ================= RECURRING DEDUCTIONS =================
  startY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text('Recurring Deductions', 10, startY);
  startY += 10;

  doc.autoTable({
    startY,
    head: [['Service', 'Amount']],
    body: recurringDeduction.map((ded) => [
      `${ded.type} – ${ded.description} – ${ded.date || ""}`,
      `-$${parseFloat(ded.amount || 0).toFixed(2)}`
    ]),
    theme: 'grid',
    styles: {
      textColor: "#000000",
      lineWidth: 0.75,
      fontSize: 8,
      cellPadding: 1.5
    },
    margin: { top: 10, left: 10, right: 10 },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'right' }
    }
  });

  // ================= GRAND TOTAL =================
  startY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text(
    `Grand Total: $${totalWithAdjustments.toFixed(2)}`,
    10,
    startY
  );

  addFooter();

  doc.save(`Settlement_${pay.settlementNumber}.pdf`);
};


  return (
    <div className={styles.DriverPayManagerSection}>

      {/* HEADER */}
      <div className={styles.DriverPayManagerHeader}>
        <h2 className={styles.DriverPayManagerTitle}>
          Driver Pay Manager
        </h2>
        <span className={styles.DriverPayManagerCount}>
          {filteredPays.length} Settlements
        </span>
      </div>

      {/* FILTER BAR */}
      <div className={styles.DriverPayManagerFilterBar}>
        <input
          className={styles.DriverPayManagerSearchInput}
          placeholder="Search Settlement Number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
<select
  className={styles.DriverPayManagerSelect}
  value={selectedDriverId}
  onChange={(e) => setSelectedDriverId(e.target.value)}
>
  <option value="">All Drivers</option>
  {drivers.map(d => (
    <option key={d._id} value={d._id}>
      {d.firstName} {d.lastName}
    </option>
  ))}
</select>

        <input
          className={styles.DriverPayManagerDateInput}
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <input
          className={styles.DriverPayManagerDateInput}
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <button
          className={styles.DriverPayManagerExportButton}
          disabled={!selectedPays.length}
        >
          Export Selected
        </button>
      </div>

      {/* TABLE */}
      <div className={styles.DriverPayManagerTableWrapper}>
        <table className={styles.DriverPayManagerTable}>
          <thead>
            <tr>
              <th></th>
              <th>Settlement</th>
              <th>Driver</th>
              <th>Truck</th>
              <th>Start</th>
              <th>End</th>
              <th>Loads</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {filteredPays.map(pay => (
              <tr
                key={pay._id}
                className={styles.DriverPayManagerRow}
                onClick={() => setSelectedPay(pay)}
              >
                <td
                  className={styles.DriverPayManagerCheckboxCell}
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="checkbox"
                    checked={selectedPays.includes(pay._id)}
                    onChange={() => toggleSelect(pay._id)}
                  />
                </td>

                <td className={styles.DriverPayManagerSettlement}>
                  {pay.settlementNumber}
                </td>

                <td>
                  {pay.driverId
                    ? `${pay.driverId.firstName} ${pay.driverId.lastName}`
                    : ""}
                </td>

                <td>
  {pay.driverId?.truckNumber
    ? pay.driverId.truckNumber
    : pay.truckId?.truckNumber || ""}
</td>


                <td>{new Date(pay.startDate).toLocaleDateString()}</td>
                <td>{new Date(pay.endDate).toLocaleDateString()}</td>

                <td>
                  {Array.isArray(pay.payDetails)
                    ? pay.payDetails.length
                    : 0}
                </td>

                <td className={styles.DriverPayManagerTotal}>
                  ${Number(pay.totalWithAdjustments || 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedPay && (
        <div className={styles.DriverPayManagerModalOverlay}>
          <div className={styles.DriverPayManagerModal}>

            <div className={styles.DriverPayManagerModalHeader}>
              <h3>
                Settlement #{selectedPay.settlementNumber}
              </h3>
              <button
                className={styles.DriverPayManagerCloseButton}
                onClick={() => setSelectedPay(null)}
              >
                ✕
              </button>
            </div>

            <div className={styles.DriverPayManagerModalContent}>

              <div className={styles.DriverPayManagerModalInfo}>
                <button
  className={styles.DriverPayManagerDownloadButton}
  onClick={() => generateExistingPDF(selectedPay)}
>
  Download PDF
</button>

                <p>
                  <strong>Driver:</strong>{" "}
                  {selectedPay.driverId?.firstName}{" "}
                  {selectedPay.driverId?.lastName}
                </p>

               <p>
  <strong>Truck:</strong>{" "}
  {selectedPay.driverId?.truckNumber
    ? selectedPay.driverId.truckNumber
    : selectedPay.truckId?.truckNumber || "-"}
</p>

                <p>
                  <strong>Period:</strong>{" "}
                  {new Date(selectedPay.startDate).toLocaleDateString()}
                  {" - "}
                  {new Date(selectedPay.endDate).toLocaleDateString()}
                </p>

                <p className={styles.DriverPayManagerModalTotal}>
                  <strong>Total:</strong>{" "}
                  ${Number(selectedPay.totalWithAdjustments).toFixed(2)}
                </p>
              </div>

         <h4 className={styles.DriverPayManagerLoadsTitle}>
  Loads
</h4>

{Array.isArray(selectedPay.payDetails) &&
  selectedPay.payDetails.map((l, i) => {

    const pickupList = Array.isArray(l.shippers) ? l.shippers : [];
    const deliveryList = Array.isArray(l.consignees) ? l.consignees : [];

    return (
      <div
        key={i}
        className={styles.DriverPayManagerLoadCard}
      >
        <div className={styles.DriverPayManagerLoadHeader}>
          <strong>Load #:</strong> {l.loadNumber}
        </div>

        <div className={styles.DriverPayManagerLoadGrid}>

          {/* PICKUP */}
          <div>
            <strong>Pickup:</strong>
            {pickupList.length > 0 ? (
              pickupList.map((p, idx) => (
                <div key={idx} className={styles.DriverPayManagerAddressBlock}>
                  <div>{p.address || "-"}</div>
                  <div className={styles.DriverPayManagerDate}>
                    {p.pickUpTime
                      ? new Date(p.pickUpTime).toLocaleString()
                      : "-"}
                  </div>
                </div>
              ))
            ) : (
              <div>-</div>
            )}
          </div>

          {/* DELIVERY */}
          <div>
            <strong>Delivery:</strong>
            {deliveryList.length > 0 ? (
              deliveryList.map((d, idx) => (
                <div key={idx} className={styles.DriverPayManagerAddressBlock}>
                  <div>{d.address || "-"}</div>
                  <div className={styles.DriverPayManagerDate}>
                    {d.deliveryTime
                      ? new Date(d.deliveryTime).toLocaleString()
                      : "-"}
                  </div>
                </div>
              ))
            ) : (
              <div>-</div>
            )}
          </div>

        </div>

        <div className={styles.DriverPayManagerLoadFooter}>
          <span><strong>Rate:</strong> ${l.rate}</span>
          <span><strong>Miles:</strong> {l.miles}</span>
          <span><strong>DH:</strong> {l.dh}</span>
          <span><strong>Pay:</strong> ${l.pay}</span>
        </div>

      </div>
    );
  })}

            </div>

          </div>
        </div>
      )}
    </div>
  );
};



const DriverPay = ({ drivers, trucks, loads, onAddDriverPay }) => {
  const payrollDrivers = Array.isArray(drivers)
  ? drivers.filter(
      d =>
        d.driverType === 'employee' ||
        d.driverType === 'owner_operator'
    )
  : [];

  const { notify } = useNotification();
  
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [recurringDeductions, setRecurringDeductions] = useState([]);
  const [recurringAdditions, setRecurringAdditions] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
const [selectedDriver, setSelectedDriver] = useState(null);
const [settlementNumber, setSettlementNumber] = useState("");
const [autoGenerateSettlement, setAutoGenerateSettlement] = useState(true);
// PDF Display Settings
const [showSettlementNumber, setShowSettlementNumber] = useState(true);
const [showDriverNumber, setShowDriverNumber] = useState(true);
const [showTruckNumber, setShowTruckNumber] = useState(true);
const [showPhone, setShowPhone] = useState(true);
const [showEmail, setShowEmail] = useState(true);

const [settlementSubtitle, setSettlementSubtitle] = useState('');
const [extraHeaderLine, setExtraHeaderLine] = useState('');
const [pdfSettingsOpen, setPdfSettingsOpen] = useState(false);
const [pdfSettingsModalOpen, setPdfSettingsModalOpen] = useState(false);
const [paymentDate, setPaymentDate] = useState(
  new Date().toISOString().split("T")[0]
);


const [truckCosts, setTruckCosts] = useState([]);
const itemStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "6px",
  padding: "6px 8px",
  border: "1px solid #333",
  borderRadius: "6px",
  fontSize: "12px",
};

const truckCostDeductions = truckCosts.filter(
  cost => cost.type === "deduction"
);

const truckCostAdditions = truckCosts.filter(
  cost => cost.type === "addition"
);

const [ownerFuelDeductions, setOwnerFuelDeductions] = useState([]);
const isLocked = (item) =>
  item.source === "truck-cost" || item.source === "fuel";

const employerDrivers = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'employee')
  : [];

const ownerOperators = Array.isArray(drivers)
  ? drivers.filter(d => d.driverType === 'owner_operator')
  : [];


  const [clientInfo, setClientInfo] = useState({
    companyName: '',
    companyAddress: '',
    email: '',
    phone: '',
  });

  const [logo, setLogo] = useState(null);
  const [customFooterText, setCustomFooterText] = useState('');
  const [useCustomFooter, setUseCustomFooter] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
const [theme, setTheme] = useState("dark");
const getNextMonday = (date = new Date()) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = (8 - day) % 7 || 7; // luni următoare
  d.setDate(d.getDate() + diff);
  return d;
};

useEffect(() => {
  const fetchOwnerAssetCosts = async () => {
    if (
      !selectedDriver ||
      selectedDriver.driverType !== "owner_operator"
    ) {
      setTruckCosts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/asset-costs/by-owner-driver/${selectedDriver._id}`,
        config
      );

      console.log("🧾 OWNER ASSET COSTS:", res.data);
      setTruckCosts(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch owner asset costs", err);
      setTruckCosts([]);
    }
  };

  fetchOwnerAssetCosts();
}, [selectedDriver]);



const formatAssetCostProgress = (cost) => {
  if (cost.paymentType !== "recurring") return "";

  const total = cost.recurrence?.occurrences;

  // forever
  if (!total) return "";

  const paid = Array.isArray(cost.payments)
    ? cost.payments.filter(p => p.status === "paid").length
    : 0;

  const current = paid + 1;
  const totalAmount = Number(cost.amount || 0) * total;

  return ` ${current}/${total} from $${totalAmount.toFixed(2)}`;
};


  // Configurația pentru autentificare
  const token = sessionStorage.getItem('token');
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

useEffect(() => {
  const fetchOwnerFuel = async () => {
    console.log("🔥 FETCH OWNER FUEL – EFFECT TRIGGERED", {
      selectedDriver,
      driverType: selectedDriver?.driverType,
      isOwnerOperator: selectedDriver?.isOwnerOperator,
      startDate,
      endDate,
    });

    // GUARD
    if (
      !selectedDriver ||
      !startDate ||
      !endDate ||
      (selectedDriver.driverType !== "owner_operator" &&
        !selectedDriver.isOwnerOperator)
    ) {
      console.log("⛔ GUARD BLOCKED – CONDITIONS NOT MET");
      setOwnerFuelDeductions([]);
      return;
    }

    console.log("✅ PASSED GUARD – FETCHING FUEL");

    try {
      console.log("➡️ SENDING FUEL REQUEST WITH PARAMS:", {
        driverId: selectedDriver._id,
        startDate,
        endDate,
      });

      const res = await axios.get(
        "https://api-backend.full-trucking-service.com/api/fuel-reports/owner/open-by-driver",
        {
          params: {
            driverId: selectedDriver._id,
            startDate,
            endDate,
          },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      console.log("🟢 FUEL RESPONSE FROM BACKEND:", res.data);
      console.log("🟢 FUEL RESPONSE LENGTH:", res.data?.length);

      const fuelRows = (res.data || []).map((f) => ({
        type: "Fuel",
        description: `Fuel – ${f.merchant || "Unknown"} – ${new Date(
          f.transactionDate
        ).toLocaleDateString()}`,
        amount: Number(f.totalToPay || 0),
        date: new Date(f.transactionDate).toISOString().split("T")[0],
        source: "fuel",
        fuelReportId: f._id,
      }));

      console.log("🧩 MAPPED FUEL ROWS:", fuelRows);

      setOwnerFuelDeductions(fuelRows);
      console.log("📦 SET ownerFuelDeductions:", fuelRows.length);
    } catch (err) {
      console.error("❌ FAILED TO FETCH OWNER FUEL", err);
      setOwnerFuelDeductions([]);
    }
  };

  fetchOwnerFuel();
}, [selectedDriver, startDate, endDate]);


useEffect(() => {
  if (autoGenerateSettlement) {
    const generated = `ST-${Date.now()}`;
    setSettlementNumber(generated);
  }
}, [autoGenerateSettlement]);


const markAssetCostsAsPaid = async () => {
  const assetCostIds = [
    ...recurringDeductions,
    ...recurringAdditions,
  ]
    .filter(i => i.source === "truck-cost" && i.assetCostId)
    .map(i => i.assetCostId);

  if (assetCostIds.length === 0) return;

  await axios.put(
    "https://api-backend.full-trucking-service.com/api/asset-costs/mark-paid",
    { assetCostIds },
    config
  );
};


const markFuelAsPaid = async () => {
  const fuelIds = recurringDeductions
    .filter(d => d.source === "fuel" && d.fuelReportId)
    .map(d => d.fuelReportId);

  if (fuelIds.length === 0) return;

  try {
    await axios.put(
      "https://api-backend.full-trucking-service.com/api/fuel-reports/mark-paid",
      { fuelIds },
      config
    );

    console.log("✅ Fuel marked as PAID:", fuelIds);
  } catch (err) {
    console.error("❌ Failed to mark fuel as paid", err);
  }
};

  const saveTotalPay = async () => {
    if (!selectedDriver || !startDate || !endDate) {
  
      return;
    }
  
    const { totalPayWithAdjustments } = calculatePay();
  
    try {
      const response = await axios.post(
        'https://api-backend.full-trucking-service.com/api/totalpays',
        {
          driverId: selectedDriver._id,
          startDate,
          endDate,
          totalWithAdjustments: totalPayWithAdjustments
        },
        config
      );
  
      if (response.status === 201) {
       
      } else {
     
      }
    } catch (error) {

    }
  };
  
  useEffect(() => {
    const fetchClientInfo = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/settings', config);
        const { companyName, companyAddress, email, phone } = response.data;
        setClientInfo({ companyName, companyAddress, email, phone });
        if (customFooterText) setCustomFooterText(customFooterText);
        if (useCustomFooter !== undefined) setUseCustomFooter(useCustomFooter);
      } catch (error) {
    
      }
    };

    const fetchLogo = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/logo', config);
        setLogo(response.data.logo);
      } catch (error) {
       
      }
    };

    fetchClientInfo();
    fetchLogo();
  }, []);
  
  useEffect(() => {
    const fetchFooterText = async () => {
      try {
        const response = await axios.get('https://api-backend.full-trucking-service.com/api/footer', config);
        if (response.status === 200) {
          const { customFooterText, useCustomFooter } = response.data;
          setCustomFooterText(customFooterText || '');
          setUseCustomFooter(useCustomFooter || false);
        }
      } catch (error) {
 
      }
    };

    fetchFooterText();
  }, []);

  // Save Footer
  const handleSaveFooterText = async () => {
    try {
      const response = await axios.put(
        'https://api-backend.full-trucking-service.com/api/footer',
        { customFooterText, useCustomFooter },
        config
      );
      if (response.status === 200) {
        notify('Footer text saved successfully!' ,'success');
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
   
      notify('Failed to save footer text.' , 'error');
    }
  };


  const handleDeleteFooterText = () => {
    setDeleteTarget('footer');
  };
  
  const confirmDeleteFooterText = async () => {
    try {
      await axios.delete('https://api-backend.full-trucking-service.com/api/footer', config);
      setCustomFooterText('');
      setUseCustomFooter(false);
      notify('Footer text deleted successfully!' , 'success');
    } catch (error) {
   
      notify('Failed to delete footer text.' , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
const handleLogoChange = async (e) => {
  const file = e.target.files[0];
  if (file && file.size > 5000000) { // 5MB limit
    notify("File is too large! Please select a file smaller than 5MB." , 'error');
    return;
  }
  if (file && !file.type.startsWith("image/")) {
   notify("Invalid file type! Please select an image." , 'error');
    return;
  }

  const reader = new FileReader();
  reader.onload = async (event) => {
    const imageData = event.target.result;
    try {
      await axios.put(
        'https://api-backend.full-trucking-service.com/api/logo',
        { logo: imageData },
        config
      );
      setLogo(imageData);
    } catch (error) {
  
    }
  };
  reader.readAsDataURL(file);
};

const handleLogoDelete = () => {
  setDeleteTarget('logo');
};

const confirmDeleteLogo = async () => {
  try {
    await axios.delete('https://api-backend.full-trucking-service.com/api/logo', config);
    setLogo(null);
  } catch (error) {

   notify("Failed to delete logo." , 'error');
  }
  setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
};



const handleDriverSelect = (e) => {
  const driver = drivers.find((driver) => driver._id === e.target.value);
  setSelectedDriver(driver);
  setSelectedTruck(null);
  setFilteredLoads([]);
  setSelectedLoads([]);
  setRecurringAdditions([]);
  setRecurringDeductions([]);
};


const handleTruckSelect = (e) => {
  const truck = trucks.find((truck) => truck._id === e.target.value);
  setSelectedTruck(truck);
  setFilteredLoads([]);
  setSelectedLoads([]);
  setRecurringAdditions([]);
  setRecurringDeductions([]);
  setSelectedDriver(null);
};


const handleAddDriverPay = async () => {
  // Verificare date esențiale
  if ((!selectedDriver && !selectedTruck) || !startDate || !endDate) {

    return false;
  }

const normalize = (items) =>
  items.map((item) => ({
    type: item.type || '',
    description: item.description || '',
    amount: parseFloat(item.amount || 0),
    date: item.date || new Date().toISOString().split('T')[0],

    // 🔥 OBLIGATORIU
    source: item.source || undefined,
    fuelReportId: item.fuelReportId || undefined,
    assetCostId: item.assetCostId || undefined,
  }));

  const transformedAdditions = normalize(recurringAdditions);
  const transformedDeductions = normalize(recurringDeductions);

  // Calculăm plățile
 const { payDetails, totalRate, totalPay, totalPayWithAdjustments } = calculatePay();


if (isNaN(totalPayWithAdjustments)) {


  return false;
}

  try {
    // Trimitem cererea de salvare
    const response = await axios.post(
      'https://api-backend.full-trucking-service.com/api/driverpays',
      {
  settlementNumber,
  driver: selectedDriver ? selectedDriver._id : null,
  truck: selectedTruck ? selectedTruck._id : null,

  startDate,
  endDate,

  totalPay,
  totalWithAdjustments: totalPayWithAdjustments,

  payDetails,

  recurringAddition: transformedAdditions,
  recurringDeduction: transformedDeductions,

  // 🔥 PDF SETTINGS
  settlementSubtitle,
  extraHeaderLine,
  showSettlementNumber,
  showDriverNumber,
  showTruckNumber,
  showPhone,
  showEmail,

  companyName: clientInfo.companyName,
  logo,
},
      config
    );

if (response.status === 201) {

  // 🔥 RESET UI
  setRecurringAdditions([]);
  setRecurringDeductions([]);
  setSelectedLoads([]);
  setFilteredLoads([]);

  // 🔥 GENERATE NEW SETTLEMENT NUMBER
  if (autoGenerateSettlement) {
    const newNumber = `ST-${Date.now()}`;
    setSettlementNumber(newNumber);
  }

  return true;
}
 else {

      return false;
    }
  } catch (error) {

    return false;
  }
};


  const handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'startDate') setStartDate(value);
    else setEndDate(value);
  };
const searchLoads = () => {
  if (!selectedDriver || !startDate || !endDate) return;

  const filtered = loads.filter(load => {
    if (load.status !== 'Completed') return false;

    const isAssigned =
      load.driver?.toString() === selectedDriver._id.toString() ||
      load.ownerOperator?.toString() === selectedDriver._id.toString() ||
      (Array.isArray(load.teamDrivers) &&
        load.teamDrivers.some(id =>
          id.toString() === selectedDriver._id.toString()
        ));

    if (!isAssigned) return false;

    const hasPickup = load.shippers.some(
      s => s.pickUpTime && new Date(s.pickUpTime) >= new Date(startDate)
    );

    const hasDelivery = load.consignees.some(
      c => c.deliveryTime && new Date(c.deliveryTime) <= new Date(endDate)
    );

    return hasPickup && hasDelivery;
  });

  setFilteredLoads(filtered);
};

  
  

  const handleLoadSelection = (loadNumber) => {
    setSelectedLoads((prevSelected) =>
      prevSelected.includes(loadNumber)
        ? prevSelected.filter((num) => num !== loadNumber)
        : [...prevSelected, loadNumber]
    );
  };
const toNumber = (val) => {
  const num = parseFloat(val);
  return isNaN(num) ? 0 : num;
};

const calculatePay = () => {
  const payDetails = filteredLoads
    .filter(load => selectedLoads.includes(load.loadNumber))
    .map((load) => {
      let pay = 0;

      if (selectedDriver) {
        switch (selectedDriver.settlement) {
          case 'Hourly pay':
            pay = toNumber(selectedDriver.hoursWorked) * toNumber(selectedDriver.settlementAmount);
            break;
          case 'Per mile pay':
            pay = toNumber(load.miles) * toNumber(selectedDriver.normalMileRate) + toNumber(load.dh) * toNumber(selectedDriver.dhMileRate);
            break;
          case 'Fixed salary':
            pay = toNumber(selectedDriver.settlementAmount);
            break;
          case 'Percentage of the load':
            pay = toNumber(load.rate) * toNumber(selectedDriver.settlementAmount) / 100;
            break;
          case 'Team driver pay':
            pay = toNumber(load.rate) / 2;
            break;
        }
      }

      if (selectedTruck) {
        switch (selectedTruck.settlement) {
          case 'Hourly pay':
            pay = toNumber(selectedTruck.hoursWorked) * toNumber(selectedTruck.settlementAmount);
            break;
          case 'Per mile pay':
            pay = toNumber(load.miles) * toNumber(selectedTruck.normalMileRate) + toNumber(load.dh) * toNumber(selectedTruck.dhMileRate);
            break;
          case 'Fixed salary':
            pay = toNumber(selectedTruck.settlementAmount);
            break;
          case 'Percentage of the load':
            pay = toNumber(load.rate) * toNumber(selectedTruck.settlementAmount) / 100;
            break;
          case 'Team driver pay':
            pay = toNumber(load.rate) / 2;
            break;
        }
      }

      return {
        loadNumber: load.loadNumber || '',
        rate: toNumber(load.rate),
        dh: toNumber(load.dh),
        miles: toNumber(load.miles),
        pay,
        payDescription: '',
        shippers: load.shippers || [],
        consignees: load.consignees || []
      };
    });

  const totalRate = payDetails.reduce((sum, d) => sum + toNumber(d.rate), 0);
  const totalPay = payDetails.reduce((sum, d) => sum + toNumber(d.pay), 0);
  const totalAdditions = recurringAdditions.reduce((sum, a) => sum + toNumber(a.amount), 0);
  const totalDeductions = recurringDeductions.reduce((sum, d) => sum + toNumber(d.amount), 0);

  let totalPayWithAdjustments = totalPay + totalAdditions - totalDeductions;

  return {
    payDetails,
    totalRate,
    totalPay,
    totalPayWithAdjustments: Number.isFinite(totalPayWithAdjustments) ? totalPayWithAdjustments : 0
  };
};

const formatRecurringDescription = (item) => {
  // baza
  let desc = item.description || "";

  // dacă NU e recurring → nimic extra
  if (item.paymentType !== "recurring") {
    return desc;
  }

  // dacă e recurring FOREVER → nimic extra
  if (!item.totalPayments || item.totalPayments <= 0) {
    return desc;
  }

  // recurring limitat → X / total
  const current = (item.paidPayments || 0) + 1;

  return `${desc} ${current}/${item.totalPayments}`;
};

const formatLimitedRecurringInfo = (item) => {
  if (
    item.paymentType !== "recurring" ||
    !item.totalPayments ||
    item.totalPayments <= 0
  ) {
    return "";
  }

  const paid = Number(item.paidPayments || 0) + 1;
  const total = Number(item.totalPayments);
  const totalAmount = Number(item.totalAmount || 0);

  return ` ${paid}/${total} from $${totalAmount.toFixed(2)}`;
};


  const generatePDF = async () => { 
    const { payDetails, totalRate, totalPayWithAdjustments, totalPay } = calculatePay();
    const doc = new jsPDF();

 const addHeader = () => {

  const today = new Date().toISOString().split("T")[0];
  setPaymentDate(today);

  if (logo && typeof logo === "string") {
    doc.addImage(logo, "PNG", 10, 10, 55, 25);
  }

  doc.setFontSize(16);
  doc.text("DRIVER SETTLEMENT", 105, 20, { align: "center" });

  if (settlementSubtitle) {
    doc.setFontSize(10);
    doc.text(settlementSubtitle, 105, 26, { align: "center" });
  }

  doc.setFontSize(10);

  let y = 45;

  // 🔒 OBLIGATORIU
  doc.text(
    `Driver Name: ${selectedDriver?.firstName || ""} ${selectedDriver?.lastName || ""}`,
    10,
    y
  );
  y += 6;

  doc.text(
    `Driver Address: ${selectedDriver?.address || "N/A"}`,
    10,
    y
  );
  y += 6;

  doc.text(`Start Date: ${startDate}`, 10, y);
  y += 6;

  doc.text(`End Date: ${endDate}`, 10, y);
  y += 6;

  doc.text(`Payment Date: ${today}`, 10, y);
  y += 8;

  // 🔘 OPTIONAL FIELDS

  if (showSettlementNumber) {
    doc.text(`Settlement #: ${settlementNumber}`, 140, 45);
  }

  let rightY = 55;

  if (showDriverNumber) {
    doc.text(
      `Driver #: ${selectedDriver?.driverNumber || "N/A"}`,
      140,
      rightY
    );
    rightY += 6;
  }

  if (showTruckNumber) {
    doc.text(
      `Truck: ${selectedDriver?.truckNumber || "N/A"}`,
      140,
      rightY
    );
    rightY += 6;
  }

  if (showPhone) {
    doc.text(
      `Phone: ${selectedDriver?.phone || ""}`,
      140,
      rightY
    );
    rightY += 6;
  }

  if (showEmail) {
    doc.text(
      `Email: ${selectedDriver?.email || ""}`,
      140,
      rightY
    );
    rightY += 6;
  }

  if (extraHeaderLine) {
    doc.text(extraHeaderLine, 10, y + 4);
  }
};


  
    const addFooter = () => {
      const pageHeight = doc.internal.pageSize.height;
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);

      // ✅ Dacă nu este loc, mută pe pagina următoare
      if (doc.lastAutoTable.finalY + 30 > pageHeight) {
          doc.addPage();
          addHeader();
      }

      doc.text(`Page ${pageCount}`, 10, pageHeight - 10);

      if (useCustomFooter && customFooterText) {
          doc.text(customFooterText, 105, pageHeight - 20, { align: 'center' });
      } else {
          doc.text('Thank you for your business!', 105, pageHeight - 20, { align: 'center' });
          doc.text(`${clientInfo.companyName}`, 105, pageHeight - 15, { align: 'center' });
          doc.text(`${clientInfo.companyAddress}`, 105, pageHeight - 10, { align: 'center' });
      }
  };
  
    // Adaugă antetul pe prima pagină
    addHeader();
  
    let startY = 100;

  
    // Iterează prin detalii și adaugă conținut
    payDetails.forEach((detail, index) => {
     
      // Verifică dacă este necesară o pagină nouă
      if (startY > doc.internal.pageSize.height - 40) {
        doc.addPage();
        addHeader(); // Antet pe pagina nouă
        addFooter(); // Footer pe pagina nouă
        startY = 30;
      }
  
      doc.setFontSize(8);
  
      const pickupDetails = detail.shippers.length > 0
      ? detail.shippers.map((shipper) => {
          if (!shipper.pickUpTime || isNaN(new Date(shipper.pickUpTime).getTime())) {
            return `Unknown Date - ${shipper.address || 'No data'}`;
          }
          return `${new Date(shipper.pickUpTime).toLocaleString()} - ${shipper.address || 'No data'}`;
        }).join('\n')
      : 'No data';
    
    const deliveryDetails = detail.consignees.length > 0
      ? detail.consignees.map((consignee) => {
          if (!consignee.deliveryTime || isNaN(new Date(consignee.deliveryTime).getTime())) {
            return `Unknown Date - ${consignee.address || 'No data'}`;
          }
          return `${new Date(consignee.deliveryTime).toLocaleString()} - ${consignee.address || 'No data'}`;
        }).join('\n')
      : 'No data';
  
      doc.autoTable({
        startY: startY,
        body: [
          [
            { content: `Load #`, styles: { fontStyle: 'bold', halign: 'left' } },
            `${index + 1}`,
            '',
          ],
          [
            { content: 'Pickup:', styles: { fontStyle: 'bold', halign: 'left' } },
            { content: pickupDetails || 'No data', colSpan: 2 },
          ],
          [
            { content: 'Delivery:', styles: { fontStyle: 'bold', halign: 'left' } },
            { content: deliveryDetails || 'No data', colSpan: 2 },
          ],
          [
            { content: 'Rate', styles: { fontStyle: 'bold', halign: 'left' } },
            getRateDetail(detail),
            '',
          ],
          [
            'Notes',
            detail.notes || 'No notes available',
            {
              content: `Total Pay: $${detail.pay.toFixed(2)}`,
              styles: { fontStyle: 'bold', halign: 'right' },
            },
          ],
        ],
        theme: 'grid',
        styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
        margin: { top: 10, left: 10, right: 10 },
        columnStyles: { 0: { halign: 'left' }, 1: { halign: 'left' }, 2: { halign: 'right' } },
      });
  
      startY = doc.lastAutoTable.finalY + 10;
    });
  
    // Adaugă totaluri și salariul fix
    if (selectedDriver && selectedDriver.settlement === 'Fixed salary') {
      startY += 20;
      doc.text(`Fixed Salary: $${totalPay.toFixed(2)}`, 10, startY);
    }
  
    // Sub-Total
    doc.setFontSize(10);
    doc.text('Sub-Total', 10, startY);
    startY += 10;
  
    doc.autoTable({
      startY: startY,
      body: [['Sub-Total', `$${totalPay.toFixed(2)}`]],
      theme: 'grid',
      styles: { textColor: "#000000", lineWidth: 0.75, fontSize: 8, cellPadding: 1.5 },
      margin: { top: 10, left: 10, right: 10 },
      columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
    });
  
 // Recurring Additions
startY = doc.lastAutoTable.finalY + 10;
doc.setFontSize(10);
doc.text('Recurring Additions', 10, startY);
startY += 10;

doc.autoTable({
  startY: startY,
  head: [['Service', 'Amount']],
  body: recurringAdditions.map((add) => [
    {
      content: `${add.type} – ${add.description} – ${add.date}`,
      styles: {
        fontStyle: 'normal',
        textColor: [15, 23, 42],
        fontSize: 8
      }
    },
    {
      content: `$${parseFloat(add.amount || 0).toFixed(2)}`,
      styles: {
        fontSize: 8,
        halign: 'right'
      }
    }
  ]),
  theme: 'grid',
  styles: {
    textColor: "#000000",
    lineWidth: 0.75,
    fontSize: 8,
    cellPadding: 1.5
  },
  margin: { top: 10, left: 10, right: 10 },
  columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
});


  
    // Recurring Deductions
startY = doc.lastAutoTable.finalY + 10;
doc.setFontSize(10);
doc.text('Recurring Deductions', 10, startY);
startY += 10;

doc.autoTable({
  startY: startY,
  head: [['Service', 'Amount']],
  body: recurringDeductions.map((ded) => [
    {
      content: `${ded.type} – ${ded.description} – ${ded.date}`,
      styles: {
        fontStyle: 'normal',
        textColor: [255, 0, 0], // roșu
        fontSize: 8
      }
    },
    {
      content: `-$${parseFloat(ded.amount || 0).toFixed(2)}`,
      styles: {
        fontSize: 8,
        halign: 'right'
      }
    }
  ]),
  theme: 'grid',
  styles: {
    textColor: "#000000",
    lineWidth: 0.75,
    fontSize: 8,
    cellPadding: 1.5
  },
  margin: { top: 10, left: 10, right: 10 },
  columnStyles: { 0: { halign: 'left' }, 1: { halign: 'right' } },
});

    // Grand Total
    startY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.text(`Grand Total: $${totalPayWithAdjustments.toFixed(2)}`, 10, startY);
  
    // Adaugă footer-ul final
    addFooter();
 
  await saveTotalPay(); 
      // Salvare PDF local
      doc.save('driver_payroll.pdf');

    };

        const getRateDetail = (detail) => {
  if (selectedTruck && selectedTruck.settlement) {
    switch (selectedTruck.settlement) {
      case 'Hourly pay':
        return `Truck: ${selectedTruck.hoursWorked || 0} hours * $${selectedTruck.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Truck: Miles ${detail.miles} * $${selectedTruck.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedTruck.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Truck) - $${selectedTruck.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Truck: ${selectedTruck.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Truck Team Driver: Load Rate $${detail.rate || 0} / 2 (Each driver receives half)`;
      default:
        return `Truck rate for load: $${detail.rate || 0}`;
    }
  }
  
  if (selectedDriver && selectedDriver.settlement) {
    switch (selectedDriver.settlement) {
      case 'Hourly pay':
        return `Driver: ${selectedDriver.hoursWorked || 0} hours * $${selectedDriver.settlementAmount || 0} per hour`;
      case 'Per mile pay':
        return `Driver: Miles ${detail.miles} * $${selectedDriver.normalMileRate || 0} + DH Miles ${detail.dh} * $${selectedDriver.dhMileRate || 0}`;
      case 'Fixed salary':
        return `Fixed Salary (Driver) - $${selectedDriver.settlementAmount || 0}`;
      case 'Percentage of the load':
        return `Driver: ${selectedDriver.settlementAmount}% of $${detail.rate || 0}`;
      case 'Team driver pay':
        return `Driver Team: Load Rate $${detail.rate || 0} / 2`;
      default:
        return `Driver rate for load: $${detail.rate || 0}`;
    }
  }
  
  return `Rate: $${detail.rate || 0}`;
};


  const removeRecurring = (type, index) => {
    if (type === 'deduction') {
      setRecurringDeductions(recurringDeductions.filter((_, i) => i !== index));
    } else {
      setRecurringAdditions(recurringAdditions.filter((_, i) => i !== index));
    }
  };

  const addDeduction = () => {
  setRecurringDeductions([
    ...recurringDeductions,
    { type: '', description: '', amount: 0, date: new Date().toISOString().slice(0, 10) }
  ]);
};

const addAddition = () => {
  setRecurringAdditions([
    ...recurringAdditions,
    { type: '', description: '', amount: 0, date: new Date().toISOString().slice(0, 10) }
  ]);
};



  return (
    <div
  className={`${styles.ultimatedriverPaySection} ${
    theme === "light" ? styles.ultimatedriverPaySectionLight : ""
  }`}
>

      <h2 className={styles.titledriverPayultimatedriverPay}>Driver Pay</h2>
{/* EMPLOYER DRIVERS */}
<div className={styles.formGroupultimatedriverPay}>
  <label>Driver / Employer</label>
  <select
    value={
      selectedDriver?.driverType === 'employee'
        ? selectedDriver._id
        : ''
    }
    onChange={(e) => {
      const driver = employerDrivers.find(d => d._id === e.target.value);
      setSelectedDriver(driver || null);

      setFilteredLoads([]);
      setSelectedLoads([]);
      setRecurringAdditions([]);
setRecurringDeductions([]);

    }}
    className={styles.selectFieldultimatedriverPay}
  >
    <option value="">Select Employer Driver</option>
    {employerDrivers.map(d => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>
</div>

{/* OWNER OPERATORS */}
<div className={styles.formGroupultimatedriverPay}>
  <label>Owner Operator</label>
  <select
    value={
      selectedDriver?.driverType === 'owner_operator'
        ? selectedDriver._id
        : ''
    }
    onChange={(e) => {
      const driver = ownerOperators.find(d => d._id === e.target.value);
      setSelectedDriver(driver || null);

      setFilteredLoads([]);
      setSelectedLoads([]);
     setRecurringAdditions([]);
setRecurringDeductions([]);


    }}
    className={styles.selectFieldultimatedriverPay}
  >
    <option value="">Select Owner Operator</option>
    {ownerOperators.map(d => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>
</div>



{deleteTarget !== null && (
  <DeleteNotifications
    message={
      deleteTarget === 'logo'
        ? "Are you sure you want to remove the company logo?"
        : "Are you sure you want to delete the footer text?"
    }
    onConfirm={deleteTarget === 'logo' ? confirmDeleteLogo : confirmDeleteFooterText}
    onCancel={() => setDeleteTarget(null)}
  />
)}


      {(selectedDriver || selectedTruck) && (
        <div className={styles.driverDetailsultimatedriverPay}>
          <h3 className={styles.subtitleultimatedriverPay}>
           {selectedDriver && `Driver: ${selectedDriver.firstName} ${selectedDriver.lastName}`}
{selectedOwner && `Owner Operator: ${selectedOwner.firstName} ${selectedOwner.lastName}`}

          </h3>

<button
  onClick={() => setPdfSettingsModalOpen(true)}
  className={styles.openPdfSettingsButton}
>
  Configure PDF Settlement
</button>

    {pdfSettingsModalOpen && (
  <div className={styles.pdfModalOverlay}>
    <div className={styles.pdfModalContainer}>

      {/* HEADER */}
      <div className={styles.pdfModalHeader}>
        <h3>Settlement PDF Settings</h3>
        <button
          onClick={() => setPdfSettingsModalOpen(false)}
          className={styles.pdfModalClose}
        >
          ✕
        </button>
      </div>

      <div className={styles.pdfModalContent}>

        {/* LOGO */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Company Logo</label>
          <input type="file" onChange={handleLogoChange} />
          {logo && (
            <div className={styles.logoPreview}>
              <img src={logo} alt="Company Logo" />
              <button onClick={handleLogoDelete}>Remove</button>
            </div>
          )}
        </div>

        {/* SETTLEMENT NUMBER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Settlement Number</label>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="text"
              value={settlementNumber}
              disabled={autoGenerateSettlement}
              onChange={(e) => setSettlementNumber(e.target.value)}
              className={styles.inputFieldultimatedriverPay}
            />
            <label>
              <input
                type="checkbox"
                checked={autoGenerateSettlement}
                onChange={(e) => setAutoGenerateSettlement(e.target.checked)}
              />
              Auto
            </label>
          </div>
        </div>

        {/* SUBTITLE */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Subtitle</label>
          <input
            type="text"
            value={settlementSubtitle}
            onChange={(e) => setSettlementSubtitle(e.target.value)}
            className={styles.inputFieldultimatedriverPay}
          />
        </div>

        {/* EXTRA HEADER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Extra Header Line</label>
          <input
            type="text"
            value={extraHeaderLine}
            onChange={(e) => setExtraHeaderLine(e.target.value)}
            className={styles.inputFieldultimatedriverPay}
          />
        </div>

        {/* TOGGLES */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Display On PDF</label>
          <div className={styles.pdfToggleGrid}>
            <label><input type="checkbox" checked={showSettlementNumber} onChange={(e)=>setShowSettlementNumber(e.target.checked)} /> Settlement #</label>
            <label><input type="checkbox" checked={showDriverNumber} onChange={(e)=>setShowDriverNumber(e.target.checked)} /> Driver</label>
            <label><input type="checkbox" checked={showTruckNumber} onChange={(e)=>setShowTruckNumber(e.target.checked)} /> Truck</label>
            <label><input type="checkbox" checked={showPhone} onChange={(e)=>setShowPhone(e.target.checked)} /> Phone</label>
            <label><input type="checkbox" checked={showEmail} onChange={(e)=>setShowEmail(e.target.checked)} /> Email</label>
          </div>
        </div>

        {/* FOOTER */}
        <div className={styles.formGroupultimatedriverPay}>
          <label>Custom Footer</label>
          <textarea
            value={customFooterText}
            onChange={(e) => setCustomFooterText(e.target.value)}
          />
          <label>
            <input
              type="checkbox"
              checked={useCustomFooter}
              onChange={(e) => setUseCustomFooter(e.target.checked)}
            />
            Use Custom Footer
          </label>
        </div>

      </div>
    </div>
  </div>
)}




   
          <div className={styles.formRowultimatedriverPay}>
            <div className={styles.formGroupultimatedriverPay}>
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={startDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
            <div className={styles.formGroupultimatedriverPay}>
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                value={endDate}
                onChange={handleDateChange}
                className={styles.inputFieldultimatedriverPay}
              />
            </div>
          </div>
          <button onClick={searchLoads} className={styles.actionButtonultimatedriverPay}>
            Search
          </button>


          {(filteredLoads.length > 0 || recurringDeductions.length > 0) && (
  <div className={styles.recurringSectionultimatedriverPay}>

              <h3 className={styles.subtitleultimatedriverPay}>Load Details</h3>
              <ul className={styles.loadListultimatedriverPay}>
              {filteredLoads.map((load, index) => (
  <li key={index} className={styles.loadItemultimatedriverPay}>
    <input
      type="checkbox"
      checked={selectedLoads.includes(load.loadNumber)}
      onChange={() => handleLoadSelection(load.loadNumber)}
    />
    <strong>Load #:</strong> {load.loadNumber || 'No data'} <br />
    <strong>Pick Up:</strong> {
  load.shippers.length > 0 && load.shippers[0].pickUpTime
    ? new Date(load.shippers[0].pickUpTime).toLocaleString()
    : 'No data'
} <br />
<strong>Delivery:</strong> {
  load.consignees.length > 0 && load.consignees[0].deliveryTime
    ? new Date(load.consignees[0].deliveryTime).toLocaleString()
    : 'No data'
} <br />
    <strong>Rate:</strong> ${parseFloat(load.rate || 0).toFixed(2)} <br />
  </li>
))}

              </ul>

             
             <div className={styles.recurringSectionultimatedriverPay}>


  {/* DEDUCTIONS */}
  {truckCosts.length > 0 && (
  <div className={styles.formGroupultimatedriverPay}>
            {/* OWNER FUEL – QUICK DEDUCTIONS */}
{selectedDriver?.driverType === "owner_operator" &&
 ownerFuelDeductions.length > 0 && (
  <div className={styles.formGroupultimatedriverPay}>
    <label>Fuel (Owner – Open)</label>

    {ownerFuelDeductions.map(fuel => (
      <div
        key={fuel.fuelReportId}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "6px",
          padding: "6px 8px",
          border: "1px solid #333",
          borderRadius: "6px",
          fontSize: "12px"
        }}
      >
        <div>
          <strong>Fuel</strong>
          <div style={{ color: "#999" }}>
            {fuel.description}
          </div>
        </div>

        <button
          onClick={() => {
            setRecurringDeductions(prev => {
              if (prev.some(d => d.fuelReportId === fuel.fuelReportId)) {
                return prev;
              }
              return [...prev, fuel];
            });
          }}
          className={styles.addButtonultimatedriverPay}
        >
          Add
        </button>
      </div>
    ))}
  </div>
)}
   <label>Truck Costs (Quick Deductions)</label>

{truckCostDeductions.map(cost => (
  <div key={cost._id} style={itemStyle}>
    <div>
      <strong>{cost.category}</strong>
      {cost.vendor && ` – ${cost.vendor}`}
      <div style={{ color: "#999" }}>
        {cost.description || "No description"}
      </div>
    </div>

    <button
      onClick={() => {
        const item = {
          itemType: cost.category,
          description: `${cost.description || ""}${formatAssetCostProgress(cost)}`,
          amount: Number(cost.amount) || 0,
          date: cost.nextBillingDate
            ? cost.nextBillingDate.split("T")[0]
            : cost.startDate
              ? cost.startDate.split("T")[0]
              : new Date().toISOString().split("T")[0],
          source: "truck-cost",
          assetCostId: cost._id,
        };

        setRecurringDeductions(prev =>
          prev.some(d => d.assetCostId === cost._id)
            ? prev
            : [...prev, item]
        );
      }}
      className={styles.addButtonultimatedriverPay}
    >
      Add
    </button>
  </div>
))}
<label>Truck Costs (Quick Additions)</label>

{truckCostAdditions.map(cost => (
  <div key={cost._id} style={itemStyle}>
    <div>
      <strong>{cost.category}</strong>
      {cost.vendor && ` – ${cost.vendor}`}
      <div style={{ color: "#999" }}>
        {cost.description || "No description"}
      </div>
    </div>

    <button
      onClick={() => {
        const item = {
          type: cost.category,
          description: `${cost.description || ""}${formatAssetCostProgress(cost)}`,
          amount: Number(cost.amount) || 0,
          date: cost.nextBillingDate
            ? cost.nextBillingDate.split("T")[0]
            : cost.startDate
              ? cost.startDate.split("T")[0]
              : new Date().toISOString().split("T")[0],
          source: "truck-cost",
          assetCostId: cost._id,
        };

        setRecurringAdditions(prev =>
          prev.some(a => a.assetCostId === cost._id)
            ? prev
            : [...prev, item]
        );
      }}
      className={styles.addButtonultimatedriverPay}
    >
      Add
    </button>
  </div>
))}

  </div>
)}

  <div className={styles.formGroupultimatedriverPay}>
    <label>Recurring Deductions</label>
{recurringDeductions.map((item, index) => (
  <div key={index} className={styles.recurringItemultimatedriverPay}>
   <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
  {/* TYPE */}
  {isLocked(item) ? (
    <input
      type="text"
      value={item.type}
      disabled
      className={styles.inputFieldultimatedriverPay}
      style={{ flex: 1, opacity: 0.6 }}
    />
  ) : (
    <select
      value={item.type}
      onChange={(e) => {
        const updated = [...recurringDeductions];
        updated[index].type = e.target.value;
        setRecurringDeductions(updated);
      }}
      className={styles.selectFieldultimatedriverPay}
      style={{ flex: 1 }}
    >
      <option value="">Select Type</option>
      <option value="Fuel">Fuel</option>
      <option value="Insurance">Insurance</option>
      <option value="Cash Advance">Cash Advance</option>
      <option value="Maintenance">Maintenance</option>
      <option value="IFTA">IFTA</option>
      <option value="Other">Other</option>
    </select>
  )}

  {/* DESCRIPTION */}
  <input
    type="text"
    value={item.description}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].description = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />
</div>

<div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
  {/* DATE */}
  <input
    type="date"
    value={item.date || new Date().toISOString().split("T")[0]}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].date = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />

  {/* AMOUNT */}
  <input
    type="number"
    value={item.amount}
    disabled={isLocked(item)}
    onChange={(e) => {
      if (isLocked(item)) return;
      const updated = [...recurringDeductions];
      updated[index].amount = e.target.value;
      setRecurringDeductions(updated);
    }}
    className={styles.inputFieldultimatedriverPay}
    style={{ flex: 1, opacity: isLocked(item) ? 0.6 : 1 }}
  />

  {/* REMOVE – DOAR DACĂ NU E FUEL */}
  {item.source !== "fuel" && (
    <button
      onClick={() => removeRecurring("deduction", index)}
      className={styles.removeButtonultimatedriverPay}
    >
      X
    </button>
  )}
</div>

  </div>
))}

    
  </div>

  {/* ADDITIONS */}
  <div className={styles.formGroupultimatedriverPay}>
    <label>Recurring Additions</label>
{recurringAdditions.map((item, index) => (
  <div key={index} className={styles.recurringItemultimatedriverPay}>
    <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
      <select
        value={item.type}
        onChange={(e) => {
          const updated = [...recurringAdditions];
          updated[index].type = e.target.value;
          if (e.target.value !== "Other") updated[index].description = '';
          setRecurringAdditions(updated);
        }}
        className={styles.selectFieldultimatedriverPay}
        style={{ flex: 1 }}
      >
        <option value="">Select Type</option>
        <option value="Bonus">Bonus</option>
        <option value="Referral">Referral</option>
        <option value="Reimbursement">Reimbursement</option>
        <option value="Other">Other</option>
      </select>

      <input
        type="text"
        placeholder="Description"
        value={item.description}
        onChange={(e) => {
          const updated = [...recurringAdditions];
          updated[index].description = e.target.value;
          setRecurringAdditions(updated);
        }}
        className={styles.inputFieldultimatedriverPay}
        style={{ flex: 1 }}
      />
    </div>

    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <input
        type="date"
        value={item.date || new Date().toISOString().split("T")[0]}
        onChange={(e) => {
          const updated = [...recurringAdditions];
          updated[index].date = e.target.value;
          setRecurringAdditions(updated);
        }}
        className={styles.inputFieldultimatedriverPay}
        style={{ flex: 1 }}
      />

      <input
        type="number"
        placeholder="Amount"
        value={item.amount}
        onChange={(e) => {
          const updated = [...recurringAdditions];
          updated[index].amount = e.target.value;
          setRecurringAdditions(updated);
        }}
        className={styles.inputFieldultimatedriverPay}
        style={{ flex: 1 }}
      />

      <button
        onClick={() => removeRecurring("addition", index)}
        className={styles.removeButtonultimatedriverPay}
      >
        X
      </button>
    </div>
  </div>
))}

    
  </div>
</div>

 <button
  onClick={async () => {
    // GUARD 1: driver selectat
    if (!selectedDriver) {
      notify("You must select a driver first.", "error");
      return;
    }

    // GUARD 2: date selectate
    if (!startDate || !endDate) {
      notify("Start date and end date are required.", "error");
      return;
    }

    // GUARD 3: load-uri selectate
    if (!selectedLoads || selectedLoads.length === 0) {
      notify("You must select at least one load to preview the PDF.", "error");
      return;
    }

    try {
      // 📄 DOAR GENERARE + PREVIEW PDF
      await generatePDF();
    } catch (err) {
      console.error("❌ PDF preview failed:", err);
      notify("Failed to generate PDF preview.", "error");
    }
  }}
  className={styles.previewButtonultimatedriverPay}
>
  Preview PDF
</button>

<button
  onClick={async () => {

    if (!selectedDriver) {
      notify("You must select a driver first.", "error");
      return;
    }

    if (!startDate || !endDate) {
      notify("Start date and end date are required.", "error");
      return;
    }

   if (!autoGenerateSettlement && !settlementNumber.trim()) {
  notify("Settlement number is required.", "error");
  return;
}


    const saved = await handleAddDriverPay();
    if (!saved) {
      notify("Saving failed.", "error");
      return;
    }

    await markFuelAsPaid();
    await markAssetCostsAsPaid();

    notify("Settlement saved successfully.", "success");

  }}
  className={styles.saveButtonultimatedriverPay}
>
  Save Settlement
</button>




            </div>
          )}
        </div>
      )}
    </div>
    
  );
};

const FleetReport = ({ trucks, loads }) => {
  const { notify } = useNotification();

  const [selectedTruck, setSelectedTruck] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
const [driverPays, setDriverPays] = useState([]);
const [selectedDriverPayIds, setSelectedDriverPayIds] = useState([]);

  const [recurringDeductions, setRecurringDeductions] = useState([]);
  const [recurringAdditions, setRecurringAdditions] = useState([]);

  const [truckFuelDeductions, setTruckFuelDeductions] = useState([]);
  const [truckCosts, setTruckCosts] = useState([]);

  const [fleetNumber, setFleetNumber] = useState("");
  const [autoGenerateSettlement, setAutoGenerateSettlement] = useState(true);
const truckCostDeductions = truckCosts.filter(
  cost => cost.type === "deduction"
);

const truckCostAdditions = truckCosts.filter(
  cost => cost.type === "addition"
);

  const token = sessionStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };


  const formatAssetCostProgress = (cost) => {
  if (cost.paymentType !== "recurring") return "";

  const total = cost.recurrence?.occurrences;
  if (!total) return "";

  const paid = Array.isArray(cost.payments)
    ? cost.payments.filter(p => p.status === "paid").length
    : 0;

  const current = paid + 1;
  const totalAmount = Number(cost.amount || 0) * total;

  return ` ${current}/${total} from $${totalAmount.toFixed(2)}`;
};

// =====================================
// FETCH DRIVER PAYS FOR TRUCK
// =====================================
useEffect(() => {
  const fetchDriverPays = async () => {
    if (!selectedTruck) {
      setDriverPays([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/driverpays/by-truck/${selectedTruck._id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`
          },
          withCredentials: true
        }
      );

      setDriverPays(
  (res.data || []).filter(p => !p.includedInFleetReport)
);

    } catch (err) {
      console.error("❌ Failed to fetch driver pays", err);
      setDriverPays([]);
    }
  };

  fetchDriverPays();
}, [selectedTruck]);



  // ===============================
  // AUTO SETTLEMENT NUMBER
  // ===============================
 useEffect(() => {
  if (autoGenerateSettlement) {
    setFleetNumber(`FR-${Date.now()}`);
  }
}, [autoGenerateSettlement]);

  // ===============================
  // SELECT TRUCK
  // ===============================
  const handleTruckSelect = (e) => {
    const truck = trucks.find(t => t._id === e.target.value);
    setSelectedTruck(truck || null);

    setFilteredLoads([]);
    setSelectedLoads([]);
    setRecurringAdditions([]);
    setRecurringDeductions([]);
  };

  // ===============================
  // SEARCH LOADS (IDENTIC STRUCTURA)
  // ===============================
  const searchLoads = () => {
    if (!selectedTruck || !startDate || !endDate) return;

    const filtered = loads.filter(load => {
      if (load.status !== "Completed") return false;

      if (load.truck?.toString() !== selectedTruck._id.toString()) return false;

      const hasPickup = load.shippers.some(
        s => s.pickUpTime && new Date(s.pickUpTime) >= new Date(startDate)
      );

      const hasDelivery = load.consignees.some(
        c => c.deliveryTime && new Date(c.deliveryTime) <= new Date(endDate)
      );

      return hasPickup && hasDelivery;
    });

    setFilteredLoads(filtered);
  };

  const handleLoadSelection = (loadNumber) => {
    setSelectedLoads(prev =>
      prev.includes(loadNumber)
        ? prev.filter(n => n !== loadNumber)
        : [...prev, loadNumber]
    );
  };

  const toNumber = val => {
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };

  // =====================================
// FETCH TRUCK COSTS (Asset Costs)
// =====================================
useEffect(() => {
  const fetchTruckCosts = async () => {
    if (!selectedTruck) {
      setTruckCosts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/asset-costs/by-truck/${selectedTruck._id}`,
        config
      );

      setTruckCosts(res.data || []);
    } catch (err) {
      console.error("❌ Failed to fetch truck costs", err);
      setTruckCosts([]);
    }
  };

  fetchTruckCosts();
}, [selectedTruck]);

// =====================================
// FETCH TRUCK FUEL (OWNER ONLY)
// =====================================
useEffect(() => {
  const fetchTruckFuel = async () => {
    if (!selectedTruck || !startDate || !endDate) {
      setTruckFuelDeductions([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://api-backend.full-trucking-service.com/api/fuel-reports/truck/${selectedTruck._id}`,
        config
      );

      const fuelRows = (res.data || [])
        .filter(f =>
          f.fuelResponsibility === "owner" &&
          f.fuelPaymentStatus === "open"
        )
        .filter(f => {
          const date = new Date(f.transactionDate);
          return (
            date >= new Date(startDate) &&
            date <= new Date(endDate)
          );
        })
        .map(f => ({
          type: "Fuel",
          description: `Fuel – ${f.merchant || "Unknown"} – ${new Date(
            f.transactionDate
          ).toLocaleDateString()}`,
          amount: Number(f.totalToPay || 0),
          date: new Date(f.transactionDate)
            .toISOString()
            .split("T")[0],
          source: "fuel",
          fuelReportId: f._id
        }));

      setTruckFuelDeductions(fuelRows);
    } catch (err) {
      console.error("❌ Failed to fetch truck fuel", err);
      setTruckFuelDeductions([]);
    }
  };

  fetchTruckFuel();
}, [selectedTruck, startDate, endDate]);


  // ===============================
  // CALCULATE PAY – IDENTIC DRIVERPAY STRUCTURA
  // ===============================
  const calculatePay = () => {
    const payDetails = filteredLoads
      .filter(load => selectedLoads.includes(load.loadNumber))
      .map(load => {
        let pay = 0;

        switch (selectedTruck?.settlement) {
          case "Hourly pay":
            pay =
              toNumber(selectedTruck.hoursWorked) *
              toNumber(selectedTruck.settlementAmount);
            break;

          case "Per mile pay":
            pay =
              toNumber(load.miles) *
                toNumber(selectedTruck.normalMileRate) +
              toNumber(load.dh) *
                toNumber(selectedTruck.dhMileRate);
            break;

          case "Fixed salary":
            pay = toNumber(selectedTruck.settlementAmount);
            break;

          case "Percentage of the load":
            pay =
              toNumber(load.rate) *
              toNumber(selectedTruck.settlementAmount) / 100;
            break;

          case "Team driver pay":
            pay = toNumber(load.rate) / 2;
            break;
        }

        return {
          loadNumber: load.loadNumber,
          rate: toNumber(load.rate),
          miles: toNumber(load.miles),
          dh: toNumber(load.dh),
          pay,
          shippers: load.shippers || [],
          consignees: load.consignees || []
        };
      });

    const totalRate = payDetails.reduce((sum, d) => sum + d.rate, 0);
    const totalPay = payDetails.reduce((sum, d) => sum + d.pay, 0);

    const totalAdditions = recurringAdditions.reduce(
      (sum, a) => sum + toNumber(a.amount), 0
    );

    const totalDeductions = recurringDeductions.reduce(
      (sum, d) => sum + toNumber(d.amount), 0
    );

const totalPayWithAdjustments =
  totalPay +
  totalAdditions -
  totalDeductions -
  Math.abs(totalDriverPayrollCost);

    return {
      payDetails,
      totalRate,
      totalPay,
      totalPayWithAdjustments:
        Number.isFinite(totalPayWithAdjustments)
          ? totalPayWithAdjustments
          : 0
    };
  };

const totalDriverPayrollCost = driverPays
  .filter(pay => selectedDriverPayIds.includes(pay._id))
  .reduce(
    (sum, pay) => sum + Number(pay.totalWithAdjustments || 0),
    0
  );

const toggleDriverPaySelection = (id) => {
  setSelectedDriverPayIds(prev =>
    prev.includes(id)
      ? prev.filter(p => p !== id)
      : [...prev, id]
  );
};

  const {
  totalPay,
  totalPayWithAdjustments
} = calculatePay();

  // ===============================
  // GENERATE PDF (STRUCTURA IDENTICA)
  // ===============================
  const generatePDF = async () => {
    const { payDetails, totalPay, totalPayWithAdjustments } = calculatePay();

    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("FLEET REPORT", 105, 20, { align: "center" });

    doc.setFontSize(10);
    doc.text(`Truck: ${selectedTruck?.truckNumber}`, 10, 40);
    doc.text(`Start Date: ${startDate}`, 10, 46);
    doc.text(`End Date: ${endDate}`, 10, 52);
    doc.text(`Fleet number #: ${fleetNumber}`, 140, 40);

    let startY = 70;

    payDetails.forEach((detail, index) => {
      doc.autoTable({
        startY,
        body: [
          ["Load #", detail.loadNumber],
          ["Rate", `$${detail.rate.toFixed(2)}`],
          ["Miles", detail.miles],
          ["DH", detail.dh],
          ["Truck Pay", `$${detail.pay.toFixed(2)}`],
        ],
        theme: "grid",
        styles: { fontSize: 8 }
      });

      startY = doc.lastAutoTable.finalY + 10;
    });

    doc.autoTable({
      startY,
      body: [
        ["Sub-Total", `$${totalPay.toFixed(2)}`],
        ["Additions", `$${recurringAdditions.reduce((s,a)=>s+toNumber(a.amount),0).toFixed(2)}`],
        ["Deductions", `-$${recurringDeductions.reduce((s,d)=>s+toNumber(d.amount),0).toFixed(2)}`],
        ["Grand Total", `$${totalPayWithAdjustments.toFixed(2)}`],
      ],
      theme: "grid",
      styles: { fontSize: 9, fontStyle: "bold" }
    });

    doc.save("fleet_report.pdf");
  };

const markTruckCostsAsPaid = async () => {
  try {
    // 🔎 colectăm toate costurile de tip truck-cost
    const assetCostIds = [
      ...recurringDeductions,
      ...recurringAdditions,
    ]
      .filter(item =>
        item?.source === "truck-cost" &&
        item?.assetCostId
      )
      .map(item => item.assetCostId.toString());

    // 🔒 eliminăm duplicatele
    const uniqueIds = [...new Set(assetCostIds)];

    if (uniqueIds.length === 0) return;

    await axios.put(
      "https://api-backend.full-trucking-service.com/api/asset-costs/mark-paid",
      { assetCostIds: uniqueIds },
      config
    );

  } catch (err) {
    console.error("❌ Failed to mark truck costs as paid:", err);
    throw err; // propagă eroarea către handlerul superior
  }
};

const markFuelAsPaid = async () => {
  const fuelIds = recurringDeductions
    .filter(d => d.source === "fuel")
    .map(d => d.fuelReportId);

  if (fuelIds.length === 0) return;

  await axios.put(
    "https://api-backend.full-trucking-service.com/api/fuel-reports/mark-paid",
    { fuelIds },
    config
  );
};

  // ===============================
  // SAVE SETTLEMENT
  // ===============================
  const handleSaveFleetReport = async () => {
    if (!selectedTruck || !startDate || !endDate) return false;

    const { payDetails, totalPay, totalPayWithAdjustments } = calculatePay();

    try {
const res = await axios.post(
  "https://api-backend.full-trucking-service.com/api/fleet-reports",
  {
    fleetNumber,
    truck: selectedTruck._id,
    startDate,
    endDate,
    payDetails,

    // 🔹 TRIMITEM ARRAY REAL
    recurringAddition: [...recurringAdditions],
    recurringDeduction: [...recurringDeductions],

    // 🔹 TRIMITEM DRIVER PAY IDS (LIPSEA!)
    driverPayIds: [...selectedDriverPayIds],

    totalPay,
    totalWithAdjustments: totalPayWithAdjustments
  },
  config
);



      return res.status === 201;
    } catch {
      return false;
    }
  };

  // ===============================
  // UI
  // ===============================
  return (
    <div className={styles.ultimatefleetreportSection}>
      <h2 className={styles.titlefleetreportultimatedriverPay}>
        Fleet Report
      </h2>

      <div className={styles.formGroupultimatefleetreport}>
        <label>Select Truck</label>
        <select
          value={selectedTruck?._id || ""}
          onChange={handleTruckSelect}
          className={styles.selectFieldultimatefleetreport}
        >
          <option value="">Select Truck</option>
          {trucks.map(truck => (
            <option key={truck._id} value={truck._id}>
              {truck.truckNumber}
            </option>
          ))}
        </select>
      </div>

      {selectedTruck && (
        <>
          <div className={styles.formRowultimatefleetreport}>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              className={styles.inputFieldultimatefleetreport}
            />
            <input
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
              className={styles.inputFieldultimatefleetreport}
            />
          </div>

          <button
            onClick={searchLoads}
            className={styles.actionButtonultimatefleetreport}
          >
            Search
          </button>

          {filteredLoads.length > 0 && (
            <>
              <ul className={styles.loadListultimatefleetreport}>
                {filteredLoads.map(load => (
                  <li key={load._id}>
                    <input
                      type="checkbox"
                      checked={selectedLoads.includes(load.loadNumber)}
                      onChange={() =>
                        handleLoadSelection(load.loadNumber)
                      }
                    />
                    Load #{load.loadNumber} – $
                    {parseFloat(load.rate || 0).toFixed(2)}
                  </li>
                ))}
              </ul>
{truckCostDeductions.map(cost => (
  <div key={cost._id} className={styles.loadItemultimatefleetreport}>

    <div className={styles.costLeftFleetReport}>
      <div className={styles.costTitleFleetReport}>
        {cost.category}
        {cost.vendor && ` – ${cost.vendor}`}
      </div>

      <div className={styles.costDescriptionFleetReport}>
        {cost.description || "No description"}
        {formatAssetCostProgress(cost)}
      </div>

      <div className={styles.costMetaFleetReport}>
        Next Billing: {
          cost.nextBillingDate
            ? cost.nextBillingDate.split("T")[0]
            : cost.startDate
              ? cost.startDate.split("T")[0]
              : "-"
        }
      </div>
    </div>

    <div className={styles.costRightFleetReport}>
      <div className={styles.costAmountFleetReport}>
        -${parseFloat(cost.amount || 0).toFixed(2)}
      </div>

      <button
        onClick={() => {
          const item = {
            type: cost.category,
            description: `${cost.description || ""}${formatAssetCostProgress(cost)}`,
            amount: Number(cost.amount) || 0,
            date: cost.nextBillingDate
              ? cost.nextBillingDate.split("T")[0]
              : cost.startDate
                ? cost.startDate.split("T")[0]
                : new Date().toISOString().split("T")[0],
            source: "truck-cost",
            assetCostId: cost._id
          };

          setRecurringDeductions(prev =>
            prev.some(d => d.assetCostId === cost._id)
              ? prev
              : [...prev, item]
          );
        }}
        className={styles.addButtonultimatefleetreport}
      >
        Add
      </button>
    </div>

  </div>
))}


{/* ============================= */}
{/* TRUCK COST ADDITIONS */}
{/* ============================= */}
{truckCostAdditions.length > 0 && (
  <div className={styles.formGroupultimatefleetreport}>
    <h3>Truck Cost Additions</h3>

    {truckCostAdditions.map(cost => {

      const paid = Array.isArray(cost.payments)
        ? cost.payments.filter(p => p.status === "paid").length
        : 0;

      const totalOccurrences = cost.recurrence?.occurrences || 0;
      const isRecurringLimited =
        cost.paymentType === "recurring" && totalOccurrences > 0;

      const progressText = isRecurringLimited
        ? ` ${paid + 1}/${totalOccurrences}`
        : "";

      const totalAmountRecurring = isRecurringLimited
        ? ` from $${(Number(cost.amount || 0) * totalOccurrences).toFixed(2)}`
        : "";

      return (
        <div
          key={cost._id}
          className={styles.quickItemFleetReport}
        >
          <div className={styles.quickItemLeftFleetReport}>
            <div className={styles.quickItemTitleFleetReport}>
              {cost.category}
              {cost.vendor && ` – ${cost.vendor}`}
            </div>

            <div className={styles.quickItemDescriptionFleetReport}>
              {cost.description || "No description"}
              {progressText}
              {totalAmountRecurring}
            </div>
          </div>

          <div className={styles.quickItemRightFleetReport}>
            <div className={styles.quickItemAmountFleetReport}>
              +${Number(cost.amount || 0).toFixed(2)}
            </div>

            <button
              onClick={() => {
                const item = {
                  type: cost.category,
                  description: `${cost.description || ""}${progressText}${totalAmountRecurring}`,
                  amount: Number(cost.amount) || 0,
                  date: cost.nextBillingDate
                    ? cost.nextBillingDate.split("T")[0]
                    : cost.startDate
                      ? cost.startDate.split("T")[0]
                      : new Date().toISOString().split("T")[0],
                  source: "truck-cost",
                  assetCostId: cost._id
                };

                setRecurringAdditions(prev =>
                  prev.some(a => a.assetCostId === cost._id)
                    ? prev
                    : [...prev, item]
                );
              }}
              className={styles.addButtonultimatefleetreport}
            >
              Add
            </button>
          </div>
        </div>
      );
    })}
  </div>
)}

{/* ============================= */}
{/* FUEL (OWNER OPEN) */}
{/* ============================= */}
{truckFuelDeductions.map(fuel => (
  <div key={fuel.fuelReportId} className={styles.loadItemultimatefleetreport}>

    <div className={styles.costLeftFleetReport}>
      <div className={styles.costTitleFleetReport}>
        Fuel
      </div>

      <div className={styles.costDescriptionFleetReport}>
        {fuel.description}
      </div>

      <div className={styles.costMetaFleetReport}>
        Date: {fuel.date}
      </div>
    </div>

    <div className={styles.costRightFleetReport}>
      <div className={styles.costAmountFleetReport}>
        -${parseFloat(fuel.amount || 0).toFixed(2)}
      </div>

      <button
        onClick={() => {
          setRecurringDeductions(prev =>
            prev.some(d => d.fuelReportId === fuel.fuelReportId)
              ? prev
              : [...prev, fuel]
          );
        }}
        className={styles.addButtonultimatefleetreport}
      >
        Add
      </button>
    </div>

  </div>
))}

{/* ============================= */}
{/* DRIVER PAYROLL COSTS */}
{driverPays.length > 0 && (
  <div className={styles.formGroupultimatefleetreport}>
    <h3>Driver Payroll (Select to Include)</h3>

{driverPays.map(pay => {
  const isSelected = selectedDriverPayIds.includes(pay._id);

  return (
    <div key={pay._id} className={styles.loadItemultimatefleetreport}>

      <div className={styles.costLeftFleetReport}>

        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => toggleDriverPaySelection(pay._id)}
          style={{ marginRight: 10 }}
        />

        <div>
          <div className={styles.costTitleFleetReport}>
            {pay.driverId?.firstName} {pay.driverId?.lastName}
          </div>

          <div className={styles.costDescriptionFleetReport}>
            Fleet number #: {pay.fleetNumber}
          </div>

          <div className={styles.costMetaFleetReport}>
            {pay.startDate?.split("T")[0]} → {pay.endDate?.split("T")[0]}
          </div>
        </div>
      </div>

      <div className={styles.costRightFleetReport}>
        <div className={styles.costAmountFleetReport}>
          -${Number(pay.totalWithAdjustments || 0).toFixed(2)}
        </div>
      </div>

    </div>
  );
})}

  </div>
)}

{/* ========================================= */}
{/* LIVE TOTAL SECTION */}
{/* ========================================= */}
<div className={styles.totalsContainerFleetReport}>

  <div className={styles.totalRowFleetReport}>
    <span>Sub-Total</span>
    <span>${totalPay.toFixed(2)}</span>
  </div>

  {recurringAdditions.length > 0 && (
    <div className={styles.adjustmentsSectionFleetReport}>
      <h4>Additions</h4>
      {recurringAdditions.map((a, i) => (
        <div key={i} className={styles.additionRowFleetReport}>
          <span>{a.itemType} – {a.description}</span>
          <span>+${parseFloat(a.amount || 0).toFixed(2)}</span>
        </div>
      ))}
    </div>
  )}

  {recurringDeductions.length > 0 && (
    <div className={styles.adjustmentsSectionFleetReport}>
      <h4>Deductions</h4>
      {recurringDeductions.map((d, i) => (
        <div key={i} className={styles.deductionRowFleetReport}>
          <span>{d.type} – {d.description}</span>
          <span>-${parseFloat(d.amount || 0).toFixed(2)}</span>
        </div>
      ))}
    </div>
  )}

{driverPays.length > 0 && (
  <div className={styles.adjustmentsSectionFleetReport}>
    <h4>Driver Payroll</h4>
    <div className={styles.deductionRowFleetReport}>
      <span>Total Driver Cost</span>
      <span>-${totalDriverPayrollCost.toFixed(2)}</span>
    </div>
  </div>
)}

  <div className={styles.grandTotalFleetReport}>
    <span>Grand Total</span>
    <span>${totalPayWithAdjustments.toFixed(2)}</span>
  </div>

</div>


              <button
                onClick={generatePDF}
                className={styles.previewButtonultimatefleetreport}
              >
                Preview PDF
              </button>

              <button
            onClick={async () => {
  const saved = await handleSaveFleetReport();

  if (!saved) {
    notify("Save failed.", "error");
    return;
  }

  try {
    // 🔹 mark fuel
    await markFuelAsPaid();

    // 🔹 mark truck costs
    await markTruckCostsAsPaid();

    // 🔹 mark driver payroll as included
    if (selectedDriverPayIds.length > 0) {
      await axios.put(
        "https://api-backend.full-trucking-service.com/api/driverpays/mark-included",
        { driverPayIds: selectedDriverPayIds },
        config
      );
    }

    notify("Fleet report saved.", "success");

  } catch (err) {
    console.error("Post-save update error:", err);
    notify("Fleet report saved but update failed.", "warning");
  }
}}


                className={styles.saveButtonultimatefleetreport}
              >
                Save Fleet Report
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
};


const PayrollEmployee = () => {
  const { notify } = useNotification();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [notes, setNotes] = useState('');
  const [deductions, setDeductions] = useState([]);
  const [additions, setAdditions] = useState([]);
  const [hoursWorked, setHoursWorked] = useState(0);
  const [commissions, setCommissions] = useState([{ description: '', amount: '' }]);
  const [otherTaxes, setOtherTaxes] = useState([]);
  const [theme, setTheme] = useState("dark");

  const [extraFields, setExtraFields] = useState({
    businessUnit: '',
    checkNo: '',
    benefitDate: '',
    allowances: '',
    regularHours: '',
    regularPay: '',
    overtimeHours: '',
    overtimePay: '',
    holidayHours: '',
    holidayPay: '',
    personalDayHours: '',
    personalDayPay: '',
    vacationHours: '',
    vacationPay: '',
    sickLeaveHours: '',
    sickLeavePay: '',
    fmlaHours: '',
    fmlaPay: '',
    bonusHours: '',
    bonusPay: '',
  });
  const [taxes, setTaxes] = useState({
    federalIncome: 0,
    stateIncome: 0,
    socialSecurity: 0,
    medicare: 0,
  });
  const [logo, setLogo] = useState(null);
  const [footer, setFooter] = useState('');
  const [useCustomFooter, setUseCustomFooter] = useState(false);

  const token = sessionStorage.getItem('token');
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const { data } = await axios.get('https://api-backend.full-trucking-service.com/api/employees', config);
        setEmployees(Array.isArray(data) ? data : []);
      } catch (err) {
      
      }
    };
    const fetchLogo = async () => {
      try {
        const res = await axios.get('https://api-backend.full-trucking-service.com/api/logo', config);
        setLogo(res.data.logo);
      } catch (err) {
     
      }
    };
    const fetchFooter = async () => {
      try {
        const res = await axios.get('https://api-backend.full-trucking-service.com/api/footer', config);
        setFooter(res.data.customFooterText || '');
        setUseCustomFooter(res.data.useCustomFooter || false);
      } catch (err) {
     
      }
    };
    fetchEmployees();
    fetchLogo();
    fetchFooter();
  }, []);

  const [ytdTotals, setYtdTotals] = useState({
    regularHours: 0,
    regularPay: 0,
    overtimeHours: 0,
    overtimePay: 0,
    holidayHours: 0,
    holidayPay: 0,
    personalDayHours: 0,
    personalDayPay: 0,
    vacationHours: 0,
    vacationPay: 0,
    sickLeaveHours: 0,
    sickLeavePay: 0,
    fmlaHours: 0,
    fmlaPay: 0,
    bonusHours: 0,
    bonusPay: 0,
  });
  
  useEffect(() => {
    if (!selectedEmployee) return;
  
    const fetchPayrolls = async () => {
      try {
        const { data } = await axios.get(
          `https://api-backend.full-trucking-service.com/api/employees/${selectedEmployee._id}/payrolls`,
          config
        );
  
        // ✅ Filtrăm doar anul curent:
        const currentYear = new Date().getFullYear();
        const filtered = data.filter(payroll => {
          const payDate = new Date(payroll.endDate);
          return payDate.getFullYear() === currentYear;
        });
  
        // ✅ Facem totalurile
        const totals = {
          regularHours: 0,
          regularPay: 0,
          overtimeHours: 0,
          overtimePay: 0,
          holidayHours: 0,
          holidayPay: 0,
          personalDayHours: 0,
          personalDayPay: 0,
          vacationHours: 0,
          vacationPay: 0,
          sickLeaveHours: 0,
          sickLeavePay: 0,
          fmlaHours: 0,
          fmlaPay: 0,
          bonusHours: 0,
          bonusPay: 0,
        };
  
        filtered.forEach(payroll => {
          const ef = payroll.extraFields || {};
          Object.keys(totals).forEach(key => {
            const val = parseFloat(ef[key]) || 0;
            totals[key] += val;
          });
        });
  
        setYtdTotals(totals);
      } catch (err) {
       
      }
    };
  
    fetchPayrolls();
  }, [selectedEmployee]);
  
  const calculateExtraPayTotal = () => {
    const pays = [
      Number(extraFields.regularPay) || 0,
      Number(extraFields.overtimePay) || 0,
      Number(extraFields.holidayPay) || 0,
      Number(extraFields.personalDayPay) || 0,
      Number(extraFields.vacationPay) || 0,
      Number(extraFields.sickLeavePay) || 0,
      Number(extraFields.fmlaPay) || 0,
      Number(extraFields.bonusPay) || 0,
    ];
    return pays.reduce((acc, val) => acc + val, 0);
  };
  
  const addDeduction = () => setDeductions([...deductions, { name: '', amount: '' }]);
  const addAddition = () => setAdditions([...additions, { name: '', amount: '' }]);
  const addOtherTax = () => setOtherTaxes([...otherTaxes, { name: '', percentage: '' }]);
  const removeOtherTax = (i) => setOtherTaxes(otherTaxes.filter((_, idx) => idx !== i));

  const calculateTotal = () => {
    if (!selectedEmployee) return 0;

    let base = 0;

    if (selectedEmployee?.payType === 'Hourly') {
      base = (Number(selectedEmployee?.payAmount) || 0) * (Number(hoursWorked) || 0);
    } else if (selectedEmployee?.payType === 'Commission') {
      const commissionRate = Number(selectedEmployee?.commissionPercentage) || 0;
      base = commissions.reduce((sum, com) => {
        const amount = Number(com.amount) || 0;
        return sum + (amount * commissionRate) / 100;
      }, 0);
    } else {
      // Fixed salary
      base = Number(selectedEmployee?.payAmount) || 0;
    }
    
  
  const extraPayTotal = calculateExtraPayTotal();
  const gross = base + extraPayTotal;
  

    const addTotal = additions.reduce((sum, a) => sum + Number(a.amount || 0), 0);
    const dedTotal = deductions.reduce((sum, d) => sum + Number(d.amount || 0), 0);

    const taxTotal =
  (gross * taxes.federalIncome) / 100 +
  (gross * taxes.stateIncome) / 100 +
  (gross * taxes.socialSecurity) / 100 +
  (gross * taxes.medicare) / 100 +
  otherTaxes.reduce((sum, t) => sum + (gross * Number(t.percentage || 0)) / 100, 0);

return gross + addTotal - dedTotal - taxTotal;

  };

  const handleGeneratePDF = () => {
  const doc = new jsPDF();
  const today = new Date().toLocaleDateString();

  if (logo) {
    doc.addImage(logo, 'PNG', 150, 10, 50, 20);
  }

  doc.setFontSize(18).text('PAYROLL STATEMENT', 105, 30, { align: 'center' });

  const headerTable1 = [
    ['EMPLOYEE NAME', `${selectedEmployee?.firstName || '-'} ${selectedEmployee?.lastName || '-'}`, 'EMPLOYEE ID', selectedEmployee?._id || '-'],
    ['ADDRESS', selectedEmployee?.address || '-', 'BUSINESS UNIT', extraFields.businessUnit || '-'],
    ['PHONE', selectedEmployee?.phone || '-', 'PAY GROUP', selectedEmployee?.payType || '-'],
    ['POSITION', selectedEmployee?.position || '-', '', '']
  ];

  const headerTable2 = [
    ['CHECK NO.', extraFields.checkNo || '-', 'ISSUE DATE', today],
    ['BENEFITS DATE', extraFields.benefitDate ||  '-', 'HOURS WORKED', hoursWorked || '-'],
    ['PAY PD BEGIN', startDate || '-', 'PAY PD END', endDate || '-'],
  ];

  doc.autoTable({
    startY: 40,
    body: headerTable1,
    styles: { fontSize: 8 },
    theme: 'grid',
    columnStyles: { 0: { cellWidth: 40 }, 1: { cellWidth: 60 }, 2: { cellWidth: 40 }, 3: { cellWidth: 40 } }
  });

  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 2,
    body: headerTable2,
    styles: { fontSize: 8 },
    theme: 'grid',
    columnStyles: { 0: { cellWidth: 40 }, 1: { cellWidth: 60 }, 2: { cellWidth: 40 }, 3: { cellWidth: 40 } }
  });

  // ✅ Prima dată afișăm salariul de bază (fără extra)
  const baseSalary = selectedEmployee?.payType === 'Hourly'
    ? (Number(selectedEmployee?.payAmount) * Number(hoursWorked))
    : Number(selectedEmployee?.payAmount) || 0;
  let y = doc.lastAutoTable.finalY + 7;
  doc.setFontSize(12).text(`GROSS SALARY (Base): $${baseSalary.toFixed(2)}`, 15, y);

  // 🟢 PAY DESCRIPTION tabel
  const payDescBody = [
    [
      'Regular',
      extraFields.regularHours || '-',
      `$${extraFields.regularPay || '-'}`,
      `$${extraFields.regularPay || '-'}`,
      ytdTotals.regularHours ? ytdTotals.regularHours.toFixed(2) : '-',
      ytdTotals.regularPay ? `$${ytdTotals.regularPay.toFixed(2)}` : '-',
    ],
    [
      'Overtime',
      extraFields.overtimeHours || '-',
      `$${extraFields.overtimePay || '-'}`,
      `$${extraFields.overtimePay || '-'}`,
      ytdTotals.overtimeHours ? ytdTotals.overtimeHours.toFixed(2) : '-',
      ytdTotals.overtimePay ? `$${ytdTotals.overtimePay.toFixed(2)}` : '-',
    ],
    [
      'Holiday',
      extraFields.holidayHours || '-',
      `$${extraFields.holidayPay || '-'}`,
      `$${extraFields.holidayPay || '-'}`,
      ytdTotals.holidayHours ? ytdTotals.holidayHours.toFixed(2) : '-',
      ytdTotals.holidayPay ? `$${ytdTotals.holidayPay.toFixed(2)}` : '-',
    ],
    [
      'Personal Day',
      extraFields.personalDayHours || '-',
      `$${extraFields.personalDayPay || '-'}`,
      `$${extraFields.personalDayPay || '-'}`,
      ytdTotals.personalDayHours ? ytdTotals.personalDayHours.toFixed(2) : '-',
      ytdTotals.personalDayPay ? `$${ytdTotals.personalDayPay.toFixed(2)}` : '-',
    ],
    [
      'Vacation',
      extraFields.vacationHours || '-',
      `$${extraFields.vacationPay || '-'}`,
      `$${extraFields.vacationPay || '-'}`,
      ytdTotals.vacationHours ? ytdTotals.vacationHours.toFixed(2) : '-',
      ytdTotals.vacationPay ? `$${ytdTotals.vacationPay.toFixed(2)}` : '-',
    ],
    [
      'Sick Leave',
      extraFields.sickLeaveHours || '-',
      `$${extraFields.sickLeavePay || '-'}`,
      `$${extraFields.sickLeavePay || '-'}`,
      ytdTotals.sickLeaveHours ? ytdTotals.sickLeaveHours.toFixed(2) : '-',
      ytdTotals.sickLeavePay ? `$${ytdTotals.sickLeavePay.toFixed(2)}` : '-',
    ],
    [
      'FMLA',
      extraFields.fmlaHours || '-',
      `$${extraFields.fmlaPay || '-'}`,
      `$${extraFields.fmlaPay || '-'}`,
      ytdTotals.fmlaHours ? ytdTotals.fmlaHours.toFixed(2) : '-',
      ytdTotals.fmlaPay ? `$${ytdTotals.fmlaPay.toFixed(2)}` : '-',
    ],
    [
      'Bonus',
      extraFields.bonusHours || '-',
      `$${extraFields.bonusPay || '-'}`,
      `$${extraFields.bonusPay || '-'}`,
      ytdTotals.bonusHours ? ytdTotals.bonusHours.toFixed(2) : '-',
      ytdTotals.bonusPay ? `$${ytdTotals.bonusPay.toFixed(2)}` : '-',
    ],
  ];
  

  doc.autoTable({
    startY: y + 10,
    head: [['PAY DESCRIPTION', 'HOURS', 'RATE', 'CURRENT PAY', 'YTD HOURS', 'YTD PAY']],
    body: payDescBody,
    styles: { fontSize: 8 },
    theme: 'grid'
  });

  // 🟢 ADDITIONS tabel
  const additionsY = doc.lastAutoTable.finalY + 5;
  doc.autoTable({
    startY: additionsY,
    head: [['ADDITIONS', 'AMOUNT']],
    body: additions.length > 0 ? additions.map(add => [add.name, `$${add.amount}`]) : [['-', '-']],
    styles: { fontSize: 8 },
    theme: 'grid'
  });

  // 🟢 DEDUCTIONS tabel
  const deductionsY = doc.lastAutoTable.finalY + 5;
  doc.autoTable({
    startY: deductionsY,
    head: [['DEDUCTIONS', 'AMOUNT']],
    body: deductions.length > 0 ? deductions.map(ded => [ded.name, `$${ded.amount}`]) : [['-', '-']],
    styles: { fontSize: 8 },
    theme: 'grid'
  });
  if (selectedEmployee?.payType === 'Commission') {
    const commissionsY = doc.lastAutoTable.finalY + 5;
    doc.autoTable({
      startY: commissionsY,
      head: [['DESCRIPTION', 'GROSS AMOUNT', `COMMISSION (${selectedEmployee.commissionPercentage}%)`, 'TOTAL EARNED']],
      body: commissions.length > 0
        ? commissions.map(com => {
            const amt = Number(com.amount) || 0;
            const rate = Number(selectedEmployee.commissionPercentage) || 0;
            const commissionEarned = ((amt * rate) / 100).toFixed(2);
            return [com.description, `$${amt.toFixed(2)}`, `${rate}%`, `$${commissionEarned}`];
          })
        : [['-', '-', '-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });
    
  }
// 🔥 Gross Salary final (Base + extra pay)
const extraPayTotal = calculateExtraPayTotal();
let grossTotal;
const grossY = doc.lastAutoTable.finalY + 7;  // ✅ DEFINIM AICI ÎNAINTE

if (selectedEmployee?.payType === 'Commission') {
  let totalCommissionEarned = 0;
  commissions.forEach(com => {
    const amt = Number(com.amount) || 0;
    const rate = Number(selectedEmployee.commissionPercentage) || 0;
    totalCommissionEarned += (amt * rate) / 100;
  });
  grossTotal = (totalCommissionEarned + extraPayTotal).toFixed(2);
} else {
  grossTotal = (baseSalary + extraPayTotal).toFixed(2);
}

doc.setFontSize(12).text(`GROSS SALARY (Total with Extra): $${grossTotal}`, 15, grossY);

  // 🟢 TAXES tabel (mutat mai jos)
  const taxesList = [
    { name: 'Federal', percent: taxes.federalIncome, amount: ((taxes.federalIncome / 100) * grossTotal).toFixed(2) },
    { name: 'State', percent: taxes.stateIncome, amount: ((taxes.stateIncome / 100) * grossTotal).toFixed(2) },
    { name: 'Social Security', percent: taxes.socialSecurity, amount: ((taxes.socialSecurity / 100) * grossTotal).toFixed(2) },
    { name: 'Medicare', percent: taxes.medicare, amount: ((taxes.medicare / 100) * grossTotal).toFixed(2) },
    ...otherTaxes.map(tax => ({
      name: tax.name,
      percent: tax.percentage,
      amount: ((tax.percentage / 100) * grossTotal).toFixed(2)
    }))
  ];
  const taxBody = taxesList
    .filter(tax => tax.percent && Number(tax.percent) > 0)
    .map(tax => [tax.name, `${tax.percent}%`, `$${tax.amount}`]);

  const taxesY = grossY + 10;
  doc.autoTable({
    startY: taxesY,
    head: [['TAX TYPE', 'PERCENT', 'AMOUNT']],
    body: taxBody.length > 0 ? taxBody : [['-', '-', '-']],
    styles: { fontSize: 8 },
    theme: 'grid'
  });

  // ✅ NET PAY la final
  let netY = doc.lastAutoTable.finalY + 7;
  doc.setFontSize(12).text(`NET PAY: $${calculateTotal().toFixed(2)}`, 15, netY);

  // 🔚 NOTES
  netY += 10;
  doc.autoTable({
    startY: netY,
    head: [['MESSAGES']],
    body: [[notes || 'No additional notes.']],
    styles: { fontSize: 8 },
    theme: 'grid',
    columnStyles: { 0: { cellWidth: 180 } }
  });

  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(8);
  doc.text(useCustomFooter && footer ? footer : 'Thank you!', 105, pageHeight - 10, { align: 'center' });

  doc.save('employee_payroll.pdf');
  // 🔥 Salvează payroll-ul în baza de date DOAR AICI


  const payrollData = {
    employeeId: selectedEmployee._id,
    startDate,
    endDate,
    total: calculateTotal().toFixed(2),
   gross: grossTotal,

    additions,
    deductions,
    commissions,
    taxes: {
      ...taxes,
      otherTaxes,
    },
    extraFields,
    notes,
  };

  axios.post('https://api-backend.full-trucking-service.com/api/employees/save-payroll', payrollData, config)
    .then(res => {
     
     notify('Payroll saved successfully!', 'succes');
    })
    .catch(err => {
      notify('Failed to save payroll!' , 'error');
    });

  };

  return (
    <div
  className={`${styles.payrollEmployeeSection} ${
    theme === "light" ? styles.payrollEmployeeSectionLight : ""
  }`}
>

      <h3>Employee Payroll</h3>
      <select
       className={styles.employeeSelect}
        value={selectedEmployee?._id || ''}
        onChange={(e) => setSelectedEmployee(employees.find((emp) => emp._id === e.target.value))}
      >
        <option value="">Select Employee</option>
        {employees.map((emp) => (
          <option key={emp._id} value={emp._id}>
            {emp.firstName} {emp.lastName}
          </option>
        ))}
      </select>
      {selectedEmployee?.payType === 'Commission' && (
  <div>
    <h4>Commissions</h4>
    {commissions.map((com, idx) => (
      <div key={idx} className={styles.itemRowPayrollEmployee}>
        <input
          placeholder="Description"
          value={com.description}
          onChange={(e) => {
            const copy = [...commissions];
            copy[idx].description = e.target.value;
            setCommissions(copy);
          }}
        />
        <input
          placeholder="Amount"
          type="number"
          value={com.amount}
          onChange={(e) => {
            const copy = [...commissions];
            copy[idx].amount = e.target.value;
            setCommissions(copy);
          }}
        />
<button
  className={styles.removeCommissionButton}
  onClick={() => setCommissions(commissions.filter((_, i) => i !== idx))}
>
  X
</button>
      </div>
    ))}
<button
  className={styles.addCommissionButton}
  onClick={() => setCommissions([...commissions, { description: '', amount: '' }])}
>
  + Add Commission
</button>
  </div>
)}

<div>
  <label>Hours Worked:</label>
  <input
    type="number"
    value={hoursWorked}
    onChange={(e) => setHoursWorked(e.target.value)}
  />
  {selectedEmployee?.payType !== 'Hourly' && (
    <small style={{ color: '#777' }}>
      (Visible for record only; not used in salary calculation)
    </small>
  )}
</div>


      <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
      <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      <textarea placeholder="Notes" value={notes} onChange={(e) => setNotes(e.target.value)} />

 {/* Extra Fields generale */}
<div className={styles.itemRowPayrollEmployee}>
  <label>Business Unit</label>
  <input
    value={extraFields.businessUnit}
    onChange={(e) => setExtraFields({ ...extraFields, businessUnit: e.target.value })}
  />
</div>
<div className={styles.itemRowPayrollEmployee}>
  <label>Check No.</label>
  <input
    value={extraFields.checkNo}
    onChange={(e) => setExtraFields({ ...extraFields, checkNo: e.target.value })}
  />
</div>
<div className={styles.itemRowPayrollEmployee}>
  <label>Benefit Date</label>
  <input
    type="date"
    value={extraFields.benefitDate}
    onChange={(e) => setExtraFields({ ...extraFields, benefitDate: e.target.value })}
  />
</div>
<div className={styles.itemRowPayrollEmployee}>
  <label>Allowances</label>
  <input
    value={extraFields.allowances}
    onChange={(e) => setExtraFields({ ...extraFields, allowances: e.target.value })}
  />
</div>

{/* Pay sections: Regular, Overtime etc. */}
<h4>Regular</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.regularHours}
    onChange={(e) => setExtraFields({ ...extraFields, regularHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.regularPay}
    onChange={(e) => setExtraFields({ ...extraFields, regularPay: e.target.value })}
  />
</div>

<h4>Overtime</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.overtimeHours}
    onChange={(e) => setExtraFields({ ...extraFields, overtimeHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.overtimePay}
    onChange={(e) => setExtraFields({ ...extraFields, overtimePay: e.target.value })}
  />
</div>

<h4>Holiday</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.holidayHours}
    onChange={(e) => setExtraFields({ ...extraFields, holidayHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.holidayPay}
    onChange={(e) => setExtraFields({ ...extraFields, holidayPay: e.target.value })}
  />
</div>

<h4>Personal Day</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.personalDayHours}
    onChange={(e) => setExtraFields({ ...extraFields, personalDayHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.personalDayPay}
    onChange={(e) => setExtraFields({ ...extraFields, personalDayPay: e.target.value })}
  />
</div>

<h4>Vacation</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.vacationHours}
    onChange={(e) => setExtraFields({ ...extraFields, vacationHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.vacationPay}
    onChange={(e) => setExtraFields({ ...extraFields, vacationPay: e.target.value })}
  />
</div>

<h4>Sick Leave</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.sickLeaveHours}
    onChange={(e) => setExtraFields({ ...extraFields, sickLeaveHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.sickLeavePay}
    onChange={(e) => setExtraFields({ ...extraFields, sickLeavePay: e.target.value })}
  />
</div>

<h4>FMLA</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.fmlaHours}
    onChange={(e) => setExtraFields({ ...extraFields, fmlaHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.fmlaPay}
    onChange={(e) => setExtraFields({ ...extraFields, fmlaPay: e.target.value })}
  />
</div>

<h4>Bonus</h4>
<div className={styles.itemRowPayrollEmployee}>
  <label>Hours</label>
  <input
    value={extraFields.bonusHours}
    onChange={(e) => setExtraFields({ ...extraFields, bonusHours: e.target.value })}
  />
  <label>Pay</label>
  <input
    value={extraFields.bonusPay}
    onChange={(e) => setExtraFields({ ...extraFields, bonusPay: e.target.value })}
  />
</div>


      {/* Additions */}
      <h4>Additions</h4>
      {additions.map((add, idx) => (
  <div key={idx} className={styles.itemRowPayrollEmployee}>
    <input
      placeholder="Name"
      value={add.name}
      onChange={(e) => {
        const copy = [...additions];
        copy[idx].name = e.target.value;
        setAdditions(copy);
      }}
    />
    <input
      placeholder="Amount"
      type="number"
      value={add.amount}
      onChange={(e) => {
        const copy = [...additions];
        copy[idx].amount = e.target.value;
        setAdditions(copy);
      }}
    />
    <button
      className={styles.removeAdditionButton} 
      onClick={() => setAdditions(additions.filter((_, i) => i !== idx))}
    >
      X
    </button>
  </div>
))}
<button
  className={styles.addAdditionButton} 
  onClick={addAddition}
>
  + Add Addition
</button>


      {/* Deductions */}
      <h4>Deductions</h4>
      {deductions.map((ded, idx) => (
        <div key={idx} className={styles.itemRowPayrollEmployee}>
          <input placeholder="Name" value={ded.name} onChange={(e) => {
            const copy = [...deductions];
            copy[idx].name = e.target.value;
            setDeductions(copy);
          }} />
          <input placeholder="Amount" type="number" value={ded.amount} onChange={(e) => {
            const copy = [...deductions];
            copy[idx].amount = e.target.value;
            setDeductions(copy);
          }} />
<button
  className={styles.removeDeductionButton}
  onClick={() => setDeductions(deductions.filter((_, i) => i !== idx))}
>
  X
</button>    

    </div>
      ))}
      <button
       className={styles.addAdditionButton} 
        onClick={addDeduction}>+ Add Deduction</button>

      {/* Taxes */}
      <h4>Federal Income Tax (%)</h4>
      <input type="number" value={taxes.federalIncome} onChange={(e) => setTaxes({ ...taxes, federalIncome: e.target.value })} />
      <h4>State Income Tax (%)</h4>
      <input type="number" value={taxes.stateIncome} onChange={(e) => setTaxes({ ...taxes, stateIncome: e.target.value })} />
      <h4>Social Security Tax (%)</h4>
      <input type="number" value={taxes.socialSecurity} onChange={(e) => setTaxes({ ...taxes, socialSecurity: e.target.value })} />
      <h4>Medicare Tax (%)</h4>
      <input type="number" value={taxes.medicare} onChange={(e) => setTaxes({ ...taxes, medicare: e.target.value })} />

      {/* Other Taxes */}
      <h4>Other Taxes</h4>
      {otherTaxes.map((tax, idx) => (
        <div key={idx}>
          <input placeholder="Name" value={tax.name} onChange={(e) => {
            const copy = [...otherTaxes];
            copy[idx].name = e.target.value;
            setOtherTaxes(copy);
          }} />
          <input type="number" placeholder="%" value={tax.percentage} onChange={(e) => {
            const copy = [...otherTaxes];
            copy[idx].percentage = e.target.value;
            setOtherTaxes(copy);
          }} />
        <button
  className={styles.removeOtherTaxButton}
  onClick={() => removeOtherTax(idx)}
>
  X
</button>
        </div>
      ))}
    <button
  className={styles.addOtherTaxButton}
  onClick={addOtherTax}
>
  + Add Other Tax
</button>

      <h4>Total: ${calculateTotal().toFixed(2)}</h4>
      <button
  className={styles.generatePayrollButton}
  onClick={handleGeneratePDF}
>
  Generate & Download PDF
</button>
    </div>
  );
};


const PayrollManager = () => {
  const { notify } = useNotification();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [payrolls, setPayrolls] = useState([]);
  const [selectedPayroll, setSelectedPayroll] = useState(null);  // pentru See More
  const [logo, setLogo] = useState(null);
  const [footer, setFooter] = useState('');
  const [selectedPayrolls, setSelectedPayrolls] = useState([]);
  const [useCustomFooter, setUseCustomFooter] = useState(false);
const [theme, setTheme] = useState("dark");

  const token = sessionStorage.getItem('token');
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };
useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const { data } = await axios.get('https://api-backend.full-trucking-service.com/api/employees', config);
        setEmployees(Array.isArray(data) ? data : []);
      } catch (err) {
      
      }
    };
    const fetchLogo = async () => {
      try {
        const res = await axios.get('https://api-backend.full-trucking-service.com/api/logo', config);
        setLogo(res.data.logo);
      } catch (err) {
   
      }
    };
    const fetchFooter = async () => {
      try {
        const res = await axios.get('https://api-backend.full-trucking-service.com/api/footer', config);
        setFooter(res.data.customFooterText || '');
        setUseCustomFooter(res.data.useCustomFooter || false);
      } catch (err) {

      }
    };
    fetchEmployees();
    fetchLogo();
    fetchFooter();
  }, []);
 
  const fetchPayrolls = async () => {
    if (!selectedEmployee) return;
    try {
      const { data } = await axios.get('https://api-backend.full-trucking-service.com/api/employees', config);
      const employee = data.find(emp => emp._id === selectedEmployee._id);
      if (!employee || !employee.payrolls) {
        setPayrolls([]);
        return;
      }
      const filtered = employee.payrolls.filter(pay => {
        const payStart = new Date(pay.startDate);
        const payEnd = new Date(pay.endDate);
        const filterStart = new Date(startDate);
        const filterEnd = new Date(endDate);
        return payStart >= filterStart && payEnd <= filterEnd;
      });
      setPayrolls(filtered);
    } catch (err) {
 
    }
  };
  
  const togglePayrollSelection = (payroll) => {
    setSelectedPayrolls(prev => {
      if (prev.includes(payroll)) {
        return prev.filter(p => p !== payroll);
      } else {
        return [...prev, payroll];
      }
    });
  };
  

  const handleDownloadPDF = (payroll) => {
    const doc = new jsPDF();
    const today = new Date().toLocaleDateString();
    const currentYear = new Date(payroll.endDate).getFullYear();
    const ytdPayrolls = selectedEmployee.payrolls.filter(p => {
      const pDate = new Date(p.endDate);
      return (
        pDate.getFullYear() === currentYear &&
        pDate <= new Date(payroll.endDate)
      );
    });
  
    // Initialize totals
    const ytdTotals = {
      regularHours: 0, regularPay: 0,
      overtimeHours: 0, overtimePay: 0,
      holidayHours: 0, holidayPay: 0,
      personalDayHours: 0, personalDayPay: 0,
      vacationHours: 0, vacationPay: 0,
      sickLeaveHours: 0, sickLeavePay: 0,
      fmlaHours: 0, fmlaPay: 0,
      bonusHours: 0, bonusPay: 0,
    };
  
    // Sum up totals
    ytdPayrolls.forEach(p => {
      const ex = p.extraFields || {};
      ytdTotals.regularHours += Number(ex.regularHours) || 0;
      ytdTotals.regularPay += Number(ex.regularPay) || 0;
      ytdTotals.overtimeHours += Number(ex.overtimeHours) || 0;
      ytdTotals.overtimePay += Number(ex.overtimePay) || 0;
      ytdTotals.holidayHours += Number(ex.holidayHours) || 0;
      ytdTotals.holidayPay += Number(ex.holidayPay) || 0;
      ytdTotals.personalDayHours += Number(ex.personalDayHours) || 0;
      ytdTotals.personalDayPay += Number(ex.personalDayPay) || 0;
      ytdTotals.vacationHours += Number(ex.vacationHours) || 0;
      ytdTotals.vacationPay += Number(ex.vacationPay) || 0;
      ytdTotals.sickLeaveHours += Number(ex.sickLeaveHours) || 0;
      ytdTotals.sickLeavePay += Number(ex.sickLeavePay) || 0;
      ytdTotals.fmlaHours += Number(ex.fmlaHours) || 0;
      ytdTotals.fmlaPay += Number(ex.fmlaPay) || 0;
      ytdTotals.bonusHours += Number(ex.bonusHours) || 0;
      ytdTotals.bonusPay += Number(ex.bonusPay) || 0;
    });
    if (logo) {
      doc.addImage(logo, 'PNG', 150, 10, 50, 20);
    }

    doc.setFontSize(18).text('PAYROLL STATEMENT', 105, 30, { align: 'center' });

    const headerTable1 = [
      ['EMPLOYEE NAME', `${selectedEmployee?.firstName || '-'} ${selectedEmployee?.lastName || '-'}`, 'EMPLOYEE ID', selectedEmployee?._id || '-'],
      ['ADDRESS', selectedEmployee?.address || '-', 'BUSINESS UNIT', payroll.extraFields.businessUnit || '-'],
      ['PHONE', selectedEmployee?.phone || '-', 'PAY GROUP', selectedEmployee?.payType || '-'],
      ['POSITION', selectedEmployee?.position || '-', '', '']
    ];

    const headerTable2 = [
      ['CHECK NO.', payroll.extraFields.checkNo || '-', 'ISSUE DATE', today],
      ['BENEFITS DATE', payroll.extraFields.benefitDate || '-', 'HOURS WORKED', payroll.extraFields.regularHours || '-'],
      ['PAY PD BEGIN', new Date(payroll.startDate).toLocaleDateString(), 'PAY PD END', new Date(payroll.endDate).toLocaleDateString()],
    ];

    doc.autoTable({
      startY: 40,
      body: headerTable1,
      styles: { fontSize: 8 },
      theme: 'grid',
      columnStyles: { 0: { cellWidth: 40 }, 1: { cellWidth: 60 }, 2: { cellWidth: 40 }, 3: { cellWidth: 40 } }
    });

    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 2,
      body: headerTable2,
      styles: { fontSize: 8 },
      theme: 'grid',
      columnStyles: { 0: { cellWidth: 40 }, 1: { cellWidth: 60 }, 2: { cellWidth: 40 }, 3: { cellWidth: 40 } }
    });

    const payDescBody = [
      [
        'Regular',
        payroll.extraFields.regularHours || '-',
        `$${payroll.extraFields.regularPay || '-'}`,
        `$${payroll.extraFields.regularPay || '-'}`,
        ytdTotals.regularHours ? ytdTotals.regularHours.toFixed(2) : '-',
        ytdTotals.regularPay ? `$${ytdTotals.regularPay.toFixed(2)}` : '-',
      ],
      [
        'Overtime',
        payroll.extraFields.overtimeHours || '-',
        `$${payroll.extraFields.overtimePay || '-'}`,
        `$${payroll.extraFields.overtimePay || '-'}`,
        ytdTotals.overtimeHours ? ytdTotals.overtimeHours.toFixed(2) : '-',
        ytdTotals.overtimePay ? `$${ytdTotals.overtimePay.toFixed(2)}` : '-',
      ],
      [
        'Holiday',
        payroll.extraFields.holidayHours || '-',
        `$${payroll.extraFields.holidayPay || '-'}`,
        `$${payroll.extraFields.holidayPay || '-'}`,
        ytdTotals.holidayHours ? ytdTotals.holidayHours.toFixed(2) : '-',
        ytdTotals.holidayPay ? `$${ytdTotals.holidayPay.toFixed(2)}` : '-',
      ],
      [
        'Personal Day',
        payroll.extraFields.personalDayHours || '-',
        `$${payroll.extraFields.personalDayPay || '-'}`,
        `$${payroll.extraFields.personalDayPay || '-'}`,
        ytdTotals.personalDayHours ? ytdTotals.personalDayHours.toFixed(2) : '-',
        ytdTotals.personalDayPay ? `$${ytdTotals.personalDayPay.toFixed(2)}` : '-',
      ],
      [
        'Vacation',
        payroll.extraFields.vacationHours || '-',
        `$${payroll.extraFields.vacationPay || '-'}`,
        `$${payroll.extraFields.vacationPay || '-'}`,
        ytdTotals.vacationHours ? ytdTotals.vacationHours.toFixed(2) : '-',
        ytdTotals.vacationPay ? `$${ytdTotals.vacationPay.toFixed(2)}` : '-',
      ],
      [
        'Sick Leave',
        payroll.extraFields.sickLeaveHours || '-',
        `$${payroll.extraFields.sickLeavePay || '-'}`,
        `$${payroll.extraFields.sickLeavePay || '-'}`,
        ytdTotals.sickLeaveHours ? ytdTotals.sickLeaveHours.toFixed(2) : '-',
        ytdTotals.sickLeavePay ? `$${ytdTotals.sickLeavePay.toFixed(2)}` : '-',
      ],
      [
        'FMLA',
        payroll.extraFields.fmlaHours || '-',
        `$${payroll.extraFields.fmlaPay || '-'}`,
        `$${payroll.extraFields.fmlaPay || '-'}`,
        ytdTotals.fmlaHours ? ytdTotals.fmlaHours.toFixed(2) : '-',
        ytdTotals.fmlaPay ? `$${ytdTotals.fmlaPay.toFixed(2)}` : '-',
      ],
      [
        'Bonus',
        payroll.extraFields.bonusHours || '-',
        `$${payroll.extraFields.bonusPay || '-'}`,
        `$${payroll.extraFields.bonusPay || '-'}`,
        ytdTotals.bonusHours ? ytdTotals.bonusHours.toFixed(2) : '-',
        ytdTotals.bonusPay ? `$${ytdTotals.bonusPay.toFixed(2)}` : '-',
      ],
    ];
    

    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 10,
      head: [['PAY DESCRIPTION', 'HOURS', 'RATE', 'CURRENT PAY', 'YTD HOURS', 'YTD PAY']],
      body: payDescBody,
      styles: { fontSize: 8 },
      theme: 'grid'
    });
    

    // Additions
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      head: [['ADDITIONS', 'AMOUNT']],
      body: payroll.additions.length > 0 ? payroll.additions.map(add => [add.name, `$${add.amount}`]) : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });

    // Deductions
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      head: [['DEDUCTIONS', 'AMOUNT']],
      body: payroll.deductions.length > 0 ? payroll.deductions.map(ded => [ded.name, `$${ded.amount}`]) : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });

    // Taxes
    const taxes = payroll.taxes;
    const taxesBody = [
      ['Federal Income', `${taxes.federalIncome}%`],
      ['State Income', `${taxes.stateIncome}%`],
      ['Social Security', `${taxes.socialSecurity}%`],
      ['Medicare', `${taxes.medicare}%`],
      ...taxes.otherTaxes.map(t => [t.name, `${t.percentage}%`])
    ];

    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      head: [['TAX TYPE', 'PERCENT']],
      body: taxesBody.length > 0 ? taxesBody : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });

    // Net Pay
    doc.setFontSize(12).text(`NET PAY: $${payroll.total.toFixed(2)}`, 15, doc.lastAutoTable.finalY + 10);

    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text(useCustomFooter && footer ? footer : 'Thank you!', 105, pageHeight - 10, { align: 'center' });

    doc.save('employee_payroll.pdf');
  };
  const handleDownloadMultiplePDF = (payrolls) => {
    const doc = new jsPDF();
    const today = new Date().toLocaleDateString();
  
    if (logo) {
      doc.addImage(logo, 'PNG', 150, 10, 50, 20);
    }
  
    doc.setFontSize(18).text('TOTAL PAYROLL STATEMENT', 105, 30, { align: 'center' });
  
    // PERIOADA TOTALĂ
    const startDates = payrolls.map(p => new Date(p.startDate));
    const endDates = payrolls.map(p => new Date(p.endDate));
    const minDate = new Date(Math.min(...startDates));
    const maxDate = new Date(Math.max(...endDates));
  
    // TOTAL HOURS adunate
    let totalHours = 0;
    payrolls.forEach(p => {
      const ex = p.extraFields || {};
      totalHours +=
        (Number(ex.regularHours) || 0) +
        (Number(ex.overtimeHours) || 0) +
        (Number(ex.holidayHours) || 0) +
        (Number(ex.personalDayHours) || 0) +
        (Number(ex.vacationHours) || 0) +
        (Number(ex.sickLeaveHours) || 0) +
        (Number(ex.fmlaHours) || 0) +
        (Number(ex.bonusHours) || 0);
    });
  
    // 🧮 TOTAL GROSS & NET
    let totalGrossNoExtras = 0;
    let totalGrossWithExtras = 0;
    let totalNetPay = 0;
  
    // ➕ TOTALIZARE Pay Description
    const totals = {
      regularHours: 0, regularPay: 0,
      overtimeHours: 0, overtimePay: 0,
      holidayHours: 0, holidayPay: 0,
      personalDayHours: 0, personalDayPay: 0,
      vacationHours: 0, vacationPay: 0,
      sickLeaveHours: 0, sickLeavePay: 0,
      fmlaHours: 0, fmlaPay: 0,
      bonusHours: 0, bonusPay: 0,
    };
  
    // ➕ Additions/Deductions
    const allAdditions = [];
    const allDeductions = [];
    const allTaxes = {};
  
    payrolls.forEach(p => {
      const ex = p.extraFields || {};
  
      // ➕ SUMĂ pe fiecare PAY DESCRIPTION
      totals.regularHours += Number(ex.regularHours) || 0;
      totals.regularPay += Number(ex.regularPay) || 0;
      totals.overtimeHours += Number(ex.overtimeHours) || 0;
      totals.overtimePay += Number(ex.overtimePay) || 0;
      totals.holidayHours += Number(ex.holidayHours) || 0;
      totals.holidayPay += Number(ex.holidayPay) || 0;
      totals.personalDayHours += Number(ex.personalDayHours) || 0;
      totals.personalDayPay += Number(ex.personalDayPay) || 0;
      totals.vacationHours += Number(ex.vacationHours) || 0;
      totals.vacationPay += Number(ex.vacationPay) || 0;
      totals.sickLeaveHours += Number(ex.sickLeaveHours) || 0;
      totals.sickLeavePay += Number(ex.sickLeavePay) || 0;
      totals.fmlaHours += Number(ex.fmlaHours) || 0;
      totals.fmlaPay += Number(ex.fmlaPay) || 0;
      totals.bonusHours += Number(ex.bonusHours) || 0;
      totals.bonusPay += Number(ex.bonusPay) || 0;
  
      // ➕ Gross fără extras
      totalGrossNoExtras += Number(p.gross) || 0;
      totalNetPay += Number(p.total) || 0;
  
      // ➕ Additions
      if (Array.isArray(p.additions)) {
        p.additions.forEach(add => {
          const existing = allAdditions.find(a => a.name === add.name);
          if (existing) {
            existing.amount += Number(add.amount) || 0;
          } else {
            allAdditions.push({ name: add.name, amount: Number(add.amount) || 0 });
          }
        });
      }
  
      // ➖ Deductions
      if (Array.isArray(p.deductions)) {
        p.deductions.forEach(ded => {
          const existing = allDeductions.find(d => d.name === ded.name);
          if (existing) {
            existing.amount += Number(ded.amount) || 0;
          } else {
            allDeductions.push({ name: ded.name, amount: Number(ded.amount) || 0 });
          }
        });
      }
  
 // 🏦 Taxes
const taxes = p.taxes || {};
const gross = Number(p.gross) || 0;

// Standard taxes
const standardTaxes = [
  { key: 'Federal Income', val: taxes.federalIncome },
  { key: 'State Income', val: taxes.stateIncome },
  { key: 'Social Security', val: taxes.socialSecurity },
  { key: 'Medicare', val: taxes.medicare }
];

standardTaxes.forEach(({ key, val }) => {
  const pct = Number(val) || 0;
  const amt = (pct / 100) * gross;
  if (!allTaxes[key]) {
    allTaxes[key] = { percentage: 0, amount: 0 };
  }
  allTaxes[key].percentage += pct;
  allTaxes[key].amount += amt;
});

// Other Taxes
if (Array.isArray(taxes.otherTaxes)) {
  taxes.otherTaxes.forEach(t => {
    const key = t.name;
    const pct = Number(t.percentage) || 0;
    const amt = (pct / 100) * gross;
    if (!allTaxes[key]) {
      allTaxes[key] = { percentage: 0, amount: 0 };
    }
    allTaxes[key].percentage += pct;
    allTaxes[key].amount += amt;
  });
}

      // ➕ Gross cu extras
      totalGrossWithExtras += (Number(p.gross) || 0) +
        (p.additions?.reduce((sum, a) => sum + (Number(a.amount) || 0), 0) || 0) -
        (p.deductions?.reduce((sum, d) => sum + (Number(d.amount) || 0), 0) || 0);
    });
  
    // 🧾 --- EMPLOYEE INFO TABLE ---
    const empInfo = [
      ['EMPLOYEE NAME', `${selectedEmployee?.firstName || '-'} ${selectedEmployee?.lastName || '-'}`],
      ['EMPLOYEE ID', selectedEmployee?._id || '-'],
      ['ADDRESS', selectedEmployee?.address || '-'],
      ['PHONE', selectedEmployee?.phone || '-'],
      ['POSITION', selectedEmployee?.position || '-'],
      ['PERIOD', `${minDate.toLocaleDateString()} - ${maxDate.toLocaleDateString()}`],
      ['TOTAL HOURS', totalHours.toFixed(2)]
    ];
    doc.autoTable({
      startY: 50,
      body: empInfo,
      styles: { fontSize: 8 },
      theme: 'grid',
      columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 100 } }
    });
  
    // 🔥 Gross Salary (fără extras)
    doc.setFontSize(12).text(`TOTAL GROSS PAY (without additions/deductions): $${totalGrossNoExtras.toFixed(2)}`, 15, doc.lastAutoTable.finalY + 10);
  
    // PAY DESCRIPTION table
    const payDescBody = [
      ['Regular', totals.regularHours.toFixed(2), `$${totals.regularPay.toFixed(2)}`],
      ['Overtime', totals.overtimeHours.toFixed(2), `$${totals.overtimePay.toFixed(2)}`],
      ['Holiday', totals.holidayHours.toFixed(2), `$${totals.holidayPay.toFixed(2)}`],
      ['Personal Day', totals.personalDayHours.toFixed(2), `$${totals.personalDayPay.toFixed(2)}`],
      ['Vacation', totals.vacationHours.toFixed(2), `$${totals.vacationPay.toFixed(2)}`],
      ['Sick Leave', totals.sickLeaveHours.toFixed(2), `$${totals.sickLeavePay.toFixed(2)}`],
      ['FMLA', totals.fmlaHours.toFixed(2), `$${totals.fmlaPay.toFixed(2)}`],
      ['Bonus', totals.bonusHours.toFixed(2), `$${totals.bonusPay.toFixed(2)}`],
    ];
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 10,
      head: [['PAY DESCRIPTION', 'TOTAL HOURS', 'TOTAL PAY']],
      body: payDescBody,
      styles: { fontSize: 8 },
      theme: 'grid'
    });
  
    // Additions
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      head: [['ADDITIONS', 'TOTAL AMOUNT']],
      body: allAdditions.length > 0 ? allAdditions.map(add => [add.name, `$${add.amount.toFixed(2)}`]) : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });
  
    // Deductions
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 5,
      head: [['DEDUCTIONS', 'TOTAL AMOUNT']],
      body: allDeductions.length > 0 ? allDeductions.map(ded => [ded.name, `$${ded.amount.toFixed(2)}`]) : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });
  
    // Gross Pay cu extras
    doc.setFontSize(12).text(`TOTAL GROSS PAY (with additions/deductions): $${totalGrossWithExtras.toFixed(2)}`, 15, doc.lastAutoTable.finalY + 10);
  
    // Taxes
    const taxesBody = Object.keys(allTaxes).map(key => [
      key,
      `${allTaxes[key].percentage.toFixed(2)}%`,
      `$${allTaxes[key].amount.toFixed(2)}`
    ]);
    
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 10,
      head: [['TAX TYPE', 'TOTAL PERCENT', 'TOTAL AMOUNT']],
      body: taxesBody.length > 0 ? taxesBody : [['-', '-']],
      styles: { fontSize: 8 },
      theme: 'grid'
    });
  
    // Net Pay FINAL
    doc.setFontSize(12).text(`TOTAL NET PAY: $${totalNetPay.toFixed(2)}`, 15, doc.lastAutoTable.finalY + 15);
  
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.text(useCustomFooter && footer ? footer : 'Thank you!', 105, pageHeight - 10, { align: 'center' });
  
    doc.save('total_payroll.pdf');
  };
  
  return (
    <div
  className={`${styles.payrollManagerSection} ${
    theme === "light" ? styles.payrollManagerSectionLight : ""
  }`}
>

      <h3>Payroll Manager</h3>
      <select
      className={styles.employeeSelect}
        value={selectedEmployee?._id || ''}
        onChange={(e) => {
          const emp = employees.find(emp => emp._id === e.target.value);
          setSelectedEmployee(emp);
          setPayrolls([]);
        }}
      >
        <option value="">Select Employee</option>
        {employees.map(emp => (
          <option key={emp._id} value={emp._id}>
            {emp.firstName} {emp.lastName}
          </option>
        ))}
      </select>

      {selectedEmployee && (
        <div className={styles.dateInputsRow}>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          <button className={styles.searchButton} onClick={fetchPayrolls}>Search Payrolls</button>
        </div>
      )}

      {payrolls.length > 0 && (
        <table className={styles.payrollTable}>
        
        <thead className={styles.tableHeader}>
  <tr>
    <th>Select</th> {/* 👈 nou */}
    <th>Period</th>
    <th>Total Net Pay</th>
    <th>Actions</th>
  </tr>
</thead>
<tbody className={styles.tableBody}>
  {payrolls.map((pay, idx) => (
    <tr key={idx}>
      <td>
        <input
          type="checkbox"
          checked={selectedPayrolls.includes(pay)}
          onChange={() => togglePayrollSelection(pay)}
        />
      </td>
      <td>{new Date(pay.startDate).toLocaleDateString()} - {new Date(pay.endDate).toLocaleDateString()}</td>
      <td>${pay.total.toFixed(2)}</td>
      <td>
        <button className={styles.seeMoreButton} onClick={() => setSelectedPayroll(pay)}>See More</button>
      </td>
    </tr>
  ))}
</tbody>
{selectedPayrolls.length > 1 && (
  <button className={styles.downloadPDFButton} onClick={() => handleDownloadMultiplePDF(selectedPayrolls)}>
    Download Total PDF ({selectedPayrolls.length} selected)
  </button>
)}

        </table>
      )}

      {selectedPayroll && (
        <div className={styles.payrollDetailsContainer}>
          <button onClick={() => setSelectedPayroll(null)}>X Close</button>
          <h4>Payroll Details</h4>

<p><strong>Pay Period:</strong> {new Date(selectedPayroll.startDate).toLocaleDateString()} - {new Date(selectedPayroll.endDate).toLocaleDateString()}</p>
<p><strong>Total Net Pay:</strong> ${selectedPayroll.total.toFixed(2)}</p>
<p><strong>Gross Pay:</strong> ${selectedPayroll.gross.toFixed(2)}</p>

{/* Additions */}
<h5>Additions</h5>
{selectedPayroll.additions.length > 0 ? (
  <ul>
    {selectedPayroll.additions.map((add, idx) => (
      <li key={idx}>{add.name}: ${add.amount}</li>
    ))}
  </ul>
) : <p>- No additions</p>}

{/* Deductions */}
<h5>Deductions</h5>
{selectedPayroll.deductions.length > 0 ? (
  <ul>
    {selectedPayroll.deductions.map((ded, idx) => (
      <li key={idx}>{ded.name}: ${ded.amount}</li>
    ))}
  </ul>
) : <p>- No deductions</p>}

{/* Commissions */}
{selectedPayroll.commissions && selectedPayroll.commissions.length > 0 && (
  <>
    <h5>Commissions</h5>
    <ul>
      {selectedPayroll.commissions.map((com, idx) => (
        <li key={idx}>{com.description || 'No data'}: ${com.amount !== null ? com.amount : '0'}</li>
      ))}
    </ul>
  </>
)}

{/* Extra Fields */}
<h5>Pay Breakdown</h5>
<ul>
  <li>Business Unit: {selectedPayroll.extraFields.businessUnit || '-'}</li>
  <li>Check No: {selectedPayroll.extraFields.checkNo || '-'}</li>
  <li>Benefit Date: {selectedPayroll.extraFields.benefitDate ? new Date(selectedPayroll.extraFields.benefitDate).toLocaleDateString() : '-'}</li>
  <li>Allowances: {selectedPayroll.extraFields.allowances || '-'}</li>
  <li>Regular: {selectedPayroll.extraFields.regularHours} hrs - ${selectedPayroll.extraFields.regularPay}</li>
  <li>Overtime: {selectedPayroll.extraFields.overtimeHours} hrs - ${selectedPayroll.extraFields.overtimePay}</li>
  <li>Holiday: {selectedPayroll.extraFields.holidayHours} hrs - ${selectedPayroll.extraFields.holidayPay}</li>
  <li>Personal Day: {selectedPayroll.extraFields.personalDayHours} hrs - ${selectedPayroll.extraFields.personalDayPay}</li>
  <li>Vacation: {selectedPayroll.extraFields.vacationHours} hrs - ${selectedPayroll.extraFields.vacationPay}</li>
  <li>Sick Leave: {selectedPayroll.extraFields.sickLeaveHours} hrs - ${selectedPayroll.extraFields.sickLeavePay}</li>
  <li>FMLA: {selectedPayroll.extraFields.fmlaHours} hrs - ${selectedPayroll.extraFields.fmlaPay}</li>
  <li>Bonus: {selectedPayroll.extraFields.bonusHours} hrs - ${selectedPayroll.extraFields.bonusPay}</li>
</ul>

{/* Taxes */}
<h5>Taxes</h5>
<ul>
  <li>Federal Income: {selectedPayroll.taxes.federalIncome}%</li>
  <li>State Income: {selectedPayroll.taxes.stateIncome}%</li>
  <li>Social Security: {selectedPayroll.taxes.socialSecurity}%</li>
  <li>Medicare: {selectedPayroll.taxes.medicare}%</li>
  {selectedPayroll.taxes.otherTaxes.length > 0 ? (
    selectedPayroll.taxes.otherTaxes.map((tax, idx) => (
      <li key={idx}>{tax.name}: {tax.percentage}%</li>
    ))
  ) : <li>No other taxes</li>}
</ul>

{/* Notes */}
<h5>Notes</h5>
<p>{selectedPayroll.notes || 'No additional notes.'}</p>

<button onClick={() => handleDownloadPDF(selectedPayroll)}>Download PDF</button>

        </div>
      )}
    </div>
  );
};


const FuelReport = ({ drivers, trucks }) => {
  const { notify } = useNotification();
  const [filterDriver, setFilterDriver] = useState('');
const [filterTruck, setFilterTruck] = useState('');
const [theme, setTheme] = useState("dark");
const [csvFile, setCsvFile] = useState(null);
const [importLoading, setImportLoading] = useState(false);
const [importResult, setImportResult] = useState(null);
const [previewRows, setPreviewRows] = useState([]);
const [showPreview, setShowPreview] = useState(false);
const [fuelResponsibilityFilter, setFuelResponsibilityFilter] = useState('');
const [aiText, setAiText] = useState("");
const [aiLoading, setAiLoading] = useState(false);

const [fuelData, setFuelData] = useState({
  driverId: '',
  truckId: '',
  transactionDate: '',
  merchant: '',
  state: '',
  cardNumber: '',
  cardName: '',
  paymentId: '',
  invoiceNumber: '',
  location: '',

  fuelQuantity: 0,
  fuelPPG: 0,
  fuelAmount: 0,

  defQuantity: 0,
  defAmount: 0,

  reeferQuantity: 0,
  reeferPPG: 0,
  reeferAmount: 0,

  additives: 0,
  oil: 0,
  otherFees: 0,

  discount: 0,
  totalToPay: 0
});

  const [fuelReports, setFuelReports] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteTarget, setDeleteTarget] = useState(null);
const driverByTruckNumber = useMemo(() => {
  const map = {};
  drivers.forEach(d => {
    if (d.truckNumber) {
      map[d.truckNumber] = d;
    }
  });
  return map;
}, [drivers]);

const truckByTruckNumber = useMemo(() => {
  const map = {};
  trucks.forEach(t => {
    if (t.truckNumber) {
      map[t.truckNumber] = t;
    }
  });
  return map;
}, [trucks]);


  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  useEffect(() => {
    fetchFuelReports();
  }, []);

  
  const handleAIParse = async () => {
  if (!aiText) {
    notify("Paste receipt text first", "error");
    return;
  }

  try {
    setAiLoading(true);

    const res = await axios.post(
      `${apiUrl}/fuel-reports/ai-parse`,
      { rawText: aiText },
      config
    );

    setFuelData((prev) => ({
      ...prev,
      ...res.data,
    }));

    notify("Fuel data extracted by AI", "success");
  } catch (err) {
    notify("AI parsing failed", "error");
  } finally {
    setAiLoading(false);
  }
};

const handleCSVImport = async () => {
  if (!csvFile) {
    notify("Please select a CSV file", "error");
    return;
  }

  try {
    setImportLoading(true);

    const text = await csvFile.text();

    const startRes = await axios.post(
      `${apiUrl}/fuel-reports/ai-parse-full-csv`,
      { csvText: text },
      config
    );

    const jobId = startRes.data.jobId;

    pollJobStatus(jobId);

  } catch (err) {
    notify("Failed to start CSV import", "error");
    setImportLoading(false);
  }
};

const pollJobStatus = (jobId) => {

  const interval = setInterval(async () => {
    try {
      const res = await axios.get(
        `${apiUrl}/fuel-reports/job-status/${jobId}`,
        config
      );

      if (res.data.status === "processing") {
        console.log("Progress:", res.data.progress);
      }

      if (res.data.status === "done") {
        clearInterval(interval);

        setPreviewRows(res.data.result);
        setShowPreview(true);
        setImportLoading(false);
      }

      if (res.data.status === "failed") {
        clearInterval(interval);
        notify("CSV import failed", "error");
        setImportLoading(false);
      }

    } catch (err) {
      clearInterval(interval);
      setImportLoading(false);
    }
  }, 2000);
};

const confirmCSVImport = async () => {
  try {
    const res = await axios.post(
      `${apiUrl}/fuel-reports/import-csv/confirm`,
      { rows: previewRows },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    // ✅ FULL SUCCESS
    if (res.status === 200 || res.status === 201) {
      notify(
        `CSV imported successfully. Imported: ${res.data.imported}`,
        "success"
      );
    }

    setShowPreview(false);
    setPreviewRows([]);
    setCsvFile(null);
    fetchFuelReports();

  } catch (err) {
    const status = err.response?.status;
    const data = err.response?.data;

    // 🔴 TOATE RÂNDURILE SUNT DUPLICATE
    if (status === 409) {
      notify(
        "CSV import failed. All rows already exist (duplicate Payment IDs).",
        "error"
      );
    }

    // 🟡 IMPORT PARȚIAL (UNELE DUPLICATE)
    else if (status === 207) {
      notify(
        `CSV partially imported. Imported: ${data.imported}, Skipped: ${data.failed}`,
        "warning"
      );

      setShowPreview(false);
      setPreviewRows([]);
      setCsvFile(null);
      fetchFuelReports();
    }

    // ❌ EROARE REALĂ
    else {
      notify("CSV import failed due to server error.", "error");
      console.error("CSV IMPORT ERROR:", err);
    }
  }
};


  const fetchFuelReports = async () => {
    try {
      const response = await axios.get(`${apiUrl}/fuel-reports`, config);
      setFuelReports(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
     
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFuelData((prev) => ({
        ...prev,
        [name]: value,
        grandTotal:
            name === 'fuelSubtotal' || name === 'otherCosts'
                ? parseFloat(prev.fuelSubtotal || 0) + parseFloat(prev.otherCosts || 0)
                : prev.grandTotal,
    }));
};

useEffect(() => {
  const fuelAmount = fuelData.fuelQuantity * fuelData.fuelPPG;
  const reeferAmount = fuelData.reeferQuantity * fuelData.reeferPPG;

  const total =
    fuelAmount +
    reeferAmount +
    Number(fuelData.defAmount || 0) +
    Number(fuelData.additives || 0) +
    Number(fuelData.oil || 0) +
    Number(fuelData.otherFees || 0) -
    Number(fuelData.discount || 0);

  setFuelData(prev => ({
    ...prev,
    fuelAmount,
    reeferAmount,
    totalToPay: Number(total.toFixed(2))
  }));
}, [
  fuelData.fuelQuantity,
  fuelData.fuelPPG,
  fuelData.reeferQuantity,
  fuelData.reeferPPG,
  fuelData.defAmount,
  fuelData.additives,
  fuelData.oil,
  fuelData.otherFees,
  fuelData.discount
]);


  const addFuelEntry = async () => {
    try {
        const entry = {
            ...fuelData,
            grandTotal: parseFloat(fuelData.fuelSubtotal || 0) + parseFloat(fuelData.otherCosts || 0),
        };

        const response = await axios.post(`${apiUrl}/fuel-reports`, entry, config);
        if (response.status === 201 && response.data?.data) {
            notify('Fuel entry added successfully' , 'success');
            setFuelReports((prev) => [...prev, response.data.data]);
            setFuelData({
                driverId: '',
                truckId: '',
                paymentMethod: '',
                location: '',
                fuelSubtotal: 0,
                otherCosts: 0,
                grandTotal: 0,
            });
        } else {
          notify('Failed to add fuel entry.' , 'error');
        }
    } catch (error) {
  if (error.response?.status === 409) {
    notify(
      "This Payment ID already exists for this client. Entry was not added.",
      "error"
    );
  } else {
    notify("Failed to add fuel entry.", "error");
  }
}

};


  const editFuelEntry = async () => {
    try {
      const response = await axios.put(`${apiUrl}/fuel-reports/${isEditing}`, fuelData, config);
      if (response.status === 200) {
        notify('Fuel entry updated successfully', 'success');
        setFuelReports((prev) =>
          prev.map((entry) => (entry._id === isEditing ? response.data.data : entry))
        );
        setIsEditing(null); // Resetează modul de editare
        setFuelData({
          driverId: '',
          truckId: '',
          paymentMethod: '',
          location: '',
          fuelSubtotal: 0,
          otherCosts: 0,
          grandTotal: 0,
        });
      }
    } catch (error) {
   
     notify('Failed to edit fuel entry.' , 'error');
    }
  };

  const handlePreviewChange = (index, field, value) => {
  setPreviewRows(prev => {
    const updated = [...prev];
    updated[index] = {
      ...updated[index],
      [field]: value
    };

    // recalcul automat total
    const fuelAmount =
      Number(updated[index].fuelQuantity || 0) *
      Number(updated[index].fuelPPG || 0);

    const total =
      fuelAmount +
      Number(updated[index].defAmount || 0) +
      Number(updated[index].reeferAmount || 0) +
      Number(updated[index].additives || 0) +
      Number(updated[index].oil || 0) +
      Number(updated[index].otherFees || 0) -
      Number(updated[index].discount || 0);

    updated[index].fuelAmount = fuelAmount;
    updated[index].totalToPay = Number(total.toFixed(2));

    return updated;
  });
};
  
  const handleEditClick = (entry) => {
    setIsEditing(entry._id); // Setează ID-ul raportului pentru editare
    setFuelData({
      driverId: entry.driverId?._id || '', // ID-ul șoferului
      truckId: entry.truckId?._id || '', // ID-ul camionului
      paymentMethod: entry.paymentMethod || '',
      location: entry.location || '',
      fuelSubtotal: entry.fuelSubtotal || 0,
      otherCosts: entry.otherCosts || 0,
      grandTotal: entry.grandTotal || 0,
      
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  

  const confirmDeleteFuelEntry = async (id) => {
    try {
      await axios.delete(`${apiUrl}/fuel-reports/${id}`, config);
      setFuelReports((prev) => prev.filter((entry) => entry._id !== id));
    } catch (error) {

     notify('Failed to delete fuel entry.' , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascunde notificarea după ștergere
  };
  
  const handleExport = () => {
  const selectedData = fuelReports
    .filter((report) => selectedReports.includes(report._id))
    .map((entry) => {
      const driver = entry.driverId;
      const truck = entry.truckId;

      return {
        "Driver Name": driver
          ? `${driver.firstName} ${driver.lastName}`
          : "",

        "Truck Number": truck?.truckNumber || "",

        "Transaction Date": entry.transactionDate
          ? new Date(entry.transactionDate).toLocaleString()
          : "",

        "Merchant": entry.merchant || "",
        "State": entry.state || "",
        "Location": entry.location || "",

        "Invoice Number": entry.invoiceNumber || "",
        "Card Number": entry.cardNumber || "",
        "Card Name": entry.cardName || "",
        "Payment ID": entry.paymentId || "",

        "Fuel Quantity": Number(entry.fuelQuantity || 0),
        "Fuel PPG": Number(entry.fuelPPG || 0),
        "Fuel Amount": Number(entry.fuelAmount || 0),

        "DEF Quantity": Number(entry.defQuantity || 0),
        "DEF Amount": Number(entry.defAmount || 0),

        "Reefer Quantity": Number(entry.reeferQuantity || 0),
        "Reefer PPG": Number(entry.reeferPPG || 0),
        "Reefer Amount": Number(entry.reeferAmount || 0),

        "Additives": Number(entry.additives || 0),
        "Oil": Number(entry.oil || 0),
        "Other Fees": Number(entry.otherFees || 0),
        "Discount": Number(entry.discount || 0),

        "Total To Pay": Number(entry.totalToPay || 0),

        "Fuel Responsibility":
          entry.fuelResponsibility === "owner"
            ? "Owner Paid"
            : "Company Expense",

        "Fuel Payment Status": entry.fuelPaymentStatus || "open",

        "Created At": entry.createdAt
          ? new Date(entry.createdAt).toLocaleString()
          : ""
      };
    });

  if (selectedData.length === 0) {
    notify("No reports selected for export!", "error");
    return;
  }

  // Total calculation
  const totalAmount = selectedData.reduce(
    (sum, r) => sum + Number(r["Total To Pay"] || 0),
    0
  );

  selectedData.push({
    "Driver Name": "",
    "Truck Number": "",
    "Transaction Date": "",
    "Merchant": "",
    "State": "",
    "Location": "",
    "Invoice Number": "",
    "Card Number": "",
    "Card Name": "",
    "Payment ID": "",
    "Fuel Quantity": "",
    "Fuel PPG": "",
    "Fuel Amount": "",
    "DEF Quantity": "",
    "DEF Amount": "",
    "Reefer Quantity": "",
    "Reefer PPG": "",
    "Reefer Amount": "",
    "Additives": "",
    "Oil": "",
    "Other Fees": "",
    "Discount": "",
    "Total To Pay": totalAmount,
    "Fuel Responsibility": "",
    "Fuel Payment Status": "",
    "Created At": "TOTAL"
  });

  const worksheet = XLSX.utils.json_to_sheet(selectedData, {
    header: [
      "Driver Name",
      "Truck Number",
      "Transaction Date",
      "Merchant",
      "State",
      "Location",
      "Invoice Number",
      "Card Number",
      "Card Name",
      "Payment ID",
      "Fuel Quantity",
      "Fuel PPG",
      "Fuel Amount",
      "DEF Quantity",
      "DEF Amount",
      "Reefer Quantity",
      "Reefer PPG",
      "Reefer Amount",
      "Additives",
      "Oil",
      "Other Fees",
      "Discount",
      "Total To Pay",
      "Fuel Responsibility",
      "Fuel Payment Status",
      "Created At"
    ]
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Fuel Report");

  XLSX.writeFile(workbook, "Fuel_Report_Full_Export.xlsx");
};

  
  

  const handleSelect = (id) => {
    setSelectedReports((prev) =>
      prev.includes(id) ? prev.filter((reportId) => reportId !== id) : [...prev, id]
    );
  };

 const selectAll = () => {
  const filteredIds = filteredReports.map((r) => r._id);

  if (filteredIds.every((id) => selectedReports.includes(id))) {
    // dacă TOATE cele filtrate sunt deja selectate → deselectăm DOAR filtratele
    setSelectedReports((prev) =>
      prev.filter((id) => !filteredIds.includes(id))
    );
  } else {
    // selectăm toate rândurile filtrate
    setSelectedReports((prev) => [
      ...new Set([...prev, ...filteredIds])
    ]);
  }
};

const filteredReports = fuelReports.filter((report) => {
  const driver = drivers.find((d) => String(d._id) === String(report.driverId?._id || report.driverId));
  const truck = trucks.find((t) => String(t._id) === String(report.truckId?._id || report.truckId));

  const matchesSearch =
    (driver ? `${driver.firstName} ${driver.lastName}`.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
    (truck ? truck.truckNumber.toString() : '').includes(searchTerm.toLowerCase()) ||
    report.location.toLowerCase().includes(searchTerm.toLowerCase());

  const matchesDriverFilter = filterDriver ? String(report.driverId?._id || report.driverId) === filterDriver : true;
  const matchesTruckFilter = filterTruck ? String(report.truckId?._id || report.truckId) === filterTruck : true;
const matchesFuelResponsibility =
  fuelResponsibilityFilter
    ? report.fuelResponsibility === fuelResponsibilityFilter
    : true;

  return (
  matchesSearch &&
  matchesDriverFilter &&
  matchesTruckFilter &&
  matchesFuelResponsibility
);

});


  const currentReports = filteredReports.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div
  className={`${styles.fuelReportContainer} ${
    theme === "light" ? styles.fuelReportContainerLight : ""
  }`}
>

      <h2 className={styles.titlefuelReport}>Fuel Report</h2>
      <div className={styles.csvImportBoxfuelReport}>
 {showPreview && (
  <div className={styles.csvPreviewModalfuelReport}>
    <h3>CSV Import Preview</h3>

    <div style={{ overflowX: "auto", maxHeight: "65vh" }}>
  <table className={styles.previewTablefuelReport} style={{ minWidth: "2000px" }}>
    <thead>
  <tr>
    <th>Driver</th>
    <th>Truck</th>
    <th>Date</th>
       <th>Invoice</th>
<th>Card</th>
<th>Card Name</th>
<th>Payment ID</th>
    <th>Merchant</th>
    <th>State</th>
    <th>Fuel Qty</th>
    <th>PPG</th>
    <th>Fuel $</th>
    <th>DEF Qty</th>
    <th>DEF $</th>
    <th>Reefer Qty</th>
    <th>Reefer $</th>
    <th>Additives</th>
    <th>Oil</th>
    <th>Other Fees</th>
    <th>Discount</th>
    <th>Total</th>
    <th>Fuel Type</th>

  </tr>
</thead>

<tbody>
  {previewRows.map((r, i) => {
    const dateValue = r.transactionDate
      ? new Date(r.transactionDate).toISOString().slice(0,16)
      : "";

    return (
      <tr key={i}>
        <td>
          <input
            value={r.driverName || ""}
            onChange={(e) => handlePreviewChange(i, "driverName", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.truckNumber || ""}
            onChange={(e) => handlePreviewChange(i, "truckNumber", e.target.value)}
          />
        </td>

        <td>
          <input
            type="datetime-local"
            value={dateValue}
            onChange={(e) => handlePreviewChange(i, "transactionDate", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.invoiceNumber || ""}
            onChange={(e) => handlePreviewChange(i, "invoiceNumber", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.cardNumber || ""}
            onChange={(e) => handlePreviewChange(i, "cardNumber", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.cardName || ""}
            onChange={(e) => handlePreviewChange(i, "cardName", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.paymentId || ""}
            onChange={(e) => handlePreviewChange(i, "paymentId", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.merchant || ""}
            onChange={(e) => handlePreviewChange(i, "merchant", e.target.value)}
          />
        </td>

        <td>
          <input
            value={r.state || ""}
            onChange={(e) => handlePreviewChange(i, "state", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.fuelQuantity || 0}
            onChange={(e) => handlePreviewChange(i, "fuelQuantity", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.fuelPPG || 0}
            onChange={(e) => handlePreviewChange(i, "fuelPPG", e.target.value)}
          />
        </td>

        <td>${Number(r.fuelAmount || 0).toFixed(2)}</td>

        <td>
          <input
            type="number"
            value={r.defAmount || 0}
            onChange={(e) => handlePreviewChange(i, "defAmount", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.reeferAmount || 0}
            onChange={(e) => handlePreviewChange(i, "reeferAmount", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.additives || 0}
            onChange={(e) => handlePreviewChange(i, "additives", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.oil || 0}
            onChange={(e) => handlePreviewChange(i, "oil", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.otherFees || 0}
            onChange={(e) => handlePreviewChange(i, "otherFees", e.target.value)}
          />
        </td>

        <td>
          <input
            type="number"
            value={r.discount || 0}
            onChange={(e) => handlePreviewChange(i, "discount", e.target.value)}
          />
        </td>

       <td>
  <select
    value={r.fuelResponsibility ?? "company"}
    onChange={(e) => handlePreviewChange(i, "fuelResponsibility", e.target.value)}
  >
    <option value="company">Company</option>
    <option value="owner">Owner</option>
  </select>
</td>
        <td>
          <select
            value={r.fuelResponsibility}
            onChange={(e) => handlePreviewChange(i, "fuelResponsibility", e.target.value)}
          >
            <option value="company">Company</option>
            <option value="owner">Owner</option>
          </select>
        </td>
      </tr>
    );
  })}
</tbody>


    </table>
</div>

    <button onClick={confirmCSVImport}>Confirm Import</button>
    <button onClick={() => setShowPreview(false)}>Cancel</button>
  </div>
)}


  <h3>Import Fuel CSV</h3>

  <input
    type="file"
    accept=".csv"
    onChange={(e) => setCsvFile(e.target.files[0])}
  />

  <button
    onClick={handleCSVImport}
    disabled={importLoading}
    className={styles.submitButtonfuelReport}
  >
    {importLoading ? "Importing..." : "Import CSV"}
  </button>

  {importResult && (
    <div style={{ marginTop: "10px", fontSize: "14px" }}>
      <div>✅ Imported: {importResult.imported}</div>
      <div>❌ Failed: {importResult.failed}</div>
    </div>
  )}
</div>

<div className={styles.formContainerfuelReport}>

<label>Driver</label>
<select
  value={fuelData.driverId}
  onChange={(e) => {
    const driverId = e.target.value;
    const driver = drivers.find(d => d._id === driverId);

    let truckId = '';
    if (driver?.truckNumber) {
      const truck = truckByTruckNumber[driver.truckNumber];
      truckId = truck?._id || '';
    }

    setFuelData(prev => ({
      ...prev,
      driverId,
      truckId
    }));
  }}
  className={styles.customSelectFuelReport}
>
  <option value="">Select Driver</option>
  {drivers.map(d => (
    <option key={d._id} value={d._id}>
      {d.firstName} {d.lastName}
    </option>
  ))}
</select>

<label>Truck (Unit)</label>
<select
  value={fuelData.truckId}
  onChange={(e) => {
    const truckId = e.target.value;
    const truck = trucks.find(t => t._id === truckId);

    let driverId = '';
    if (truck?.truckNumber) {
      const driver = driverByTruckNumber[truck.truckNumber];
      driverId = driver?._id || '';
    }

    setFuelData(prev => ({
      ...prev,
      truckId,
      driverId
    }));
  }}
  className={styles.customSelectFuelReport}
>
  <option value="">Select Truck</option>
  {trucks.map(t => (
    <option key={t._id} value={t._id}>
      {t.truckNumber}
    </option>
  ))}
</select>

  {/* === TRANSACTION INFO === */}
  <label>Transaction Date & Time</label>
  <input
    type="datetime-local"
    name="transactionDate"
    value={fuelData.transactionDate}
    onChange={handleInputChange}
  />

  <label>Merchant</label>
  <input
    type="text"
    name="merchant"
    placeholder="Love’s"
    value={fuelData.merchant}
    onChange={handleInputChange}
  />

  <label>State</label>
  <input
    type="text"
    name="state"
    placeholder="KY"
    value={fuelData.state}
    onChange={handleInputChange}
  />

  <label>Location</label>
  <input
    type="text"
    name="location"
    placeholder="Loves, Shepherdsville, KY"
    value={fuelData.location}
    onChange={handleInputChange}
  />

  <label>Invoice Number</label>
  <input
    type="text"
    name="invoiceNumber"
    value={fuelData.invoiceNumber}
    onChange={handleInputChange}
  />

  <label>Card Number</label>
  <input
    type="text"
    name="cardNumber"
    placeholder="*19765"
    value={fuelData.cardNumber}
    onChange={handleInputChange}
  />

<label>Card Group</label>
<input
  type="text"
  name="cardName"
  placeholder="COMDATA / EFS / WEX"
  value={fuelData.cardName}
  onChange={handleInputChange}
/>

<label>Payment ID</label>
<input
  type="text"
  name="paymentId"
  placeholder="Transaction / Auth ID"
  value={fuelData.paymentId}
  onChange={handleInputChange}
/>

  {/* === FUEL (DEF) === */}
  <label>Fuel Quantity (Gallons)</label>
  <input
    type="number"
    step="0.001"
    name="fuelQuantity"
    value={fuelData.fuelQuantity}
    onChange={handleInputChange}
  />

  <label>Fuel Price per Gallon (PPG)</label>
  <input
    type="number"
    step="0.001"
    name="fuelPPG"
    value={fuelData.fuelPPG}
    onChange={handleInputChange}
  />

  <label>Fuel Amount ($)</label>
  <input
    type="number"
    value={fuelData.fuelAmount}
    readOnly
  />

  {/* === DEF === */}
  <label>DEF Quantity</label>
  <input
    type="number"
    step="0.001"
    name="defQuantity"
    value={fuelData.defQuantity}
    onChange={handleInputChange}
  />

  <label>DEF Amount ($)</label>
  <input
    type="number"
    step="0.01"
    name="defAmount"
    value={fuelData.defAmount}
    onChange={handleInputChange}
  />

  {/* === REEFER === */}
  <label>Reefer Quantity</label>
  <input
    type="number"
    step="0.001"
    name="reeferQuantity"
    value={fuelData.reeferQuantity}
    onChange={handleInputChange}
  />

  <label>Reefer PPG</label>
  <input
    type="number"
    step="0.001"
    name="reeferPPG"
    value={fuelData.reeferPPG}
    onChange={handleInputChange}
  />

  <label>Reefer Amount ($)</label>
  <input
    type="number"
    value={fuelData.reeferAmount}
    readOnly
  />

  {/* === EXTRAS === */}
  <label>Additives</label>
  <input
    type="number"
    step="0.01"
    name="additives"
    value={fuelData.additives}
    onChange={handleInputChange}
  />

  <label>Oil</label>
  <input
    type="number"
    step="0.01"
    name="oil"
    value={fuelData.oil}
    onChange={handleInputChange}
  />

  <label>Other Fees</label>
  <input
    type="number"
    step="0.01"
    name="otherFees"
    value={fuelData.otherFees}
    onChange={handleInputChange}
  />

  <label>Discount</label>
  <input
    type="number"
    step="0.01"
    name="discount"
    value={fuelData.discount}
    onChange={handleInputChange}
  />

  {/* === TOTAL === */}
  <label>Total To Pay ($)</label>
  <input
    type="number"
    value={fuelData.totalToPay}
    readOnly
  />

  <button
    onClick={isEditing ? editFuelEntry : addFuelEntry}
    className={styles.submitButtonfuelReport}
  >
    {isEditing ? 'Update Fuel Entry' : 'Add Fuel Entry'}
  </button>

  {isEditing && (
    <button
      onClick={() => setIsEditing(null)}
      className={styles.cancelButtonfuelReport}
    >
      Cancel
    </button>
  )}
</div>


<div className={styles.buttonGroupfuelReport}>
    <button onClick={handleExport} className={styles.exportButtonfuelReport}>Export to Excel</button>
    <button onClick={selectAll} className={styles.selectAllButtonfuelReport}>Select All</button>
<div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
  <select 
    value={filterDriver} 
    onChange={(e) => setFilterDriver(e.target.value)}
    className={styles.customSelectFuelReport}
  >
    <option value="">Filter by Driver</option>
    {drivers.map((d) => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>

  <select 
    value={filterTruck} 
    onChange={(e) => setFilterTruck(e.target.value)}
    className={styles.customSelectFuelReport}
  >
    <option value="">Filter by Truck</option>
    {trucks.map((t) => (
      <option key={t._id} value={t._id}>
        {t.truckNumber}
      </option>
    ))}
  </select>
</div>

<select
  value={fuelResponsibilityFilter}
  onChange={(e) => setFuelResponsibilityFilter(e.target.value)}
  className={styles.customSelectFuelReport}
>
  <option value="">All Fuel</option>
  <option value="company">Company Fuel</option>
  <option value="owner">Owner Operator Fuel</option>
</select>

</div>
<div className={styles.tableScrollfuelReport}>
<table className={styles.fuelReportTablefuelReport}>
  <thead className={styles.tableHeaderfuelReport}>
    <tr>
      <th>Select</th>
      <th>Driver</th>
      <th>Truck</th>
      <th>Transaction Date</th>

      <th>Merchant</th>
      <th>State</th>
      <th>Location</th>

      <th>Invoice</th>
      <th>Card</th>
      <th>Card Name</th>
      <th>Payment ID</th>

      <th>Fuel Qty</th>
      <th>Fuel PPG</th>
      <th>Fuel $</th>

      <th>DEF Qty</th>
      <th>DEF $</th>

      <th>Reefer Qty</th>
      <th>Reefer PPG</th>
      <th>Reefer $</th>

      <th>Additives</th>
      <th>Oil</th>
      <th>Other Fees</th>
      <th>Discount</th>

      <th>Total</th>
      <th>Fuel Status</th>

      <th>Actions</th>
    </tr>
  </thead>

  <tbody className={styles.tableBodyfuelReport}>
    {currentReports.map((entry) => (
      <tr key={entry._id} className={styles.tableRowfuelReport}>
        <td>
          <input
            type="checkbox"
            checked={selectedReports.includes(entry._id)}
            onChange={() => handleSelect(entry._id)}
          />
        </td>

        <td>
          {entry.driverId
            ? `${entry.driverId.firstName} ${entry.driverId.lastName}`
            : "—"}
        </td>

        <td>{entry.truckId?.truckNumber || "—"}</td>

        <td>
          {entry.transactionDate
            ? new Date(entry.transactionDate).toLocaleString()
            : "—"}
        </td>

        <td>{entry.merchant || "—"}</td>
        <td>{entry.state || "—"}</td>
        <td>{entry.location || "—"}</td>

        <td>{entry.invoiceNumber || "—"}</td>
        <td>{entry.cardNumber || "—"}</td>
        <td>{entry.cardName || "—"}</td>
        <td>{entry.paymentId || "—"}</td>

        <td>{entry.fuelQuantity}</td>
        <td>{entry.fuelPPG}</td>
        <td>${Number(entry.fuelAmount || 0).toFixed(2)}</td>

        <td>{entry.defQuantity}</td>
        <td>${Number(entry.defAmount || 0).toFixed(2)}</td>

        <td>{entry.reeferQuantity}</td>
        <td>{entry.reeferPPG}</td>
        <td>${Number(entry.reeferAmount || 0).toFixed(2)}</td>

        <td>${Number(entry.additives || 0).toFixed(2)}</td>
        <td>${Number(entry.oil || 0).toFixed(2)}</td>
        <td>${Number(entry.otherFees || 0).toFixed(2)}</td>
        <td>${Number(entry.discount || 0).toFixed(2)}</td>

        <td>
          <strong>${Number(entry.totalToPay || 0).toFixed(2)}</strong>
        </td>
<td>
  {entry.fuelResponsibility === 'owner' ? (
    <span style={{ color: '#22c55e', fontWeight: 600 }}>
      Owner Paid
    </span>
  ) : (
    <span style={{ color: '#ef4444', fontWeight: 600 }}>
      Company Expense
    </span>
  )}
</td>

        <td>
          {deleteTarget && (
            <DeleteNotifications
              message="Are you sure you want to delete this fuel report?"
              onConfirm={() => confirmDeleteFuelEntry(deleteTarget)}
              onCancel={() => setDeleteTarget(null)}
            />
          )}

          <button
            onClick={() => handleEditClick(entry)}
            className={styles.editButtonfuelReport}
          >
            Edit
          </button>

          <button
            onClick={() => setDeleteTarget(entry._id)}
            className={styles.deleteButtonfuelReport}
          >
            Delete
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
</div>

      {/* Paginare */}
      <div className={styles.paginationContainerfuelReport}>
  <button 
    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
    className={styles.prevButtonfuelReport}
  >
    Previous
  </button>
  
  <button 
    onClick={() => setCurrentPage((prev) => prev + 1)}
    disabled={currentPage * rowsPerPage >= filteredReports.length}
    className={styles.nextButtonfuelReport}
  >
    Next
  </button>
</div>
    </div>
  );
};


const Invoice = ({ loads, settings, setLoads, drivers, trucks, brokers, consignee, shippers }) => {
  const { notify } = useNotification();
  const [search, setSearch] = useState('');
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [selectedLoads, setSelectedLoads] = useState([]);
  const [invoices, setInvoices] = useState([]); // Starea pentru facturi
  const [showPDFPreview, setShowPDFPreview] = useState(false);
  const [invoiceNotes, setInvoiceNotes] = useState('');
  const [emailDetails, setEmailDetails] = useState({ subject: '', message: '', brokerEmail: '' });
  const [activeTab, setActiveTab] = useState('open'); // 'open' sau 'invoiced'
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const token = sessionStorage.getItem('token');
  const clientId = localStorage.getItem("clientId");
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [editedInvoiceNumber, setEditedInvoiceNumber] = useState("");
const [theme, setTheme] = useState("dark");


  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await axios.get(`${apiUrl}/invoices`, config);
        setInvoices(response.data);
      } catch (error) {
      
       notify('Failed to fetch invoices.', 'error');
      }
    };

    fetchInvoices();
  }, []);

  useEffect(() => {
    if (activeTab === 'open') {
      setFilteredLoads(loads.filter((load) => 
        load.status === "Completed" && 
        !load.isInvoiced &&
        (load.loadNumber?.toLowerCase().includes(search.toLowerCase()) ||
         load.brokerName?.toLowerCase().includes(search.toLowerCase()))
      ));
    } else if (activeTab === 'invoiced') {
      setFilteredLoads(invoices.filter((invoice) => 
        !invoice.isPayed &&  // ✅ doar facturile NE-platite aici
        (invoice.loadNumber?.toLowerCase().includes(search.toLowerCase()) ||
        invoice.brokerName?.toLowerCase().includes(search.toLowerCase()))
      ));
    } else if (activeTab === 'payed') {
   setFilteredLoads(
    invoices
.filter((invoice) => invoice.isPayed === true)
      .filter((invoice) =>
        invoice.loadNumber?.toLowerCase().includes(search.toLowerCase()) ||
        invoice.brokerName?.toLowerCase().includes(search.toLowerCase())
      )
  );
}
  }, [search, loads, invoices, activeTab]);

  
  const handleGenerateInvoice = async () => {
    if (selectedLoads.length === 0) {
       notify("No loads selected for invoicing!" , 'error');
        return;
    }

    try {
        const invoiceResponse = await axios.post(`${apiUrl}/generate-invoice`, {}, config);
        const invoiceNumber = invoiceResponse.data.invoiceNumber;

      const invoicesData = selectedLoads.map(loadId => {
    const load = loads.find(l => l._id === loadId);
    return {
        loadNumber: load.loadNumber || "No data",
        brokerName: load.brokerName || "No data",
        brokerAddress: load.brokerAddress || "No data",
        invoiceNumber: invoiceNumber,
        invoiceDate: new Date(),
        rate: load.rate || 0,
        driverId: load.driver || null,  // 🛑 AICI CORECT: trebuie să pui driverId dacă există!
        shippers: load.shippers || [],
        consignees: load.consignees || [],
        notes: invoiceNotes,
        status: "Pending",
    };
});

        const saveResponse = await axios.post(`${apiUrl}/invoices`, { invoices: invoicesData }, config);
        const savedInvoices = saveResponse.data.invoices;

        setInvoices(prev => [...prev, ...savedInvoices]);
        setSelectedInvoice(savedInvoices[0]); // ✅ Afișează primul invoice generat
        setShowPDFPreview(true);

    } catch (error) {
      
notify("Failed to generate invoice." , 'error');
    }
};

  
  
  const handleSelectLoad = (loadId) => {
    setSelectedLoads((prevSelected) => {
      if (prevSelected.includes(loadId)) {
        return prevSelected.filter((id) => id !== loadId); // 🔹 Elimină dacă era deja selectat
      } else {
        return [...prevSelected, loadId]; // 🔹 Adaugă în selecție
      }
    });
  };
  
  const handleEditInvoiceNumber = (newInvoiceNumber) => {
    setEditedInvoiceNumber(newInvoiceNumber); // 🔄 Doar actualizează state-ul
  };
  
  
  
  const handleClosePDFPreview = () => {
    setShowPDFPreview(false);
  };
  
  const handlePreviewPDF = async () => {
    const loadsToSave = filteredLoads.filter((load) => selectedLoads.includes(load._id));
  
    if (!loadsToSave || loadsToSave.length === 0) {
     notify("No loads selected for invoicing!" , 'error');
      return;
    }
  
    try {
      // ✅ Reîncarcă datele pentru a afișa `invoiceNumber` în PDF
      const response = await axios.get(`${apiUrl}/invoices`, config);
      setInvoices(response.data);
  
      // ✅ Deschide Preview PDF
      setShowPDFPreview(true);
    } catch (error) {
   
     notify("Failed to load updated invoices." , 'error');
    }

  
  
    // ✅ Verifică și salvează `invoiceNumber` în baza de date
    await Promise.all(
      loadsToSave.map(async (load, index) => {
        if (!load.invoiceNumber || load.invoiceNumber.trim() === '') {
          load.invoiceNumber = `INV-${String(invoices.length + index + 1).padStart(4, '0')}`;
        }
  
        // ✅ Trimite doar `invoiceNumber` la backend
        try {
          await axios.put(`${apiUrl}/loads/${load._id}`, { invoiceNumber: load.invoiceNumber }, config);
        } catch (error) {
       
          notify(`Failed to save invoice number for Load ${load.loadNumber}`, 'error');
        }
      })
    );
  
    try {
      // ✅ Reîncarcă datele pentru a afișa `invoiceNumber` în PDF
      const response = await axios.get(`${apiUrl}/invoices`, config);
      setInvoices(response.data);
      setShowPDFPreview(true); // ✅ Deschide `Preview PDF`
    } catch (error) {
   
      notify('Failed to load updated invoices.' , 'error');
    }
  };
  
  const handleSaveInvoice = async () => {
    if (!selectedInvoice) {
        notify("No invoice selected for saving!" , 'error');
        return;
    }

    try {
        const response = await axios.put(`${apiUrl}/invoices/${selectedInvoice._id}`, { isInvoiced: true }, config);

        setInvoices(prevInvoices =>
            prevInvoices.map(inv =>
                inv._id === selectedInvoice._id ? { ...inv, isInvoiced: true } : inv
            )
        );

        setFilteredLoads(prevLoads =>
            prevLoads.filter(load => load._id !== selectedInvoice.loadNumber) // ❌ Elimină din Open
        );

        setShowPDFPreview(false);
        setActiveTab("invoiced"); // ✅ Mută în tab-ul Invoiced
notify("Invoice saved successfully!" , 'success');

    } catch (error) {
      
       notify("Failed to save invoice." , 'error');
    }
};

const handleSaveInvoiceNumber = async () => {
  if (!selectedInvoice?._id) {
   notify("Cannot update invoice: Missing Invoice ID." , 'error');
    return;
  }

  if (!editedInvoiceNumber || editedInvoiceNumber.trim() === "") {
    notify("Invoice Number cannot be empty!" , 'error');
    return;
  }

  try {
    await axios.put(`${apiUrl}/invoices/${selectedInvoice._id}`, { invoiceNumber: editedInvoiceNumber }, config);
    notify("Invoice number updated successfully!" , 'succes');

    setInvoices((prevInvoices) =>
      prevInvoices.map((inv) =>
        inv._id === selectedInvoice._id ? { ...inv, invoiceNumber: editedInvoiceNumber } : inv
      )
    );

    setSelectedInvoice((prevInvoice) => ({
      ...prevInvoice,
      invoiceNumber: editedInvoiceNumber,
    }));

    setShowPDFPreview(true); // ✅ Reafișează Preview PDF

  } catch (error) {

   notify("Failed to update invoice number." , 'error');
  }
};

  
  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };
  
  // Funcție pentru generarea unui PDF Blob și crearea unui URL descărcabil
  const generatePDFBlob = async (PDFContent) => {
    try {
      const blob = await pdf(PDFContent).toBlob();
      return URL.createObjectURL(blob);
    } catch (error) {

      notify("Failed to generate PDF. Please try again." , 'error');
      return null;
    }
  };
  
  // Funcție pentru deschiderea aplicației locale de email
  const openEmailClient = async () => {
    if (selectedLoads.length === 0) {
      notify("No loads selected for sending!" , 'error');
      return;
    }
  
    try {
      const PDFUrl = await generatePDFBlob(PDFContent);
  
      if (!PDFUrl) {
       notify("Unable to generate PDF for email." , 'error');
        return;
      }
  
      const recipient = emailDetails.brokerEmail || ""; // Email-ul brokerului
      const subject = encodeURIComponent(emailDetails.subject || "Invoice Details");
      const body = encodeURIComponent(
        `${emailDetails.message || "Please find the attached invoice."}\n\nDownload the invoice here: ${PDFUrl}`
      );
      const cc = encodeURIComponent(settings.email || ""); // Email-ul companiei clientului
  
      // Construim link-ul pentru `mailto:`
      const mailtoLink = `mailto:${recipient}?subject=${subject}&body=${body}&cc=${cc}`;
  
      // Deschidem aplicația locală de email
      window.location.href = mailtoLink;
  
      // Deschidem PDF-ul într-un tab separat (opțional, pentru transparență)
      window.open(PDFUrl, "_blank");
    } catch (error) {
  
      notify("Failed to open email client. Please try again." , 'error');
    }
  };

const handleMarkAsPayed = async (invoiceId) => {
    try {
await axios.put(`${apiUrl}/invoices/${invoiceId}`, { isPayed: true }, config);
setInvoices((prev) =>
    prev.map((inv) =>
        inv._id === invoiceId ? { ...inv, isPayed: true, status: 'Paid' } : inv
    )
);


      // Scoatem din filteredLoads local ca să dispară instant
      setFilteredLoads((prev) => prev.filter((inv) => inv._id !== invoiceId));
      notify("Invoice marked as Payed successfully!" , 'success');
    } catch (error) {
     
      notify("Failed to mark invoice as Payed." , 'error');
    }
};

  
  const handlePreviewFromTable = (invoice) => {
    setSelectedInvoice(invoice);
    setShowPDFPreview(true);
  };
  
  // Handler principal pentru trimiterea email-ului
  const handleSendEmail = async () => {
    await openEmailClient();
  };
  
  const PDFContent = (() => {
   const selectedLoadObjects =
  activeTab === 'open'
    ? selectedLoads.map((id) => loads.find((load) => load._id === id))
    : [selectedInvoice]; // ✅ aici folosești direct factura selectată!!


  return (
    <Document>
      <Page style={{ padding: 40, fontFamily: 'Helvetica', backgroundColor: '#f8f9fa' }}>
        {/* Header Section */}
        <View style={{ marginBottom: 30 }}>
          <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <View>
              <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#343a40' }}>{settings.companyName}</Text>
              <Text style={{ fontSize: 12, color: '#6c757d' }}>{settings.companyAddress}</Text>
              <Text style={{ fontSize: 12, color: '#6c757d' }}>Phone: {settings.phone}</Text>
              <Text style={{ fontSize: 12, color: '#6c757d' }}>Email: {settings.email}</Text>
            </View>
            <View style={{ textAlign: 'right' }}>
              <Text style={{ fontSize: 16, fontWeight: 'bold', color: '#343a40' }}>Invoice</Text>
              <Text style={{ fontSize: 12, color: '#6c757d' }}>Date: {new Date().toLocaleDateString()}</Text>
           {/* ✅ Afișează corect invoice number */}
           <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#343a40' }}>
                                Invoice Number: {selectedInvoice?.invoiceNumber || 'No data'}
                            </Text>
                        </View>
                    </View>
                </View>

        {/* Bill To Section */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{ fontSize: 14, fontWeight: 'bold', color: '#343a40' }}>Bill To:</Text>
          <Text style={{ fontSize: 12, color: '#6c757d' }}>{selectedLoadObjects[0]?.brokerName || 'Broker Name Missing'}</Text>
          <Text style={{ fontSize: 12, color: '#6c757d' }}>{selectedLoadObjects[0]?.brokerAddress || 'Broker Address Missing'}</Text>
        </View>

        {/* Table Section */}
        <View>
          {/* Table Header */}
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              backgroundColor: '#343a40',
              color: '#ffffff',
              paddingVertical: 8,
              paddingHorizontal: 10,
              borderRadius: 4,
            }}
          >
            <Text style={{ flex: 1, fontSize: 12, fontWeight: 'bold' }}>Qty</Text>
            <Text style={{ flex: 4, fontSize: 12, fontWeight: 'bold' }}>Description</Text>
            <Text style={{ flex: 1, fontSize: 12, fontWeight: 'bold', textAlign: 'right' }}>Unit Price</Text>
            <Text style={{ flex: 1, fontSize: 12, fontWeight: 'bold', textAlign: 'right' }}>Line Price</Text>
          </View>

          {/* Table Rows */}
          {selectedLoadObjects.map((load, index) => (
            <View
              key={load?._id || index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                paddingVertical: 8,
                paddingHorizontal: 10,
                borderBottom: '1px solid #dee2e6',
              }}
            >
              <Text style={{ flex: 1, fontSize: 12 }}>{index + 1}</Text>
             <Text style={{ flex: 4, fontSize: 12 }}>
  {(load?.shippers?.[0]?.address || load?.shipperAddress || 'Pickup Address Missing')} to{' '}
  {(load?.consignees?.[0]?.address || load?.consigneeAddress || 'Delivery Address Missing')}
</Text>

              <Text style={{ flex: 1, fontSize: 12, textAlign: 'right' }}>
                ${load?.rate ? load.rate.toFixed(2) : '0.00'}
              </Text>
              <Text style={{ flex: 1, fontSize: 12, textAlign: 'right' }}>
                ${load?.rate ? load.rate.toFixed(2) : '0.00'}
              </Text>
            </View>
          ))}

          {/* Table Footer */}
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              paddingVertical: 8,
              paddingHorizontal: 10,
              backgroundColor: '#f8f9fa',
              borderTop: '2px solid #343a40',
              marginTop: 10,
            }}
          >
            <Text style={{ flex: 5, fontSize: 12, textAlign: 'right', fontWeight: 'bold', color: '#343a40' }}>
              Total:
            </Text>
            <Text style={{ flex: 1, fontSize: 12, textAlign: 'right', fontWeight: 'bold', color: '#343a40' }}>
              ${selectedLoadObjects.reduce((total, load) => total + (load?.rate || 0), 0).toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Notes Section */}
        <View style={{ marginTop: 20, padding: 10, backgroundColor: '#e9ecef', borderRadius: 4 }}>
          <Text style={{ fontSize: 12, fontWeight: 'bold', color: '#343a40' }}>Notes:</Text>
          <Text style={{ fontSize: 12, color: '#495057' }}>{invoiceNotes || 'No additional notes.'}</Text>
        </View>

        {/* Footer Section */}
        <View style={{ marginTop: 40, textAlign: 'center', color: '#6c757d' }}>
          <Text style={{ fontSize: 12 }}>Thank you for your business!</Text>
          <Text style={{ fontSize: 12 }}>If you have any questions, please contact {settings.email}</Text>
        </View>
      </Page>
    </Document>
  );
})();

  
  
  

  return (
    <div
  className={`${styles.invoiceContainer} ${
    theme === "light" ? styles.invoiceContainerLight : ""
  }`}
>

      <h2>Invoices</h2>
      <div className={styles.invoiceTabs}>
    <button 
        onClick={() => setActiveTab('open')} 
        className={styles.tabButtonInvoice}
    >
        Open Invoice
    </button>
    <button 
        onClick={() => setActiveTab('invoiced')} 
        className={styles.tabButtonInvoice}
    >
        Invoiced
  </button>
  <button 
      onClick={() => setActiveTab('payed')} 
      className={styles.tabButtonInvoice}
  >
      Payed
  </button>
</div>
      <input
        type="text"
        placeholder="Search by Load Number or Broker Name"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInputinvoice}
      />
      <textarea
        placeholder="Add notes to the invoice"
        value={invoiceNotes}
        onChange={(e) => setInvoiceNotes(e.target.value)}
        className={styles.notesInputinvoice}
      />
      <table className={styles.invoiceTableinvoice}>
        <thead>
          <tr>
            <th>Select</th>
            <th>Load</th>
            <th>Status</th>
            <th>Load Number / POD</th>
            <th>Broker Name</th>
            <th>Broker Address</th>
{(activeTab === 'invoiced' || activeTab === 'payed') && <th>Invoice Number</th>}
            <th>Invoice Date</th>
            <th>Rate</th>
            <th>Driver</th>
            <th>Pick Up</th>
            <th>Delivery</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredLoads.map((load, index) => (
            <tr key={load._id}>
           <td>
  <input
    type="checkbox"
    checked={selectedLoads.includes(load._id)} // 🔹 Acum verifică corect selecția
    onChange={() => handleSelectLoad(load._id)}
  />
</td>
              <td>{index + 1}</td>
              <td>{load.status}</td>
              <td>{load.loadNumber}</td>
              <td>{load.brokerName}</td>
              <td>{load.brokerAddress}</td>
              
              {(activeTab === 'invoiced' || activeTab === 'payed') && <td>{load.invoiceNumber || "No data"}</td>}


              <td>{new Date(load.createdAt).toLocaleDateString()}</td>
              <td>{load.rate}</td>
              <td>
  {(() => {
    const driver = drivers.find((d) => d._id === load.driver);
    return driver ? `${driver.firstName} ${driver.lastName}` : 'No data';
  })()}
</td>

              <td>
                {load.shippers.map((shipper, i) => (
                  <div key={i}>{shipper.pickUpTime ? new Date(shipper.pickUpTime).toLocaleDateString() : 'No data'}</div>
                ))}
              </td>
              <td>
                {load.consignees.map((consignee, i) => (
                  <div key={i}>{consignee.deliveryTime ? new Date(consignee.deliveryTime).toLocaleDateString() : 'No data'}</div>
                ))}
              </td>
              
              <td>
  {activeTab === 'open' ? (
    <button
      onClick={() => handleGenerateInvoice(load._id)}
      className={styles.generateInvoiceButton}
    >
      Generate Invoice
    </button>
  ) : activeTab === 'invoiced' ? (
    <>
      <button
        onClick={() => handlePreviewFromTable(load)}
        className={styles.previewPDFButton}
      >
        Preview PDF
      </button>
      <button
        onClick={() => handleMarkAsPayed(load._id)}
        className={styles.payedButton}
      >
        Payed
      </button>
    </>
  ) : (
    <button
      onClick={() => handlePreviewFromTable(load)}
      className={styles.previewPDFButton}
    >
      Preview PDF
    </button>
  )}
</td>

            </tr>
          ))}
        </tbody>
      </table>

      {showPDFPreview && (
  <div className={styles.pdfOverlayinvoice}>
    <div className={styles.pdfViewerContainerinvoice}>
    <PDFViewer width="100%" height="500">
      {PDFContent}
    </PDFViewer>
      {/* ✅ Edit Invoice Number */}
      <div className={styles.invoiceEditContainer}>
  <label>Edit Invoice Number:</label>
  <input
    type="text"
    value={editedInvoiceNumber || selectedInvoice?.invoiceNumber || ""}
    onChange={(e) => handleEditInvoiceNumber(e.target.value)}
  />
  <button 
    onClick={handleSaveInvoiceNumber} 
    className={styles.regenerateInvoiceButton}
>
    Regenerate Invoice
</button>

</div>


      {/* Secțiunea pentru butoane și câmpuri */}
      <div className={styles.pdfActionsInvoiceContainer}>
        <div className={styles.buttonGroupinvoice}>
        <button 
    onClick={handleSaveInvoice} 
    className={styles.saveInvoiceButton}
>
    Save Invoice
</button>

<button 
    onClick={handleClosePDFPreview} 
    className={styles.closePreviewButton}
>
    Close Preview
</button>

<button 
    onClick={handleSendEmail} 
    className={styles.sendEmailButton}
>
    Send via Email
</button>

        </div>

        <div className={styles.emailFieldsinvoice}>
          <input
            type="text"
            placeholder="Email Subject"
            name="subject"
            value={emailDetails.subject}
            onChange={handleEmailChange}
          />
          <textarea
            placeholder="Message"
            name="message"
            value={emailDetails.message}
            onChange={handleEmailChange}
          />
          <input
            type="email"
            placeholder="Broker's Email"
            name="brokerEmail"
            value={emailDetails.brokerEmail}
            onChange={handleEmailChange}
          />
        </div>
      </div>
    </div>
  </div>
)}
 </div>
  );
};


const ReceivedInvoices = () => {
  const { notify } = useNotification();
const [activeTab, setActiveTab] = useState('archiving');
const [recordedInvoices, setRecordedInvoices] = useState([]);
const [paidInvoices, setPaidInvoices] = useState([]);
const [editingInvoice, setEditingInvoice] = useState(false);
const [editedInvoice, setEditedInvoice] = useState({});
const [showConfirmation, setShowConfirmation] = useState(false);
const [selectedRecordedInvoice, setSelectedRecordedInvoice] = useState(null);
const [theme, setTheme] = useState("dark");

const [selectedPaidInvoice, setSelectedPaidInvoice] = useState(null);
  const [pdfQueue, setPdfQueue] = useState([]); // o listă cu TOATE fișierele uploadate
const currentPdf = pdfQueue[0] || null; // fișierul curent
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: '',
    invoiceDate: '',
    internalInvoiceNumber: '',
    companyName: '',
    companyAddress: '',
    mcNumber: '',
    description: '',
    rate: '',
    dueDate: '',
    earlyPaymentDiscount: 'No',
    paymentMethod: '',
    status: 'Pending',
  });

  const [pdfUrl, setPdfUrl] = useState(null);
  const [currentPickingField, setCurrentPickingField] = useState(null);
  const iframeRef = useRef(null);

  const [leftWidth, setLeftWidth] = useState(50);
  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const newQueue = files.map(file => ({
        file,
        url: URL.createObjectURL(file),
      }));
      setPdfQueue(prev => [...prev, ...newQueue]); // adaugă la coadă
    }
  };
  
  const handleMouseUp = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const selectedText = iframe.contentWindow?.getSelection()?.toString().trim();
    if (selectedText && currentPickingField) {
      setInvoiceData((prev) => ({
        ...prev,
        [currentPickingField]: selectedText,
      }));
      const input = document.querySelector(`input[name="${currentPickingField}"], select[name="${currentPickingField}"]`);
      if (input) {
        input.focus();
        input.select?.();
      }
    }
  };

  useEffect(() => {
    if (!pdfUrl || !iframeRef.current) return;
    const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow?.document;
    iframeDoc?.addEventListener('mouseup', handleMouseUp);
    return () => {
      iframeDoc?.removeEventListener('mouseup', handleMouseUp);
    };
  }, [pdfUrl, currentPickingField]);

  const handleRecordInvoice = async () => {
    try {
      await axios.post(`${apiUrl}/received-invoices`, invoiceData, config);
      notify('Invoice recorded successfully!' , 'success');
  
      // Reset formular și trece la următorul PDF
      setInvoiceData({
        invoiceNumber: '',
        invoiceDate: '',
        internalInvoiceNumber: '',
        companyName: '',
        companyAddress: '',
        mcNumber: '',
        description: '',
        rate: '',
        dueDate: '',
        earlyPaymentDiscount: 'No',
        paymentMethod: '',
        status: 'Recorded',
      });
      setPdfQueue(prev => prev.slice(1)); // scoate primul PDF din coadă (next!)
  
    } catch (err) {
   
      notify('Failed to record invoice.' , 'error');
    }
  };
  
  const resetInvoiceAndNext = () => {
    setInvoiceData({
      invoiceNumber: '',
      invoiceDate: '',
      internalInvoiceNumber: '',
      companyName: '',
      companyAddress: '',
      mcNumber: '',
      description: '',
      rate: '',
      dueDate: '',
      earlyPaymentDiscount: 'No',
      paymentMethod: '',
      status: 'Pending',
    });
    setPdfQueue(prev => prev.slice(1)); // scoate primul PDF
  };
  
  const fetchPaidInvoices = async () => {
    try {
      const response = await axios.get(`${apiUrl}/received-invoices`, config);
      const onlyPaid = response.data.filter(inv => inv.status === 'Paid');
      setPaidInvoices(onlyPaid);
    } catch (err) {
     
    }
  };
  
  // Split logic
  const startDragging = (e) => {
    e.preventDefault();
    document.addEventListener('mousemove', onDragging);
    document.addEventListener('mouseup', stopDragging);
  };

  const onDragging = (e) => {
    const container = document.querySelector(`.${styles.archivingSection}`);
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const newLeftWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;
    if (newLeftWidth > 10 && newLeftWidth < 90) {
      setLeftWidth(newLeftWidth);
    }
  };

  const stopDragging = () => {
    document.removeEventListener('mousemove', onDragging);
    document.removeEventListener('mouseup', stopDragging);
  };
  useEffect(() => {
    if (activeTab === 'recorded') {
      fetchRecordedInvoices();
    }
    if (activeTab === 'paid') {
      fetchPaidInvoices();
    }
  }, [activeTab]);
  
  
  const fetchRecordedInvoices = async () => {
    try {
      const response = await axios.get(`${apiUrl}/received-invoices`, config);
      const onlyRecorded = response.data.filter(inv => inv.status === 'Recorded');
      setRecordedInvoices(onlyRecorded);
    } catch (err) {
   
    }
  };
  
  return (
    <div
  className={`${styles.receivedInvoicesContainer} ${
    theme === "light" ? styles.receivedInvoicesContainerLight : ""
  }`}
>

      <h2>Received Invoices</h2>

      {/* Tab buttons */}
      <div className={styles.tabButtons}>
        {['archiving', 'recorded', 'paid'].map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? styles.activeTab : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {activeTab === 'paid' && (
  <div className={styles.paidSection}>
    {selectedPaidInvoice  ? (
      <div className={styles.invoiceDetailContainer}>
        <h3>Paid Invoice Details</h3>
        {Object.entries(selectedPaidInvoice).map(([key, value]) => {
          if (['_id', 'clientId', '__v', 'createdAt'].includes(key)) return null;
          const niceLabel = key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase());
          return (
            <div key={key} className={styles.invoiceDetailRow}>
              <strong>{niceLabel}:</strong>{' '}
              <span>{value ?? '-'}</span>
            </div>
          );
        })}
        {selectedPaidInvoice.paidAt && (
          <div className={styles.invoiceDetailRow}>
            <strong>Paid At:</strong>{' '}
            <span>{new Date(selectedPaidInvoice.paidAt).toLocaleString()}</span>
          </div>
        )}
        <div className={styles.buttonsRowInvoice}>
          <button
            className={styles.skipButtonInvoiced}
            onClick={() => setSelectedPaidInvoice(null)}
          >
            Close
          </button>
        </div>
      </div>
    ) : (
      <table className={styles.invoiceTable}>
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Company</th>
            <th>Amount</th>
            <th>Paid At</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {paidInvoices.map(inv => (
            <tr
              key={inv._id}
              className={`${styles.invoiceRow} ${styles.paidRow}`} // 👈 îi dai și clasa paidRow pentru stil verde
              onClick={() => setSelectedPaidInvoice(inv)}
            >
              <td>{inv.invoiceNumber}</td>
              <td>{inv.companyName}</td>
              <td>${inv.rate}</td>
              <td>{inv.paidAt ? new Date(inv.paidAt).toLocaleDateString() : 'No data'}</td>
              <td>{inv.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}

      {activeTab === 'recorded' && (
  <div className={styles.recordedSection}>
    {selectedRecordedInvoice ? (
    <div className={styles.invoiceDetailContainer}>
    <div className={styles.headerRowRinvoice}>
      <h3>Invoice Details</h3>
      <button
        className={styles.closeButtonRinvoice}
        onClick={() => {
          setSelectedRecordedInvoice(null);
          setEditingInvoice(false);
          setShowConfirmation(false);
        }}
      >
        ❌
      </button>
    </div>
  

        {Object.entries(selectedRecordedInvoice).map(([key, value]) => {
          if (['_id', 'clientId', '__v', 'createdAt'].includes(key)) return null;
          const niceLabel = key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase());
          return (
            <div key={key} className={styles.invoiceDetailRow}>
              <strong>{niceLabel}:</strong>{' '}
              {editingInvoice ? (
                <input
                  type="text"
                  value={editedInvoice[key] ?? ''}
                  onChange={e =>
                    setEditedInvoice(prev => ({
                      ...prev,
                      [key]: e.target.value,
                    }))
                  }
                />
              ) : (
                <span>{value ?? '-'}</span>
              )}
            </div>
          );
        })}

        <div className={styles.buttonsRowInvoice}>
          {!showConfirmation && (
            <>
              <button
                className={styles.recordButton}
                onClick={() => {
                  setEditedInvoice(selectedRecordedInvoice);
                  setEditingInvoice(prev => !prev); // toggle edit ON/OFF
                }}
              >
                {editingInvoice ? 'Cancel Edit' : 'Edit'}
              </button>

              <button
                className={styles.recordButton}
                onClick={async () => {
                  if (editingInvoice) {
                    try {
                      await axios.put(
                        `${apiUrl}/received-invoices/${selectedRecordedInvoice._id}`,
                        editedInvoice,
                        config
                      );
                      notify('Invoice updated successfully!' , 'succes');
                      setSelectedRecordedInvoice(prev => ({
                        ...prev,
                        ...editedInvoice,
                      }));
                      setEditingInvoice(false);
                    } catch (err) {
                    
                     notify('Failed to update invoice.' , 'error');
                      return; // nu continuăm dacă fail
                    }
                  }
                  setShowConfirmation(true); // show confirmation după edit (sau direct dacă nu editezi)
                }}
              >
                Next
              </button>
            </>
          )}

          {showConfirmation && (
            <>
              <h4>Are you sure you want to mark this invoice as Paid?</h4>
              <button
                className={styles.skipButtonInvoiced}
                onClick={() => {
                  setShowConfirmation(false);
                  setEditingInvoice(false);
                }}
              >
                No
              </button>
              <button
                className={styles.recordButton}
                onClick={async () => {
                  try {
                    await axios.put(
                      `${apiUrl}/received-invoices/${selectedRecordedInvoice._id}/mark-paid`,
                      {},
                      config
                    );
                    notify('Invoice marked as paid!' , 'success');
                    setSelectedRecordedInvoice(null);
                    setEditingInvoice(false);
                    setShowConfirmation(false);
                    fetchRecordedInvoices();
                  } catch (err) {
                    
                    notify('Failed to mark as paid.' , 'error');
                  }
                }}
              >
                Yes
              </button>
            </>
          )}
        </div>
      </div>
    ) : (
      <table className={styles.invoiceTable}>
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Company</th>
            <th>Amount</th>
            <th>Due Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {recordedInvoices.map(inv => {
            const dueDate = new Date(inv.dueDate);
            const daysLeft = Math.ceil((dueDate - new Date()) / (1000 * 60 * 60 * 24));

            return (
              <tr
                key={inv._id}
                className={styles.invoiceRow}
                onClick={() => {
                  setSelectedRecordedInvoice(inv);
                  setShowConfirmation(false);
                  setEditingInvoice(false);
                }}
              >
                <td>{inv.invoiceNumber}</td>
                <td>{inv.companyName}</td>
                <td>${inv.rate}</td>
                <td>
                  {inv.dueDate ? new Date(inv.dueDate).toLocaleDateString() : 'No data'}
                  {daysLeft <= 3 && (
                    <span className={styles.expiringBadge}>
                      ⚠️ Expiring Soon
                    </span>
                  )}
                </td>
                <td>{inv.status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )}
  </div>
)}

      {activeTab === 'archiving' && (
        <div className={styles.archivingSection}>
          {/* Left (inputs) */}
          <div
            className={styles.leftFormContainerInvoice}
            style={{ width: `calc(${leftWidth}% - 3px)` }}
          >
            {[ 
              { label: 'Invoice Number', name: 'invoiceNumber', type: 'text' },
              { label: 'Invoice Date', name: 'invoiceDate', type: 'date' },
              { label: 'Internal Invoice Number', name: 'internalInvoiceNumber', type: 'text' },
              { label: 'Company Name', name: 'companyName', type: 'text' },
              { label: 'Company Address', name: 'companyAddress', type: 'text' },
              { label: 'MC Number', name: 'mcNumber', type: 'text' },
              { label: 'Description', name: 'description', type: 'text' },
              { label: 'Rate', name: 'rate', type: 'number' },
              { label: 'Due Date', name: 'dueDate', type: 'date' },
            ].map(({ label, name, type }) => (
              <div className={styles.formGroupInvoiced} key={name}>
                <label>{label}</label>
                <input
                  type={type}
                  name={name}
                  value={invoiceData[name]}
                  onChange={handleChange}
                  onClick={() => setCurrentPickingField(name)}
                  placeholder={label}
                  style={{
                    outline: currentPickingField === name ? '2px solid #00c6ff' : undefined,
                    boxShadow: currentPickingField === name ? '0 0 8px #00c6ff' : undefined,
                    transition: 'all 0.3s ease-in-out',
                  }}
                />
              </div>
            ))}

            <div className={styles.formGroupInvoiced}>
              <label>Early Payment Discount</label>
              <select
                name="earlyPaymentDiscount"
                value={invoiceData.earlyPaymentDiscount}
                onChange={handleChange}
                onClick={() => setCurrentPickingField('earlyPaymentDiscount')}
                style={{
                  outline: currentPickingField === 'earlyPaymentDiscount' ? '2px solid #00c6ff' : undefined,
                  boxShadow: currentPickingField === 'earlyPaymentDiscount' ? '0 0 8px #00c6ff' : undefined,
                }}
              >
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>

            <div className={styles.formGroupInvoiced}>
              <label>Payment Method</label>
              <select
                name="paymentMethod"
                value={invoiceData.paymentMethod}
                onChange={handleChange}
                onClick={() => setCurrentPickingField('paymentMethod')}
                style={{
                  outline: currentPickingField === 'paymentMethod' ? '2px solid #00c6ff' : undefined,
                  boxShadow: currentPickingField === 'paymentMethod' ? '0 0 8px #00c6ff' : undefined,
                }}
              >
                <option value="">Select Method</option>
                <option value="Wire">Wire</option>
                <option value="ACH">ACH</option>
                <option value="Check">Check</option>
                <option value="Credit Card">Credit Card</option>
              </select>
            </div>
            <div className={styles.buttonsRowInvoice}>
  <button
    onClick={() => {
      resetInvoiceAndNext();
    notify('Invoice skipped.' , 'succes');
    }}
    className={styles.skipButtonInvoiced}
  >
    Skip Invoice
  </button>

  <button onClick={handleRecordInvoice} className={styles.recordButton}>
    Record Invoice
  </button>
</div>

          </div>
         

          {/* Splitter */}
          <div
            className={styles.splitterInvoice}
            onMouseDown={startDragging}
            style={{ left: `calc(${leftWidth}% - 3px)` }}
          ></div>

          {/* Right (PDF upload + viewer) */}
          <div
            className={styles.rightPdfContainerInvoice}
            style={{ width: `calc(${100 - leftWidth}% - 3px)` }}
          >
       {!currentPdf ? (
  <div className={styles.uploadAreaInvoice}>
    <p>Upload Invoice PDFs</p>
    <input
      type="file"
      accept="application/pdf"
      multiple
      onChange={handleFileUpload}
      className={styles.pdfUploadInput}
    />
  </div>
) : (
  <PdfViewerWithSelect
    fileUrl={currentPdf.url}
    onSelectText={(selectedText) => {
      if (!currentPickingField) return;
      setInvoiceData((prev) => ({
        ...prev,
        [currentPickingField]: selectedText,
      }));

      const input = document.querySelector(
        `input[name="${currentPickingField}"], select[name="${currentPickingField}"]`
      );
      if (input) {
        input.focus();
        input.select?.();
      }
    }}
  />
)}

          </div>
        </div>
      )}
    </div>
  );
};


const BalanceSheet = () => {
  const { notify } = useNotification();
const [loads, setLoads] = useState([]);
const [invoices, setInvoices] = useState([]);
const [receivedInvoices, setReceivedInvoices] = useState([]);
const [fuelReports, setFuelReports] = useState([]);
const [driverPays, setDriverPays] = useState([]);
const [totalPays, setTotalPays] = useState([]);
const [ifta, setIfta] = useState([]);
const [trucks, setTrucks] = useState([]);
const [trailers, setTrailers] = useState([]);
  const [manualAssets, setManualAssets] = useState([]);
  const [manualLiabilities, setManualLiabilities] = useState([]);
  const [manualExpenses, setManualExpenses] = useState([]);
  const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
  const [manualIncome, setManualIncome] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
const [balanceData, setBalanceData] = useState(null);
const [theme, setTheme] = useState("dark");

useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const handleAdd = (section) => {
    const name = prompt('Enter description:');
    const value = parseFloat(prompt('Enter value:'));
    if (!name || isNaN(value)) {
      notify('Invalid input.' , 'error');
      return;
    }
    const newItem = { name, value };
    if (section === 'assets') setManualAssets([...manualAssets, newItem]);
    if (section === 'liabilities') setManualLiabilities([...manualLiabilities, newItem]);
    if (section === 'expenses') setManualExpenses([...manualExpenses, newItem]);
    if (section === 'income') setManualIncome([...manualIncome, newItem]);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 2000);
  };

  const sumSection = (arr) => arr.reduce((sum, item) => sum + (item.value || 0), 0);

 const exportFullDetailsToExcel = async () => {
  const token = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const query = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : '';

  try {
    const res = await axios.get(`${apiUrl}/balance-sheet/full-details${query}`, config);
    const data = res.data;
    const wb = XLSX.utils.book_new();

    const formatDate = (date) => {
      if (!date) return '';
      const d = new Date(date);
      return d.toISOString().split('T')[0];
    };

    const sanitizeItem = (item, context) => {
      const clean = {};
      for (let key in item) {
        if (
          key === '_id' ||
          key === 'id' ||
          key === 'clientId' ||
          key === '__v' ||
          key === 'socketId' ||
          key === 'expoPushToken' ||
          key === 'password' ||
          key === 'consignees' ||
          key === 'shippers' ||
          key === 'paymentStatus'
        ) continue;

        const value = item[key];

        if (key === 'createdAt' || key === 'pickUpTime' || key === 'deliveryTime') {
          clean[key] = formatDate(value);
        } else if (key === 'driver' && context === 'loads' && value && typeof value === 'object') {
          clean.driver = `${value.firstName || ''} ${value.lastName || ''}`.trim();
        } else if (key === 'truck' && context === 'loads' && value && typeof value === 'object') {
          clean.truck = value.truckNumber || '';
        } else if (typeof value !== 'object') {
          clean[key] = value;
        }
      }
      return clean;
    };

 const addSheet = (title, items, context = '') => {
  if (!items || !items.length) return;

  const sanitized = items.map(item => sanitizeItem(item, context));
  const headers = Object.keys(sanitized[0]);
  const sheetData = [headers];
  sanitized.forEach(item => {
    sheetData.push(headers.map(h => item[h] ?? ''));
  });

  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  // ✅ Stil pentru antet (header row)
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    const cell = ws[cellAddress];
    if (cell) {
      cell.s = {
        fill: { fgColor: { rgb: "D9D9D9" } }, // gri deschis
        font: { bold: true, color: { rgb: "000000" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "medium", color: { rgb: "000000" } },
          bottom: { style: "medium", color: { rgb: "000000" } },
        },
      };
    }
  }

  // ✅ Dimensiuni coloane — mai largi pentru text, mai înguste pentru rate/date
  ws['!cols'] = headers.map(header => {
    const lower = header.toLowerCase();
    if (lower.includes('rate') || lower.includes('amount') || lower.includes('date')) {
      return { wch: 14 };
    } else if (lower.includes('note') || lower.includes('description') || lower.includes('truck') || lower.includes('driver') || lower.includes('name')) {
      return { wch: 28 };
    } else {
      return { wch: 20 };
    }
  });

  XLSX.utils.book_append_sheet(wb, ws, title);
};

    addSheet("Loads", data.loads, 'loads');
    addSheet("Invoices", data.invoices);
    addSheet("ReceivedInvoices", data.receivedInvoices);
    addSheet("IFTA", data.ifta);
    addSheet("FuelReports", data.fuelReports);
    addSheet("DriverPays", data.driverPays);
    addSheet("Employees", data.employees);
    addSheet("Trucks", data.trucks);
    addSheet("Trailers", data.trailers);

    XLSX.writeFile(wb, `Balance_Sheet_Full_${Date.now()}.xlsx`);
  } catch (err) {

notify("Export failed." , 'error');
  }
};



const totalAssets = () => {
  const trucksTotal = balanceData?.trucksTotalCost || 0;
  const trailersTotal = balanceData?.trailersTotalCost || 0;
  const receivedPaid = balanceData?.receivedPaidTotal || 0;
  return (
   
    trucksTotal +
    trailersTotal +
    receivedPaid +
    sumSection(manualAssets)
  ).toFixed(2);
};


const totalLiabilities = () => {
  const brokerDebts = balanceData?.liabilitiesTotal || 0;
  const iftaTaxes = balanceData?.iftaTotal || 0;
  return (brokerDebts + iftaTaxes + sumSection(manualLiabilities)).toFixed(2);
};

const totalExpenses = () => {
  const driverPay = balanceData?.driverPayTotal || 0;
  const employerPayroll = balanceData?.employerPayrollTotal || 0;
  const fuel = balanceData?.fuelTotal || 0;
  return (driverPay + employerPayroll + fuel + sumSection(manualExpenses)).toFixed(2);
};

const totalIncome = () => {
  const openInvoices = balanceData?.openInvoicesTotal || 0;
  const invoicedUnpaid = balanceData?.invoicedUnpaidTotal || 0;
  const paidInvoices = balanceData?.paidInvoicesTotal || 0;
  return (openInvoices + invoicedUnpaid + paidInvoices + sumSection(manualIncome)).toFixed(2);
};

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text('Balance Sheet Report', 14, 15);

    const sections = [
      { title: 'Assets', data: getAssetsData() },
      { title: 'Liabilities', data: getLiabilitiesData() },
      { title: 'Expenses', data: getExpensesData() },
      { title: 'Income', data: getIncomeData() },
    ];

    let finalY = 25;
    sections.forEach(section => {
      doc.setFontSize(12);
      doc.text(section.title, 14, finalY);
      doc.autoTable({
        startY: finalY + 5,
        head: [['Description', 'Amount']],
        body: section.data.map(item => [item.name, `$${parseFloat(item.value).toFixed(2)}`]),
      });
      finalY = doc.lastAutoTable.finalY + 10;
    });

    doc.save(`Balance_Sheet_${Date.now()}.pdf`);
  };
const fetchBalanceSheet = async () => {
  const token = sessionStorage.getItem('token');
  const config = { headers: { Authorization: `Bearer ${token}` } };
  const query =
    startDate && endDate
      ? `?startDate=${startDate}&endDate=${endDate}`
      : '';

  try {
    const res = await axios.get(`${apiUrl}/balance-sheet/summary${query}`, config);
    setBalanceData(res.data);
  } catch (error) {
   
  }
};

// IAR AICI DOAR O APELI
useEffect(() => {
  fetchBalanceSheet();
}, []);

  const exportToExcel = () => {
    const data = [
      { section: 'Assets', data: getAssetsData() },
      { section: 'Liabilities', data: getLiabilitiesData() },
      { section: 'Expenses', data: getExpensesData() },
      { section: 'Income', data: getIncomeData() },
    ];

    const wsData = [];
    data.forEach(section => {
      wsData.push([section.section]);
      wsData.push(['Description', 'Amount']);
      section.data.forEach(item => {
        wsData.push([item.name, item.value]);
      });
      wsData.push([]);
    });

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Balance Sheet');
    XLSX.writeFile(wb, `Balance_Sheet_${Date.now()}.xlsx`);
  };

const getAssetsData = () => {
  if (!balanceData) return [];
  return [
    { name: 'Received Invoices Paid', value: balanceData.receivedPaidTotal || 0 },
    { name: 'Trucks (Total Costs)', value: balanceData.trucksTotalCost || 0 },
    { name: 'Trailers (Total Costs)', value: balanceData.trailersTotalCost || 0 },
    ...manualAssets,
  ];
};


const getLiabilitiesData = () => {
  if (!balanceData) return [];
  return [
    { name: 'Received Invoices (Recorded)', value: balanceData.liabilitiesTotal || 0 },
    { name: 'IFTA (Unpaid)', value: balanceData.iftaUnpaidTotal || 0 },
    ...manualLiabilities,
  ];
};



const getExpensesData = () => {
  if (!balanceData) return [];
  return [
    { name: 'Driver Payroll', value: balanceData.driverPayTotal || 0 },
    { name: 'Employer Payroll', value: balanceData.employerPayrollTotal || 0 },
    { name: 'Fuel Reports', value: balanceData.fuelTotal || 0 },
    { name: 'IFTA (Paid)', value: balanceData.iftaPaidTotal || 0 },
    ...manualExpenses,
  ];
};


const getIncomeData = () => {
  if (!balanceData) return [];
  return [
    { name: 'Invoices Paid', value: balanceData.paidInvoicesTotal || 0 },
    { name: 'Paid Loads (Direct)', value: balanceData.incomeLoadsTotal || 0 },
    { name: 'Invoices Invoiced (Unpaid)', value: balanceData.invoicedUnpaidTotal || 0 },
    { name: 'Invoices Open (Not Invoiced)', value: balanceData.openInvoicesTotal || 0 },
    ...manualIncome,
  ];
};

const totalIncomePaid = () => {
  const paidInvoices = balanceData?.paidInvoicesTotal || 0;
  const paidLoads = balanceData?.incomeLoadsTotal || 0;
  return (paidInvoices + paidLoads + sumSection(manualIncome)).toFixed(2);
};

const totalIncomeUnpaid = () => {
  const invoicedUnpaid = balanceData?.invoicedUnpaidTotal || 0;
  const openInvoices = balanceData?.openInvoicesTotal || 0;
  return (invoicedUnpaid + openInvoices).toFixed(2);
};

const calculateNetBalance = () => {
  if (!balanceData) return 0;

  const assets =
    (balanceData.receivedPaidTotal || 0) +
    (balanceData.trucksTotalCost || 0) +
    (balanceData.trailersTotalCost || 0) +
    sumSection(manualAssets);

  const liabilities =
    (balanceData.liabilitiesTotal || 0) +
    (balanceData.iftaUnpaidTotal || 0) +
    sumSection(manualLiabilities);

  const expenses =
    (balanceData.driverPayTotal || 0) +
    (balanceData.employerPayrollTotal || 0) +
    (balanceData.fuelTotal || 0) +
    sumSection(manualExpenses);

  const income = Number(totalIncomePaid());

  return (assets + income) - (liabilities + expenses);
};

const calculateProjectedBalance = () => {
  if (!balanceData) return 0;
  const unpaid =
    (balanceData.openInvoicesTotal || 0) +
    (balanceData.invoicedUnpaidTotal || 0);
  return calculateNetBalance() + unpaid;
};



  return (
    <div
  className={`${styles.balanceSheetWrapper} ${
    theme === "light" ? styles.balanceSheetWrapperLight : ""
  }`}
>

      <h2 className={styles.balanceSheetTitle}>Balance Sheet</h2>

      {showSuccess && (
        <div className={styles.balanceSheetSuccess}>
          Manual entry added successfully!
        </div>
      )}
<div
  className={`${styles.dateFilterRowBalanceSheet} ${
    theme === "light" ? styles.dateFilterRowBalanceSheetLight : ""
  }`}
>

  <label>
    Start Date:
    <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
  </label>
  <label>
    End Date:
    <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
  </label>
  <button onClick={fetchBalanceSheet} className={styles.refreshButtonNalanceSheet}>
    Refresh
  </button>
</div>


      {['assets', 'liabilities', 'expenses', 'income'].map((section) => (
        <div key={section} className={styles.balanceSheetSection}>
          <h3 className={styles.balanceSheetSectionTitle}>{section.charAt(0).toUpperCase() + section.slice(1)}</h3>
          <ul className={styles.balanceSheetList}>
            {section === 'assets' && getAssetsData().map((item, idx) => (
              <li key={idx}>{item.name}: <strong>${parseFloat(item.value).toFixed(2)}</strong></li>
            ))}
            {section === 'liabilities' && getLiabilitiesData().map((item, idx) => (
              <li key={idx}>{item.name}: <strong>${parseFloat(item.value).toFixed(2)}</strong></li>
            ))}
            {section === 'expenses' && getExpensesData().map((item, idx) => (
              <li key={idx}>{item.name}: <strong>${parseFloat(item.value).toFixed(2)}</strong></li>
            ))}
            {section === 'income' && getIncomeData().map((item, idx) => (
              <li key={idx}>{item.name}: <strong>${parseFloat(item.value).toFixed(2)}</strong></li>
            ))}
          </ul>
          <p className={styles.balanceSheetTotal}>
            <strong>Total: $
              {section === 'assets' ? totalAssets() :
                section === 'liabilities' ? totalLiabilities() :
                  section === 'expenses' ? totalExpenses() :
                    totalIncome()
              }
            </strong>
        
          </p>

        </div>
      ))}
<p className={styles.balanceSheetNet}>
  <strong> Net Balance (Now): {
    calculateNetBalance() >= 0
      ? `+ $${calculateNetBalance().toFixed(2)}`
      : `- $${Math.abs(calculateNetBalance()).toFixed(2)}`
  }</strong>
</p>

<p className={styles.balanceSheetNetProjected}>
  <strong>Projected Balance (If All Paid): + ${calculateProjectedBalance().toFixed(2)}</strong>
</p>

<p className={styles.balanceSheetSubTotals}>
  <strong> Paid Income Total: $ {totalIncomePaid()}</strong><br />
  <strong>Unpaid Income Expected: $ {totalIncomeUnpaid()}</strong>
</p>


      <div className={styles.balanceSheetActionsRow}>
        <button className={styles.balanceSheetExportButton} onClick={exportToPDF}>Export to PDF</button>
        <button className={styles.balanceSheetExportButton} onClick={exportToExcel}>Export to Excel</button>
        <button onClick={exportFullDetailsToExcel} className={styles.balanceSheetExportButton}>
   Export Explicit
</button>

      </div>
    </div>
  );
};

const WEEK_DAYS = [
  "Monday", "Tuesday", "Wednesday",
  "Thursday", "Friday", "Saturday", "Sunday"
];
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];


const TruckAndTrailers = () => {
  const { notify } = useNotification();
  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  const [theme, setTheme] = useState("dark");
  const [trucks, setTrucks] = useState([]);
  const [trailers, setTrailers] = useState([]);
  const [selectedTruck, setSelectedTruck] = useState("");
  const [selectedTrailer, setSelectedTrailer] = useState("");
  const [showReports, setShowReports] = useState(false);
  const [assetCosts, setAssetCosts] = useState([]);
  const [loadingReports, setLoadingReports] = useState(false);
const [selectedCost, setSelectedCost] = useState(null);
const [showPaymentsModal, setShowPaymentsModal] = useState(false);
const [drivers, setDrivers] = useState([]);
const [selectedDriver, setSelectedDriver] = useState("");
const isDriver = Boolean(selectedDriver);
  const isCostFullyPaid = (c) => {
  if (!c || !c.installments) return false;
  if (c.installments.total === Infinity) return false;
  return c.installments.paid >= c.installments.total;
};
const fullyPaid = selectedCost ? isCostFullyPaid(selectedCost) : false;

const [costData, setCostData] = useState({
   type: "deduction",
  category: "",
  vendor: "",
  description: "",
  amount: "",

  paymentType: "one_time",

  repeatInterval: 1,
  repeatUnit: "week",

  onWeekDay: "",
  onMonthDay: "",
  onYearMonth: "",
  onYearDay: "",

  occurrences: 1,
  forever: false, 

  startDate: "",
  endDate: "",

  bankName: "",
  iban: "",
  bic: "",
  reference: "",
  status: "planned",
  notes: "",
});


const formatRecurrence = (c) => {


  // One-time OR broken legacy data
  if (
    c.paymentType !== "recurring" ||
    !c.recurrence ||
    !c.recurrence.every
  ) {
    return "One-time";
  }

  const every = c.recurrence.every;
  const on = c.recurrence.on || {};
  const occurrences = c.recurrence.occurrences;

  let text = `Every ${every.interval} ${every.unit}`;

  if (every.interval > 1) text += "s";

  if (on.weekDay) text += ` on ${on.weekDay}`;
  if (on.monthDay) text += ` on day ${on.monthDay}`;
  if (on.yearMonth && on.yearDay)
    text += ` on ${on.yearMonth} ${on.yearDay}`;

  if (occurrences === null) {
    text += " • Forever";
  } else if (occurrences) {
    text += ` • ${occurrences} times`;
  }

  return text;
};


  /* ================= THEME ================= */
  useEffect(() => {
    axios.get(`${apiUrl}/settings`, config)
      .then(res => setTheme(res.data.theme || "dark"))
      .catch(() => setTheme("dark"));
  }, []);

  /* ================= ASSETS ================= */
 useEffect(() => {
  Promise.all([
    axios.get(`${apiUrl}/trucks`, config),
    axios.get(`${apiUrl}/trailers`, config),
    axios.get(`${apiUrl}/drivers`, config),
  ])
    .then(([t, tr, d]) => {
      setTrucks(t.data);
      setTrailers(tr.data);
      setDrivers(d.data);
    })
    .catch(() => notify("Failed to load assets", "error"));
}, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setCostData(prev => ({ ...prev, [name]: value }));
  };




const buildPayload = () => {
  const payload = {
    type: costData.type,
    category: costData.category,
    vendor: costData.vendor,
    amount: Number(costData.amount),
    description: costData.description,
    paymentType: costData.paymentType,
    startDate: costData.startDate,
    endDate: costData.endDate || undefined,

    bankName: costData.bankName,
    iban: costData.iban,
    bic: costData.bic,
    reference: costData.reference,

    status: costData.status,
    notes: costData.notes,
  };

if (costData.paymentType === "recurring") {
  payload.recurrence = {
    every: {
      interval: Number(costData.repeatInterval),
      unit: costData.repeatUnit,
    },
    on: {
      weekDay: costData.onWeekDay || null,
      monthDay: costData.onMonthDay || null,
      yearMonth: costData.onYearMonth || null,
      yearDay: costData.onYearDay || null,
    },
    occurrences: costData.forever
      ? null
      : Number(costData.occurrences),
  };
}


  return payload;
};



const calculateEndDate = (startDate, interval, unit, occurrences) => {
  if (!startDate || !interval || !unit || !occurrences) return "";

  const d = new Date(startDate);
  const total = interval * occurrences;

  switch (unit) {
    case "day":
      d.setDate(d.getDate() + total);
      break;
    case "week":
      d.setDate(d.getDate() + total * 7);
      break;
    case "month":
      d.setMonth(d.getMonth() + total);
      break;
    case "year":
      d.setFullYear(d.getFullYear() + total);
      break;
  }

  return d.toISOString().split("T")[0];
};


const handleSubmit = async () => {
  // 1️⃣ VALIDARE ASSET
  let assetType = "";
  let assetId = "";

  if (selectedTruck) {
    assetType = "truck";
    assetId = selectedTruck;
  } else if (selectedTrailer) {
    assetType = "trailer";
    assetId = selectedTrailer;
  } else if (selectedDriver) {
    assetType = "driver";
    assetId = selectedDriver;
  } else {
    notify("Select a Truck, Trailer or Driver", "error");
    return;
  }

  // 2️⃣ VALIDARE DATE OBLIGATORII
  if (!costData.category || !costData.amount || !costData.startDate) {
    notify("Category, amount and start date are required", "error");
    return;
  }

  try {
    // 3️⃣ BUILD PAYLOAD
    const payload = buildPayload();

    // 4️⃣ SAVE COST
    await axios.post(
      `${apiUrl}/asset-costs`,
      {
        assetType,
        assetId,
        ...payload,
      },
      config
    );

    notify("Cost saved successfully", "success");
  } catch (err) {
    notify("Failed to save cost", "error");
  }
};

const openReports = async () => {
  let assetType = "";
  let assetId = "";

  if (selectedTruck) {
    assetType = "truck";
    assetId = selectedTruck;
  } else if (selectedTrailer) {
    assetType = "trailer";
    assetId = selectedTrailer;
  } else if (selectedDriver) {
    assetType = "driver";
    assetId = selectedDriver;
  } else {
    return;
  }

  setLoadingReports(true);
  setShowReports(true);

  try {
    const res = await axios.get(
      `${apiUrl}/asset-costs`,
      {
        params: { assetType, assetId },
        ...config,
      }
    );

    setAssetCosts(res.data);
  } catch {
    notify("Failed to load reports", "error");
  } finally {
    setLoadingReports(false);
  }
};


  /* ================= UI ================= */
  return (
    <div className={`${styles.wrapperTruckandTrailer} ${theme === "light" ? styles.lightTruckandTrailer : ""}`}>
      <h2 className={styles.titleTruckandTrailer}>Truck & Trailer Cost Manager</h2>

 <div className={styles.assetRowTruckandTrailer}>
  <select
    value={selectedTruck}
    onChange={e => {
      setSelectedTruck(e.target.value);
      setSelectedTrailer("");
      setSelectedDriver("");
    }}
  >
    <option value="">Select Truck</option>
    {trucks.map(t => (
      <option key={t._id} value={t._id}>
        {t.truckNumber}
      </option>
    ))}
  </select>

  <select
    value={selectedTrailer}
    onChange={e => {
      setSelectedTrailer(e.target.value);
      setSelectedTruck("");
      setSelectedDriver("");
    }}
  >
    <option value="">Select Trailer</option>
    {trailers.map(t => (
      <option key={t._id} value={t._id}>
        {t.trailerNumber}
      </option>
    ))}
  </select>

  <select
    value={selectedDriver}
    onChange={e => {
      setSelectedDriver(e.target.value);
      setSelectedTruck("");
      setSelectedTrailer("");
    }}
  >
    <option value="">Select Driver</option>
    {drivers.map(d => (
      <option key={d._id} value={d._id}>
        {d.firstName} {d.lastName}
      </option>
    ))}
  </select>
</div>


{(selectedTruck || selectedTrailer || selectedDriver) && (
  <button
    className={styles.seeReportsBtnTruckandTrailer}
    onClick={openReports}
  >
    See Reports
  </button>
)}

{showReports && (
  <div className={styles.reportsPanelTruckandTrailer}>
    <div className={styles.reportsHeaderTruckandTrailer}>
      <h3>
  {selectedTruck &&
    `Truck ${trucks.find(t => t._id === selectedTruck)?.truckNumber}`}

  {selectedTrailer &&
    `Trailer ${trailers.find(t => t._id === selectedTrailer)?.trailerNumber}`}

  {selectedDriver &&
    `Driver ${drivers.find(d => d._id === selectedDriver)?.firstName} ${drivers.find(d => d._id === selectedDriver)?.lastName}`}
</h3>


      <button onClick={() => setShowReports(false)}>✕</button>
    </div>

    {loadingReports ? (
      <p>Loading...</p>
    ) : assetCosts.length === 0 ? (
      <p>No costs found</p>
    ) : (
    <table className={styles.reportsTableTruckandTrailer}>
<thead>
  <tr>
    <th>Type</th>
    <th>Category</th>
    <th>Vendor</th>
    <th>Description</th>
    <th>Amount</th>
    <th>Billing</th>
    <th>Installments</th>
    <th>Start</th>
    <th>Next</th>
    <th>End</th>
    <th>Status</th>
  </tr>
</thead>

 <tbody>
  {assetCosts.map(c => (
    <tr
      key={c._id}
      className={`${styles.clickableRow} ${
        c.active === false ? styles.inactiveRow : ""
      }`}
     onClick={() => {
  if (c.active === false) return;
  if (isCostFullyPaid(c)) return;

  setSelectedCost(JSON.parse(JSON.stringify(c)));
  setShowPaymentsModal(true);
}}

    >
      {/* TYPE */}
      <td
        className={
          c.type === "addition"
            ? styles.additionLabel
            : styles.deductionLabel
        }
      >
        {c.type === "addition" ? "Addition" : "Deduction"}
      </td>

      {/* CATEGORY */}
      <td
        className={`${styles.badgeTruckandTrailer} ${
          c.type === "addition" ? styles.addition : styles.deduction
        }`}
      >
        {c.category}
      </td>

      {/* VENDOR */}
      <td>{c.vendor || "-"}</td>

      {/* DESCRIPTION */}
      <td className={styles.descTruckandTrailer}>
        {c.description || "-"}
      </td>

      {/* AMOUNT */}
      <td className={styles.amountTruckandTrailer}>
        {c.amount} {c.currency}
      </td>

      {/* BILLING */}
      <td className={styles.recurrenceTruckandTrailer}>
        {formatRecurrence(c)}
      </td>

      {/* ✅ INSTALLMENTS – AICI ERA PROBLEMA */}
      <td className={styles.installmentsTruckandTrailer}>
        <strong>
          {c.installments?.paid ?? 0}/
          {c.installments?.total === Infinity
            ? "∞"
            : c.installments?.total ?? 1}
        </strong>
        <div className={styles.installmentsSubTruckandTrailer}>
          Due by now: {c.installments?.dueByNow ?? 0}
        </div>
        <div className={styles.installmentsOpenTruckandTrailer}>
          Open: {c.installments?.open ?? 0}
        </div>
      </td>

      {/* START */}
      <td>{new Date(c.startDate).toLocaleDateString()}</td>

      {/* NEXT */}
      <td>{new Date(c.nextBillingDate).toLocaleDateString()}</td>

      {/* END */}
      <td>{c.endDate ? new Date(c.endDate).toLocaleDateString() : "—"}</td>

      {/* STATUS */}
      <td className={`${styles.statusTruckandTrailer} ${styles[c.status]}`}>
        {c.status}
      </td>
    </tr>
  ))}
</tbody>

</table>

    )}
  </div>
  
)}
{showPaymentsModal && selectedCost && (
  
  <div className={styles.modalBackdrop}>
    
    <div className={styles.modalCard}>
      
      <h3>
        {selectedCost.category.toUpperCase()} – Payments
      </h3>

      <table className={styles.paymentsTable}>
        <thead>
          <tr>
            <th>#</th>
            <th>Due Date</th>
            <th>Status</th>
          </tr>
        </thead>

<tbody>
  {Array.isArray(selectedCost.payments) &&
    selectedCost.payments.map(p => (
      <tr key={p.index}>
        <td>{p.index}</td>

        <td>
          {new Date(p.dueDate).toLocaleDateString()}
        </td>

        <td>
      <select
  value={p.status}
  disabled={selectedCost.active === false || fullyPaid}
  onChange={async e => {
    if (selectedCost.active === false || fullyPaid) return;

    const newStatus = e.target.value;

    try {
      const res = await axios.put(
        `${apiUrl}/asset-costs/${selectedCost._id}/payments/${p.index}`,
        { status: newStatus },
        config
      );

      setSelectedCost(res.data);
      setAssetCosts(prev =>
        prev.map(c => (c._id === res.data._id ? res.data : c))
      );
    } catch {
      notify("Failed to update payment", "error");
    }
  }}
>

  <option value="open">Open</option>
  <option value="paid">Paid</option>
  <option value="overdue">Overdue</option>
</select>

        </td>
      </tr>
    ))}
</tbody>

      </table>

      {/* ACTIONS */}
      <div className={styles.modalActions}>
{selectedCost.active !== false &&
 !fullyPaid && (

  <button
    className={styles.deactivateBtn}
    onClick={async () => {
      try {
        const res = await axios.put(
          `${apiUrl}/asset-costs/${selectedCost._id}/deactivate`,
          {},
          config
        );

        setAssetCosts(prev =>
          prev.map(c =>
            c._id === res.data._id ? res.data : c
          )
        );

        setShowPaymentsModal(false);
      } catch {
        notify("Failed to deactivate cost", "error");
      }
    }}
  >
    Deactivate Cost
  </button>
)}



        <button onClick={() => setShowPaymentsModal(false)}>
          Close
        </button>
      </div>
    </div>
  </div>
)}

      {(selectedTruck || selectedTrailer || selectedDriver) && (
  <div className={styles.formCardTruckandTrailer}>
<select
  name="type"
  value={costData.type}
  onChange={e =>
    setCostData(prev => ({
      ...prev,
      type: e.target.value,
      category: "", // 🔁 reset category la schimbare
    }))
  }
>
  <option value="deduction">Deduction</option>
  <option value="addition">Addition</option>
</select>

<select
  name="category"
  value={costData.category}
  onChange={handleChange}
>
  <option value="">
    {costData.type === "deduction"
      ? "Deduction Category"
      : "Addition Category"}
  </option>

  {/* ================= DRIVER ================= */}
  {isDriver && costData.type === "deduction" && (
    <>
      <option value="late_arrival">Late Arrival</option>
      <option value="missed_pickup">Missed Pickup</option>
      <option value="missed_delivery">Missed Delivery</option>
      <option value="damage">Cargo / Equipment Damage</option>
      <option value="violation">Violation / Fine</option>
      <option value="fuel_misuse">Fuel Misuse</option>
      <option value="advance">Cash Advance</option>
      <option value="other_driver_deduction">Other Driver Deduction</option>
    </>
  )}

  {isDriver && costData.type === "addition" && (
    <>
      <option value="detention_pay">Detention Pay</option>
      <option value="layover_pay">Layover Pay</option>
      <option value="bonus">Bonus</option>
      <option value="performance_bonus">Performance Bonus</option>
      <option value="extra_stop">Extra Stop</option>
      <option value="safety_bonus">Safety Bonus</option>
      <option value="other_driver_addition">Other Driver Addition</option>
    </>
  )}

  {/* ================= TRUCK / TRAILER ================= */}
  {!isDriver && costData.type === "deduction" && (
    <>
      <option value="insurance">Insurance</option>
      <option value="leasing">Leasing</option>
      <option value="maintenance">Maintenance</option>
      <option value="maut">Maut / Toll</option>
      <option value="trailer_rent">Trailer Rent</option>
      <option value="service">Service</option>
      <option value="other">Other</option>
    </>
  )}

  {!isDriver && costData.type === "addition" && (
    <>
      <option value="lumper">Lumper</option>
      <option value="extra_pickup">Extra Pick-up</option>
      <option value="extra_delivery">Extra Delivery</option>
      <option value="detention">Detention</option>
      <option value="layover">Layover</option>
      <option value="bonus">Bonus</option>
      <option value="other_addition">Other Addition</option>
    </>
  )}
</select>



          <input name="vendor" placeholder="Vendor / Company" onChange={handleChange} />
          <label>Description</label>
<input
  name="description"
  placeholder="Description"
  value={costData.description}
  onChange={handleChange}
/>

          <input name="amount" type="number" placeholder="Amount" onChange={handleChange} />

       <select name="paymentType" onChange={handleChange}>
  <option value="one_time">One-time payment</option>
  <option value="recurring">Recurring payment</option>
</select>


         {costData.paymentType === "recurring" && (
  <div className={styles.recurrenceSectionTruckandTrailer}>
    <label>Recurrence type</label>

 {costData.paymentType === "recurring" && (
  <div className={styles.recurrenceSectionTruckandTrailer}>

    <label>Repeat</label>

    <div className={styles.row}>
      <span>Every</span>

      <input
        type="number"
        min="1"
        name="repeatInterval"
        value={costData.repeatInterval}
        onChange={handleChange}
      />

      <select
        name="repeatUnit"
        value={costData.repeatUnit}
        onChange={handleChange}
      >
        <option value="day">Day(s)</option>
        <option value="week">Week(s)</option>
        <option value="month">Month(s)</option>
        <option value="year">Year(s)</option>
      </select>
    </div>

    {/* WEEK */}
    {costData.repeatUnit === "week" && (
      <select name="onWeekDay" onChange={handleChange}>
        <option value="">On which weekday?</option>
        {WEEK_DAYS.map(d => (
          <option key={d} value={d}>{d}</option>
        ))}
      </select>
    )}

    {/* MONTH */}
    {costData.repeatUnit === "month" && (
      <input
        type="number"
        min="1"
        max="31"
        name="onMonthDay"
        placeholder="Day of month"
        onChange={handleChange}
      />
    )}

    {/* YEAR */}
    {costData.repeatUnit === "year" && (
      <div>
        <select name="onYearMonth" onChange={handleChange}>
          <option value="">Month</option>
          {MONTHS.map(m => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        <input
          type="number"
          min="1"
          max="31"
          name="onYearDay"
          placeholder="Day"
          onChange={handleChange}
        />
      </div>
    )}

   <label>Duration</label>

<div className={styles.row}>
  <label>
    <input
      type="radio"
      name="durationType"
      checked={!costData.forever}
      onChange={() =>
        setCostData(prev => ({
          ...prev,
          forever: false,
          occurrences: prev.occurrences || 1
        }))
      }
    />
    Limited
  </label>

  <label>
    <input
      type="radio"
      name="durationType"
      checked={costData.forever}
      onChange={() =>
        setCostData(prev => ({
          ...prev,
          forever: true,
          occurrences: null
        }))
      }
    />
    Forever
  </label>
</div>

{!costData.forever && (
  <input
    type="number"
    min="1"
    name="occurrences"
    value={costData.occurrences}
    onChange={handleChange}
    placeholder="Number of occurrences"
  />
)}


  </div>
)}


  </div>
)}


          <div className={styles.dateRowTruckandTrailer}>
            <div>
              <label>Start date</label>
              <input type="date" name="startDate" onChange={handleChange} />
            </div>
            <div>
              <label>End date</label>
              <input type="date" name="endDate" onChange={handleChange} />
            </div>
          </div>

          <h4>Bank Details</h4>
          <input name="bankName" placeholder="Bank name" onChange={handleChange} />
          <input name="iban" placeholder="IBAN" onChange={handleChange} />
          <input name="bic" placeholder="BIC / SWIFT" onChange={handleChange} />
          <input name="reference" placeholder="Payment reference" onChange={handleChange} />

          <select name="status" onChange={handleChange}>
            <option value="planned">Planned</option>
            <option value="paid">Paid</option>
            <option value="overdue">Overdue</option>
            <option value="cancelled">Cancelled</option>
          </select>

          <textarea name="notes" placeholder="Notes" onChange={handleChange} />

          <button className={styles.saveBtnTruckandTrailer} onClick={handleSubmit}>
            Save Cost
          </button>
        </div>
      )}
    </div>
  );
};

const AddLoad = ({
  
  onClose,
  onAddLoad,
  drivers,
  trucks,
  trailers,

  brokers,
  shippers,
  consignees,
  dispatchers,
  currentUserId,
  currentUserRole
}) => {
  const { notify } = useNotification();
  const [loadData, setLoadData] = useState({
    loadNumber: "",
    dispatcher: "",
    brokerName: "",
    brokerAddress: "",
    rate: "",
    shippers: [],
    consignees: [],
    dispatcher: "",
    driver: "",
    teamDrivers: [],
    truck: "",
    trailers: "",
    status: "",
    paymentStatus: "Not Paid", 
    miles: "",
    dh: "",
    notes: "",
  });

  const [shippersSuggestions, setShippersSuggestions] = useState([]);
  const [consigneesSuggestions, setConsigneesSuggestions] = useState([]);
  const [showMultiLoadSection, setShowMultiLoadSection] = useState(false);
  const [rcFiles, setRcFiles] = useState([]);
  const [isPickingLoadNumber, setIsPickingLoadNumber] = useState(false);
  const [showPickingBanner, setShowPickingBanner] = useState(false);
  const iframeRef = useRef(null);
  const loadNumberInputRef = useRef(null);
const [currentRCIndex, setCurrentRCIndex] = useState(0);
const [isMultiRCMode, setIsMultiRCMode] = useState(false);
const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
const [zoom, setZoom] = useState(1.5); 
const [currentPickingField, setCurrentPickingField] = useState(null);
const leftRef = useRef(null);
const [leftWidth, setLeftWidth] = useState(50);  // ✅ număr
const [theme, setTheme] = useState("dark");
useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);


const startDragging = (e) => {
  e.preventDefault();
  document.addEventListener("mousemove", onDragging);
  document.addEventListener("mouseup", stopDragging);
};

const onDragging = (e) => {
  const container = document.querySelector(`.${styles.addLoadContentWrapper}`);
  const containerRect = container.getBoundingClientRect();
  const newLeftWidth = ((e.clientX - containerRect.left) / containerRect.width) * 100;

  if (newLeftWidth > 10 && newLeftWidth < 90) {
    setLeftWidth(newLeftWidth);
  }
};



const stopDragging = () => {
  document.removeEventListener("mousemove", onDragging);
  document.removeEventListener("mouseup", stopDragging);
};


const fieldOrder = [
  "loadNumber",          // 1. Load Number
  "brokerName",          // 2. Broker Name
  "brokerAddress",       // 3. Broker Address
  "rate",                // 4. Rate
  "miles",               // 5. Miles
  "dh",                  // 6. DH
  "notes",               // 7. Notes
  // Shippers (primul shipper)
  "shipperName-0",       // 8. Shipper Name
  "shipperAddress-0",    // 9. Shipper Address
  "pickUpTime-0",        // 10. PickUp Time
  // Consignees (primul consignee)
  "consigneeName-0",     // 11. Consignee Name
  "consigneeAddress-0",  // 12. Consignee Address
  "deliveryTime-0",      // 13. Delivery Time
];

const initialEmptyLoadData = {
  loadNumber: "",
  dispatcher: "",
  brokerName: "",
  brokerAddress: "",
  rate: "",
  shippers: [],
  consignees: [],
  driver: "",
  teamDrivers: [],
  truck: "",
  trailers: "",
  status: "",
  paymentStatus: "Not Paid",
  miles: "",
  dh: "",
  notes: "",
  equipment: ""
};

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  const token = sessionStorage.getItem('token');  // Obține tokenul din sessionStorage
  const clientId = localStorage.getItem('clientId');  // Obține clientId din localStorage
  const apiUrl = 'https://api-backend.full-trucking-service.com/api'; // URL-ul backend-ului
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,  // Adaugă tokenul cu prefixul Bearer
      'Content-Type': 'application/json',
    },
    withCredentials: true,  // Trimite cookies pentru autentificare
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoadData((prevState) => ({
      ...prevState,
      [name]: value || "",
    }));
  };

const handleDriverChange = (e) => {
  const driverId = e.target.value;
  const driverObj = drivers.find((d) => d._id === driverId);

  console.log("Driver selectat:", driverObj);

  let matchedTruck = "";
  if (driverObj?.truckNumber) {
    const truckObj = trucks.find((t) => t.truckNumber === driverObj.truckNumber);
    console.log("Truck găsit:", truckObj);

    if (truckObj?._id) {
      matchedTruck = truckObj._id;
    }
  }

  setLoadData((prevState) => {
    console.log("Setez loadData cu driver+truck:", {
      driver: driverId,
      truck: matchedTruck,
    });
    return {
      ...prevState,
      driver: driverId,
      truck: matchedTruck,
    };
  });
};


const handleTruckChange = (truckId) => {
  const truckObj = trucks.find((t) => t._id === truckId);

  let matchedDriver = "";
  if (truckObj?.truckNumber) {
    const driverObj = drivers.find((d) => d.truckNumber === truckObj.truckNumber);
    if (driverObj?._id) matchedDriver = driverObj._id;
  }

  setLoadData((prev) => ({
    ...prev,
    truck: truckId,
    driver: matchedDriver || prev.driver, // dacă găsim driver, îl suprascriem
  }));
};

  // Selectare șoferi pentru echipă (Team Drivers)
  const handleTeamDriverChange = (selectedOptions) => {
    setLoadData((prevState) => ({
      ...prevState,
      teamDrivers: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };

  const handleBrokerSelect = (e) => {
    const selectedBrokerName = e.target.value;
    const selectedBroker = brokers.find(
      (b) => b.brokerName === selectedBrokerName
    );
    setLoadData((prevState) => ({
      ...prevState,
      brokerName: selectedBrokerName,
      brokerAddress: selectedBroker ? selectedBroker.address : "",
    }));
  };
  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const shippersResponse = await axios.get(`${apiUrl}/shippers`, config);
        const consigneesResponse = await axios.get(`${apiUrl}/consignees`, config);
        setShippersSuggestions(shippersResponse.data);
        setConsigneesSuggestions(consigneesResponse.data);
      } catch (error) {
       
      }
    };

    fetchSuggestions();
  }, []);
useEffect(() => {
  const fetchAiPreference = async () => {
    try {
      const res = await axios.get(`${apiUrl}/morehelpfromai`, config);
      setLoadData((prev) => ({
        ...prev,
        moreHelpFromAI: res.data.enabled || false
      }));
    } catch (err) {
      console.error("Error fetching AI preference:", err);
    }
  };
  fetchAiPreference();
}, []);


useEffect(() => {
  if (!loadData.moreHelpFromAI) return;

  let newLoad = { ...loadData };

  // 1. Status Completed dacă deliveryTime < azi
  const earliestConsignee = newLoad.consignees[0];
  if (earliestConsignee?.deliveryTime && new Date(earliestConsignee.deliveryTime) < new Date()) {
    newLoad.status = "Completed";
  }

// 2. Auto-match driver ↔ truck prin truckNumber
if (newLoad.driver && !newLoad.truck) {
  const driverObj = drivers.find((d) => d._id === newLoad.driver);
  if (driverObj?.truckNumber) {
    const truckObj = trucks.find((t) => t.truckNumber === driverObj.truckNumber);
    if (truckObj?._id) {
      newLoad.truck = truckObj._id; // salvăm ObjectId-ul Truckului
    }
  }
}

if (newLoad.truck && !newLoad.driver) {
  const truckObj = trucks.find((t) => t._id === newLoad.truck);
  if (truckObj?.truckNumber) {
    const driverObj = drivers.find((d) => d.truckNumber === truckObj.truckNumber);
    if (driverObj?._id) {
      newLoad.driver = driverObj._id; // salvăm ObjectId-ul Driverului
    }
  }
}


  // 3. DH calculat
  const calcDH = async () => {
    if (!newLoad.driver) return;

    try {
      const lastLoad = await axios.get(
        `${apiUrl}/loads/by-assignment?driverId=${newLoad.driver}`,
        config
      );
      if (lastLoad.data.length > 0) {
        const prevConsignee = lastLoad.data[0].consignees.at(-1);
        const newShipper = newLoad.shippers[0];
        if (prevConsignee?.address && newShipper?.address) {
          const url = `${apiUrl}/calculate-distance?origins=${encodeURIComponent(
            prevConsignee.address
          )}&destinations=${encodeURIComponent(newShipper.address)}&apiKey=${apiKey}`;

          const dhRes = await axios.get(url);
          const miles = Math.round(dhRes.data.distance.value * 0.000621371);
          setLoadData((prev) => ({ ...prev, dh: miles }));
        }
      }
    } catch (err) {
      console.error("Error calculating DH:", err);
    }
  };

  calcDH();

  // 🔥 aplică modificările în state
  setLoadData(newLoad);
}, [loadData.moreHelpFromAI, loadData.driver, loadData.truck, loadData.shippers, loadData.consignees]);

// ✅ Dicționar echivalențe echipamente
const equipmentMap = {
  "VAN": "Van",
  "DRY VAN": "Dry Van",
  "53 VAN": "53 Van",
  "53 REEFER": "53 Reefer",
  "REEFER": "53 Reefer",
  "FLATBED": "Flatbed",
  "STEP DECK": "Step Deck"
  // 🔧 mai adaugi aici ce variante mai vezi în PDF-uri
};

// ✅ Funcția care normalizează
const normalizeEquipment = (raw) => {
  if (!raw) return "";
  const key = raw.trim().toUpperCase();
  return equipmentMap[key] || raw; 
};

  const handleShipperSelect = (index, selectedName) => {
    const selectedShipper = shippersSuggestions.find(
      (shipper) => shipper.shipperName === selectedName
    );
    
    if (selectedShipper) {
      const newShippers = [...loadData.shippers];
      newShippers[index] = {
        ...newShippers[index],
        name: selectedShipper.shipperName,
        address: selectedShipper.shipperAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
    }
  };
 
  
  const handleConsigneeSelect = (index, selectedName) => {
    const selectedConsignee = consigneesSuggestions.find(
      (consignee) => consignee.consigneeName === selectedName
    );
  
    if (selectedConsignee) {
      const newConsignees = [...loadData.consignees];
      newConsignees[index] = {
        ...newConsignees[index],
        name: selectedConsignee.consigneeName,
        address: selectedConsignee.consigneeAddress, // setează adresa corectă
      };
      setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
    }
  };
  
  
  

  const handleAddShipper = () => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: [...prevState.shippers, { name: "", address: "", pickUpTime: "" }], // folosește 'name' și 'address'
    }));
  };
  
  const handleAddConsignee = () => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: [...prevState.consignees, { name: "", address: "", deliveryTime: "" }], // folosește 'name' și 'address'
    }));
  };
  

  const handleRemoveShipper = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      shippers: prevState.shippers.filter((_, i) => i !== index),
    }));
  };

  const handleRemoveConsignee = (index) => {
    setLoadData((prevState) => ({
      ...prevState,
      consignees: prevState.consignees.filter((_, i) => i !== index),
    }));
  };

  const handleShipperChange = (index, e) => {
    const { name, value } = e.target;
    const newShippers = [...loadData.shippers];
    newShippers[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, shippers: newShippers }));
  };

  const handleConsigneeChange = (index, e) => {
    const { name, value } = e.target;
    const newConsignees = [...loadData.consignees];
    newConsignees[index][name] = value;
    setLoadData((prevState) => ({ ...prevState, consignees: newConsignees }));
  };

  const calculateMiles = async () => {
    const allAddresses = [
      ...loadData.shippers.map((s) => s.address),
      ...loadData.consignees.map((c) => c.address),
    ];

    if (allAddresses.length < 2) return;

    try {
      let totalMiles = 0;
      for (let i = 0; i < allAddresses.length - 1; i++) {
        const url = `${apiUrl}/calculate-distance?origins=${encodeURIComponent(
          allAddresses[i]
        )}&destinations=${encodeURIComponent(allAddresses[i + 1])}&apiKey=${apiKey}`;

        const response = await axios.get(url);
        const data = response.data;

        if (data.distance) {
          const distanceInMeters = data.distance.value;
          totalMiles += distanceInMeters * 0.000621371;
        }
      }
      setLoadData((prevState) => ({ ...prevState, miles: totalMiles.toFixed(2) }));
    } catch (error) {
    
    }
  };
  useEffect(() => {
    // Căutăm dispatcher-ul curent bazat pe clientId, în cazul în care utilizatorul autentificat este client
  
  
    if (
      currentUserRole === 'dispatcher' &&
      Array.isArray(dispatchers) &&
      dispatchers.length > 0 &&
      currentUserId
    ) {
      // Dacă `currentUserId` este al clientului, găsim dispatcher-ul bazat pe `clientId`
      const currentDispatcher = dispatchers.find(d => d.clientId === currentUserId);
     
  
      if (currentDispatcher) {
        setLoadData(prev => ({
          ...prev,
          dispatcher: currentDispatcher._id
        }));
      }
    }
  }, [currentUserId, dispatchers, currentUserRole]);
  
  
  
  useEffect(() => {
    if (loadData.shippers.length && loadData.consignees.length) {
      calculateMiles();
    }
  }, [loadData.shippers, loadData.consignees]);
  const handleSubmit = async () => {
    if (isLoading) return;
    try {
       let newLoad = { ...loadData };

  if (newLoad.moreHelpFromAI) {
    // 1. Status Completed dacă deliveryTime < azi
    const earliestConsignee = newLoad.consignees[0];
    if (earliestConsignee?.deliveryTime && new Date(earliestConsignee.deliveryTime) < new Date()) {
      newLoad.status = "Completed";
    }

    // 2. DH calculat cu Google API
    if (newLoad.driver) {
      const lastLoad = await axios.get(
        `${apiUrl}/loads/by-assignment?driverId=${newLoad.driver}`,
        config
      );

      if (lastLoad.data.length > 0) {
        const prevConsignee = lastLoad.data[0].consignees.at(-1);
        const newShipper = newLoad.shippers[0];
        if (prevConsignee?.address && newShipper?.address) {
          const url = `${apiUrl}/calculate-distance?origins=${encodeURIComponent(
            prevConsignee.address
          )}&destinations=${encodeURIComponent(newShipper.address)}&apiKey=${apiKey}`;

          const dhRes = await axios.get(url);
          newLoad.dh = Math.round(dhRes.data.distance.value * 0.000621371);
        }
      }
    }

    // 3. Auto-match driver ↔ truck
    if (newLoad.driver && !newLoad.truck) {
      const driverObj = drivers.find((d) => d._id === newLoad.driver);
      if (driverObj?.assignedTruck) newLoad.truck = driverObj.assignedTruck;
    }
    if (newLoad.truck && !newLoad.driver) {
      const truckObj = trucks.find((t) => t._id === newLoad.truck);
      if (truckObj?.assignedDriver) newLoad.driver = truckObj.assignedDriver;
    }
  }

      if (!loadData.driver && !loadData.truck) {
       notify("You must select either a Driver or a Truck before submitting." , 'error');
        return;
    }
      if (
        !loadData.loadNumber.trim() ||
        loadData.shippers.length === 0 ||
        loadData.consignees.length === 0
      ) {
        notify("Load Number, Driver or Truck, Shipper, and Consignee are mandatory fields." , 'error');
        return;
      }
  
      setIsLoading(true);

      // Validare câmp rate (doar numere și punct zecimal)
      if (loadData.rate && !/^\d+(\.\d{1,2})?$/.test(loadData.rate)) {
       notify("Rate must be a valid number (e.g., 200 or 200.00)." , 'error');
        return;
      }
  
      // Validare câmpuri de tip ObjectId
      if (loadData.truck && !/^[0-9a-fA-F]{24}$/.test(loadData.truck)) {
        notify("Invalid Truck ID." , 'error');
        return;
      }
  
   const dataToSend = {
  ...newLoad,   // 🔥 aici folosim newLoad, nu loadData
  clientId,
  truck: newLoad.truck || null,
  trailers: newLoad.trailers || null,
  paymentStatus: newLoad.paymentStatus || "Not Paid",
};


       // ✅ Verifică dacă există load-uri active pentru acest driver sau truck
    const incompleteLoadsResponse = await axios.get(`${apiUrl}/loads/incomplete`, config);
    const incompleteLoads = incompleteLoadsResponse.data || [];

    // Verificare pentru driver
    if (loadData.driver) {
      const driverHasActiveLoad = incompleteLoads.some(load => load.driver === loadData.driver);
      if (driverHasActiveLoad) {
       notify("This driver already has an active load! Please complete the existing load first." , 'error');
        return;
      }
    }

    // Verificare pentru truck
    if (loadData.truck) {
      const truckHasActiveLoad = incompleteLoads.some(load => load.truck === loadData.truck);
      if (truckHasActiveLoad) {
        notify("This truck already has an active load! Please complete the existing load first." , 'error');
        return;
      }
    }
  
      // Salvează shipperii
      for (const shipper of loadData.shippers) {
        const existingShipper = shippersSuggestions.find(
          (s) => s.shipperName === shipper.name && s.shipperAddress === shipper.address
        );
        if (!existingShipper) {
          await axios.post(
            `${apiUrl}/shippers`,
            { shipperName: shipper.name, shipperAddress: shipper.address },
            config
          );
        }
      }
  
      // Salvează consignees
      for (const consignee of loadData.consignees) {
        const existingConsignee = consigneesSuggestions.find(
          (c) => c.consigneeName === consignee.name && c.consigneeAddress === consignee.address
        );
        if (!existingConsignee) {
          await axios.post(
            `${apiUrl}/consignees`,
            { consigneeName: consignee.name, consigneeAddress: consignee.address },
            config
          );
        }
      }
  
      // Salvează încărcătura (load)
      const response = await axios.post(`${apiUrl}/loads`, dataToSend, config);
  
      if (response.status === 201) {  
        // Resetează formularul
        setLoadData({
          loadNumber: "",
          dispatcher: "",
          brokerName: "",
          brokerAddress: "",
          rate: "",
          equipment: "",
          driver: "",
          teamDrivers: [],
          truck: "",
          trailers: "",
          status: "",
          shippers: [],
          consignees: [],
          miles: "",
          dh: "",
          notes: "",
        });
  
        window.location.href = '?tab=add-new-load';
      }
    } catch (error) {
     
      notify(error.response?.data?.error || "There was an error saving the load." , 'error');
    } finally {
      setIsLoading(false); // 🔥 Oprim loading-ul indiferent de rezultat
    }
  };
  const handleRateChange = (e) => {
    const value = e.target.value;
    // Păstrează doar numerele și punctul
    const filteredValue = value.replace(/[^0-9.]/g, "");
    setLoadData((prevState) => ({
      ...prevState,
      rate: filteredValue,
    }));
  };
  

  const saveBrokersShippersConsignees = async () => {
    try {
      const brokerExists = brokers.some(
        (broker) => broker.brokerName === loadData.brokerName
      );
      if (!brokerExists) {
        await axios.post(`${apiUrl}/brokers`, {
          brokerName: loadData.brokerName,
          brokerAddress: loadData.brokerAddress,
        }, config);
      }

      const shipperExists = shippers.some(
        (shipper) => shipper.shipperName === loadData.shipperName
      );
      if (!shipperExists) {
        await axios.post(`${apiUrl}/shippers`, {
          shipperName: loadData.shipperName,
          shipperAddress: loadData.shipperAddress,
        }, config);
      }

      const consigneeExists = consignees.some(
        (consignee) => consignee.consigneeName === loadData.consigneeName
      );
      if (!consigneeExists) {
        await axios.post(`${apiUrl}/consignees`, {
          consigneeName: loadData.consigneeName,
          consigneeAddress: loadData.consigneeAddress,
        }, config);
      }

   
    } catch (error) {
    
      throw error;
    }
  };
  const [isLoading, setIsLoading] = useState(false);

  
  
  const handleCancel = () => {
    onClose();
  };

  const toDatetimeLocalFormat = (text) => {
    const date = new Date(text);
    if (isNaN(date.getTime())) {
      return "";
    }
    return date.toISOString().slice(0, 16);
  };
  

  useEffect(() => {
    if (!isPickingLoadNumber || !iframeRef.current) return;
  
    const iframe = iframeRef.current;
    const iframeWin = iframe.contentWindow;
    const iframeDoc = iframe.contentDocument || iframeWin?.document;
  
    if (!iframeDoc || !iframeWin) return;
  
    const handleMouseUp = () => {
      const selectedText = iframeWin.getSelection()?.toString().trim();
      if (selectedText) {
        setLoadData((prev) => ({
          ...prev,
          loadNumber: selectedText,
        }));
        setIsPickingLoadNumber(false);
  
        // Focus input după ce selectezi
        loadNumberInputRef.current?.focus();
        loadNumberInputRef.current?.select();
      }
    };
  
    iframeDoc.addEventListener("mouseup", handleMouseUp);
  
    // cleanup
    return () => {
      iframeDoc.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isPickingLoadNumber, currentPdfUrl]);
  useEffect(() => {
    if (isPickingLoadNumber) {
      setShowPickingBanner(true);
    } else {
      setShowPickingBanner(false);
    }
  }, [isPickingLoadNumber]);
  return (
    <>
      {showPickingBanner && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "#00c6ff",
          color: "white",
          fontWeight: "bold",
          textAlign: "center",
          padding: "10px",
          zIndex: 9999,
        }}>
        
        </div>
      )}

<Loader isLoading={isLoading} />

    <div
  className={`${styles.ultimateaddloadsectionContainer} ${
    theme === "light" ? styles.ultimateaddloadsectionContainerLight : ""
  }`}
>

      <h2 className={styles.titleultimateaddload}>Add New Load</h2>
      <div style={{ marginBottom: "20px" }}>
  
  
<label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
  <input
    type="checkbox"
    checked={loadData.moreHelpFromAI || false}
    onChange={async (e) => {
      const checked = e.target.checked;
      setLoadData((prev) => ({ ...prev, moreHelpFromAI: checked }));
      try {
        await axios.post(`${apiUrl}/morehelpfromai`, {
          clientId,
          enabled: checked
        }, config);
        notify(`Help from AI ${checked ? "enabled" : "disabled"}`, "success");
      } catch (err) {
        notify("Error saving AI preference", "error");
      }
    }}
  />
  <span style={{ fontWeight: "600", color: "#00c6ff" }}>
    Help more from AI
  </span>
</label>

</div>

      <div className={styles.addLoadContentWrapper}>

<div
  ref={leftRef}
  className={styles.leftFormContainer}
  style={{
    width: `calc(${leftWidth}% - 3px)`,
    maxHeight: 'calc(100vh - 150px)',   // reglabil în funcție de header
    overflowY: 'auto',
    paddingRight: '10px'   // ca să nu îți taie scrollul peste butoane
  }}
>


        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
          <label>Load Number</label>


<input
  ref={loadNumberInputRef}
  name="loadNumber"
  value={loadData.loadNumber}
  onChange={handleChange}
  placeholder="Load Number"
  required
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === "loadNumber" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "loadNumber" ? "0 0 8px #00c6ff" : undefined,
    transition: "all 0.3s ease-in-out",
    backgroundColor: currentPickingField === "loadNumber" ? "" : undefined,
  }}
  onClick={() => setCurrentPickingField("loadNumber")}
/>


          </div>
          <div className={styles.formGroupultimateaddload}>
          <label>Dispatcher</label>
          <select
  name="dispatcher"
  value={loadData.dispatcher}
  onChange={handleChange}
  className={styles.selectFieldultimateaddload}
  disabled={currentUserRole === 'dispatcher'}
  required
>
  {currentUserRole === 'dispatcher' ? (
    dispatchers.length > 0 ? (
      <option value={currentUserId}>
        {
          dispatchers.find(d => d.clientId === currentUserId)?.firstName
        } {
          dispatchers.find(d => d.clientId === currentUserId)?.lastName
        }
      </option>
    ) : (
      <option>Loading...</option>
    )
  ) : (
    <>
      <option value="">Select Dispatcher</option>
      {dispatchers.map((dispatcher) => (
        <option key={dispatcher._id} value={dispatcher._id}>
          {dispatcher.firstName} {dispatcher.lastName}
        </option>
      ))}
    </>
  )}
</select>

        </div>


        </div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
            <label>Broker Name</label>
            <input
  list="brokers-list"
  name="brokerName"
  value={loadData.brokerName}
  onChange={handleBrokerSelect}
  placeholder="Broker Name"
  required
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === "brokerName" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "brokerName" ? "0 0 8px #00c6ff" : undefined,
    transition: "all 0.3s ease-in-out",
  
  }}
  onClick={() => setCurrentPickingField("brokerName")}
/>

            <datalist id="brokers-list">
              {brokers.map((broker) => (
                <option key={broker._id} value={broker.brokerName} />
              ))}
            </datalist>
          </div>
          <div className={styles.formGroupultimateaddload}>
            <label>Broker Address</label>
            <input
  name="brokerAddress"
  value={loadData.brokerAddress}
  onChange={handleChange}
  placeholder="Broker Address"
  required
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === "brokerAddress" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "brokerAddress" ? "0 0 8px #00c6ff" : undefined,
    transition: "all 0.3s ease-in-out",
  
  }}
  onClick={() => setCurrentPickingField("brokerAddress")}
/>

          </div>
        </div>

        <div className={styles.formRowultimateaddload}>
        <div className={styles.formGroupultimateaddload}>
  <label>Rate</label>

  <input
    name="rate"
    value={loadData.rate}
    onChange={handleRateChange}
    placeholder="Rate"
    required
    className={styles.inputFieldultimateaddload}
    style={{
      outline: currentPickingField === "rate" ? "2px solid #00c6ff" : undefined,
      boxShadow: currentPickingField === "rate" ? "0 0 8px #00c6ff" : undefined,
    
    }}
    onClick={() => setCurrentPickingField("rate")}
  />
</div>
          <div className={styles.formGroupultimateEquipmentaddload}>
            <label>Equipment</label>
            <select
              name="equipment"
              value={loadData.equipment}
              onChange={handleChange}
              className={styles.selectFieldEquipmentultimateaddload}
            >
              <option value="">Select Equipment</option>
              <option value="Dry Van">Dry Van</option>
              <option value="53 Van">53 Van</option>
              <option value="53' Reefer">53 Reefer</option>
              <option value="Air Freight">Air Freight</option>
              <option value="Airride/Logistical Van">Airride/Logistical Van</option>
              <option value="Any Equipment">Any Equipment</option>
              <option value="Beam">Beam</option>
              <option value="Cargo Van (1 Ton)">Cargo Van</option>
              <option value="Conestoga">Conestoga</option>
              <option value="Convertible Hopper">Convertible Hopper</option>
              <option value="Conveyor Belt">Conveyor Belt</option>
              <option value="Curtain Siders">Curtain Siders</option>
              <option value="Curtain Van">Curtain Van</option>
              <option value="Double Drop">Double Drop</option>
              <option value="Drive Away">Drive Away</option>
              <option value="Flat Intermodal">Flat Intermodal</option>
              <option value="Flat or Step Deck">Flat or Step Deck</option>
              <option value="Flat with Tarps">Flat with Tarps</option>
              <option value="Flatbed">Flatbed</option>
              <option value="Flatbed Air-Ride">Flatbed Air-Ride</option>
              <option value="Flatbed Blanket Wrapped">Flatbed Blanket Wrapped</option>
              <option value="Flatbed or Van">Flatbed or Van</option>
              <option value="Haul and Tow Unit">Haul and Tow Unit</option>
              <option value="Hazardous Material Load">Hazardous Material Load</option>
              <option value="Landoll Flatbed">Landoll Flatbed</option>
              <option value="Live Bottom Trailer">Live Bottom Trailer</option>
              <option value="Load-Out">Load-Out</option>
              <option value="Lowboy">Lowboy</option>
              <option value="Lowboy over-dimension load">Lowboy over-dimension load</option>
              <option value="Maxi or Double Flat Trailers">Maxi or Double Flat Trailers</option>
              <option value="Maxi/Double Flat Trailer">Maxi/Double Flat Trailer</option>
              <option value="Moving Van">Moving Van</option>
              <option value="Multi-Axle Heavy Hauler">Multi-Axle Heavy Hauler</option>
              <option value="Pneumatic">Pneumatic</option>
              <option value="Power Only">Power Only</option>
              <option value="Reefer Pallet Exchange">Reefer Pallet Exchange</option>
              <option value="Refrigerated Carrier">Refrigerated Carrier</option>
              <option value="Removable Goose Neck">Removable Goose Neck</option>
              <option value="Removable Goose Neck & Multi-Axle Heavy Haulers">Removable Goose Neck & Multi-Axle Heavy Haulers</option>
              <option value="RGN Extendable">RGN Extendable</option>
              <option value="Step Deck"></option>
              <option value="Straight Van">Straight Van</option>
              <option value="Tandem Van">Tandem Van</option>
              <option value="Tanker">Tanker</option>
              <option value="Team Driver Needed">Team Driver Needed</option>
              <option value="Van">Van</option>
              <option value="Van Air-Ride">Van Air-Ride</option>
              <option value="Van intermodal">Van intermodal</option>
              <option value="Van or Flatbed">Van or Flatbed</option>
              <option value="Van or Reefer">Van or Reefer</option>
              <option value="Van Pallet Exchange">Van Pallet Exchange</option>
              <option value="Vented Insulated Van">Vented Insulated Van</option>
              <option value="Vented Van">Vented Van</option>
              <option value="Walking Floor">Walking Floor</option>
            </select>
          </div>
        </div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateDriveraddload}>
            <label>Driver</label>
            <select
              name="driver"
              value={loadData.driver}
              onChange={handleChange}
              required
              className={styles.selectFieldultimateaddload}
            >
              <option value="">Select Driver</option>
              {drivers.map((driver, index) => (
                <option key={index} value={driver._id}>
                  {driver.firstName} {driver.lastName}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.formGroupultimateTeamDriversaddload}>
            <label>Team Drivers</label>
            <Select
              isMulti
              options={drivers.map((driver) => ({
                value: driver._id,
                label: `${driver.firstName} ${driver.lastName}`,
              }))}
              onChange={handleTeamDriverChange}
              className={styles.selectFieldultimateaddload}
              placeholder="Select Team Drivers"
            />
          </div>
          <div className={styles.formGroupultimateTruckaddload}>
            <label>Truck</label>
            <select
              name="truck"
              value={loadData.truck}
              onChange={handleChange}
              className={styles.selectFieldultimateaddload}
            >
              <option value="">Select Truck</option>
              {trucks.map((truck, index) => (
                <option key={index} value={truck._id}>
                  {truck.truckNumber}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={styles.formGroupultimateTraileraddload}>
  <label>Trailer</label>
  <select
    name="trailer"
    value={loadData.trailer}
    onChange={handleChange}
    className={styles.selectFieldultimateaddload}
  >
    <option value="">Select Trailer</option>
    {Array.isArray(trailers) && trailers.map((trailer) => (
  <option key={trailer._id} value={trailer._id}>
    {trailer.trailerNumber}
  </option>
))}

  </select>
</div>


 
        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateStatusaddload}>
            <label>Status</label>
            <select
              name="status"
              value={loadData.status}
              onChange={handleChange}
              required
              className={styles.selectFieldultimateStatusaddload}
            >
              <option value="">Select Status</option>
              <option value="Pending">Pending</option>
              <option value="Open">Open</option>
              <option value="Refused">Refused</option>
              <option value="Assigned">Assigned</option>
              <option value="Dispatched">Dispatched</option>
              <option value="On Route">On Route</option>
              <option value="In Progress">In Progress</option>
              <option value="Delivered">Delivered</option>
              <option value="(Un)Loading">Un-Loading</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
              <option value="In Yard">In Yard</option>

            </select>
          </div>
        </div>

        <div className={styles.formGroupultimatePaymentStatusaddload}>
  <label>Payment Status</label>
  <select
    name="paymentStatus"
    value={loadData.paymentStatus}
    onChange={handleChange}
    className={styles.selectFieldultimatePaymentStatusaddload}
    required
  >
    <option value="">Select Payment Status</option>
    <option value="Not Paid">Not Paid</option>
    <option value="Pending Payment">Pending Payment</option>
    <option value="Payment in Progress">Payment in Progress</option>
    <option value="Payment Cancelled">Payment Cancelled</option>
    <option value="Paid">Paid</option>
    <option value="Paid in Installments">Paid in Installments</option>
  </select>
</div>


   {/* Shippers Section */}
<div className={styles.sectionultimateaddload}>
  <h3>Shippers</h3>
  {loadData.shippers.map((shipper, index) => (
    <div key={index} className={styles.formGroupultimateaddload}>
<input
  name="name"
  list={`shipper-suggestions-${index}`}
  value={shipper.name}
  onChange={(e) => {
    handleShipperChange(index, e);
    handleShipperSelect(index, e.target.value);
  }}
  placeholder="Shipper Name"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `shipperName-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `shipperName-${index}` ? "0 0 8px #00c6ff" : undefined,
  }}
  onClick={() => setCurrentPickingField(`shipperName-${index}`)}
/>

      <datalist id={`shipper-suggestions-${index}`}>
        {shippersSuggestions.map((sugg) => (
          <option key={sugg._id} value={sugg.shipperName} />
        ))}
      </datalist>
      <input
  name="address"
  value={shipper.address}
  onChange={(e) => handleShipperChange(index, e)}
  placeholder="Shipper Address"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `shipperAddress-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `shipperAddress-${index}` ? "0 0 8px #00c6ff" : undefined,
  }}
  onClick={() => setCurrentPickingField(`shipperAddress-${index}`)}
/>

<input
  name="pickUpTime"
  type="datetime-local"
  value={shipper.pickUpTime}
  onChange={(e) => handleShipperChange(index, e)}
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `pickUpTime-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `pickUpTime-${index}` ? "0 0 8px #00c6ff" : undefined,

  }}
  onClick={() => setCurrentPickingField(`pickUpTime-${index}`)}
/>

 <button
        type="button"
        onClick={() => handleRemoveShipper(index)}
        className={styles.removeButtonShipperultimateaddload} // ✅ Adăugat clasa
      >
        Remove
      </button>
    </div>
  ))}
  <button
    type="button"
    onClick={handleAddShipper}
    className={styles.addButtonShipperultimateaddload} // ✅ Adăugat clasa
  >
    Add Shipper
  </button>
</div>


{/* Consignees Section */}
<div className={styles.sectionultimateaddload}>
  <h3>Consignees</h3>
  {loadData.consignees.map((consignee, index) => (
    <div key={index} className={styles.formGroupultimateaddload}>
     <input
  name="name"
  list={`consignee-suggestions-${index}`}
  value={consignee.name}
  onChange={(e) => {
    handleConsigneeChange(index, e);
    handleConsigneeSelect(index, e.target.value);
  }}
  placeholder="Consignee Name"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `consigneeName-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `consigneeName-${index}` ? "0 0 8px #00c6ff" : undefined,
  }}
  onClick={() => setCurrentPickingField(`consigneeName-${index}`)}
/>

      <datalist id={`consignee-suggestions-${index}`}>
        {consigneesSuggestions.map((sugg) => (
          <option key={sugg._id} value={sugg.consigneeName} />
        ))}
      </datalist>
    

<input
  name="address"
  value={consignee.address}
  onChange={(e) => handleConsigneeChange(index, e)}
  placeholder="Consignee Address"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `consigneeAddress-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `consigneeAddress-${index}` ? "0 0 8px #00c6ff" : undefined,
  }}
  onClick={() => setCurrentPickingField(`consigneeAddress-${index}`)}
/>


<input
  name="deliveryTime"
  type="datetime-local"
  value={consignee.deliveryTime}
  onChange={(e) => handleConsigneeChange(index, e)}
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === `deliveryTime-${index}` ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === `deliveryTime-${index}` ? "0 0 8px #00c6ff" : undefined,
  }}
  onClick={() => setCurrentPickingField(`deliveryTime-${index}`)}
/>

      <button
        type="button"
        onClick={() => handleRemoveConsignee(index)}
        className={styles.removeButtonConsigneeultimateaddload} // ✅ Adăugat clasa
      >
        Remove
      </button>
    </div>
  ))}
  <button
    type="button"
    onClick={handleAddConsignee}
    className={styles.addButtonConsigneeultimateaddload} // ✅ Adăugat clasa
  >
    Add Consignee
  </button>
</div>

        <div className={styles.formRowultimateaddload}>
          <div className={styles.formGroupultimateaddload}>
            <label>Miles</label>
            <input
  name="miles"
  value={loadData.miles}
  onChange={handleChange}
  placeholder="Miles"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === "miles" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "miles" ? "0 0 8px #00c6ff" : undefined,
    backgroundColor: currentPickingField === "miles" ? "#e6f7ff" : undefined,
  }}
  onClick={() => setCurrentPickingField("miles")}
/>

          </div>
          <div className={styles.formGroupultimateaddload}>
            <label>DH</label>
            <input
  name="dh"
  value={loadData.dh}
  onChange={handleChange}
  placeholder="DH"
  className={styles.inputFieldultimateaddload}
  style={{
    outline: currentPickingField === "dh" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "dh" ? "0 0 8px #00c6ff" : undefined,
  
  }}
  onClick={() => setCurrentPickingField("dh")}
/>

          </div>
        </div>

        <div className={styles.formGroupultimateaddload}>
          <label>Notes</label>
          <textarea
  name="notes"
  value={loadData.notes}
  onChange={handleChange}
  placeholder="Notes"
  className={styles.textareaFieldultimateaddload}
  style={{
    outline: currentPickingField === "notes" ? "2px solid #00c6ff" : undefined,
    boxShadow: currentPickingField === "notes" ? "0 0 8px #00c6ff" : undefined,
  
  }}
  onClick={() => setCurrentPickingField("notes")}
/>

        </div>

        <button 
  type="button" 
  onClick={handleSubmit} 
  className={styles.submitButtonultimateaddload}
  disabled={isLoading} // 🔥 Dezactivăm butonul în timpul încărcării
>
  {isLoading ? "Adding Load..." : "Add New Load"} {/* 🔥 Schimbă textul în funcție de stare */}
</button>

        <button type="button" onClick={handleCancel} className={styles.closeBtnultimateaddload}>
          Cancel
        </button>
       </div>
  <div
  className={styles.splitter}
  onMouseDown={startDragging}
  style={{ left: `calc(${leftWidth}% - 3px)` }}  // 🔥 aici, adăugăm left dinamic!
></div>
     <div 
  className={styles.rightPreviewContainer}
  
  style={{ width: `calc(${100 - leftWidth}% - 3px)` }}  // 🔥 minus 3px pentru marginea splitter-ului
>
{!currentPdfUrl && (
  <div className={styles.uploadArea}
    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => {
      e.preventDefault();
      const files = Array.from(e.dataTransfer.files).filter(file => file.type === 'application/pdf');
      if (files.length > 0) {
        setRcFiles(files);
        setCurrentRCIndex(0);
        setIsMultiRCMode(true);
       
      }
    }}
    style={{
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      border: "2px dashed #00c6ff",
      color: "#00c6ff",
      fontSize: "1.5rem",
      cursor: "pointer",
    }}
  >
    <input
      type="file"
      accept="application/pdf"
      multiple
      style={{ display: "none" }}
      id="file-upload"
      onChange={(e) => {
        const files = Array.from(e.target.files).filter(file => file.type === 'application/pdf');
        if (files.length > 0) {
          setRcFiles(files);
          setCurrentRCIndex(0);
          setIsMultiRCMode(true);
        
        }
      }}
    />
    <label htmlFor="file-upload" style={{ cursor: "pointer", textAlign: "center" }}>
      📄 Click to Choose RC<br/>or Drag & Drop PDFs Here
    </label>
  </div>
)}

      {isMultiRCMode && currentPdfUrl && (
  <div className={styles.multiRCPreview}>
{isMultiRCMode && currentPdfUrl && (
  <div style={{ height: "100%", overflowY: "auto" }}>

<div className={styles.uploadArea}
     onDragOver={(e) => e.preventDefault()}
     onDrop={(e) => {
       e.preventDefault();
       const files = Array.from(e.dataTransfer.files).filter(file => file.type === 'application/pdf');
       if (files.length > 0) {
         setRcFiles(files);
         setCurrentRCIndex(0);
         setIsMultiRCMode(true);
        
       }
     }}>
  <input
    type="file"
    accept="application/pdf"
    multiple
    style={{ display: "none" }}
    id="file-upload"
    onChange={(e) => {
      const files = Array.from(e.target.files).filter(file => file.type === 'application/pdf');
      if (files.length > 0) {
        setRcFiles(files);
        setCurrentRCIndex(0);
        setIsMultiRCMode(true);
       
      }
    }}
  />
  <label htmlFor="file-upload" className={styles.uploadLabel}>
    📄 Choose RC<br/>(or Drag & Drop PDFs)
  </label>
</div>

<PdfViewerWithSelect

  fileUrl={currentPdfUrl}
  
  onSelectText={(selectedText) => {
    if (!currentPickingField) return;
  
    setLoadData((prev) => {
      const updated = { ...prev };
  // ✅ Dicționar echivalențe echipamente


      if (currentPickingField.startsWith("shipper")) {
        const [field, idx] = currentPickingField.split("-");
        const index = parseInt(idx, 10);
        if (!updated.shippers[index]) {
          updated.shippers[index] = { name: "", address: "", pickUpTime: "" };
        }
        if (field === "shipperName") {
          updated.shippers[index].name = selectedText;
        } else if (field === "shipperAddress") {
          updated.shippers[index].address = selectedText;
        } else if (field === "pickUpTime") {
          updated.shippers[index].pickUpTime = toDatetimeLocalFormat(selectedText); // 🎯 aici corect
        }
      } else if (currentPickingField.startsWith("consignee")) {
        const [field, idx] = currentPickingField.split("-");
        const index = parseInt(idx, 10);
        if (!updated.consignees[index]) {
          updated.consignees[index] = { name: "", address: "", deliveryTime: "" };
        }
        if (field === "consigneeName") {
          updated.consignees[index].name = selectedText;
        } else if (field === "consigneeAddress") {
          updated.consignees[index].address = selectedText;
        } else if (field === "deliveryTime") {
          updated.consignees[index].deliveryTime = toDatetimeLocalFormat(selectedText); // 🎯 aici corect
        }
      } else {
        updated[currentPickingField] = selectedText;
      }
  
      return updated;
    });
  
    const currentIndex = fieldOrder.indexOf(currentPickingField);
    if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
      setCurrentPickingField(fieldOrder[currentIndex + 1]);
    } else {
      setCurrentPickingField(null);
    }
  }}
  
/>
  </div>
)}



    <p>Preview RC {currentRCIndex + 1} of {rcFiles.length}</p>

    <div className={styles.multiRCButtons}>
      <button
        type="button"
        className={styles.skipButton}
        onClick={() => {
          const nextIndex = currentRCIndex + 1;
          if (nextIndex < rcFiles.length) {
            setCurrentRCIndex(nextIndex);
            setLoadData({ ...initialEmptyLoadData });
           
          } else {
          notify("All loads have been processed." , 'succes');
            setRcFiles([]);
            setIsMultiRCMode(false);
            setShowMultiLoadSection(false);
            setCurrentRCIndex(0);
            setCurrentPdfUrl(null);
          }
        }}
      >
        Skip Load
      </button>

      <button
        type="button"
        className={styles.addButtonAddLoad}
        onClick={async () => {
          const initialRcIndex = currentRCIndex;
          await handleSubmit();
          if (initialRcIndex === currentRCIndex) {
            // Adică load-ul NU s-a adăugat => nu schimba PDF-ul
            return;
          }
          const nextIndex = currentRCIndex + 1;
          if (nextIndex < rcFiles.length) {
            setCurrentRCIndex(nextIndex);
            setLoadData({ ...initialEmptyLoadData });
            
          } else {
            notify("All loads have been added." , 'success');
            setRcFiles([]);
            setIsMultiRCMode(false);
            setShowMultiLoadSection(false);
            setCurrentRCIndex(0);
            setCurrentPdfUrl(null);
          }
        }}
        
      >
        Add Load
      </button>
    </div>
  </div>
)}
   </div>
   

</div>
</div>
  </>

);

};

const IFTA = () => {
  const { notify } = useNotification();
  const [showReportContainer, setShowReportContainer] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [activeEditId, setActiveEditId] = useState(null);
  const [iftaData, setIftaData] = useState({
    fuelPurchasedState: "",
    fuelPrice: "",
    milesDrivenState: "",
    milesDriven: "",
    fuelLoaded: "",
    fuelConsumed: "",
    taxRate: "",
    quarter: "",
    year: "",
    dateOfFuelPurchase: "",
    fuelTaxPaid: "",
    paidIfta: ""
  });

  const [reports, setReports] = useState([]);
  const [selectedReports, setSelectedReports] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectAll, setSelectAll] = useState(false);
const [theme, setTheme] = useState("dark");

  const apiUrl = "https://api-backend.full-trucking-service.com/api";
  const token = sessionStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
  const fetchTheme = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const apiUrl = "https://api-backend.full-trucking-service.com/api";

      const res = await axios.get(`${apiUrl}/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTheme(res.data.theme || "dark");
    } catch (err) {
      setTheme("dark");
    }
  };

  fetchTheme();
}, []);

  const states = [
    // US STATES + CANADA ONLY ✅
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
    "Wisconsin", "Wyoming",
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia",
    "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan"
  ];

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const response = await axios.get(`${apiUrl}/ifta`, config);
      setReports(response.data);
    } catch (error) {
      
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIftaData({ ...iftaData, [name]: value });
  };

const handleSaveAndDownload = async () => {
  const {
    fuelPurchasedState,
    milesDrivenState,
    fuelPrice,
    fuelLoaded,
    milesDriven,
    quarter,
    year,
    dateOfFuelPurchase,
    paidIfta
  } = iftaData;

  // dacă e nou (nu există id), validăm
  if (!iftaData._id) {
    if (!fuelPurchasedState || !milesDrivenState || !fuelPrice || !fuelLoaded || !milesDriven || !quarter || !year || !dateOfFuelPurchase) {
    notify("All fields marked as required must be completed!" , 'error');
      return;
    }
  }

  const payload = {
    ...iftaData,
    fuelPrice: fuelPrice ? parseFloat(fuelPrice) : 0,
    fuelLoaded: fuelLoaded ? parseFloat(fuelLoaded) : 0,
    milesDriven: milesDriven ? parseFloat(milesDriven) : 0,
    fuelConsumed: iftaData.fuelConsumed ? parseFloat(iftaData.fuelConsumed) : null,
    taxRate: iftaData.taxRate ? parseFloat(iftaData.taxRate) : null,
    fuelTaxPaid: iftaData.fuelTaxPaid ? parseFloat(iftaData.fuelTaxPaid).toFixed(2) : 0,
    paidIfta: paidIfta || "No"
  };

  try {
    if (iftaData._id) {
      // UPDATE
      const response = await axios.put(`${apiUrl}/ifta/${iftaData._id}`, payload, config);
      if (response.status === 200) {
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2500);
        setActiveEditId(null);
        fetchReports();
      }
    } else {
      // CREATE
      const response = await axios.post(`${apiUrl}/ifta`, payload, config);
      if (response.status === 201) {
        generatePDF(response.data.result);
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2500);
        fetchReports();
      }
    }
  } catch (error) {
   
  }
};

const handleEditReport = (report) => {
  setIftaData({ ...report });
  setActiveEditId(report._id);
};

  const generatePDF = (data) => {
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("IFTA Report", 10, 10);

    doc.autoTable({
      startY: 20,
      head: [["Field", "Value"]],
      body: [
        ["Fuel Purchased State", data.fuelPurchasedState],
        ["Fuel Price ($/gal)", data.fuelPrice],
        ["Miles Driven State", data.milesDrivenState],
        ["Miles Driven", data.milesDriven],
        ["Fuel Loaded (gal)", data.fuelLoaded],
        ["Fuel Consumed (gal)", data.fuelConsumed || "-"],
        ["Tax Rate (¢/gal)", data.taxRate || "-"],
        ["Quarter", data.quarter],
        ["Year", data.year],
        ["Date of Fuel Purchase", data.dateOfFuelPurchase],
        ["Fuel Tax Paid", `$${data.fuelTaxPaid}`],
        ["Created At", new Date(data.createdAt).toLocaleString()]
      ]
    });

    doc.save(`IFTA_Report_${Date.now()}.pdf`);
  };

  const exportToExcel = () => {
    const selectedData = reports
      .filter(report => selectedReports.includes(report._id))
.map(({ fuelPurchasedState, milesDrivenState, fuelPrice, fuelConsumed, fuelLoaded, milesDriven, taxRate, quarter, year, dateOfFuelPurchase, fuelTaxPaid, paidIfta, createdAt }) => ({
        fuelPurchasedState,
        milesDrivenState,
        fuelPrice,
        fuelConsumed,
        fuelLoaded,
        milesDriven,
        taxRate,
        quarter,
        year,
        dateOfFuelPurchase,
        fuelTaxPaid,
        paidIfta,
        createdAt
      }));

    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "IFTA Reports");
    XLSX.writeFile(wb, "IFTA_Reports.xlsx");
  };

  const exportSelectedToPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text("Selected IFTA Reports", 10, 10);

    const selectedData = reports
      .filter(report => selectedReports.includes(report._id))
      .map(({ fuelPurchasedState, milesDrivenState, fuelPrice, fuelLoaded, milesDriven, fuelConsumed, taxRate, quarter, year, dateOfFuelPurchase, fuelTaxPaid, paidIfta, createdAt }) => [
        fuelPurchasedState,
        milesDrivenState,
        `$${fuelPrice}`,
        milesDriven,
        fuelLoaded,
        fuelConsumed || "-",
        taxRate || "-",
        quarter,
        year,
        paidIfta,
        dateOfFuelPurchase,
        `$${fuelTaxPaid}`,
        new Date(createdAt).toLocaleString()
      ]);

    doc.autoTable({
      startY: 20,
      head: [["Fuel State", "Miles State", "Fuel Price", "Miles", "Fuel Loaded", "Fuel Consumed", "Tax Rate", "Quarter", "Year", "Purchase Date", "Fuel Tax Paid", "Created At"]],
      body: selectedData,
    });

    doc.save("Selected_IFTA_Reports.pdf");
  };

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    setSelectedReports(!selectAll ? reports.map(report => report._id) : []);
  };

  const handleCheckboxChange = (id) => {
    setSelectedReports(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    );
  };

  return (
    <div
  className={`${styles.iftaManagerSection} ${
    theme === "light" ? styles.iftaManagerSectionLight : ""
  }`}
>

      <h2 className={styles.sectionTitleIFTA}>IFTA Fuel Tax Reporting (Manual Entry)</h2>
  
      <div className={styles.searchWrapperIFTA}>
        <input
          type="text"
          className={styles.searchInputIFTA}
          placeholder="Search reports..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Fuel Purchased State *</label>
        <select className={styles.formSelectIFTA} name="fuelPurchasedState" value={iftaData.fuelPurchasedState} onChange={handleChange}>
          <option value="">Select State</option>
          {states.map((state, index) => (
            <option key={index} value={state}>{state}</option>
          ))}
        </select>
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Fuel Price ($/gal) *</label>
        <input className={styles.formInputIFTA} type="number" name="fuelPrice" value={iftaData.fuelPrice} onChange={handleChange} />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Miles Driven State *</label>
        <select className={styles.formSelectIFTA} name="milesDrivenState" value={iftaData.milesDrivenState} onChange={handleChange}>
          <option value="">Select State</option>
          {states.map((state, index) => (
            <option key={index} value={state}>{state}</option>
          ))}
        </select>
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Miles Driven *</label>
        <input className={styles.formInputIFTA} type="number" name="milesDriven" value={iftaData.milesDriven} onChange={handleChange} />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Fuel Loaded (gal) *</label>
        <input className={styles.formInputIFTA} type="number" name="fuelLoaded" value={iftaData.fuelLoaded} onChange={handleChange} />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Fuel Consumed (gal)</label>
        <input className={styles.formInputIFTA} type="number" name="fuelConsumed" value={iftaData.fuelConsumed} onChange={handleChange} />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Tax Rate (¢/gal)</label>
        <input className={styles.formInputIFTA} type="number" name="taxRate" value={iftaData.taxRate} onChange={handleChange} />
      </div>
      <div className={styles.formGroupIFTA}>
  <label className={styles.formLabelIFTA}>Fuel Tax Paid *</label>
  <input
    className={styles.formInputIFTA}
    type="number"
    name="fuelTaxPaid"
    value={iftaData.fuelTaxPaid}
    onChange={handleChange}
  />
</div>

      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Quarter *</label>
        <select className={styles.formSelectIFTA} name="quarter" value={iftaData.quarter} onChange={handleChange}>
          <option value="">Select Quarter</option>
          <option value="Q1">Q1 (Jan-Mar)</option>
          <option value="Q2">Q2 (Apr-Jun)</option>
          <option value="Q3">Q3 (Jul-Sep)</option>
          <option value="Q4">Q4 (Oct-Dec)</option>
        </select>
      </div>
  <div className={styles.formGroupIFTA}>
  <label className={styles.formLabelIFTA}>Paid IFTA?</label>
  <select
    className={styles.formSelectIFTA}
    name="paidIfta"
    value={iftaData.paidIfta || 'No'}
    onChange={handleChange}
  >
    <option value="No">No</option>
    <option value="Yes">Yes</option>
  </select>
</div>

      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Year *</label>
        <input className={styles.formInputIFTA} type="number" name="year" value={iftaData.year} onChange={handleChange} />
      </div>
  
      <div className={styles.formGroupIFTA}>
        <label className={styles.formLabelIFTA}>Date of Fuel Purchase *</label>
        <input className={styles.formInputIFTA} type="date" name="dateOfFuelPurchase" value={iftaData.dateOfFuelPurchase} onChange={handleChange} />
      </div>
  
      <div className={styles.buttonsRowIFTA}>
        <button className={styles.primaryButtonIFTA} onClick={handleSaveAndDownload}>Save & Download PDF</button>
      </div>
      
{showSuccess && (
  <div className={styles.successNotification}>
    IFTA Report saved & PDF downloaded!
  </div>
)}


  <div className={styles.seeReportWrapper}>
  <button
    className={styles.seeReportButton}
    onClick={() => setShowReportContainer(true)}
  >
    See the Reports
  </button>
</div>

{showReportContainer && (
<div className={styles.reportOverlay}>
  <div className={styles.reportContent}>
    
    <div className={styles.headerRowReport}>
      <div className={styles.buttonsRowIFTA}>
        <button className={styles.secondaryButtonIFTA} onClick={exportToExcel}>Export to Excel</button>
        <button className={styles.secondaryButtonIFTA} onClick={exportSelectedToPDF}>Export Selected as PDF</button>
      </div>
      <button className={styles.closeButtonReport} onClick={() => setShowReportContainer(false)}>
        Close
      </button>
    </div>

 <div className={styles.tableContainerReport}>
      <table className={styles.iftaTable}>
  <thead>
    <tr>
      <th>
        <input
          type="checkbox"
          checked={selectAll}
          onChange={toggleSelectAll}
          title="Select All"
        />
      </th>
      <th>Fuel Purchased State</th>
      <th>Fuel Price ($/gal)</th>
      <th>Miles Driven State</th>
      <th>Miles Driven</th>
      <th>Fuel Loaded (gal)</th>
      <th>Fuel Consumed (gal)</th>
      <th>Tax Rate (¢/gal)</th>
      <th>Fuel Tax Paid ($)</th>
      <th>Quarter</th>
      <th>Year</th>
      <th>Paid IFTA</th>
      <th>Purchase Date</th>
      <th>Created At</th>
    </tr>
  </thead>
  <tbody>
    {reports
      .filter(
        (report) =>
          report.fuelPurchasedState
            .toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          report.milesDrivenState
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
      )
      .map((report) => (
    <>
  <tr
    key={report._id}
    className={styles.tableRowIFTA}
    onClick={() => handleEditReport(report)}
  >
    <td>
      <input
        type="checkbox"
        checked={selectedReports.includes(report._id)}
        onChange={() => handleCheckboxChange(report._id)}
      />
    </td>
    <td>{report.fuelPurchasedState}</td>
    <td>{report.fuelPrice ? `$${parseFloat(report.fuelPrice).toFixed(2)}` : "-"}</td>
    <td>{report.milesDrivenState}</td>
    <td>{report.milesDriven ? parseFloat(report.milesDriven).toFixed(2) : "-"}</td>
    <td>{report.fuelLoaded ? parseFloat(report.fuelLoaded).toFixed(2) : "-"}</td>
    <td>{report.fuelConsumed ? parseFloat(report.fuelConsumed).toFixed(2) : "-"}</td>
    <td>{report.taxRate ? `${parseFloat(report.taxRate).toFixed(2)}¢` : "-"}</td>
    <td>{report.fuelTaxPaid ? `$${parseFloat(report.fuelTaxPaid).toFixed(2)}` : "-"}</td>
    <td>{report.quarter}</td>
    <td>{report.year}</td>
    <td>{report.paidIfta}</td>
    <td>{report.dateOfFuelPurchase ? new Date(report.dateOfFuelPurchase).toLocaleDateString() : "-"}</td>
    <td>{report.createdAt ? new Date(report.createdAt).toLocaleString() : "-"}</td>
  </tr>

 {activeEditId === report._id && (
  <tr className={styles.inlineEditRowIFTA}>
    <td colSpan={14}>
      <div className={styles.inlineEditContainerIFTA}>
        <button
          className={styles.closeEditButton}
          onClick={() => {
            setActiveEditId(null);
            setIftaData({});
          }}
        >
          ❌
        </button>

        <div className={styles.inlineFormRowIFTA}>
          <label>Fuel Purchased State</label>
          <select name="fuelPurchasedState" value={iftaData.fuelPurchasedState} onChange={handleChange}>
            <option value="">Select State</option>
            {states.map((state, i) => (
              <option key={i} value={state}>{state}</option>
            ))}
          </select>

          <label>Fuel Price ($/gal)</label>
          <input type="number" name="fuelPrice" value={iftaData.fuelPrice} onChange={handleChange} />

          <label>Miles Driven State</label>
          <select name="milesDrivenState" value={iftaData.milesDrivenState} onChange={handleChange}>
            <option value="">Select State</option>
            {states.map((state, i) => (
              <option key={i} value={state}>{state}</option>
            ))}
          </select>

          <label>Miles Driven</label>
          <input type="number" name="milesDriven" value={iftaData.milesDriven} onChange={handleChange} />

          <label>Fuel Loaded (gal)</label>
          <input type="number" name="fuelLoaded" value={iftaData.fuelLoaded} onChange={handleChange} />

          <label>Fuel Consumed (gal)</label>
          <input type="number" name="fuelConsumed" value={iftaData.fuelConsumed} onChange={handleChange} />

          <label>Tax Rate (¢/gal)</label>
          <input type="number" name="taxRate" value={iftaData.taxRate} onChange={handleChange} />

          <label>Fuel Tax Paid</label>
          <input type="number" name="fuelTaxPaid" value={iftaData.fuelTaxPaid} onChange={handleChange} />

          <label>Quarter</label>
          <select name="quarter" value={iftaData.quarter} onChange={handleChange}>
            <option value="">Select Quarter</option>
            <option value="Q1">Q1</option>
            <option value="Q2">Q2</option>
            <option value="Q3">Q3</option>
            <option value="Q4">Q4</option>
          </select>

          <label>Paid IFTA?</label>
          <select name="paidIfta" value={iftaData.paidIfta || 'No'} onChange={handleChange}>
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>

          <label>Year</label>
          <input type="number" name="year" value={iftaData.year} onChange={handleChange} />

          <label>Date of Fuel Purchase</label>
          <input type="date" name="dateOfFuelPurchase" value={iftaData.dateOfFuelPurchase} onChange={handleChange} />
        </div>

        <div className={styles.inlineEditButtonsIFTA}>
          <button className={styles.primaryButtonIFTA} onClick={handleSaveAndDownload}>
            Save Changes
          </button>

          <button className={styles.deleteButtonIFTA} onClick={async () => {
            try {
              await axios.delete(`${apiUrl}/ifta/${report._id}`, config);
              setIftaData({});
              setActiveEditId(null);
              fetchReports();
            } catch (error) {
            
            }
          }}>
            Delete Report
          </button>
        </div>
      </div>
    </td>
  </tr>
)}
</>

        
      ))}
      
  </tbody>
      </table>
    </div>
  </div>
    </div>
  
)}

      
    </div>
  );
};

const Settings = ({ updateUserSettings, drivers = [], handleUpdateDriver }) => {
  const [billingInfo, setBillingInfo] = useState(null);
const [showInvoices, setShowInvoices] = useState(false);
  const { notify } = useNotification();
  const [updatedSettings, setUpdatedSettings] = useState({
    companyName: '',
    companyAddress: '',
    firstName: '',
    lastName: '',
    mcNumber: '',
    phone: '',
    fax: '',
    email: '',
    password: '',
    subscriptionType: '',
    contractStart: '',
    package: '',
    contractEnd: '',
    notes: '',
    theme: 'dark' 
  });

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [driverEmail, setDriverEmail] = useState('');
  const [twoFactorMethod, setTwoFactorMethod] = useState('email');
const [qrCodeUrl, setQrCodeUrl] = useState('');
const [authenticatorSecret, setAuthenticatorSecret] = useState('');
const [verificationCode, setVerificationCode] = useState('');
const [isVerifying2FA, setIsVerifying2FA] = useState(false);
const [selectedPDFType, setSelectedPDFType] = useState('DriverPay');
const [pdfTemplates, setPdfTemplates] = useState([]);
const [editingTemplate, setEditingTemplate] = useState(null);
const [templateName, setTemplateName] = useState('');
const [templateContent, setTemplateContent] = useState({}); // conținutul JSON
const [selectedTheme, setSelectedTheme] = useState([]);
const [payrollWeekSettings, setPayrollWeekSettings] = useState({
  enabled: false,
  baseWeek: '',
  baseWeekDate: ''
});



  const [driverPassword, setDriverPassword] = useState('');
  const [subscriptionInfo, setSubscriptionInfo] = useState({
    paymentType: '',
    expirationDate: ''
  });

  const [isTwoFactorEnabled, setIsTwoFactorEnabled] = useState(false);
  const [twoFactorWarning, setTwoFactorWarning] = useState(false);
  

   
  const [dispatchers, setDispatchers] = useState([]);
  const [accountings, setAccountings] = useState([]);
  const [selectedRole, setSelectedRole] = useState('dispatcher');
  const [newAccountFirstName, setNewAccountFirstName] = useState('');
  const [newAccountLastName, setNewAccountLastName] = useState('');
  const [newAccountEmail, setNewAccountEmail] = useState('');
  const [newAccountPhone, setNewAccountPhone] = useState('');
  const [newAccountAddress, setNewAccountAddress] = useState('');
  const [newAccountDOB, setNewAccountDOB] = useState('');
  const [newAccountSalary, setNewAccountSalary] = useState('');
  const [newAccountPassword, setNewAccountPassword] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const token = sessionStorage.getItem('token');
  const apiUrl = 'https://api-backend.full-trucking-service.com/api';
  const config = {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
  fetchPayrollWeekSettings();
}, []);

const fetchPayrollWeekSettings = async () => {
  try {
    const res = await axios.get(`${apiUrl}/payroll-week`, config);

    setPayrollWeekSettings({
      enabled: !!res.data.enabled,
      baseWeek: res.data.baseWeek || '',
      baseWeekDate: res.data.baseWeekDate
        ? res.data.baseWeekDate.split('T')[0]
        : ''
    });
  } catch (err) {
    console.warn('Payroll week not configured yet');
  }
};


  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${apiUrl}/settings`, config);
      const settings = response.data;

      setUpdatedSettings({
        companyName: settings.companyName || '',
        companyAddress: settings.companyAddress || '',
        firstName: settings.firstName || '',
        lastName: settings.lastName || '',
        mcNumber: settings.mcNumber || '',
        phone: settings.phone || '',
        fax: settings.fax || '',
        email: settings.email || '',
        password: settings.password || '',
        subscriptionType: settings.subscriptionType || '',
        contractStart: settings.contractStart ? settings.contractStart.split('T')[0] : '',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : '',
        package: settings.package || '',
        notes: settings.notes || '',
        theme: settings.theme || 'dark'

      });

      setSubscriptionInfo({
        subscriptionType: settings.subscriptionType || 'No data',
        contractEnd: settings.contractEnd ? settings.contractEnd.split('T')[0] : 'No data',
        package: settings.package || 'No data',
      });

      setIsTwoFactorEnabled(settings.twoFactorAuthEnabled || false);
      setTwoFactorWarning(!settings.twoFactorAuthEnabled);
    } catch (error) {
    
    }
  };

  const handleSavePayrollWeek = async () => {
  try {
    if (
      payrollWeekSettings.enabled &&
      (!payrollWeekSettings.baseWeek || !payrollWeekSettings.baseWeekDate)
    ) {
      notify('Base week and base date are required', 'error');
      return;
    }

    await axios.put(
      `${apiUrl}/payroll-week`,
      { payrollWeekSettings },
      config
    );

    notify('Driver Pay Week saved successfully', 'success');
    fetchPayrollWeekSettings();
  } catch (err) {
    notify('Failed to save Driver Pay Week', 'error');
  }
};


const handleChange = (e) => {
  const { name, value } = e.target;

  // 🔥 Salvează tema instant în localStorage
  if (name === "theme") {
    const finalTheme = value === "light" ? "light" : "dark";
    localStorage.setItem("fts-theme", finalTheme);
  }

  setUpdatedSettings(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleSaveSettings = async () => {
  if (password && password !== confirmPassword) {
    notify('Passwords do not match!', 'error');
    return;
  }

  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@!#$%^&*])[A-Za-z\d@!#$%^&*]{12,}$/;
  if (password && !passwordRegex.test(password)) {
    notify('Password must be at least 12 characters long, contain an uppercase letter, a number, and a special character (@!#$%^&*).', 'error');
    return;
  }

  setIsSaving(true);

  try {
    const updatedData = {
      ...updatedSettings,
      theme: updatedSettings.theme || 'dark'
    };

    // 🔥 1. Salvăm tema instant în localStorage → fără flicker la reload
    localStorage.setItem("fts-theme", updatedData.theme);

    // Include parola doar dacă e setată
    if (password) {
      updatedData.password = password;
    }

    // 🔥 2. Trimitem către backend
    await updateUserSettings(updatedData);

    // 🔥 3. Refetch pentru UI stabil
    await fetchSettings();

    if (password) {
      notify('Password changed successfully. Please log in again.', 'success');
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    } else {
      notify('Settings updated successfully', 'success');
    }

  } catch (error) {
    notify('Failed to update settings. Please try again.', 'error');
  } finally {
    setIsSaving(false);
  }
};


const fetchBilling = async () => {
  try {
    const clientId = localStorage.getItem("clientId");
    const response = await axios.get(`${apiUrl}/billing/${clientId}`, config);
    setBillingInfo(response.data);
  } catch (err) {
    notify("Failed to fetch billing info", "error");
  }
};

const openBillingPortal = async () => {
  try {
    const clientId = localStorage.getItem("clientId");
    const response = await axios.post(`${apiUrl}/billing/portal`, { clientId }, config);
    window.location.href = response.data.url;
  } catch (err) {
    notify("Failed to open billing portal", "error");
  }
};

useEffect(() => {
  fetchBilling();
}, []);

const handleDriverSelection = (driverId) => {
  setSelectedDrivers((prevSelected) =>
    prevSelected.includes(driverId)
      ? prevSelected.filter((id) => id !== driverId)
      : [...prevSelected, driverId]
  );
};

const handleTruckSelection = (truckId) => {
  setSelectedTrucks((prevSelected) =>
    prevSelected.includes(truckId)
      ? prevSelected.filter((id) => id !== truckId)
      : [...prevSelected, truckId]
  );
};

const handleEnableAuthenticator = async () => {
  try {
    const response = await axios.post(`${apiUrl}/two-factor/setup`, {}, config);
    const { otpauthUrl, secret } = response.data;

    setQrCodeUrl(otpauthUrl);
    setAuthenticatorSecret(secret);
    setIsVerifying2FA(true); // ✨ Afișează formularul de confirmare
  } catch (error) {
   
   notify('Failed to generate Authenticator QR code.' , 'error');
  }
};


const handleVerifyAuthenticatorCode = async () => {
  try {
    const response = await axios.post(`${apiUrl}/two-factor/verify`, {
      code: verificationCode,
      secret: authenticatorSecret,
    }, config);

   notify('2FA via Authenticator enabled successfully!' , 'succes');
    setIsTwoFactorEnabled(true);
    setTwoFactorWarning(false);
    setQrCodeUrl('');
    setAuthenticatorSecret('');
    setVerificationCode('');
    setIsVerifying2FA(false);
  } catch (error) {
  
    notify('Invalid code. Please try again.' , 'error');
  }
};


    
const handleDriverUpdate = () => {
  if (!selectedDriver) return;

  const updatePayload = {
    email: driverEmail,
    password: driverPassword
  };

  axios.put(`${apiUrl}/drivers/${selectedDriver._id}/updateCredentials`, updatePayload, config)
    .then(() => {
      notify('Driver credentials updated successfully!' , 'success');
    })
    .catch(error => {
      notify('Failed to update driver credentials.' , 'error');
    });
};


  const handleBlockDriver = () => {
    if (!selectedDriver) return;

    const updatedDriver = { ...selectedDriver, isBlocked: true };
    handleUpdateDriver(updatedDriver);
   notify('Driver account has been blocked!' , 'succes');
  };

  const handleSelectDriver = (driverId) => {
    const driver = drivers.find((d) => d._id === driverId);
    setSelectedDriver(driver);
    setDriverEmail(driver?.email || '');
    setDriverPassword('');
  };


  const handleEnableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/enable-two-factor`, { method: 'email' }, config)
      .then(() => {
       notify('Two-Factor Authentication via Email enabled. You will receive a code during login.' , 'success');
        setIsTwoFactorEnabled(true);
        setTwoFactorWarning(false);
      })
      .catch(error => {
       
        notify('Failed to enable Two-Factor Authentication.' , 'error');
      });
  };

  const handleDisableTwoFactorAuth = () => {
    axios.post(`${apiUrl}/disable-two-factor`, {}, config)
      .then(() => {
        notify('Two-Factor Authentication has been disabled!' , 'success');
        setIsTwoFactorEnabled(false);
        setTwoFactorWarning(true);
      })
      .catch(error => {
      
        notify('Failed to disable Two-Factor Authentication.' , 'error');
      });
  };

  useEffect(() => {
    fetchClientData();  
    fetchDispatchers();
    fetchAccountings();
  }, []);

  const [clientData, setClientData] = useState({});

  const fetchClientData = async () => {
    try {
      const clientId = localStorage.getItem('clientId'); // ✅ Asigură-te că este corect
      if (!clientId) {
       
        return;
      }
  
     
  
      const response = await axios.get(`${apiUrl}/clients/${clientId}`, config); // 🔥 Schimbăm endpoint-ul
      setClientData(response.data);
      
    
  
    } catch (error) {
      
    }
  };
  

const fetchDispatchers = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
      
      return;
    }

    const response = await axios.get(`${apiUrl}/dispatchers?clientId=${clientId}`, config);
    // ✅ Asigură-te că șoferii, camioanele și permisiunile sunt incluse
    const dispatchersWithDetails = response.data.map(dispatcher => ({
      ...dispatcher,
      drivers: dispatcher.drivers || [], // Asigură că avem array
      trucks: dispatcher.trucks || [], // Asigură că avem array
      permissions: dispatcher.permissions || [] // Asigură că avem array
    }));

    setDispatchers(dispatchersWithDetails);
  } catch (error) {
  
  }
};

const fetchAccountings = async () => {
  try {
    const clientId = localStorage.getItem('clientId'); // ✅ Ia clientId corect
    if (!clientId) {
     
      return;
    }

    const response = await axios.get(`${apiUrl}/accountings?clientId=${clientId}`, config);
    const accountingsWithDetails = response.data.map(accounting => ({
      ...accounting,
      drivers: accounting.drivers || [], // Asigură că avem array
      trucks: accounting.trucks || [], // Asigură că avem array
      permissions: accounting.permissions || [] // Asigură că avem array
    }));

    setAccountings(accountingsWithDetails);
  } catch (error) {
  
  }
};


const handleSelectAccount = (account) => {
  setSelectedAccount(account);
  setPermissions(account.permissions || []);
};

const handlePermissionChange = (module) => {
  setPermissions((prevPermissions) =>
    prevPermissions.includes(module)
      ? prevPermissions.filter((perm) => perm !== module)
      : [...prevPermissions, module]
  );
};

const handleSavePermissions = async () => {
  if (!selectedAccount) return;

  try {
    await axios.put(`${apiUrl}/set-permissions/${selectedAccount._id}`, {
      permissions,
      role: selectedAccount.role,
    }, config);

   notify(`${selectedAccount.role} permissions updated successfully!` , 'success');
    selectedAccount.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
  } catch (error) {
   
    notify('Failed to update permissions.' , 'error');
  }
};

const handleCreateDispatcherOrAccounting = async () => {
  const clientId = localStorage.getItem("clientId");

  const newAccountData = {
    firstName: newAccountFirstName,
    lastName: newAccountLastName,
    email: newAccountEmail,
    phone: newAccountPhone,
    address: newAccountAddress,
    dateOfBirth: newAccountDOB,
    salaryDetails: newAccountSalary,
    password: newAccountPassword,
    role: selectedRole,
    clientId,
    permissions: permissions,
    drivers: selectedDrivers, // ✅ Adaugă șoferii direct la creare
    trucks: selectedTrucks, // ✅ Adaugă camioanele direct la creare
  };

  

  try {
    const response = await axios.post(
      `${apiUrl}/${selectedRole === "dispatcher" ? "dispatchers" : "accountings"}`,
      newAccountData,
      config
    );
  
    notify(`${selectedRole} created successfully!` , 'succes');
    selectedRole === "dispatcher" ? fetchDispatchers() : fetchAccountings();
    clearAccountForm();
  } catch (error) {
   
    notify(`Failed to create ${selectedRole}. Check console for details.` , 'error');
  }
};

  const handleEditAccount = (account) => {
    setSelectedAccount(account);
    setNewAccountFirstName(account.firstName);
    setNewAccountLastName(account.lastName);
    setNewAccountEmail(account.email);
    setNewAccountPhone(account.phone);
    setNewAccountAddress(account.address);
    setNewAccountDOB(account.dateOfBirth);
    setNewAccountSalary(account.salaryDetails);
    setSelectedRole(account.role);
    setSelectedDrivers(account.drivers ? account.drivers.map(driver => driver._id) : []);

    // ✅ Preselectează camioanele existente
    setSelectedTrucks(account.trucks ? account.trucks.map(truck => truck._id) : []);
  
    // ✅ Preselectează permisiunile existente
    setPermissions(account.permissions || []);
  };


const handleUpdateAccount = async () => {
  if (!selectedAccount) return;

  const updatedData = {
    firstName: newAccountFirstName,
    lastName: newAccountLastName,
    email: newAccountEmail,
    phone: newAccountPhone,
    address: newAccountAddress,
    dateOfBirth: newAccountDOB,
    salaryDetails: newAccountSalary,
    permissions,
    drivers: selectedDrivers,
    trucks: selectedTrucks,
   
  };

  // 🔥 dacă user-ul a completat un câmp parolă nouă, trimitem și parola
  if (newAccountPassword && newAccountPassword.trim() !== "") {
    updatedData.password = newAccountPassword;
  }

  try {
    await axios.put(
      `${apiUrl}/${selectedRole === "dispatcher" ? "dispatchers" : "accountings"}/${selectedAccount._id}`,
      updatedData,
      config
    );
    notify(`${selectedRole === "dispatcher" ? "Dispatcher" : "Accounting"} updated successfully!`, "success");
    selectedRole === "dispatcher" ? fetchDispatchers() : fetchAccountings();
    clearAccountForm();
  } catch (error) {
    console.error("❌ Update error:", error.response?.data || error.message);
    notify(`Failed to update ${selectedRole}`, "error");
  }
};


  const requestDeleteAccount = (account) => {
    setDeleteTarget(account); // Stocăm contul pentru confirmare
  };
  
  const confirmDeleteAccount = async () => {
    if (!deleteTarget) return;
  
    const accountId = deleteTarget._id;
    const accountType = deleteTarget.role === 'dispatcher' ? 'dispatchers' : 'accountings';
  
    try {
      await axios.delete(`${apiUrl}/${accountType}/${accountId}`, config);
     notify(`${deleteTarget.role} deleted successfully!`, 'success');
      deleteTarget.role === 'dispatcher' ? fetchDispatchers() : fetchAccountings();
    } catch (error) {
     
      notify(`Failed to delete ${deleteTarget.role}` , 'error');
    }
    setDeleteTarget(null); // 🔥 Ascundem notificarea după ștergere
  };
  
  const clearAccountForm = () => {
    setNewAccountFirstName('');
    setNewAccountLastName('');
    setNewAccountEmail('');
    setNewAccountPhone('');
    setNewAccountAddress('');
    setNewAccountDOB('');
    setNewAccountSalary('');
    setNewAccountPassword('');
    setSelectedAccount(null);
  };

 return (
  <div
    className={`${styles.settingsSection} ${
      updatedSettings.theme === 'light' ? styles.settingsSectionLight : ''
    }`}
  >
      {twoFactorWarning && (
        <div className={styles.twoFactorWarningsettings}>
          <p style={{ color: 'red' }}>Please set up Two-Factor Authentication to enhance your account security!</p>
        </div>
      )}



      <h2 className={styles.titlesettings}>Settings</h2>
      <form className={styles.settingsFormsettings}>
        <label>Company Name</label>
        <input
          name="companyName"
          value={updatedSettings.companyName || ''}
          onChange={handleChange}
          placeholder="Company Name"
          className={styles.inputFieldsettings}
        />

        <label>Company Address</label>
        <input
          name="companyAddress"
          value={updatedSettings.companyAddress || ''}
          onChange={handleChange}
          placeholder="Company Address"
          className={styles.inputFieldsettings}
        />

        <label>First Name</label>
        <input
          name="firstName"
          value={updatedSettings.firstName || ''}
          onChange={handleChange}
          placeholder="First Name"
          className={styles.inputFieldsettings}
        />

        <label>Last Name</label>
        <input
          name="lastName"
          value={updatedSettings.lastName || ''}
          onChange={handleChange}
          placeholder="Last Name"
          className={styles.inputFieldsettings}
        />

        <label>MC Number</label>
        <input
          name="mcNumber"
          value={updatedSettings.mcNumber || ''}
          onChange={handleChange}
          placeholder="MC Number"
          className={styles.inputFieldsettings}
        />

        <label>Phone Number</label>
        <input
          name="phone"
          value={updatedSettings.phone || ''}
          onChange={handleChange}
          placeholder="Phone Number"
          className={styles.inputFieldsettings}
        />

<label>Fax Number</label>
<input
  name="fax"
  value={updatedSettings.fax || ''}
  onChange={handleChange}
  placeholder="Fax Number"
  className={styles.inputFieldsettings}
/>

        <label>Email</label>
        <input
          name="email"
          value={updatedSettings.email || ''}
          onChange={handleChange}
          placeholder="Email"
          className={styles.inputFieldsettings}
        />
 
        <label>New Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="New Password"
          className={styles.inputFieldsettings}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          className={styles.inputFieldsettings}
        />

        <button type="button" onClick={handleSaveSettings} className={styles.submitButtonClientsettings}>
          Save Settings
        </button>
 {/* 🔥 NOU – SELECTOR TEMA */}
        <label>Theme</label>
        <select
          name="theme"
          value={updatedSettings.theme || 'dark'}
          onChange={handleChange}
          className={styles.inputFieldsettings}
        >
          <option value="dark">Dark (Black)</option>
          <option value="light">Light (White)</option>
        </select>
      {/* ================== BILLING ================== */}
<h3 className={styles.billingSettingsTitle}>Billing</h3>

{billingInfo ? (
  <div className={styles.billingSettings}>
    <div className={styles.billingCardBox}>
      <p className={styles.billingSettingsText}>
        <strong>Card:</strong> {billingInfo.card.brand?.toUpperCase()} **** **** **** {billingInfo.card.last4}
      </p>
      <p className={styles.billingSettingsText}>
        <strong>Exp:</strong> {billingInfo.card.expMonth}/{billingInfo.card.expYear}
      </p>

<button
  type="button" // ✅ împiedică refresh-ul
  className={styles.billingSettingsButton}
  onClick={async () => {
    try {
      const clientId = localStorage.getItem("clientId");
      const res = await axios.post(`${apiUrl}/billing/portal`, { clientId }, config);
      if (res.data.url) {
        window.open(res.data.url, "_blank"); // 🔥 deschide direct portalul Stripe
      }
    } catch (err) {
      console.error("Stripe portal error:", err);
      notify("Unable to open billing portal", "error");
    }
  }}
>
  Update Payment Method
</button>

</div>
     <button 
  type="button"
  onClick={() => setShowInvoices(true)} 
  className={styles.billingSettingsButtonSecondary}
>
  View Invoices
</button>
    </div>
) : (
  <p className={styles.billingSettingsLoading}>Loading billing info...</p>
)}



{/* ================== INVOICES MODAL ================== */}
{showInvoices && (
  <div className={styles.billingSettingsModalOverlay}>
    <div className={styles.billingSettingsModal}>
      <h4 className={styles.billingSettingsModalTitle}>Invoices</h4>

      {billingInfo.invoices.length === 0 ? (
        <p className={styles.billingSettingsText}>No invoices yet</p>
      ) : (
        <ul className={styles.billingSettingsInvoiceList}>
          {billingInfo.invoices.map(inv => (
            <li key={inv.id} className={styles.billingSettingsInvoiceItem}>
              <span>#{inv.number}</span>
              <span>{(inv.amount_paid / 100).toFixed(2)} {inv.currency.toUpperCase()}</span>
              <span>{new Date(inv.created * 1000).toLocaleDateString()}</span>
              <a 
                href={inv.hosted_invoice_url} 
                target="_blank" 
                rel="noreferrer" 
                className={styles.billingSettingsInvoiceLink}
              >
                View
              </a>
            </li>
          ))}
        </ul>
      )}

      <button 
        onClick={() => setShowInvoices(false)} 
        className={styles.billingSettingsClose}
      >
        Close
      </button>
    </div>
  </div>
)}


      </form>
      
      <h3 className={styles.subtitlesettings}>Driver Pay Week</h3>

<div className={styles.formGroupsettings}>
  <label>
    <input
      type="checkbox"
      checked={payrollWeekSettings.enabled}
      onChange={(e) =>
        setPayrollWeekSettings(prev => ({
          ...prev,
          enabled: e.target.checked
        }))
      }
    />
    Enable automatic Driver Pay Week
  </label>
</div>

<div className={styles.formGroupsettings}>
  <label>Base Week Number</label>
  <input
    type="number"
    placeholder="Ex: 115"
    value={payrollWeekSettings.baseWeek}
    disabled={!payrollWeekSettings.enabled}
    onChange={(e) =>
      setPayrollWeekSettings(prev => ({
        ...prev,
        baseWeek: Number(e.target.value)
      }))
    }
    className={styles.inputFieldsettings}
  />
</div>

<div className={styles.formGroupsettings}>
  <label>Base Week Date (MUST be Monday)</label>
  <input
    type="date"
    value={payrollWeekSettings.baseWeekDate}
    disabled={!payrollWeekSettings.enabled}
    onChange={(e) =>
      setPayrollWeekSettings(prev => ({
        ...prev,
        baseWeekDate: e.target.value
      }))
    }
    className={styles.inputFieldsettings}
  />
</div>

<button
  type="button"
  onClick={handleSavePayrollWeek}
  className={styles.submitButtonClientsettings}
>
  Save Driver Pay Week
</button>

        
<h3 className={styles.subtitleAccountultimateAccount}>Account Management</h3>
<select onChange={e => setSelectedRole(e.target.value)} className={styles.selectFieldAccountsettings}>
  <option value="dispatcher">Dispatcher</option>
  <option value="accounting">Accounting</option>
</select>

<form className={styles.accountFormsettings}>
  <label>First Name</label>
  <input
    type="text"
    value={newAccountFirstName}
    onChange={e => setNewAccountFirstName(e.target.value)}
    placeholder="First Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Last Name</label>
  <input
    type="text"
    value={newAccountLastName}
    onChange={e => setNewAccountLastName(e.target.value)}
    placeholder="Last Name"
    className={styles.inputFieldAccountsettings}
  />

  <label>Email</label>
  <input
    type="email"
    value={newAccountEmail}
    onChange={e => setNewAccountEmail(e.target.value)}
    placeholder="Email"
    className={styles.inputFieldAccountsettings}
  />

  <label>Phone</label>
  <input
    type="text"
    value={newAccountPhone}
    onChange={e => setNewAccountPhone(e.target.value)}
    placeholder="Phone"
    className={styles.inputFieldAccountsettings}
  />

  <label>Address</label>
  <input
    type="text"
    value={newAccountAddress}
    onChange={e => setNewAccountAddress(e.target.value)}
    placeholder="Address"
    className={styles.inputFieldAccountsettings}
  />

  <label>Date of Birth</label>
  <input
    type="date"
    value={newAccountDOB}
    onChange={e => setNewAccountDOB(e.target.value)}
    placeholder="Date of Birth"
    className={styles.inputFieldAccountsettings}
  />

  <label>Salary Details</label>
  <input
    type="text"
    value={newAccountSalary}
    onChange={e => setNewAccountSalary(e.target.value)}
    placeholder="Salary Details"
    className={styles.inputFieldAccountsettings}
  />

  <label>Password</label>
  <input
    type="password"
    value={newAccountPassword}
    onChange={e => setNewAccountPassword(e.target.value)}
    placeholder="Password"
    className={styles.inputFieldAccountsettings}
  />

<h4>Select Drivers</h4>
<div>
  {drivers.map((driver) => (
    <label key={driver._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedDrivers.includes(driver._id)}
        onChange={() => handleDriverSelection(driver._id)}
      />
      {driver.firstName} {driver.lastName}
    </label>
  ))}
</div>

<h4>Select Trucks</h4>
<div>
  {trucks.map((truck) => (
    <label key={truck._id} style={{ display: "block" }}>
      <input
        type="checkbox"
        checked={selectedTrucks.includes(truck._id)}
        onChange={() => handleTruckSelection(truck._id)}
      />
      {truck.truckNumber} - {truck.licensePlate}
    </label>
  ))}
</div>



<h3>Set Permissions</h3>
<div className={styles.permissionsGrid}>
  {[
    { label: 'Dashboard', value: 'dashboard' },
    { label: 'Driver Dashboard', value: 'driver-dashboard' },
    { label: 'Truck Dashboard', value: 'truck-dashboard' },

    { label: 'Accounting Manager', value: 'accounting-manager' },
    { label: 'Driver Pay', value: 'driver-pay' },
    { label: 'Driver Pay Manager', value: 'driverpay-manager' },
    { label: 'Fleet Report', value: 'fleet-report' },
    { label: 'Payroll Employee', value: 'payroll-employee' },
    { label: 'Payroll Manager', value: 'payroll-manager' },
    { label: 'Invoice', value: 'invoice' },
    { label: 'Received Invoices', value: 'receivedInvoices' },
    { label: 'Balance Sheet', value: 'balanceSheet' },
    { label: 'IFTA Manual', value: 'ifta' },
    { label: 'Fuel Report', value: 'fuel-report' },
    { label: 'Additions and Deductions', value: 'truckandtrailer' },

    { label: 'Drivers', value: 'drivers' },
    { label: 'Fleet', value: 'trucks' },
    { label: 'Trailers', value: 'trailers' },
    { label: 'Shippers', value: 'shippers' },
    { label: 'Consignees', value: 'consignee' },
    { label: 'Brokers', value: 'brokers' },
    { label: 'Employees', value: 'employees' },

    { label: 'Load Scheduler', value: 'load-manager' },
    { label: 'Load Tracker', value: 'load-finder' },
 
    { label: 'Settings', value: 'settings' },
    { label: 'Load Entry', value: 'add-new-load' },
  ].map((module) => (
    <label key={module.value} className={styles.permissionLabel}>
      <input
        type="checkbox"
        checked={permissions.includes(module.value)}
        onChange={() => handlePermissionChange(module.value)}
      />
      {module.label}
    </label>
  ))}
</div>


  {deleteTarget !== null && (
  <DeleteNotifications
    message={`Are you sure you want to delete ${deleteTarget.firstName} ${deleteTarget.lastName}'s account?`}
    onConfirm={confirmDeleteAccount}
    onCancel={() => setDeleteTarget(null)}
  />
)}

  <button type="button" onClick={selectedAccount ? handleUpdateAccount : handleCreateDispatcherOrAccounting} className={styles.submitButtonAccountsettings}>
    {selectedAccount ? 'Update Account' : 'Create Account'}
  </button>
  {selectedAccount && (
    <button type="button" onClick={clearAccountForm} className={styles.cancelButtonAccountsettings}>
      Cancel Edit
    </button>
  )}
</form>

<h3 className={styles.subtitleaccountsettings}>Existing Accounts</h3>
<div>
  {[...dispatchers, ...accountings].map((account) => (
    <div key={account._id} className={styles.accountItemsettings}>
      <p>{account.firstName} {account.lastName} - {account.role}</p>
      <div className={styles.accountItemsettingsButtons}>
        <button onClick={() => handleEditAccount(account)} className={styles.editButtonAccountnsettings}>Edit</button>
        <button onClick={() => requestDeleteAccount(account)} className={styles.deleteButtonAccountsettings}>Delete</button>
      </div>
    </div>
  ))}
</div>


<h3 className={styles.subtitlesettings}>Subscription</h3>
<p className={styles.blackTextsettings}>Subscription Type: {subscriptionInfo.subscriptionType}</p>
<p className={styles.blackTextsettings}>Expiration Date: {subscriptionInfo.contractEnd}</p>
<p className={styles.blackTextsettings}>Package: {subscriptionInfo.package}</p>

<h3 className={styles.subtitleTwoFactorsettings}>Two-Factor Authentication</h3>

{/* Selector metodă 2FA */}
<div style={{ marginBottom: '10px' }}>
  <label>Select 2FA Method:</label>
  <select
    value={twoFactorMethod}
    onChange={(e) => setTwoFactorMethod(e.target.value)}
    className={styles.inputFieldsettings}
  >
    <option value="email">Email Code</option>
    <option value="authenticator">Authenticator App</option>
  </select>
</div>

{isTwoFactorEnabled ? (
  <div>
    <p style={{ color: 'green' }}>Two-Factor Authentication is Enabled</p>
    <button onClick={handleDisableTwoFactorAuth} className={styles.deleteButtonTwoFactorsettings}>
      Disable 2FA
    </button>
  </div>
) : (
  <div>
    {twoFactorMethod === 'email' ? (
      <button onClick={handleEnableTwoFactorAuth} className={styles.submitButtonTwoFactorsettings}>
        Enable 2FA via Email
      </button>
    ) : (
      <button onClick={handleEnableAuthenticator} className={styles.submitButtonTwoFactorsettings}>
        Enable 2FA via Authenticator App
      </button>
    )}

{qrCodeUrl && isVerifying2FA && (
  <div style={{ marginTop: '15px', textAlign: 'center' }}>
    <p>Scan this QR Code with your Authenticator App:</p>
    <div style={{ background: 'white', padding: '10px', display: 'inline-block' }}>
      <QRCode value={qrCodeUrl} size={180} />
    </div>
    <p style={{ fontSize: '12px', wordBreak: 'break-word' }}>
      Manual Code: <strong>{authenticatorSecret}</strong>
    </p>
    <input
      type="text"
      placeholder="Enter code from Authenticator app"
      value={verificationCode}
      onChange={(e) => setVerificationCode(e.target.value)}
      className={styles.inputFieldsettings}
      style={{ marginTop: '10px', width: '250px' }}
    />
    <button onClick={handleVerifyAuthenticatorCode} className={styles.submitButtonTwoFactorsettings} style={{ marginTop: '10px' }}>
      Confirm 2FA
    </button>
  </div>
)}

  </div>
)}



<button onClick={() => window.location.href = '/FaqPage'} className={styles.actionButtonfaqsettings}>
  FAQ
</button>

    </div>
  );
};

export default BusinessPage;